import React, { useState, useEffect, createContext, useMemo, useContext, useRef, Children, isValidElement, cloneElement, PureComponent, createRef, useCallback } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs$1(propTypesExports);

var e = [],
  t = [];
function n(n, r) {
  if (n && "undefined" != typeof document) {
    var a,
      s = !0 === r.prepend ? "prepend" : "append",
      d = !0 === r.singleTag,
      i = "string" == typeof r.container ? document.querySelector(r.container) : document.getElementsByTagName("head")[0];
    if (d) {
      var u = e.indexOf(i);
      -1 === u && (u = e.push(i) - 1, t[u] = {}), a = t[u] && t[u][s] ? t[u][s] : t[u][s] = c();
    } else a = c();
    65279 === n.charCodeAt(0) && (n = n.substring(1)), a.styleSheet ? a.styleSheet.cssText += n : a.appendChild(document.createTextNode(n));
  }
  function c() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), r.attributes) for (var t = Object.keys(r.attributes), n = 0; n < t.length; n++) e.setAttribute(t[n], r.attributes[t[n]]);
    var a = "prepend" === s ? "afterbegin" : "beforeend";
    return i.insertAdjacentElement(a, e), e;
  }
}

var css$t = ".button_module_srkButton__717af1cb.button_module_btn__717af1cb {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_primary__717af1cb {\n  background: #0279a3;\n  border: #0279a3;\n  color: #fff;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_primary__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_primary__717af1cb:focus {\n  background: #098ebe;\n  border: #098ebe;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_secondary__717af1cb {\n  background: #41b7ea;\n  border: #41b7ea;\n  color: #002845;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_secondary__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_secondary__717af1cb:focus {\n  background: #41b7ea;\n  border: #41b7ea;\n  color: #002845;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_darkGrey__717af1cb {\n  background: #666;\n  border: #666;\n  color: #fff;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_darkGrey__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_darkGrey__717af1cb:focus {\n  background: #777;\n  border: #777;\n  color: #fff;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_lightGrey__717af1cb {\n  background: #f6f7fb;\n  border: #f6f7fb;\n  color: #000;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_lightGrey__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_lightGrey__717af1cb:focus {\n  background: #dfe1e8;\n  border: #dfe1e8;\n  color: #000;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_border__717af1cb {\n  background: transparent;\n  border: 1px solid #000;\n  color: #000;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_border__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_border__717af1cb:focus {\n  background: #0279a3;\n  border: 1px solid #0279a3;\n  color: #fff;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_borderFilter__717af1cb {\n  background: transparent;\n  border: 2px solid #0279a3;\n  border-radius: 20px;\n  padding: 1px 14px;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_borderFilter__717af1cb:hover, .button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_borderFilter__717af1cb:focus {\n  background: #0279a3;\n  color: #fff;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_large__717af1cb {\n  border-radius: 12px;\n  padding: 12px 24px;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb.button_module_fullWidth__717af1cb {\n  width: 100%;\n}\n.button_module_srkButton__717af1cb.button_module_btn__717af1cb:disabled, .button_module_srkButton__717af1cb.button_module_btn__717af1cb:hover:disabled {\n  background: #d9d9d9;\n  color: #767676;\n  cursor: default;\n}";
var modules_cca45a7f = {"srkButton":"button_module_srkButton__717af1cb","btn":"button_module_btn__717af1cb","primary":"button_module_primary__717af1cb","secondary":"button_module_secondary__717af1cb","darkGrey":"button_module_darkGrey__717af1cb","lightGrey":"button_module_lightGrey__717af1cb","border":"button_module_border__717af1cb","borderFilter":"button_module_borderFilter__717af1cb","large":"button_module_large__717af1cb","fullWidth":"button_module_fullWidth__717af1cb"};
n(css$t,{});

function Button(_ref) {
  let {
    variant,
    large,
    label,
    fullWidth,
    onClick,
    disabled,
    type
  } = _ref;
  const size = large ? modules_cca45a7f.large : '';
  const width = fullWidth ? modules_cca45a7f.fullWidth : '';
  return /*#__PURE__*/React.createElement("button", {
    type: type === 'submit' ? 'submit' : 'button',
    className: "".concat(modules_cca45a7f.srkButton, " ").concat(modules_cca45a7f.btn, " ").concat(modules_cca45a7f[variant], " ").concat(size, " ").concat(width),
    onClick: onClick,
    disabled: disabled
  }, label);
}
Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'lightGrey', 'darkGrey', 'border', 'borderFilter']),
  large: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit'])
};
Button.defaultProps = {
  variant: 'primary',
  large: false,
  fullWidth: false,
  onClick: undefined,
  disabled: false,
  type: 'button'
};

var css$s = ".tooltip_module_tooltipIcon__15400bd0 {\n  position: relative;\n  display: inline-block;\n}\n.tooltip_module_tooltipIcon__15400bd0 img {\n  max-width: 18px;\n  opacity: 0.8;\n  position: relative;\n  top: -1px;\n  left: 6px;\n}\n.tooltip_module_tooltipIcon__15400bd0 .tooltip_module_tooltipText__15400bd0 {\n  visibility: hidden;\n  width: 200px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 100%;\n  left: calc(50% + 7px);\n  margin-left: -100px;\n  opacity: 0;\n  transition: opacity 0.3s;\n  margin-bottom: 5px;\n}\n.tooltip_module_tooltipIcon__15400bd0 .tooltip_module_tooltipText__15400bd0 a {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.tooltip_module_tooltipIcon__15400bd0 .tooltip_module_tooltipText__15400bd0 a:hover {\n  color: #41b7ea;\n}\n.tooltip_module_tooltipIcon__15400bd0 .tooltip_module_tooltipText__15400bd0:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent;\n}\n.tooltip_module_tooltipIcon__15400bd0:hover .tooltip_module_tooltipText__15400bd0 {\n  visibility: visible;\n  opacity: 1;\n}";
var modules_a7663171 = {"tooltipIcon":"tooltip_module_tooltipIcon__15400bd0","tooltipText":"tooltip_module_tooltipText__15400bd0"};
n(css$s,{});

// import TooltipIcon from './tooltip.svg';

function Tooltip(_ref) {
  let {
    contents
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: modules_a7663171.tooltipIcon
  }, /*#__PURE__*/React.createElement("span", {
    className: modules_a7663171.tooltipText
  }, contents));
}
Tooltip.propTypes = {
  contents: PropTypes.string
};
Tooltip.defaultProps = {
  contents: 'This is a tooltip'
};

var css$r = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.twoRadioSelection_module_twoRadioContainer__959ea5ed {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed.twoRadioSelection_module_formGroup__959ea5ed {\n  margin: auto;\n  margin-bottom: 30px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed {\n  display: inline-flex;\n  min-width: 300px;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  padding: 6px;\n  background: #f3f3f3;\n  gap: 6px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_option__959ea5ed {\n  height: 100%;\n  width: 100%;\n  max-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-family: Rubik;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_option__959ea5ed::nth-of-type(odd) {\n  margin-right: 6px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_option__959ea5ed span {\n  font-size: 14px;\n  color: #000;\n  padding: 6px 20px;\n  min-width: 130px;\n  text-align: center;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_divider__959ea5ed {\n  position: relative;\n  padding: 0px 90px;\n  font-weight: 600;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_divider__959ea5ed:before, .twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_divider__959ea5ed:after {\n  content: \" \";\n  background: #dadada;\n  width: 50px;\n  height: 1px;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_divider__959ea5ed:before {\n  left: 0%;\n  margin-left: 20px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed .twoRadioSelection_module_divider__959ea5ed:after {\n  right: 0%;\n  margin-right: 20px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed input[type=radio] {\n  display: none;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed.twoRadioSelection_module_large__959ea5ed {\n  padding: 20px 15px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed.twoRadioSelection_module_large__959ea5ed .twoRadioSelection_module_option__959ea5ed {\n  margin: 0 10px;\n  padding: 0 10px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed.twoRadioSelection_module_large__959ea5ed .twoRadioSelection_module_option__959ea5ed::nth-of-type(odd) {\n  margin-right: 0px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed.twoRadioSelection_module_large__959ea5ed .twoRadioSelection_module_option__959ea5ed span {\n  font-size: 20px;\n  padding: 12px 20px;\n}\n.twoRadioSelection_module_twoRadioContainer__959ea5ed .twoRadioSelection_module_twoRadioSelection__959ea5ed input:checked:checked + label {\n  border: 2px solid #0279a3;\n  background: #fff;\n}";
var modules_341490ba = {"twoRadioContainer":"twoRadioSelection_module_twoRadioContainer__959ea5ed","formGroup":"twoRadioSelection_module_formGroup__959ea5ed","twoRadioSelection":"twoRadioSelection_module_twoRadioSelection__959ea5ed","option":"twoRadioSelection_module_option__959ea5ed","divider":"twoRadioSelection_module_divider__959ea5ed","large":"twoRadioSelection_module_large__959ea5ed"};
n(css$r,{});

var css$q = "@charset \"UTF-8\";/*!\n * Bootstrap  v5.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root,[data-bs-theme=light]{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-black:#000;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-primary-text-emphasis:#052c65;--bs-secondary-text-emphasis:#2b2f32;--bs-success-text-emphasis:#0a3622;--bs-info-text-emphasis:#055160;--bs-warning-text-emphasis:#664d03;--bs-danger-text-emphasis:#58151c;--bs-light-text-emphasis:#495057;--bs-dark-text-emphasis:#495057;--bs-primary-bg-subtle:#cfe2ff;--bs-secondary-bg-subtle:#e2e3e5;--bs-success-bg-subtle:#d1e7dd;--bs-info-bg-subtle:#cff4fc;--bs-warning-bg-subtle:#fff3cd;--bs-danger-bg-subtle:#f8d7da;--bs-light-bg-subtle:#fcfcfd;--bs-dark-bg-subtle:#ced4da;--bs-primary-border-subtle:#9ec5fe;--bs-secondary-border-subtle:#c4c8cb;--bs-success-border-subtle:#a3cfbb;--bs-info-border-subtle:#9eeaf9;--bs-warning-border-subtle:#ffe69c;--bs-danger-border-subtle:#f1aeb5;--bs-light-border-subtle:#e9ecef;--bs-dark-border-subtle:#adb5bd;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-color-rgb:33,37,41;--bs-body-bg:#fff;--bs-body-bg-rgb:255,255,255;--bs-emphasis-color:#000;--bs-emphasis-color-rgb:0,0,0;--bs-secondary-color:rgba(33, 37, 41, 0.75);--bs-secondary-color-rgb:33,37,41;--bs-secondary-bg:#e9ecef;--bs-secondary-bg-rgb:233,236,239;--bs-tertiary-color:rgba(33, 37, 41, 0.5);--bs-tertiary-color-rgb:33,37,41;--bs-tertiary-bg:#f8f9fa;--bs-tertiary-bg-rgb:248,249,250;--bs-heading-color:inherit;--bs-link-color:#0d6efd;--bs-link-color-rgb:13,110,253;--bs-link-decoration:underline;--bs-link-hover-color:#0a58ca;--bs-link-hover-color-rgb:10,88,202;--bs-code-color:#d63384;--bs-highlight-bg:#fff3cd;--bs-border-width:1px;--bs-border-style:solid;--bs-border-color:#dee2e6;--bs-border-color-translucent:rgba(0, 0, 0, 0.175);--bs-border-radius:0.375rem;--bs-border-radius-sm:0.25rem;--bs-border-radius-lg:0.5rem;--bs-border-radius-xl:1rem;--bs-border-radius-xxl:2rem;--bs-border-radius-2xl:var(--bs-border-radius-xxl);--bs-border-radius-pill:50rem;--bs-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-box-shadow-sm:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-box-shadow-lg:0 1rem 3rem rgba(0, 0, 0, 0.175);--bs-box-shadow-inset:inset 0 1px 2px rgba(0, 0, 0, 0.075);--bs-focus-ring-width:0.25rem;--bs-focus-ring-opacity:0.25;--bs-focus-ring-color:rgba(13, 110, 253, 0.25);--bs-form-valid-color:#198754;--bs-form-valid-border-color:#198754;--bs-form-invalid-color:#dc3545;--bs-form-invalid-border-color:#dc3545}[data-bs-theme=dark]{color-scheme:dark;--bs-body-color:#dee2e6;--bs-body-color-rgb:222,226,230;--bs-body-bg:#212529;--bs-body-bg-rgb:33,37,41;--bs-emphasis-color:#fff;--bs-emphasis-color-rgb:255,255,255;--bs-secondary-color:rgba(222, 226, 230, 0.75);--bs-secondary-color-rgb:222,226,230;--bs-secondary-bg:#343a40;--bs-secondary-bg-rgb:52,58,64;--bs-tertiary-color:rgba(222, 226, 230, 0.5);--bs-tertiary-color-rgb:222,226,230;--bs-tertiary-bg:#2b3035;--bs-tertiary-bg-rgb:43,48,53;--bs-primary-text-emphasis:#6ea8fe;--bs-secondary-text-emphasis:#a7acb1;--bs-success-text-emphasis:#75b798;--bs-info-text-emphasis:#6edff6;--bs-warning-text-emphasis:#ffda6a;--bs-danger-text-emphasis:#ea868f;--bs-light-text-emphasis:#f8f9fa;--bs-dark-text-emphasis:#dee2e6;--bs-primary-bg-subtle:#031633;--bs-secondary-bg-subtle:#161719;--bs-success-bg-subtle:#051b11;--bs-info-bg-subtle:#032830;--bs-warning-bg-subtle:#332701;--bs-danger-bg-subtle:#2c0b0e;--bs-light-bg-subtle:#343a40;--bs-dark-bg-subtle:#1a1d20;--bs-primary-border-subtle:#084298;--bs-secondary-border-subtle:#41464b;--bs-success-border-subtle:#0f5132;--bs-info-border-subtle:#087990;--bs-warning-border-subtle:#997404;--bs-danger-border-subtle:#842029;--bs-light-border-subtle:#495057;--bs-dark-border-subtle:#343a40;--bs-heading-color:inherit;--bs-link-color:#6ea8fe;--bs-link-hover-color:#8bb9fe;--bs-link-color-rgb:110,168,254;--bs-link-hover-color-rgb:139,185,254;--bs-code-color:#e685b5;--bs-border-color:#495057;--bs-border-color-translucent:rgba(255, 255, 255, 0.15);--bs-form-valid-color:#75b798;--bs-form-valid-border-color:#75b798;--bs-form-invalid-color:#ea868f;--bs-form-invalid-border-color:#ea868f}*,::after,::before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){:root{scroll-behavior:smooth}}body{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr{margin:1rem 0;color:inherit;border:0;border-top:var(--bs-border-width) solid;opacity:.25}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;color:var(--bs-heading-color)}.h1,h1{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1,h1{font-size:2.5rem}}.h2,h2{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2,h2{font-size:2rem}}.h3,h3{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3,h3{font-size:1.75rem}}.h4,h4{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4,h4{font-size:1.5rem}}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}p{margin-top:0;margin-bottom:1rem}abbr[title]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul{padding-left:2rem}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}.small,small{font-size:.875em}.mark,mark{padding:.1875em;background-color:var(--bs-highlight-bg)}sub,sup{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,1));text-decoration:underline}a:hover{--bs-link-color-rgb:var(--bs-link-hover-color-rgb)}a:not([href]):not([class]),a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:var(--bs-font-monospace);font-size:1em}pre{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code{font-size:inherit;color:inherit;word-break:normal}code{font-size:.875em;color:var(--bs-code-color);word-wrap:break-word}a>code{color:inherit}kbd{padding:.1875rem .375rem;font-size:.875em;color:var(--bs-body-bg);background-color:var(--bs-body-color);border-radius:.25rem}kbd kbd{padding:0;font-size:1em}figure{margin:0 0 1rem}img,svg{vertical-align:middle}table{caption-side:bottom;border-collapse:collapse}caption{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-secondary-color);text-align:left}th{text-align:inherit;text-align:-webkit-match-parent}tbody,td,tfoot,th,thead,tr{border-color:inherit;border-style:solid;border-width:0}label{display:inline-block}button{border-radius:0}button:focus:not(:focus-visible){outline:0}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}select:disabled{opacity:1}[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator{display:none!important}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}::-moz-focus-inner{padding:0;border-style:none}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend{font-size:1.5rem}}legend+*{clear:left}::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-fields-wrapper,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-text,::-webkit-datetime-edit-year-field{padding:0}::-webkit-inner-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-color-swatch-wrapper{padding:0}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}::file-selector-button{font:inherit;-webkit-appearance:button}output{display:inline-block}iframe{border:0}summary{display:list-item;cursor:pointer}progress{vertical-align:baseline}[hidden]{display:none!important}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1{font-size:5rem}}.display-2{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2{font-size:4.5rem}}.display-3{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3{font-size:4rem}}.display-4{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4{font-size:3.5rem}}.display-5{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5{font-size:3rem}}.display-6{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6{font-size:2.5rem}}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:.875em;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote>:last-child{margin-bottom:0}.blockquote-footer{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer::before{content:\"— \"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:var(--bs-body-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:.875em;color:var(--bs-secondary-color)}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{--bs-gutter-x:1.5rem;--bs-gutter-y:0;width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}@media (min-width:1400px){.container,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{max-width:1320px}}:root{--bs-breakpoint-xs:0;--bs-breakpoint-sm:576px;--bs-breakpoint-md:768px;--bs-breakpoint-lg:992px;--bs-breakpoint-xl:1200px;--bs-breakpoint-xxl:1400px}.row{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col{flex:1 0 0%}.row-cols-auto>*{flex:0 0 auto;width:auto}.row-cols-1>*{flex:0 0 auto;width:100%}.row-cols-2>*{flex:0 0 auto;width:50%}.row-cols-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-4>*{flex:0 0 auto;width:25%}.row-cols-5>*{flex:0 0 auto;width:20%}.row-cols-6>*{flex:0 0 auto;width:16.6666666667%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 auto;width:8.33333333%}.col-2{flex:0 0 auto;width:16.66666667%}.col-3{flex:0 0 auto;width:25%}.col-4{flex:0 0 auto;width:33.33333333%}.col-5{flex:0 0 auto;width:41.66666667%}.col-6{flex:0 0 auto;width:50%}.col-7{flex:0 0 auto;width:58.33333333%}.col-8{flex:0 0 auto;width:66.66666667%}.col-9{flex:0 0 auto;width:75%}.col-10{flex:0 0 auto;width:83.33333333%}.col-11{flex:0 0 auto;width:91.66666667%}.col-12{flex:0 0 auto;width:100%}.offset-1{margin-left:8.33333333%}.offset-2{margin-left:16.66666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333333%}.offset-5{margin-left:41.66666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333333%}.offset-8{margin-left:66.66666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333333%}.offset-11{margin-left:91.66666667%}.g-0,.gx-0{--bs-gutter-x:0}.g-0,.gy-0{--bs-gutter-y:0}.g-1,.gx-1{--bs-gutter-x:0.25rem}.g-1,.gy-1{--bs-gutter-y:0.25rem}.g-2,.gx-2{--bs-gutter-x:0.5rem}.g-2,.gy-2{--bs-gutter-y:0.5rem}.g-3,.gx-3{--bs-gutter-x:1rem}.g-3,.gy-3{--bs-gutter-y:1rem}.g-4,.gx-4{--bs-gutter-x:1.5rem}.g-4,.gy-4{--bs-gutter-y:1.5rem}.g-5,.gx-5{--bs-gutter-x:3rem}.g-5,.gy-5{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm{flex:1 0 0%}.row-cols-sm-auto>*{flex:0 0 auto;width:auto}.row-cols-sm-1>*{flex:0 0 auto;width:100%}.row-cols-sm-2>*{flex:0 0 auto;width:50%}.row-cols-sm-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>*{flex:0 0 auto;width:25%}.row-cols-sm-5>*{flex:0 0 auto;width:20%}.row-cols-sm-6>*{flex:0 0 auto;width:16.6666666667%}.col-sm-auto{flex:0 0 auto;width:auto}.col-sm-1{flex:0 0 auto;width:8.33333333%}.col-sm-2{flex:0 0 auto;width:16.66666667%}.col-sm-3{flex:0 0 auto;width:25%}.col-sm-4{flex:0 0 auto;width:33.33333333%}.col-sm-5{flex:0 0 auto;width:41.66666667%}.col-sm-6{flex:0 0 auto;width:50%}.col-sm-7{flex:0 0 auto;width:58.33333333%}.col-sm-8{flex:0 0 auto;width:66.66666667%}.col-sm-9{flex:0 0 auto;width:75%}.col-sm-10{flex:0 0 auto;width:83.33333333%}.col-sm-11{flex:0 0 auto;width:91.66666667%}.col-sm-12{flex:0 0 auto;width:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333333%}.offset-sm-2{margin-left:16.66666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333333%}.offset-sm-5{margin-left:41.66666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333333%}.offset-sm-8{margin-left:66.66666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333333%}.offset-sm-11{margin-left:91.66666667%}.g-sm-0,.gx-sm-0{--bs-gutter-x:0}.g-sm-0,.gy-sm-0{--bs-gutter-y:0}.g-sm-1,.gx-sm-1{--bs-gutter-x:0.25rem}.g-sm-1,.gy-sm-1{--bs-gutter-y:0.25rem}.g-sm-2,.gx-sm-2{--bs-gutter-x:0.5rem}.g-sm-2,.gy-sm-2{--bs-gutter-y:0.5rem}.g-sm-3,.gx-sm-3{--bs-gutter-x:1rem}.g-sm-3,.gy-sm-3{--bs-gutter-y:1rem}.g-sm-4,.gx-sm-4{--bs-gutter-x:1.5rem}.g-sm-4,.gy-sm-4{--bs-gutter-y:1.5rem}.g-sm-5,.gx-sm-5{--bs-gutter-x:3rem}.g-sm-5,.gy-sm-5{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md{flex:1 0 0%}.row-cols-md-auto>*{flex:0 0 auto;width:auto}.row-cols-md-1>*{flex:0 0 auto;width:100%}.row-cols-md-2>*{flex:0 0 auto;width:50%}.row-cols-md-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>*{flex:0 0 auto;width:25%}.row-cols-md-5>*{flex:0 0 auto;width:20%}.row-cols-md-6>*{flex:0 0 auto;width:16.6666666667%}.col-md-auto{flex:0 0 auto;width:auto}.col-md-1{flex:0 0 auto;width:8.33333333%}.col-md-2{flex:0 0 auto;width:16.66666667%}.col-md-3{flex:0 0 auto;width:25%}.col-md-4{flex:0 0 auto;width:33.33333333%}.col-md-5{flex:0 0 auto;width:41.66666667%}.col-md-6{flex:0 0 auto;width:50%}.col-md-7{flex:0 0 auto;width:58.33333333%}.col-md-8{flex:0 0 auto;width:66.66666667%}.col-md-9{flex:0 0 auto;width:75%}.col-md-10{flex:0 0 auto;width:83.33333333%}.col-md-11{flex:0 0 auto;width:91.66666667%}.col-md-12{flex:0 0 auto;width:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333333%}.offset-md-2{margin-left:16.66666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333333%}.offset-md-5{margin-left:41.66666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333333%}.offset-md-8{margin-left:66.66666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333333%}.offset-md-11{margin-left:91.66666667%}.g-md-0,.gx-md-0{--bs-gutter-x:0}.g-md-0,.gy-md-0{--bs-gutter-y:0}.g-md-1,.gx-md-1{--bs-gutter-x:0.25rem}.g-md-1,.gy-md-1{--bs-gutter-y:0.25rem}.g-md-2,.gx-md-2{--bs-gutter-x:0.5rem}.g-md-2,.gy-md-2{--bs-gutter-y:0.5rem}.g-md-3,.gx-md-3{--bs-gutter-x:1rem}.g-md-3,.gy-md-3{--bs-gutter-y:1rem}.g-md-4,.gx-md-4{--bs-gutter-x:1.5rem}.g-md-4,.gy-md-4{--bs-gutter-y:1.5rem}.g-md-5,.gx-md-5{--bs-gutter-x:3rem}.g-md-5,.gy-md-5{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg{flex:1 0 0%}.row-cols-lg-auto>*{flex:0 0 auto;width:auto}.row-cols-lg-1>*{flex:0 0 auto;width:100%}.row-cols-lg-2>*{flex:0 0 auto;width:50%}.row-cols-lg-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>*{flex:0 0 auto;width:25%}.row-cols-lg-5>*{flex:0 0 auto;width:20%}.row-cols-lg-6>*{flex:0 0 auto;width:16.6666666667%}.col-lg-auto{flex:0 0 auto;width:auto}.col-lg-1{flex:0 0 auto;width:8.33333333%}.col-lg-2{flex:0 0 auto;width:16.66666667%}.col-lg-3{flex:0 0 auto;width:25%}.col-lg-4{flex:0 0 auto;width:33.33333333%}.col-lg-5{flex:0 0 auto;width:41.66666667%}.col-lg-6{flex:0 0 auto;width:50%}.col-lg-7{flex:0 0 auto;width:58.33333333%}.col-lg-8{flex:0 0 auto;width:66.66666667%}.col-lg-9{flex:0 0 auto;width:75%}.col-lg-10{flex:0 0 auto;width:83.33333333%}.col-lg-11{flex:0 0 auto;width:91.66666667%}.col-lg-12{flex:0 0 auto;width:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333333%}.offset-lg-2{margin-left:16.66666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333333%}.offset-lg-5{margin-left:41.66666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333333%}.offset-lg-8{margin-left:66.66666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333333%}.offset-lg-11{margin-left:91.66666667%}.g-lg-0,.gx-lg-0{--bs-gutter-x:0}.g-lg-0,.gy-lg-0{--bs-gutter-y:0}.g-lg-1,.gx-lg-1{--bs-gutter-x:0.25rem}.g-lg-1,.gy-lg-1{--bs-gutter-y:0.25rem}.g-lg-2,.gx-lg-2{--bs-gutter-x:0.5rem}.g-lg-2,.gy-lg-2{--bs-gutter-y:0.5rem}.g-lg-3,.gx-lg-3{--bs-gutter-x:1rem}.g-lg-3,.gy-lg-3{--bs-gutter-y:1rem}.g-lg-4,.gx-lg-4{--bs-gutter-x:1.5rem}.g-lg-4,.gy-lg-4{--bs-gutter-y:1.5rem}.g-lg-5,.gx-lg-5{--bs-gutter-x:3rem}.g-lg-5,.gy-lg-5{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl{flex:1 0 0%}.row-cols-xl-auto>*{flex:0 0 auto;width:auto}.row-cols-xl-1>*{flex:0 0 auto;width:100%}.row-cols-xl-2>*{flex:0 0 auto;width:50%}.row-cols-xl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>*{flex:0 0 auto;width:25%}.row-cols-xl-5>*{flex:0 0 auto;width:20%}.row-cols-xl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xl-auto{flex:0 0 auto;width:auto}.col-xl-1{flex:0 0 auto;width:8.33333333%}.col-xl-2{flex:0 0 auto;width:16.66666667%}.col-xl-3{flex:0 0 auto;width:25%}.col-xl-4{flex:0 0 auto;width:33.33333333%}.col-xl-5{flex:0 0 auto;width:41.66666667%}.col-xl-6{flex:0 0 auto;width:50%}.col-xl-7{flex:0 0 auto;width:58.33333333%}.col-xl-8{flex:0 0 auto;width:66.66666667%}.col-xl-9{flex:0 0 auto;width:75%}.col-xl-10{flex:0 0 auto;width:83.33333333%}.col-xl-11{flex:0 0 auto;width:91.66666667%}.col-xl-12{flex:0 0 auto;width:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333333%}.offset-xl-2{margin-left:16.66666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333333%}.offset-xl-5{margin-left:41.66666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333333%}.offset-xl-8{margin-left:66.66666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333333%}.offset-xl-11{margin-left:91.66666667%}.g-xl-0,.gx-xl-0{--bs-gutter-x:0}.g-xl-0,.gy-xl-0{--bs-gutter-y:0}.g-xl-1,.gx-xl-1{--bs-gutter-x:0.25rem}.g-xl-1,.gy-xl-1{--bs-gutter-y:0.25rem}.g-xl-2,.gx-xl-2{--bs-gutter-x:0.5rem}.g-xl-2,.gy-xl-2{--bs-gutter-y:0.5rem}.g-xl-3,.gx-xl-3{--bs-gutter-x:1rem}.g-xl-3,.gy-xl-3{--bs-gutter-y:1rem}.g-xl-4,.gx-xl-4{--bs-gutter-x:1.5rem}.g-xl-4,.gy-xl-4{--bs-gutter-y:1.5rem}.g-xl-5,.gx-xl-5{--bs-gutter-x:3rem}.g-xl-5,.gy-xl-5{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl{flex:1 0 0%}.row-cols-xxl-auto>*{flex:0 0 auto;width:auto}.row-cols-xxl-1>*{flex:0 0 auto;width:100%}.row-cols-xxl-2>*{flex:0 0 auto;width:50%}.row-cols-xxl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>*{flex:0 0 auto;width:25%}.row-cols-xxl-5>*{flex:0 0 auto;width:20%}.row-cols-xxl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto{flex:0 0 auto;width:auto}.col-xxl-1{flex:0 0 auto;width:8.33333333%}.col-xxl-2{flex:0 0 auto;width:16.66666667%}.col-xxl-3{flex:0 0 auto;width:25%}.col-xxl-4{flex:0 0 auto;width:33.33333333%}.col-xxl-5{flex:0 0 auto;width:41.66666667%}.col-xxl-6{flex:0 0 auto;width:50%}.col-xxl-7{flex:0 0 auto;width:58.33333333%}.col-xxl-8{flex:0 0 auto;width:66.66666667%}.col-xxl-9{flex:0 0 auto;width:75%}.col-xxl-10{flex:0 0 auto;width:83.33333333%}.col-xxl-11{flex:0 0 auto;width:91.66666667%}.col-xxl-12{flex:0 0 auto;width:100%}.offset-xxl-0{margin-left:0}.offset-xxl-1{margin-left:8.33333333%}.offset-xxl-2{margin-left:16.66666667%}.offset-xxl-3{margin-left:25%}.offset-xxl-4{margin-left:33.33333333%}.offset-xxl-5{margin-left:41.66666667%}.offset-xxl-6{margin-left:50%}.offset-xxl-7{margin-left:58.33333333%}.offset-xxl-8{margin-left:66.66666667%}.offset-xxl-9{margin-left:75%}.offset-xxl-10{margin-left:83.33333333%}.offset-xxl-11{margin-left:91.66666667%}.g-xxl-0,.gx-xxl-0{--bs-gutter-x:0}.g-xxl-0,.gy-xxl-0{--bs-gutter-y:0}.g-xxl-1,.gx-xxl-1{--bs-gutter-x:0.25rem}.g-xxl-1,.gy-xxl-1{--bs-gutter-y:0.25rem}.g-xxl-2,.gx-xxl-2{--bs-gutter-x:0.5rem}.g-xxl-2,.gy-xxl-2{--bs-gutter-y:0.5rem}.g-xxl-3,.gx-xxl-3{--bs-gutter-x:1rem}.g-xxl-3,.gy-xxl-3{--bs-gutter-y:1rem}.g-xxl-4,.gx-xxl-4{--bs-gutter-x:1.5rem}.g-xxl-4,.gy-xxl-4{--bs-gutter-y:1.5rem}.g-xxl-5,.gx-xxl-5{--bs-gutter-x:3rem}.g-xxl-5,.gy-xxl-5{--bs-gutter-y:3rem}}.table{--bs-table-color-type:initial;--bs-table-bg-type:initial;--bs-table-color-state:initial;--bs-table-bg-state:initial;--bs-table-color:var(--bs-body-color);--bs-table-bg:var(--bs-body-bg);--bs-table-border-color:var(--bs-border-color);--bs-table-accent-bg:transparent;--bs-table-striped-color:var(--bs-body-color);--bs-table-striped-bg:rgba(0, 0, 0, 0.05);--bs-table-active-color:var(--bs-body-color);--bs-table-active-bg:rgba(0, 0, 0, 0.1);--bs-table-hover-color:var(--bs-body-color);--bs-table-hover-bg:rgba(0, 0, 0, 0.075);width:100%;margin-bottom:1rem;vertical-align:top;border-color:var(--bs-table-border-color)}.table>:not(caption)>*>*{padding:.5rem .5rem;color:var(--bs-table-color-state,var(--bs-table-color-type,var(--bs-table-color)));background-color:var(--bs-table-bg);border-bottom-width:var(--bs-border-width);box-shadow:inset 0 0 0 9999px var(--bs-table-bg-state,var(--bs-table-bg-type,var(--bs-table-accent-bg)))}.table>tbody{vertical-align:inherit}.table>thead{vertical-align:bottom}.table-group-divider{border-top:calc(var(--bs-border-width) * 2) solid currentcolor}.caption-top{caption-side:top}.table-sm>:not(caption)>*>*{padding:.25rem .25rem}.table-bordered>:not(caption)>*{border-width:var(--bs-border-width) 0}.table-bordered>:not(caption)>*>*{border-width:0 var(--bs-border-width)}.table-borderless>:not(caption)>*>*{border-bottom-width:0}.table-borderless>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>*{--bs-table-color-type:var(--bs-table-striped-color);--bs-table-bg-type:var(--bs-table-striped-bg)}.table-striped-columns>:not(caption)>tr>:nth-child(2n){--bs-table-color-type:var(--bs-table-striped-color);--bs-table-bg-type:var(--bs-table-striped-bg)}.table-active{--bs-table-color-state:var(--bs-table-active-color);--bs-table-bg-state:var(--bs-table-active-bg)}.table-hover>tbody>tr:hover>*{--bs-table-color-state:var(--bs-table-hover-color);--bs-table-bg-state:var(--bs-table-hover-bg)}.table-primary{--bs-table-color:#000;--bs-table-bg:#cfe2ff;--bs-table-border-color:#bacbe6;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-secondary{--bs-table-color:#000;--bs-table-bg:#e2e3e5;--bs-table-border-color:#cbccce;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-success{--bs-table-color:#000;--bs-table-bg:#d1e7dd;--bs-table-border-color:#bcd0c7;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-info{--bs-table-color:#000;--bs-table-bg:#cff4fc;--bs-table-border-color:#badce3;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-warning{--bs-table-color:#000;--bs-table-bg:#fff3cd;--bs-table-border-color:#e6dbb9;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-danger{--bs-table-color:#000;--bs-table-bg:#f8d7da;--bs-table-border-color:#dfc2c4;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-light{--bs-table-color:#000;--bs-table-bg:#f8f9fa;--bs-table-border-color:#dfe0e1;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-dark{--bs-table-color:#fff;--bs-table-bg:#212529;--bs-table-border-color:#373b3e;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-responsive{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label{margin-bottom:.5rem}.col-form-label{padding-top:calc(.375rem + var(--bs-border-width));padding-bottom:calc(.375rem + var(--bs-border-width));margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + var(--bs-border-width));padding-bottom:calc(.5rem + var(--bs-border-width));font-size:1.25rem}.col-form-label-sm{padding-top:calc(.25rem + var(--bs-border-width));padding-bottom:calc(.25rem + var(--bs-border-width));font-size:.875rem}.form-text{margin-top:.25rem;font-size:.875em;color:var(--bs-secondary-color)}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-body-bg);background-clip:padding-box;border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control[type=file]{overflow:hidden}.form-control[type=file]:not(:disabled):not([readonly]){cursor:pointer}.form-control:focus{color:var(--bs-body-color);background-color:var(--bs-body-bg);border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control::-webkit-date-and-time-value{min-width:85px;height:1.5em;margin:0}.form-control::-webkit-datetime-edit{display:block;padding:0}.form-control::-moz-placeholder{color:var(--bs-secondary-color);opacity:1}.form-control::placeholder{color:var(--bs-secondary-color);opacity:1}.form-control:disabled{background-color:var(--bs-secondary-bg);opacity:1}.form-control::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control::file-selector-button{transition:none}}.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:var(--bs-secondary-bg)}.form-control:hover:not(:disabled):not([readonly])::file-selector-button{background-color:var(--bs-secondary-bg)}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:var(--bs-body-color);background-color:transparent;border:solid transparent;border-width:var(--bs-border-width) 0}.form-control-plaintext:focus{outline:0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{min-height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2));padding:.25rem .5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.form-control-sm::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg{min-height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));padding:.5rem 1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}.form-control-lg::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control{min-height:calc(1.5em + .75rem + calc(var(--bs-border-width) * 2))}textarea.form-control-sm{min-height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2))}textarea.form-control-lg{min-height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))}.form-control-color{width:3rem;height:calc(1.5em + .75rem + calc(var(--bs-border-width) * 2));padding:.375rem}.form-control-color:not(:disabled):not([readonly]){cursor:pointer}.form-control-color::-moz-color-swatch{border:0!important;border-radius:var(--bs-border-radius)}.form-control-color::-webkit-color-swatch{border:0!important;border-radius:var(--bs-border-radius)}.form-control-color.form-control-sm{height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2))}.form-control-color.form-control-lg{height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))}.form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-body-bg);background-image:var(--bs-form-select-bg-img),var(--bs-form-select-bg-icon,none);background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-select{transition:none}}.form-select:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple],.form-select[size]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select:disabled{background-color:var(--bs-secondary-bg)}.form-select:-moz-focusring{color:transparent;text-shadow:0 0 0 var(--bs-body-color)}.form-select-sm{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.form-select-lg{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}[data-bs-theme=dark] .form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\")}.form-check{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input{float:left;margin-left:-1.5em}.form-check-reverse{padding-right:1.5em;padding-left:0;text-align:right}.form-check-reverse .form-check-input{float:right;margin-right:-1.5em;margin-left:0}.form-check-input{--bs-form-check-bg:var(--bs-body-bg);width:1em;height:1em;margin-top:.25em;vertical-align:top;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-form-check-bg);background-image:var(--bs-form-check-bg-image);background-repeat:no-repeat;background-position:center;background-size:contain;border:var(--bs-border-width) solid var(--bs-border-color);-webkit-print-color-adjust:exact;color-adjust:exact;print-color-adjust:exact}.form-check-input[type=checkbox]{border-radius:.25em}.form-check-input[type=radio]{border-radius:50%}.form-check-input:active{filter:brightness(90%)}.form-check-input:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\")}.form-check-input:checked[type=radio]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\")}.form-check-input[type=checkbox]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\")}.form-check-input:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{cursor:default;opacity:.5}.form-switch{padding-left:2.5em}.form-switch .form-check-input{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");width:2em;margin-left:-2.5em;background-image:var(--bs-form-switch-bg);background-position:left center;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input{transition:none}}.form-switch .form-check-input:focus{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\")}.form-switch .form-check-input:checked{background-position:right center;--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.form-switch.form-check-reverse{padding-right:2.5em;padding-left:0}.form-switch.form-check-reverse .form-check-input{margin-right:-2.5em;margin-left:0}.form-check-inline{display:inline-block;margin-right:1rem}.btn-check{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn,.btn-check[disabled]+.btn{pointer-events:none;filter:none;opacity:.65}[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus){--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\")}.form-range{width:100%;height:1.5rem;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent}.form-range:focus{outline:0}.form-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range::-moz-focus-outer{border:0}.form-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;-webkit-appearance:none;appearance:none;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:var(--bs-tertiary-bg);border-color:transparent;border-radius:1rem}.form-range::-moz-range-thumb{width:1rem;height:1rem;-moz-appearance:none;appearance:none;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-range::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range::-moz-range-thumb:active{background-color:#b6d4fe}.form-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:var(--bs-tertiary-bg);border-color:transparent;border-radius:1rem}.form-range:disabled{pointer-events:none}.form-range:disabled::-webkit-slider-thumb{background-color:var(--bs-secondary-color)}.form-range:disabled::-moz-range-thumb{background-color:var(--bs-secondary-color)}.form-floating{position:relative}.form-floating>.form-control,.form-floating>.form-control-plaintext,.form-floating>.form-select{height:calc(3.5rem + calc(var(--bs-border-width) * 2));min-height:calc(3.5rem + calc(var(--bs-border-width) * 2));line-height:1.25}.form-floating>label{position:absolute;top:0;left:0;z-index:2;height:100%;padding:1rem .75rem;overflow:hidden;text-align:start;text-overflow:ellipsis;white-space:nowrap;pointer-events:none;border:var(--bs-border-width) solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label{transition:none}}.form-floating>.form-control,.form-floating>.form-control-plaintext{padding:1rem .75rem}.form-floating>.form-control-plaintext::-moz-placeholder,.form-floating>.form-control::-moz-placeholder{color:transparent}.form-floating>.form-control-plaintext::placeholder,.form-floating>.form-control::placeholder{color:transparent}.form-floating>.form-control-plaintext:not(:-moz-placeholder-shown),.form-floating>.form-control:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control-plaintext:focus,.form-floating>.form-control-plaintext:not(:placeholder-shown),.form-floating>.form-control:focus,.form-floating>.form-control:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control-plaintext:-webkit-autofill,.form-floating>.form-control:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control-plaintext~label,.form-floating>.form-control:focus~label,.form-floating>.form-control:not(:placeholder-shown)~label,.form-floating>.form-select~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:not(:-moz-placeholder-shown)~label::after{position:absolute;inset:1rem 0.375rem;z-index:-1;height:1.5em;content:\"\";background-color:var(--bs-body-bg);border-radius:var(--bs-border-radius)}.form-floating>.form-control-plaintext~label::after,.form-floating>.form-control:focus~label::after,.form-floating>.form-control:not(:placeholder-shown)~label::after,.form-floating>.form-select~label::after{position:absolute;inset:1rem 0.375rem;z-index:-1;height:1.5em;content:\"\";background-color:var(--bs-body-bg);border-radius:var(--bs-border-radius)}.form-floating>.form-control:-webkit-autofill~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control-plaintext~label{border-width:var(--bs-border-width) 0}.form-floating>.form-control:disabled~label,.form-floating>:disabled~label{color:#6c757d}.form-floating>.form-control:disabled~label::after,.form-floating>:disabled~label::after{background-color:var(--bs-secondary-bg)}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control,.input-group>.form-floating,.input-group>.form-select{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control:focus,.input-group>.form-floating:focus-within,.input-group>.form-select:focus{z-index:5}.input-group .btn{position:relative;z-index:2}.input-group .btn:focus{z-index:5}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);text-align:center;white-space:nowrap;background-color:var(--bs-tertiary-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius)}.input-group-lg>.btn,.input-group-lg>.form-control,.input-group-lg>.form-select,.input-group-lg>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}.input-group-sm>.btn,.input-group-sm>.form-control,.input-group-sm>.form-select,.input-group-sm>.input-group-text{padding:.25rem .5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.input-group-lg>.form-select,.input-group-sm>.form-select{padding-right:3rem}.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select,.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:0;border-bottom-right-radius:0}.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select,.input-group.has-validation>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:calc(var(--bs-border-width) * -1);border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.form-floating:not(:first-child)>.form-control,.input-group>.form-floating:not(:first-child)>.form-select{border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:var(--bs-form-valid-color)}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:var(--bs-success);border-radius:var(--bs-border-radius)}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:var(--bs-form-valid-border-color);padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:var(--bs-form-valid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid,.was-validated .form-select:valid{border-color:var(--bs-form-valid-border-color)}.form-select.is-valid:not([multiple]):not([size]),.form-select.is-valid:not([multiple])[size=\"1\"],.was-validated .form-select:valid:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"]{--bs-form-select-bg-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");padding-right:4.125rem;background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid:focus,.was-validated .form-select:valid:focus{border-color:var(--bs-form-valid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.form-control-color.is-valid,.was-validated .form-control-color:valid{width:calc(3rem + calc(1.5em + .75rem))}.form-check-input.is-valid,.was-validated .form-check-input:valid{border-color:var(--bs-form-valid-border-color)}.form-check-input.is-valid:checked,.was-validated .form-check-input:valid:checked{background-color:var(--bs-form-valid-color)}.form-check-input.is-valid:focus,.was-validated .form-check-input:valid:focus{box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:var(--bs-form-valid-color)}.form-check-inline .form-check-input~.valid-feedback{margin-left:.5em}.input-group>.form-control:not(:focus).is-valid,.input-group>.form-floating:not(:focus-within).is-valid,.input-group>.form-select:not(:focus).is-valid,.was-validated .input-group>.form-control:not(:focus):valid,.was-validated .input-group>.form-floating:not(:focus-within):valid,.was-validated .input-group>.form-select:not(:focus):valid{z-index:3}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:var(--bs-form-invalid-color)}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:var(--bs-danger);border-radius:var(--bs-border-radius)}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:var(--bs-form-invalid-border-color);padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:var(--bs-form-invalid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid,.was-validated .form-select:invalid{border-color:var(--bs-form-invalid-border-color)}.form-select.is-invalid:not([multiple]):not([size]),.form-select.is-invalid:not([multiple])[size=\"1\"],.was-validated .form-select:invalid:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"]{--bs-form-select-bg-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");padding-right:4.125rem;background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid:focus,.was-validated .form-select:invalid:focus{border-color:var(--bs-form-invalid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.form-control-color.is-invalid,.was-validated .form-control-color:invalid{width:calc(3rem + calc(1.5em + .75rem))}.form-check-input.is-invalid,.was-validated .form-check-input:invalid{border-color:var(--bs-form-invalid-border-color)}.form-check-input.is-invalid:checked,.was-validated .form-check-input:invalid:checked{background-color:var(--bs-form-invalid-color)}.form-check-input.is-invalid:focus,.was-validated .form-check-input:invalid:focus{box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:var(--bs-form-invalid-color)}.form-check-inline .form-check-input~.invalid-feedback{margin-left:.5em}.input-group>.form-control:not(:focus).is-invalid,.input-group>.form-floating:not(:focus-within).is-invalid,.input-group>.form-select:not(:focus).is-invalid,.was-validated .input-group>.form-control:not(:focus):invalid,.was-validated .input-group>.form-floating:not(:focus-within):invalid,.was-validated .input-group>.form-select:not(:focus):invalid{z-index:4}.btn{--bs-btn-padding-x:0.75rem;--bs-btn-padding-y:0.375rem;--bs-btn-font-family: ;--bs-btn-font-size:1rem;--bs-btn-font-weight:400;--bs-btn-line-height:1.5;--bs-btn-color:var(--bs-body-color);--bs-btn-bg:transparent;--bs-btn-border-width:var(--bs-border-width);--bs-btn-border-color:transparent;--bs-btn-border-radius:var(--bs-border-radius);--bs-btn-hover-border-color:transparent;--bs-btn-box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);--bs-btn-disabled-opacity:0.65;--bs-btn-focus-box-shadow:0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);display:inline-block;padding:var(--bs-btn-padding-y) var(--bs-btn-padding-x);font-family:var(--bs-btn-font-family);font-size:var(--bs-btn-font-size);font-weight:var(--bs-btn-font-weight);line-height:var(--bs-btn-line-height);color:var(--bs-btn-color);text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;border:var(--bs-btn-border-width) solid var(--bs-btn-border-color);border-radius:var(--bs-btn-border-radius);background-color:var(--bs-btn-bg);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color)}.btn-check+.btn:hover{color:var(--bs-btn-color);background-color:var(--bs-btn-bg);border-color:var(--bs-btn-border-color)}.btn:focus-visible{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:focus-visible+.btn{border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:checked+.btn,.btn.active,.btn.show,.btn:first-child:active,:not(.btn-check)+.btn:active{color:var(--bs-btn-active-color);background-color:var(--bs-btn-active-bg);border-color:var(--bs-btn-active-border-color)}.btn-check:checked+.btn:focus-visible,.btn.active:focus-visible,.btn.show:focus-visible,.btn:first-child:active:focus-visible,:not(.btn-check)+.btn:active:focus-visible{box-shadow:var(--bs-btn-focus-box-shadow)}.btn.disabled,.btn:disabled,fieldset:disabled .btn{color:var(--bs-btn-disabled-color);pointer-events:none;background-color:var(--bs-btn-disabled-bg);border-color:var(--bs-btn-disabled-border-color);opacity:var(--bs-btn-disabled-opacity)}.btn-primary{--bs-btn-color:#fff;--bs-btn-bg:#0d6efd;--bs-btn-border-color:#0d6efd;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#0b5ed7;--bs-btn-hover-border-color:#0a58ca;--bs-btn-focus-shadow-rgb:49,132,253;--bs-btn-active-color:#fff;--bs-btn-active-bg:#0a58ca;--bs-btn-active-border-color:#0a53be;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#0d6efd;--bs-btn-disabled-border-color:#0d6efd}.btn-secondary{--bs-btn-color:#fff;--bs-btn-bg:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#5c636a;--bs-btn-hover-border-color:#565e64;--bs-btn-focus-shadow-rgb:130,138,145;--bs-btn-active-color:#fff;--bs-btn-active-bg:#565e64;--bs-btn-active-border-color:#51585e;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#6c757d;--bs-btn-disabled-border-color:#6c757d}.btn-success{--bs-btn-color:#fff;--bs-btn-bg:#198754;--bs-btn-border-color:#198754;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#157347;--bs-btn-hover-border-color:#146c43;--bs-btn-focus-shadow-rgb:60,153,110;--bs-btn-active-color:#fff;--bs-btn-active-bg:#146c43;--bs-btn-active-border-color:#13653f;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#198754;--bs-btn-disabled-border-color:#198754}.btn-info{--bs-btn-color:#000;--bs-btn-bg:#0dcaf0;--bs-btn-border-color:#0dcaf0;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#31d2f2;--bs-btn-hover-border-color:#25cff2;--bs-btn-focus-shadow-rgb:11,172,204;--bs-btn-active-color:#000;--bs-btn-active-bg:#3dd5f3;--bs-btn-active-border-color:#25cff2;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#0dcaf0;--bs-btn-disabled-border-color:#0dcaf0}.btn-warning{--bs-btn-color:#000;--bs-btn-bg:#ffc107;--bs-btn-border-color:#ffc107;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#ffca2c;--bs-btn-hover-border-color:#ffc720;--bs-btn-focus-shadow-rgb:217,164,6;--bs-btn-active-color:#000;--bs-btn-active-bg:#ffcd39;--bs-btn-active-border-color:#ffc720;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#ffc107;--bs-btn-disabled-border-color:#ffc107}.btn-danger{--bs-btn-color:#fff;--bs-btn-bg:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#bb2d3b;--bs-btn-hover-border-color:#b02a37;--bs-btn-focus-shadow-rgb:225,83,97;--bs-btn-active-color:#fff;--bs-btn-active-bg:#b02a37;--bs-btn-active-border-color:#a52834;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#dc3545;--bs-btn-disabled-border-color:#dc3545}.btn-light{--bs-btn-color:#000;--bs-btn-bg:#f8f9fa;--bs-btn-border-color:#f8f9fa;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#d3d4d5;--bs-btn-hover-border-color:#c6c7c8;--bs-btn-focus-shadow-rgb:211,212,213;--bs-btn-active-color:#000;--bs-btn-active-bg:#c6c7c8;--bs-btn-active-border-color:#babbbc;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#f8f9fa;--bs-btn-disabled-border-color:#f8f9fa}.btn-dark{--bs-btn-color:#fff;--bs-btn-bg:#212529;--bs-btn-border-color:#212529;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#424649;--bs-btn-hover-border-color:#373b3e;--bs-btn-focus-shadow-rgb:66,70,73;--bs-btn-active-color:#fff;--bs-btn-active-bg:#4d5154;--bs-btn-active-border-color:#373b3e;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#212529;--bs-btn-disabled-border-color:#212529}.btn-outline-primary{--bs-btn-color:#0d6efd;--bs-btn-border-color:#0d6efd;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#0d6efd;--bs-btn-hover-border-color:#0d6efd;--bs-btn-focus-shadow-rgb:13,110,253;--bs-btn-active-color:#fff;--bs-btn-active-bg:#0d6efd;--bs-btn-active-border-color:#0d6efd;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#0d6efd;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#0d6efd;--bs-gradient:none}.btn-outline-secondary{--bs-btn-color:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#6c757d;--bs-btn-hover-border-color:#6c757d;--bs-btn-focus-shadow-rgb:108,117,125;--bs-btn-active-color:#fff;--bs-btn-active-bg:#6c757d;--bs-btn-active-border-color:#6c757d;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#6c757d;--bs-gradient:none}.btn-outline-success{--bs-btn-color:#198754;--bs-btn-border-color:#198754;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#198754;--bs-btn-hover-border-color:#198754;--bs-btn-focus-shadow-rgb:25,135,84;--bs-btn-active-color:#fff;--bs-btn-active-bg:#198754;--bs-btn-active-border-color:#198754;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#198754;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#198754;--bs-gradient:none}.btn-outline-info{--bs-btn-color:#0dcaf0;--bs-btn-border-color:#0dcaf0;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#0dcaf0;--bs-btn-hover-border-color:#0dcaf0;--bs-btn-focus-shadow-rgb:13,202,240;--bs-btn-active-color:#000;--bs-btn-active-bg:#0dcaf0;--bs-btn-active-border-color:#0dcaf0;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#0dcaf0;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#0dcaf0;--bs-gradient:none}.btn-outline-warning{--bs-btn-color:#ffc107;--bs-btn-border-color:#ffc107;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#ffc107;--bs-btn-hover-border-color:#ffc107;--bs-btn-focus-shadow-rgb:255,193,7;--bs-btn-active-color:#000;--bs-btn-active-bg:#ffc107;--bs-btn-active-border-color:#ffc107;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#ffc107;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#ffc107;--bs-gradient:none}.btn-outline-danger{--bs-btn-color:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#dc3545;--bs-btn-hover-border-color:#dc3545;--bs-btn-focus-shadow-rgb:220,53,69;--bs-btn-active-color:#fff;--bs-btn-active-bg:#dc3545;--bs-btn-active-border-color:#dc3545;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#dc3545;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#dc3545;--bs-gradient:none}.btn-outline-light{--bs-btn-color:#f8f9fa;--bs-btn-border-color:#f8f9fa;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#f8f9fa;--bs-btn-hover-border-color:#f8f9fa;--bs-btn-focus-shadow-rgb:248,249,250;--bs-btn-active-color:#000;--bs-btn-active-bg:#f8f9fa;--bs-btn-active-border-color:#f8f9fa;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#f8f9fa;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#f8f9fa;--bs-gradient:none}.btn-outline-dark{--bs-btn-color:#212529;--bs-btn-border-color:#212529;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#212529;--bs-btn-hover-border-color:#212529;--bs-btn-focus-shadow-rgb:33,37,41;--bs-btn-active-color:#fff;--bs-btn-active-bg:#212529;--bs-btn-active-border-color:#212529;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#212529;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#212529;--bs-gradient:none}.btn-link{--bs-btn-font-weight:400;--bs-btn-color:var(--bs-link-color);--bs-btn-bg:transparent;--bs-btn-border-color:transparent;--bs-btn-hover-color:var(--bs-link-hover-color);--bs-btn-hover-border-color:transparent;--bs-btn-active-color:var(--bs-link-hover-color);--bs-btn-active-border-color:transparent;--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-border-color:transparent;--bs-btn-box-shadow:0 0 0 #000;--bs-btn-focus-shadow-rgb:49,132,253;text-decoration:underline}.btn-link:focus-visible{color:var(--bs-btn-color)}.btn-link:hover{color:var(--bs-btn-hover-color)}.btn-group-lg>.btn,.btn-lg{--bs-btn-padding-y:0.5rem;--bs-btn-padding-x:1rem;--bs-btn-font-size:1.25rem;--bs-btn-border-radius:var(--bs-border-radius-lg)}.btn-group-sm>.btn,.btn-sm{--bs-btn-padding-y:0.25rem;--bs-btn-padding-x:0.5rem;--bs-btn-font-size:0.875rem;--bs-btn-border-radius:var(--bs-border-radius-sm)}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.collapsing.collapse-horizontal{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal{transition:none}}.dropdown,.dropdown-center,.dropend,.dropstart,.dropup,.dropup-center{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{--bs-dropdown-zindex:1000;--bs-dropdown-min-width:10rem;--bs-dropdown-padding-x:0;--bs-dropdown-padding-y:0.5rem;--bs-dropdown-spacer:0.125rem;--bs-dropdown-font-size:1rem;--bs-dropdown-color:var(--bs-body-color);--bs-dropdown-bg:var(--bs-body-bg);--bs-dropdown-border-color:var(--bs-border-color-translucent);--bs-dropdown-border-radius:var(--bs-border-radius);--bs-dropdown-border-width:var(--bs-border-width);--bs-dropdown-inner-border-radius:calc(var(--bs-border-radius) - var(--bs-border-width));--bs-dropdown-divider-bg:var(--bs-border-color-translucent);--bs-dropdown-divider-margin-y:0.5rem;--bs-dropdown-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-dropdown-link-color:var(--bs-body-color);--bs-dropdown-link-hover-color:var(--bs-body-color);--bs-dropdown-link-hover-bg:var(--bs-tertiary-bg);--bs-dropdown-link-active-color:#fff;--bs-dropdown-link-active-bg:#0d6efd;--bs-dropdown-link-disabled-color:var(--bs-tertiary-color);--bs-dropdown-item-padding-x:1rem;--bs-dropdown-item-padding-y:0.25rem;--bs-dropdown-header-color:#6c757d;--bs-dropdown-header-padding-x:1rem;--bs-dropdown-header-padding-y:0.5rem;position:absolute;z-index:var(--bs-dropdown-zindex);display:none;min-width:var(--bs-dropdown-min-width);padding:var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);margin:0;font-size:var(--bs-dropdown-font-size);color:var(--bs-dropdown-color);text-align:left;list-style:none;background-color:var(--bs-dropdown-bg);background-clip:padding-box;border:var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);border-radius:var(--bs-dropdown-border-radius)}.dropdown-menu[data-bs-popper]{top:100%;left:0;margin-top:var(--bs-dropdown-spacer)}.dropdown-menu-start{--bs-position:start}.dropdown-menu-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-end{--bs-position:end}.dropdown-menu-end[data-bs-popper]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-sm-end{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start{--bs-position:start}.dropdown-menu-md-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-md-end{--bs-position:end}.dropdown-menu-md-end[data-bs-popper]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-lg-end{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-xl-end{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-xxl-end{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper]{top:auto;bottom:100%;margin-top:0;margin-bottom:var(--bs-dropdown-spacer)}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropend .dropdown-menu[data-bs-popper]{top:0;right:auto;left:100%;margin-top:0;margin-left:var(--bs-dropdown-spacer)}.dropend .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle:empty::after{margin-left:0}.dropend .dropdown-toggle::after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper]{top:0;right:100%;left:auto;margin-top:0;margin-right:var(--bs-dropdown-spacer)}.dropstart .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropstart .dropdown-toggle::after{display:none}.dropstart .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle:empty::after{margin-left:0}.dropstart .dropdown-toggle::before{vertical-align:0}.dropdown-divider{height:0;margin:var(--bs-dropdown-divider-margin-y) 0;overflow:hidden;border-top:1px solid var(--bs-dropdown-divider-bg);opacity:1}.dropdown-item{display:block;width:100%;padding:var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);clear:both;font-weight:400;color:var(--bs-dropdown-link-color);text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0;border-radius:var(--bs-dropdown-item-border-radius,0)}.dropdown-item:focus,.dropdown-item:hover{color:var(--bs-dropdown-link-hover-color);background-color:var(--bs-dropdown-link-hover-bg)}.dropdown-item.active,.dropdown-item:active{color:var(--bs-dropdown-link-active-color);text-decoration:none;background-color:var(--bs-dropdown-link-active-bg)}.dropdown-item.disabled,.dropdown-item:disabled{color:var(--bs-dropdown-link-disabled-color);pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);margin-bottom:0;font-size:.875rem;color:var(--bs-dropdown-header-color);white-space:nowrap}.dropdown-item-text{display:block;padding:var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);color:var(--bs-dropdown-link-color)}.dropdown-menu-dark{--bs-dropdown-color:#dee2e6;--bs-dropdown-bg:#343a40;--bs-dropdown-border-color:var(--bs-border-color-translucent);--bs-dropdown-box-shadow: ;--bs-dropdown-link-color:#dee2e6;--bs-dropdown-link-hover-color:#fff;--bs-dropdown-divider-bg:var(--bs-border-color-translucent);--bs-dropdown-link-hover-bg:rgba(255, 255, 255, 0.15);--bs-dropdown-link-active-color:#fff;--bs-dropdown-link-active-bg:#0d6efd;--bs-dropdown-link-disabled-color:#adb5bd;--bs-dropdown-header-color:#adb5bd}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn,.btn-group-vertical>.btn-check:focus+.btn,.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn-check:checked+.btn,.btn-group>.btn-check:focus+.btn,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group{border-radius:var(--bs-border-radius)}.btn-group>.btn-group:not(:first-child),.btn-group>:not(.btn-check:first-child)+.btn{margin-left:calc(var(--bs-border-width) * -1)}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn.dropdown-toggle-split:first-child,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:nth-child(n+3),.btn-group>:not(.btn-check)+.btn{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropend .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropstart .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:calc(var(--bs-border-width) * -1)}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn~.btn{border-top-left-radius:0;border-top-right-radius:0}.nav{--bs-nav-link-padding-x:1rem;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-link-color);--bs-nav-link-hover-color:var(--bs-link-hover-color);--bs-nav-link-disabled-color:var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);font-size:var(--bs-nav-link-font-size);font-weight:var(--bs-nav-link-font-weight);color:var(--bs-nav-link-color);text-decoration:none;background:0 0;border:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link{transition:none}}.nav-link:focus,.nav-link:hover{color:var(--bs-nav-link-hover-color)}.nav-link:focus-visible{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.nav-link.disabled,.nav-link:disabled{color:var(--bs-nav-link-disabled-color);pointer-events:none;cursor:default}.nav-tabs{--bs-nav-tabs-border-width:var(--bs-border-width);--bs-nav-tabs-border-color:var(--bs-border-color);--bs-nav-tabs-border-radius:var(--bs-border-radius);--bs-nav-tabs-link-hover-border-color:var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);--bs-nav-tabs-link-active-color:var(--bs-emphasis-color);--bs-nav-tabs-link-active-bg:var(--bs-body-bg);--bs-nav-tabs-link-active-border-color:var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);border-bottom:var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)}.nav-tabs .nav-link{margin-bottom:calc(-1 * var(--bs-nav-tabs-border-width));border:var(--bs-nav-tabs-border-width) solid transparent;border-top-left-radius:var(--bs-nav-tabs-border-radius);border-top-right-radius:var(--bs-nav-tabs-border-radius)}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{isolation:isolate;border-color:var(--bs-nav-tabs-link-hover-border-color)}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:var(--bs-nav-tabs-link-active-color);background-color:var(--bs-nav-tabs-link-active-bg);border-color:var(--bs-nav-tabs-link-active-border-color)}.nav-tabs .dropdown-menu{margin-top:calc(-1 * var(--bs-nav-tabs-border-width));border-top-left-radius:0;border-top-right-radius:0}.nav-pills{--bs-nav-pills-border-radius:var(--bs-border-radius);--bs-nav-pills-link-active-color:#fff;--bs-nav-pills-link-active-bg:#0d6efd}.nav-pills .nav-link{border-radius:var(--bs-nav-pills-border-radius)}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:var(--bs-nav-pills-link-active-color);background-color:var(--bs-nav-pills-link-active-bg)}.nav-underline{--bs-nav-underline-gap:1rem;--bs-nav-underline-border-width:0.125rem;--bs-nav-underline-link-active-color:var(--bs-emphasis-color);gap:var(--bs-nav-underline-gap)}.nav-underline .nav-link{padding-right:0;padding-left:0;border-bottom:var(--bs-nav-underline-border-width) solid transparent}.nav-underline .nav-link:focus,.nav-underline .nav-link:hover{border-bottom-color:currentcolor}.nav-underline .nav-link.active,.nav-underline .show>.nav-link{font-weight:700;color:var(--bs-nav-underline-link-active-color);border-bottom-color:currentcolor}.nav-fill .nav-item,.nav-fill>.nav-link{flex:1 1 auto;text-align:center}.nav-justified .nav-item,.nav-justified>.nav-link{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link,.nav-justified .nav-item .nav-link{width:100%}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{--bs-navbar-padding-x:0;--bs-navbar-padding-y:0.5rem;--bs-navbar-color:rgba(var(--bs-emphasis-color-rgb), 0.65);--bs-navbar-hover-color:rgba(var(--bs-emphasis-color-rgb), 0.8);--bs-navbar-disabled-color:rgba(var(--bs-emphasis-color-rgb), 0.3);--bs-navbar-active-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-padding-y:0.3125rem;--bs-navbar-brand-margin-end:1rem;--bs-navbar-brand-font-size:1.25rem;--bs-navbar-brand-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-hover-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-nav-link-padding-x:0.5rem;--bs-navbar-toggler-padding-y:0.25rem;--bs-navbar-toggler-padding-x:0.75rem;--bs-navbar-toggler-font-size:1.25rem;--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");--bs-navbar-toggler-border-color:rgba(var(--bs-emphasis-color-rgb), 0.15);--bs-navbar-toggler-border-radius:var(--bs-border-radius);--bs-navbar-toggler-focus-width:0.25rem;--bs-navbar-toggler-transition:box-shadow 0.15s ease-in-out;position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)}.navbar>.container,.navbar>.container-fluid,.navbar>.container-lg,.navbar>.container-md,.navbar>.container-sm,.navbar>.container-xl,.navbar>.container-xxl{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand{padding-top:var(--bs-navbar-brand-padding-y);padding-bottom:var(--bs-navbar-brand-padding-y);margin-right:var(--bs-navbar-brand-margin-end);font-size:var(--bs-navbar-brand-font-size);color:var(--bs-navbar-brand-color);text-decoration:none;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{color:var(--bs-navbar-brand-hover-color)}.navbar-nav{--bs-nav-link-padding-x:0;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-navbar-color);--bs-nav-link-hover-color:var(--bs-navbar-hover-color);--bs-nav-link-disabled-color:var(--bs-navbar-disabled-color);display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link.active,.navbar-nav .nav-link.show{color:var(--bs-navbar-active-color)}.navbar-nav .dropdown-menu{position:static}.navbar-text{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-navbar-color)}.navbar-text a,.navbar-text a:focus,.navbar-text a:hover{color:var(--bs-navbar-active-color)}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);font-size:var(--bs-navbar-toggler-font-size);line-height:1;color:var(--bs-navbar-color);background-color:transparent;border:var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);border-radius:var(--bs-navbar-toggler-border-radius);transition:var(--bs-navbar-toggler-transition)}@media (prefers-reduced-motion:reduce){.navbar-toggler{transition:none}}.navbar-toggler:hover{text-decoration:none}.navbar-toggler:focus{text-decoration:none;outline:0;box-shadow:0 0 0 var(--bs-navbar-toggler-focus-width)}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-image:var(--bs-navbar-toggler-icon-bg);background-repeat:no-repeat;background-position:center;background-size:100%}.navbar-nav-scroll{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-sm .offcanvas .offcanvas-header{display:none}.navbar-expand-sm .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-md .offcanvas .offcanvas-header{display:none}.navbar-expand-md .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-lg .offcanvas .offcanvas-header{display:none}.navbar-expand-lg .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-xl .offcanvas .offcanvas-header{display:none}.navbar-expand-xl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xxl .navbar-nav-scroll{overflow:visible}.navbar-expand-xxl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler{display:none}.navbar-expand-xxl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-xxl .offcanvas .offcanvas-header{display:none}.navbar-expand-xxl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand .offcanvas .offcanvas-header{display:none}.navbar-expand .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-dark,.navbar[data-bs-theme=dark]{--bs-navbar-color:rgba(255, 255, 255, 0.55);--bs-navbar-hover-color:rgba(255, 255, 255, 0.75);--bs-navbar-disabled-color:rgba(255, 255, 255, 0.25);--bs-navbar-active-color:#fff;--bs-navbar-brand-color:#fff;--bs-navbar-brand-hover-color:#fff;--bs-navbar-toggler-border-color:rgba(255, 255, 255, 0.1);--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}[data-bs-theme=dark] .navbar-toggler-icon{--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.card{--bs-card-spacer-y:1rem;--bs-card-spacer-x:1rem;--bs-card-title-spacer-y:0.5rem;--bs-card-title-color: ;--bs-card-subtitle-color: ;--bs-card-border-width:var(--bs-border-width);--bs-card-border-color:var(--bs-border-color-translucent);--bs-card-border-radius:var(--bs-border-radius);--bs-card-box-shadow: ;--bs-card-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-card-cap-padding-y:0.5rem;--bs-card-cap-padding-x:1rem;--bs-card-cap-bg:rgba(var(--bs-body-color-rgb), 0.03);--bs-card-cap-color: ;--bs-card-height: ;--bs-card-color: ;--bs-card-bg:var(--bs-body-bg);--bs-card-img-overlay-padding:1rem;--bs-card-group-margin:0.75rem;position:relative;display:flex;flex-direction:column;min-width:0;height:var(--bs-card-height);color:var(--bs-body-color);word-wrap:break-word;background-color:var(--bs-card-bg);background-clip:border-box;border:var(--bs-card-border-width) solid var(--bs-card-border-color);border-radius:var(--bs-card-border-radius)}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{flex:1 1 auto;padding:var(--bs-card-spacer-y) var(--bs-card-spacer-x);color:var(--bs-card-color)}.card-title{margin-bottom:var(--bs-card-title-spacer-y);color:var(--bs-card-title-color)}.card-subtitle{margin-top:calc(-.5 * var(--bs-card-title-spacer-y));margin-bottom:0;color:var(--bs-card-subtitle-color)}.card-text:last-child{margin-bottom:0}.card-link+.card-link{margin-left:var(--bs-card-spacer-x)}.card-header{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);margin-bottom:0;color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-bottom:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-header:first-child{border-radius:var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0}.card-footer{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-top:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-footer:last-child{border-radius:0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)}.card-header-tabs{margin-right:calc(-.5 * var(--bs-card-cap-padding-x));margin-bottom:calc(-1 * var(--bs-card-cap-padding-y));margin-left:calc(-.5 * var(--bs-card-cap-padding-x));border-bottom:0}.card-header-tabs .nav-link.active{background-color:var(--bs-card-bg);border-bottom-color:var(--bs-card-bg)}.card-header-pills{margin-right:calc(-.5 * var(--bs-card-cap-padding-x));margin-left:calc(-.5 * var(--bs-card-cap-padding-x))}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:var(--bs-card-img-overlay-padding);border-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-bottom,.card-img-top{width:100%}.card-img,.card-img-top{border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-bottom{border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card-group>.card{margin-bottom:var(--bs-card-group-margin)}@media (min-width:576px){.card-group{display:flex;flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.accordion{--bs-accordion-color:var(--bs-body-color);--bs-accordion-bg:var(--bs-body-bg);--bs-accordion-transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;--bs-accordion-border-color:var(--bs-border-color);--bs-accordion-border-width:var(--bs-border-width);--bs-accordion-border-radius:var(--bs-border-radius);--bs-accordion-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-accordion-btn-padding-x:1.25rem;--bs-accordion-btn-padding-y:1rem;--bs-accordion-btn-color:var(--bs-body-color);--bs-accordion-btn-bg:var(--bs-accordion-bg);--bs-accordion-btn-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-icon-width:1.25rem;--bs-accordion-btn-icon-transform:rotate(-180deg);--bs-accordion-btn-icon-transition:transform 0.2s ease-in-out;--bs-accordion-btn-active-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23052c65'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-focus-border-color:#86b7fe;--bs-accordion-btn-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-accordion-body-padding-x:1.25rem;--bs-accordion-body-padding-y:1rem;--bs-accordion-active-color:var(--bs-primary-text-emphasis);--bs-accordion-active-bg:var(--bs-primary-bg-subtle)}.accordion-button{position:relative;display:flex;align-items:center;width:100%;padding:var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);font-size:1rem;color:var(--bs-accordion-btn-color);text-align:left;background-color:var(--bs-accordion-btn-bg);border:0;border-radius:0;overflow-anchor:none;transition:var(--bs-accordion-transition)}@media (prefers-reduced-motion:reduce){.accordion-button{transition:none}}.accordion-button:not(.collapsed){color:var(--bs-accordion-active-color);background-color:var(--bs-accordion-active-bg);box-shadow:inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color)}.accordion-button:not(.collapsed)::after{background-image:var(--bs-accordion-btn-active-icon);transform:var(--bs-accordion-btn-icon-transform)}.accordion-button::after{flex-shrink:0;width:var(--bs-accordion-btn-icon-width);height:var(--bs-accordion-btn-icon-width);margin-left:auto;content:\"\";background-image:var(--bs-accordion-btn-icon);background-repeat:no-repeat;background-size:var(--bs-accordion-btn-icon-width);transition:var(--bs-accordion-btn-icon-transition)}@media (prefers-reduced-motion:reduce){.accordion-button::after{transition:none}}.accordion-button:hover{z-index:2}.accordion-button:focus{z-index:3;border-color:var(--bs-accordion-btn-focus-border-color);outline:0;box-shadow:var(--bs-accordion-btn-focus-box-shadow)}.accordion-header{margin-bottom:0}.accordion-item{color:var(--bs-accordion-color);background-color:var(--bs-accordion-bg);border:var(--bs-accordion-border-width) solid var(--bs-accordion-border-color)}.accordion-item:first-of-type{border-top-left-radius:var(--bs-accordion-border-radius);border-top-right-radius:var(--bs-accordion-border-radius)}.accordion-item:first-of-type .accordion-button{border-top-left-radius:var(--bs-accordion-inner-border-radius);border-top-right-radius:var(--bs-accordion-inner-border-radius)}.accordion-item:not(:first-of-type){border-top:0}.accordion-item:last-of-type{border-bottom-right-radius:var(--bs-accordion-border-radius);border-bottom-left-radius:var(--bs-accordion-border-radius)}.accordion-item:last-of-type .accordion-button.collapsed{border-bottom-right-radius:var(--bs-accordion-inner-border-radius);border-bottom-left-radius:var(--bs-accordion-inner-border-radius)}.accordion-item:last-of-type .accordion-collapse{border-bottom-right-radius:var(--bs-accordion-border-radius);border-bottom-left-radius:var(--bs-accordion-border-radius)}.accordion-body{padding:var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x)}.accordion-flush .accordion-collapse{border-width:0}.accordion-flush .accordion-item{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item:first-child{border-top:0}.accordion-flush .accordion-item:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button,.accordion-flush .accordion-item .accordion-button.collapsed{border-radius:0}[data-bs-theme=dark] .accordion-button::after{--bs-accordion-btn-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-active-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")}.breadcrumb{--bs-breadcrumb-padding-x:0;--bs-breadcrumb-padding-y:0;--bs-breadcrumb-margin-bottom:1rem;--bs-breadcrumb-bg: ;--bs-breadcrumb-border-radius: ;--bs-breadcrumb-divider-color:var(--bs-secondary-color);--bs-breadcrumb-item-padding-x:0.5rem;--bs-breadcrumb-item-active-color:var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding:var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);margin-bottom:var(--bs-breadcrumb-margin-bottom);font-size:var(--bs-breadcrumb-font-size);list-style:none;background-color:var(--bs-breadcrumb-bg);border-radius:var(--bs-breadcrumb-border-radius)}.breadcrumb-item+.breadcrumb-item{padding-left:var(--bs-breadcrumb-item-padding-x)}.breadcrumb-item+.breadcrumb-item::before{float:left;padding-right:var(--bs-breadcrumb-item-padding-x);color:var(--bs-breadcrumb-divider-color);content:var(--bs-breadcrumb-divider, \"/\")}.breadcrumb-item.active{color:var(--bs-breadcrumb-item-active-color)}.pagination{--bs-pagination-padding-x:0.75rem;--bs-pagination-padding-y:0.375rem;--bs-pagination-font-size:1rem;--bs-pagination-color:var(--bs-link-color);--bs-pagination-bg:var(--bs-body-bg);--bs-pagination-border-width:var(--bs-border-width);--bs-pagination-border-color:var(--bs-border-color);--bs-pagination-border-radius:var(--bs-border-radius);--bs-pagination-hover-color:var(--bs-link-hover-color);--bs-pagination-hover-bg:var(--bs-tertiary-bg);--bs-pagination-hover-border-color:var(--bs-border-color);--bs-pagination-focus-color:var(--bs-link-hover-color);--bs-pagination-focus-bg:var(--bs-secondary-bg);--bs-pagination-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-pagination-active-color:#fff;--bs-pagination-active-bg:#0d6efd;--bs-pagination-active-border-color:#0d6efd;--bs-pagination-disabled-color:var(--bs-secondary-color);--bs-pagination-disabled-bg:var(--bs-secondary-bg);--bs-pagination-disabled-border-color:var(--bs-border-color);display:flex;padding-left:0;list-style:none}.page-link{position:relative;display:block;padding:var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);font-size:var(--bs-pagination-font-size);color:var(--bs-pagination-color);text-decoration:none;background-color:var(--bs-pagination-bg);border:var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link{transition:none}}.page-link:hover{z-index:2;color:var(--bs-pagination-hover-color);background-color:var(--bs-pagination-hover-bg);border-color:var(--bs-pagination-hover-border-color)}.page-link:focus{z-index:3;color:var(--bs-pagination-focus-color);background-color:var(--bs-pagination-focus-bg);outline:0;box-shadow:var(--bs-pagination-focus-box-shadow)}.active>.page-link,.page-link.active{z-index:3;color:var(--bs-pagination-active-color);background-color:var(--bs-pagination-active-bg);border-color:var(--bs-pagination-active-border-color)}.disabled>.page-link,.page-link.disabled{color:var(--bs-pagination-disabled-color);pointer-events:none;background-color:var(--bs-pagination-disabled-bg);border-color:var(--bs-pagination-disabled-border-color)}.page-item:not(:first-child) .page-link{margin-left:calc(var(--bs-border-width) * -1)}.page-item:first-child .page-link{border-top-left-radius:var(--bs-pagination-border-radius);border-bottom-left-radius:var(--bs-pagination-border-radius)}.page-item:last-child .page-link{border-top-right-radius:var(--bs-pagination-border-radius);border-bottom-right-radius:var(--bs-pagination-border-radius)}.pagination-lg{--bs-pagination-padding-x:1.5rem;--bs-pagination-padding-y:0.75rem;--bs-pagination-font-size:1.25rem;--bs-pagination-border-radius:var(--bs-border-radius-lg)}.pagination-sm{--bs-pagination-padding-x:0.5rem;--bs-pagination-padding-y:0.25rem;--bs-pagination-font-size:0.875rem;--bs-pagination-border-radius:var(--bs-border-radius-sm)}.badge{--bs-badge-padding-x:0.65em;--bs-badge-padding-y:0.35em;--bs-badge-font-size:0.75em;--bs-badge-font-weight:700;--bs-badge-color:#fff;--bs-badge-border-radius:var(--bs-border-radius);display:inline-block;padding:var(--bs-badge-padding-y) var(--bs-badge-padding-x);font-size:var(--bs-badge-font-size);font-weight:var(--bs-badge-font-weight);line-height:1;color:var(--bs-badge-color);text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:var(--bs-badge-border-radius)}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.alert{--bs-alert-bg:transparent;--bs-alert-padding-x:1rem;--bs-alert-padding-y:1rem;--bs-alert-margin-bottom:1rem;--bs-alert-color:inherit;--bs-alert-border-color:transparent;--bs-alert-border:var(--bs-border-width) solid var(--bs-alert-border-color);--bs-alert-border-radius:var(--bs-border-radius);--bs-alert-link-color:inherit;position:relative;padding:var(--bs-alert-padding-y) var(--bs-alert-padding-x);margin-bottom:var(--bs-alert-margin-bottom);color:var(--bs-alert-color);background-color:var(--bs-alert-bg);border:var(--bs-alert-border);border-radius:var(--bs-alert-border-radius)}.alert-heading{color:inherit}.alert-link{font-weight:700;color:var(--bs-alert-link-color)}.alert-dismissible{padding-right:3rem}.alert-dismissible .btn-close{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary{--bs-alert-color:var(--bs-primary-text-emphasis);--bs-alert-bg:var(--bs-primary-bg-subtle);--bs-alert-border-color:var(--bs-primary-border-subtle);--bs-alert-link-color:var(--bs-primary-text-emphasis)}.alert-secondary{--bs-alert-color:var(--bs-secondary-text-emphasis);--bs-alert-bg:var(--bs-secondary-bg-subtle);--bs-alert-border-color:var(--bs-secondary-border-subtle);--bs-alert-link-color:var(--bs-secondary-text-emphasis)}.alert-success{--bs-alert-color:var(--bs-success-text-emphasis);--bs-alert-bg:var(--bs-success-bg-subtle);--bs-alert-border-color:var(--bs-success-border-subtle);--bs-alert-link-color:var(--bs-success-text-emphasis)}.alert-info{--bs-alert-color:var(--bs-info-text-emphasis);--bs-alert-bg:var(--bs-info-bg-subtle);--bs-alert-border-color:var(--bs-info-border-subtle);--bs-alert-link-color:var(--bs-info-text-emphasis)}.alert-warning{--bs-alert-color:var(--bs-warning-text-emphasis);--bs-alert-bg:var(--bs-warning-bg-subtle);--bs-alert-border-color:var(--bs-warning-border-subtle);--bs-alert-link-color:var(--bs-warning-text-emphasis)}.alert-danger{--bs-alert-color:var(--bs-danger-text-emphasis);--bs-alert-bg:var(--bs-danger-bg-subtle);--bs-alert-border-color:var(--bs-danger-border-subtle);--bs-alert-link-color:var(--bs-danger-text-emphasis)}.alert-light{--bs-alert-color:var(--bs-light-text-emphasis);--bs-alert-bg:var(--bs-light-bg-subtle);--bs-alert-border-color:var(--bs-light-border-subtle);--bs-alert-link-color:var(--bs-light-text-emphasis)}.alert-dark{--bs-alert-color:var(--bs-dark-text-emphasis);--bs-alert-bg:var(--bs-dark-bg-subtle);--bs-alert-border-color:var(--bs-dark-border-subtle);--bs-alert-link-color:var(--bs-dark-text-emphasis)}@keyframes progress-bar-stripes{0%{background-position-x:1rem}}.progress,.progress-stacked{--bs-progress-height:1rem;--bs-progress-font-size:0.75rem;--bs-progress-bg:var(--bs-secondary-bg);--bs-progress-border-radius:var(--bs-border-radius);--bs-progress-box-shadow:var(--bs-box-shadow-inset);--bs-progress-bar-color:#fff;--bs-progress-bar-bg:#0d6efd;--bs-progress-bar-transition:width 0.6s ease;display:flex;height:var(--bs-progress-height);overflow:hidden;font-size:var(--bs-progress-font-size);background-color:var(--bs-progress-bg);border-radius:var(--bs-progress-border-radius)}.progress-bar{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:var(--bs-progress-bar-color);text-align:center;white-space:nowrap;background-color:var(--bs-progress-bar-bg);transition:var(--bs-progress-bar-transition)}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:var(--bs-progress-height) var(--bs-progress-height)}.progress-stacked>.progress{overflow:visible}.progress-stacked>.progress>.progress-bar{width:100%}.progress-bar-animated{animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion:reduce){.progress-bar-animated{animation:none}}.list-group{--bs-list-group-color:var(--bs-body-color);--bs-list-group-bg:var(--bs-body-bg);--bs-list-group-border-color:var(--bs-border-color);--bs-list-group-border-width:var(--bs-border-width);--bs-list-group-border-radius:var(--bs-border-radius);--bs-list-group-item-padding-x:1rem;--bs-list-group-item-padding-y:0.5rem;--bs-list-group-action-color:var(--bs-secondary-color);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-tertiary-bg);--bs-list-group-action-active-color:var(--bs-body-color);--bs-list-group-action-active-bg:var(--bs-secondary-bg);--bs-list-group-disabled-color:var(--bs-secondary-color);--bs-list-group-disabled-bg:var(--bs-body-bg);--bs-list-group-active-color:#fff;--bs-list-group-active-bg:#0d6efd;--bs-list-group-active-border-color:#0d6efd;display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:var(--bs-list-group-border-radius)}.list-group-numbered{list-style-type:none;counter-reset:section}.list-group-numbered>.list-group-item::before{content:counters(section, \".\") \". \";counter-increment:section}.list-group-item-action{width:100%;color:var(--bs-list-group-action-color);text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:var(--bs-list-group-action-hover-color);text-decoration:none;background-color:var(--bs-list-group-action-hover-bg)}.list-group-item-action:active{color:var(--bs-list-group-action-active-color);background-color:var(--bs-list-group-action-active-bg)}.list-group-item{position:relative;display:block;padding:var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);color:var(--bs-list-group-color);text-decoration:none;background-color:var(--bs-list-group-bg);border:var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:var(--bs-list-group-disabled-color);pointer-events:none;background-color:var(--bs-list-group-disabled-bg)}.list-group-item.active{z-index:2;color:var(--bs-list-group-active-color);background-color:var(--bs-list-group-active-bg);border-color:var(--bs-list-group-active-border-color)}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:calc(-1 * var(--bs-list-group-border-width));border-top-width:var(--bs-list-group-border-width)}.list-group-horizontal{flex-direction:row}.list-group-horizontal>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}@media (min-width:576px){.list-group-horizontal-sm{flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:768px){.list-group-horizontal-md{flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:992px){.list-group-horizontal-lg{flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:1200px){.list-group-horizontal-xl{flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:1400px){.list-group-horizontal-xxl{flex-direction:row}.list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 var(--bs-list-group-border-width)}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{--bs-list-group-color:var(--bs-primary-text-emphasis);--bs-list-group-bg:var(--bs-primary-bg-subtle);--bs-list-group-border-color:var(--bs-primary-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-primary-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-primary-border-subtle);--bs-list-group-active-color:var(--bs-primary-bg-subtle);--bs-list-group-active-bg:var(--bs-primary-text-emphasis);--bs-list-group-active-border-color:var(--bs-primary-text-emphasis)}.list-group-item-secondary{--bs-list-group-color:var(--bs-secondary-text-emphasis);--bs-list-group-bg:var(--bs-secondary-bg-subtle);--bs-list-group-border-color:var(--bs-secondary-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-secondary-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-secondary-border-subtle);--bs-list-group-active-color:var(--bs-secondary-bg-subtle);--bs-list-group-active-bg:var(--bs-secondary-text-emphasis);--bs-list-group-active-border-color:var(--bs-secondary-text-emphasis)}.list-group-item-success{--bs-list-group-color:var(--bs-success-text-emphasis);--bs-list-group-bg:var(--bs-success-bg-subtle);--bs-list-group-border-color:var(--bs-success-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-success-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-success-border-subtle);--bs-list-group-active-color:var(--bs-success-bg-subtle);--bs-list-group-active-bg:var(--bs-success-text-emphasis);--bs-list-group-active-border-color:var(--bs-success-text-emphasis)}.list-group-item-info{--bs-list-group-color:var(--bs-info-text-emphasis);--bs-list-group-bg:var(--bs-info-bg-subtle);--bs-list-group-border-color:var(--bs-info-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-info-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-info-border-subtle);--bs-list-group-active-color:var(--bs-info-bg-subtle);--bs-list-group-active-bg:var(--bs-info-text-emphasis);--bs-list-group-active-border-color:var(--bs-info-text-emphasis)}.list-group-item-warning{--bs-list-group-color:var(--bs-warning-text-emphasis);--bs-list-group-bg:var(--bs-warning-bg-subtle);--bs-list-group-border-color:var(--bs-warning-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-warning-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-warning-border-subtle);--bs-list-group-active-color:var(--bs-warning-bg-subtle);--bs-list-group-active-bg:var(--bs-warning-text-emphasis);--bs-list-group-active-border-color:var(--bs-warning-text-emphasis)}.list-group-item-danger{--bs-list-group-color:var(--bs-danger-text-emphasis);--bs-list-group-bg:var(--bs-danger-bg-subtle);--bs-list-group-border-color:var(--bs-danger-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-danger-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-danger-border-subtle);--bs-list-group-active-color:var(--bs-danger-bg-subtle);--bs-list-group-active-bg:var(--bs-danger-text-emphasis);--bs-list-group-active-border-color:var(--bs-danger-text-emphasis)}.list-group-item-light{--bs-list-group-color:var(--bs-light-text-emphasis);--bs-list-group-bg:var(--bs-light-bg-subtle);--bs-list-group-border-color:var(--bs-light-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-light-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-light-border-subtle);--bs-list-group-active-color:var(--bs-light-bg-subtle);--bs-list-group-active-bg:var(--bs-light-text-emphasis);--bs-list-group-active-border-color:var(--bs-light-text-emphasis)}.list-group-item-dark{--bs-list-group-color:var(--bs-dark-text-emphasis);--bs-list-group-bg:var(--bs-dark-bg-subtle);--bs-list-group-border-color:var(--bs-dark-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-dark-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-dark-border-subtle);--bs-list-group-active-color:var(--bs-dark-bg-subtle);--bs-list-group-active-bg:var(--bs-dark-text-emphasis);--bs-list-group-active-border-color:var(--bs-dark-text-emphasis)}.btn-close{--bs-btn-close-color:#000;--bs-btn-close-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");--bs-btn-close-opacity:0.5;--bs-btn-close-hover-opacity:0.75;--bs-btn-close-focus-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-btn-close-focus-opacity:1;--bs-btn-close-disabled-opacity:0.25;--bs-btn-close-white-filter:invert(1) grayscale(100%) brightness(200%);box-sizing:content-box;width:1em;height:1em;padding:.25em .25em;color:var(--bs-btn-close-color);background:transparent var(--bs-btn-close-bg) center/1em auto no-repeat;border:0;border-radius:.375rem;opacity:var(--bs-btn-close-opacity)}.btn-close:hover{color:var(--bs-btn-close-color);text-decoration:none;opacity:var(--bs-btn-close-hover-opacity)}.btn-close:focus{outline:0;box-shadow:var(--bs-btn-close-focus-shadow);opacity:var(--bs-btn-close-focus-opacity)}.btn-close.disabled,.btn-close:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:var(--bs-btn-close-disabled-opacity)}.btn-close-white{filter:var(--bs-btn-close-white-filter)}[data-bs-theme=dark] .btn-close{filter:var(--bs-btn-close-white-filter)}.toast{--bs-toast-zindex:1090;--bs-toast-padding-x:0.75rem;--bs-toast-padding-y:0.5rem;--bs-toast-spacing:1.5rem;--bs-toast-max-width:350px;--bs-toast-font-size:0.875rem;--bs-toast-color: ;--bs-toast-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-border-width:var(--bs-border-width);--bs-toast-border-color:var(--bs-border-color-translucent);--bs-toast-border-radius:var(--bs-border-radius);--bs-toast-box-shadow:var(--bs-box-shadow);--bs-toast-header-color:var(--bs-secondary-color);--bs-toast-header-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-header-border-color:var(--bs-border-color-translucent);width:var(--bs-toast-max-width);max-width:100%;font-size:var(--bs-toast-font-size);color:var(--bs-toast-color);pointer-events:auto;background-color:var(--bs-toast-bg);background-clip:padding-box;border:var(--bs-toast-border-width) solid var(--bs-toast-border-color);box-shadow:var(--bs-toast-box-shadow);border-radius:var(--bs-toast-border-radius)}.toast.showing{opacity:0}.toast:not(.show){display:none}.toast-container{--bs-toast-zindex:1090;position:absolute;z-index:var(--bs-toast-zindex);width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container>:not(:last-child){margin-bottom:var(--bs-toast-spacing)}.toast-header{display:flex;align-items:center;padding:var(--bs-toast-padding-y) var(--bs-toast-padding-x);color:var(--bs-toast-header-color);background-color:var(--bs-toast-header-bg);background-clip:padding-box;border-bottom:var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);border-top-left-radius:calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));border-top-right-radius:calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width))}.toast-header .btn-close{margin-right:calc(-.5 * var(--bs-toast-padding-x));margin-left:var(--bs-toast-padding-x)}.toast-body{padding:var(--bs-toast-padding-x);word-wrap:break-word}.modal{--bs-modal-zindex:1055;--bs-modal-width:500px;--bs-modal-padding:1rem;--bs-modal-margin:0.5rem;--bs-modal-color: ;--bs-modal-bg:var(--bs-body-bg);--bs-modal-border-color:var(--bs-border-color-translucent);--bs-modal-border-width:var(--bs-border-width);--bs-modal-border-radius:var(--bs-border-radius-lg);--bs-modal-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-modal-inner-border-radius:calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));--bs-modal-header-padding-x:1rem;--bs-modal-header-padding-y:1rem;--bs-modal-header-padding:1rem 1rem;--bs-modal-header-border-color:var(--bs-border-color);--bs-modal-header-border-width:var(--bs-border-width);--bs-modal-title-line-height:1.5;--bs-modal-footer-gap:0.5rem;--bs-modal-footer-bg: ;--bs-modal-footer-border-color:var(--bs-border-color);--bs-modal-footer-border-width:var(--bs-border-width);position:fixed;top:0;left:0;z-index:var(--bs-modal-zindex);display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog{position:relative;width:auto;margin:var(--bs-modal-margin);pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{transform:none}.modal.modal-static .modal-dialog{transform:scale(1.02)}.modal-dialog-scrollable{height:calc(100% - var(--bs-modal-margin) * 2)}.modal-dialog-scrollable .modal-content{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - var(--bs-modal-margin) * 2)}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;color:var(--bs-modal-color);pointer-events:auto;background-color:var(--bs-modal-bg);background-clip:padding-box;border:var(--bs-modal-border-width) solid var(--bs-modal-border-color);border-radius:var(--bs-modal-border-radius);outline:0}.modal-backdrop{--bs-backdrop-zindex:1050;--bs-backdrop-bg:#000;--bs-backdrop-opacity:0.5;position:fixed;top:0;left:0;z-index:var(--bs-backdrop-zindex);width:100vw;height:100vh;background-color:var(--bs-backdrop-bg)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--bs-backdrop-opacity)}.modal-header{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:var(--bs-modal-header-padding);border-bottom:var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);border-top-left-radius:var(--bs-modal-inner-border-radius);border-top-right-radius:var(--bs-modal-inner-border-radius)}.modal-header .btn-close{padding:calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);margin:calc(-.5 * var(--bs-modal-header-padding-y)) calc(-.5 * var(--bs-modal-header-padding-x)) calc(-.5 * var(--bs-modal-header-padding-y)) auto}.modal-title{margin-bottom:0;line-height:var(--bs-modal-title-line-height)}.modal-body{position:relative;flex:1 1 auto;padding:var(--bs-modal-padding)}.modal-footer{display:flex;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);background-color:var(--bs-modal-footer-bg);border-top:var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);border-bottom-right-radius:var(--bs-modal-inner-border-radius);border-bottom-left-radius:var(--bs-modal-inner-border-radius)}.modal-footer>*{margin:calc(var(--bs-modal-footer-gap) * .5)}@media (min-width:576px){.modal{--bs-modal-margin:1.75rem;--bs-modal-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15)}.modal-dialog{max-width:var(--bs-modal-width);margin-right:auto;margin-left:auto}.modal-sm{--bs-modal-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{--bs-modal-width:800px}}@media (min-width:1200px){.modal-xl{--bs-modal-width:1140px}}.modal-fullscreen{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-footer,.modal-fullscreen .modal-header{border-radius:0}.modal-fullscreen .modal-body{overflow-y:auto}@media (max-width:575.98px){.modal-fullscreen-sm-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-footer,.modal-fullscreen-sm-down .modal-header{border-radius:0}.modal-fullscreen-sm-down .modal-body{overflow-y:auto}}@media (max-width:767.98px){.modal-fullscreen-md-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-footer,.modal-fullscreen-md-down .modal-header{border-radius:0}.modal-fullscreen-md-down .modal-body{overflow-y:auto}}@media (max-width:991.98px){.modal-fullscreen-lg-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-footer,.modal-fullscreen-lg-down .modal-header{border-radius:0}.modal-fullscreen-lg-down .modal-body{overflow-y:auto}}@media (max-width:1199.98px){.modal-fullscreen-xl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-footer,.modal-fullscreen-xl-down .modal-header{border-radius:0}.modal-fullscreen-xl-down .modal-body{overflow-y:auto}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-footer,.modal-fullscreen-xxl-down .modal-header{border-radius:0}.modal-fullscreen-xxl-down .modal-body{overflow-y:auto}}.tooltip{--bs-tooltip-zindex:1080;--bs-tooltip-max-width:200px;--bs-tooltip-padding-x:0.5rem;--bs-tooltip-padding-y:0.25rem;--bs-tooltip-margin: ;--bs-tooltip-font-size:0.875rem;--bs-tooltip-color:var(--bs-body-bg);--bs-tooltip-bg:var(--bs-emphasis-color);--bs-tooltip-border-radius:var(--bs-border-radius);--bs-tooltip-opacity:0.9;--bs-tooltip-arrow-width:0.8rem;--bs-tooltip-arrow-height:0.4rem;z-index:var(--bs-tooltip-zindex);display:block;margin:var(--bs-tooltip-margin);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-tooltip-font-size);word-wrap:break-word;opacity:0}.tooltip.show{opacity:var(--bs-tooltip-opacity)}.tooltip .tooltip-arrow{display:block;width:var(--bs-tooltip-arrow-width);height:var(--bs-tooltip-arrow-height)}.tooltip .tooltip-arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,.bs-tooltip-top .tooltip-arrow{bottom:calc(-1 * var(--bs-tooltip-arrow-height))}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,.bs-tooltip-top .tooltip-arrow::before{top:-1px;border-width:var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;border-top-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,.bs-tooltip-end .tooltip-arrow{left:calc(-1 * var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,.bs-tooltip-end .tooltip-arrow::before{right:-1px;border-width:calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;border-right-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,.bs-tooltip-bottom .tooltip-arrow{top:calc(-1 * var(--bs-tooltip-arrow-height))}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,.bs-tooltip-bottom .tooltip-arrow::before{bottom:-1px;border-width:0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);border-bottom-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,.bs-tooltip-start .tooltip-arrow{right:calc(-1 * var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,.bs-tooltip-start .tooltip-arrow::before{left:-1px;border-width:calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);border-left-color:var(--bs-tooltip-bg)}.tooltip-inner{max-width:var(--bs-tooltip-max-width);padding:var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);color:var(--bs-tooltip-color);text-align:center;background-color:var(--bs-tooltip-bg);border-radius:var(--bs-tooltip-border-radius)}.popover{--bs-popover-zindex:1070;--bs-popover-max-width:276px;--bs-popover-font-size:0.875rem;--bs-popover-bg:var(--bs-body-bg);--bs-popover-border-width:var(--bs-border-width);--bs-popover-border-color:var(--bs-border-color-translucent);--bs-popover-border-radius:var(--bs-border-radius-lg);--bs-popover-inner-border-radius:calc(var(--bs-border-radius-lg) - var(--bs-border-width));--bs-popover-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-popover-header-padding-x:1rem;--bs-popover-header-padding-y:0.5rem;--bs-popover-header-font-size:1rem;--bs-popover-header-color:inherit;--bs-popover-header-bg:var(--bs-secondary-bg);--bs-popover-body-padding-x:1rem;--bs-popover-body-padding-y:1rem;--bs-popover-body-color:var(--bs-body-color);--bs-popover-arrow-width:1rem;--bs-popover-arrow-height:0.5rem;--bs-popover-arrow-border:var(--bs-popover-border-color);z-index:var(--bs-popover-zindex);display:block;max-width:var(--bs-popover-max-width);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-popover-font-size);word-wrap:break-word;background-color:var(--bs-popover-bg);background-clip:padding-box;border:var(--bs-popover-border-width) solid var(--bs-popover-border-color);border-radius:var(--bs-popover-border-radius)}.popover .popover-arrow{display:block;width:var(--bs-popover-arrow-width);height:var(--bs-popover-arrow-height)}.popover .popover-arrow::after,.popover .popover-arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid;border-width:0}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow,.bs-popover-top>.popover-arrow{bottom:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,.bs-popover-top>.popover-arrow::after,.bs-popover-top>.popover-arrow::before{border-width:var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,.bs-popover-top>.popover-arrow::before{bottom:0;border-top-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,.bs-popover-top>.popover-arrow::after{bottom:var(--bs-popover-border-width);border-top-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow,.bs-popover-end>.popover-arrow{left:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));width:var(--bs-popover-arrow-height);height:var(--bs-popover-arrow-width)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,.bs-popover-end>.popover-arrow::after,.bs-popover-end>.popover-arrow::before{border-width:calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,.bs-popover-end>.popover-arrow::before{left:0;border-right-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,.bs-popover-end>.popover-arrow::after{left:var(--bs-popover-border-width);border-right-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow,.bs-popover-bottom>.popover-arrow{top:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,.bs-popover-bottom>.popover-arrow::after,.bs-popover-bottom>.popover-arrow::before{border-width:0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,.bs-popover-bottom>.popover-arrow::before{top:0;border-bottom-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,.bs-popover-bottom>.popover-arrow::after{top:var(--bs-popover-border-width);border-bottom-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:var(--bs-popover-arrow-width);margin-left:calc(-.5 * var(--bs-popover-arrow-width));content:\"\";border-bottom:var(--bs-popover-border-width) solid var(--bs-popover-header-bg)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow,.bs-popover-start>.popover-arrow{right:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));width:var(--bs-popover-arrow-height);height:var(--bs-popover-arrow-width)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,.bs-popover-start>.popover-arrow::after,.bs-popover-start>.popover-arrow::before{border-width:calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,.bs-popover-start>.popover-arrow::before{right:0;border-left-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,.bs-popover-start>.popover-arrow::after{right:var(--bs-popover-border-width);border-left-color:var(--bs-popover-bg)}.popover-header{padding:var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);margin-bottom:0;font-size:var(--bs-popover-header-font-size);color:var(--bs-popover-header-color);background-color:var(--bs-popover-header-bg);border-bottom:var(--bs-popover-border-width) solid var(--bs-popover-border-color);border-top-left-radius:var(--bs-popover-inner-border-radius);border-top-right-radius:var(--bs-popover-inner-border-radius)}.popover-header:empty{display:none}.popover-body{padding:var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);color:var(--bs-popover-body-color)}.carousel{position:relative}.carousel.pointer-event{touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-end,.carousel-item-next:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start,.carousel-item-prev:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start,.carousel-fade .carousel-item-prev.carousel-item-end,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end,.carousel-fade .active.carousel-item-start{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end,.carousel-fade .active.carousel-item-start{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%}.carousel-indicators [data-bs-target]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target]{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon,.carousel-dark .carousel-control-prev-icon{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target]{background-color:#000}.carousel-dark .carousel-caption{color:#000}[data-bs-theme=dark] .carousel .carousel-control-next-icon,[data-bs-theme=dark] .carousel .carousel-control-prev-icon,[data-bs-theme=dark].carousel .carousel-control-next-icon,[data-bs-theme=dark].carousel .carousel-control-prev-icon{filter:invert(1) grayscale(100)}[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target],[data-bs-theme=dark].carousel .carousel-indicators [data-bs-target]{background-color:#000}[data-bs-theme=dark] .carousel .carousel-caption,[data-bs-theme=dark].carousel .carousel-caption{color:#000}.spinner-border,.spinner-grow{display:inline-block;width:var(--bs-spinner-width);height:var(--bs-spinner-height);vertical-align:var(--bs-spinner-vertical-align);border-radius:50%;animation:var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name)}@keyframes spinner-border{to{transform:rotate(360deg)}}.spinner-border{--bs-spinner-width:2rem;--bs-spinner-height:2rem;--bs-spinner-vertical-align:-0.125em;--bs-spinner-border-width:0.25em;--bs-spinner-animation-speed:0.75s;--bs-spinner-animation-name:spinner-border;border:var(--bs-spinner-border-width) solid currentcolor;border-right-color:transparent}.spinner-border-sm{--bs-spinner-width:1rem;--bs-spinner-height:1rem;--bs-spinner-border-width:0.2em}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow{--bs-spinner-width:2rem;--bs-spinner-height:2rem;--bs-spinner-vertical-align:-0.125em;--bs-spinner-animation-speed:0.75s;--bs-spinner-animation-name:spinner-grow;background-color:currentcolor;opacity:0}.spinner-grow-sm{--bs-spinner-width:1rem;--bs-spinner-height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border,.spinner-grow{--bs-spinner-animation-speed:1.5s}}.offcanvas,.offcanvas-lg,.offcanvas-md,.offcanvas-sm,.offcanvas-xl,.offcanvas-xxl{--bs-offcanvas-zindex:1045;--bs-offcanvas-width:400px;--bs-offcanvas-height:30vh;--bs-offcanvas-padding-x:1rem;--bs-offcanvas-padding-y:1rem;--bs-offcanvas-color:var(--bs-body-color);--bs-offcanvas-bg:var(--bs-body-bg);--bs-offcanvas-border-width:var(--bs-border-width);--bs-offcanvas-border-color:var(--bs-border-color-translucent);--bs-offcanvas-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-offcanvas-transition:transform 0.3s ease-in-out;--bs-offcanvas-title-line-height:1.5}@media (max-width:575.98px){.offcanvas-sm{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:575.98px) and (prefers-reduced-motion:reduce){.offcanvas-sm{transition:none}}@media (max-width:575.98px){.offcanvas-sm.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-sm.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-sm.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-sm.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-sm.show:not(.hiding),.offcanvas-sm.showing{transform:none}.offcanvas-sm.hiding,.offcanvas-sm.show,.offcanvas-sm.showing{visibility:visible}}@media (min-width:576px){.offcanvas-sm{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-sm .offcanvas-header{display:none}.offcanvas-sm .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:767.98px){.offcanvas-md{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:767.98px) and (prefers-reduced-motion:reduce){.offcanvas-md{transition:none}}@media (max-width:767.98px){.offcanvas-md.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-md.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-md.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-md.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-md.show:not(.hiding),.offcanvas-md.showing{transform:none}.offcanvas-md.hiding,.offcanvas-md.show,.offcanvas-md.showing{visibility:visible}}@media (min-width:768px){.offcanvas-md{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-md .offcanvas-header{display:none}.offcanvas-md .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:991.98px){.offcanvas-lg{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:991.98px) and (prefers-reduced-motion:reduce){.offcanvas-lg{transition:none}}@media (max-width:991.98px){.offcanvas-lg.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-lg.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-lg.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-lg.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-lg.show:not(.hiding),.offcanvas-lg.showing{transform:none}.offcanvas-lg.hiding,.offcanvas-lg.show,.offcanvas-lg.showing{visibility:visible}}@media (min-width:992px){.offcanvas-lg{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-lg .offcanvas-header{display:none}.offcanvas-lg .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:1199.98px){.offcanvas-xl{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:1199.98px) and (prefers-reduced-motion:reduce){.offcanvas-xl{transition:none}}@media (max-width:1199.98px){.offcanvas-xl.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-xl.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-xl.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-xl.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-xl.show:not(.hiding),.offcanvas-xl.showing{transform:none}.offcanvas-xl.hiding,.offcanvas-xl.show,.offcanvas-xl.showing{visibility:visible}}@media (min-width:1200px){.offcanvas-xl{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-xl .offcanvas-header{display:none}.offcanvas-xl .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:1399.98px){.offcanvas-xxl{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:1399.98px) and (prefers-reduced-motion:reduce){.offcanvas-xxl{transition:none}}@media (max-width:1399.98px){.offcanvas-xxl.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-xxl.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-xxl.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-xxl.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-xxl.show:not(.hiding),.offcanvas-xxl.showing{transform:none}.offcanvas-xxl.hiding,.offcanvas-xxl.show,.offcanvas-xxl.showing{visibility:visible}}@media (min-width:1400px){.offcanvas-xxl{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-xxl .offcanvas-header{display:none}.offcanvas-xxl .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}.offcanvas{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}@media (prefers-reduced-motion:reduce){.offcanvas{transition:none}}.offcanvas.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas.show:not(.hiding),.offcanvas.showing{transform:none}.offcanvas.hiding,.offcanvas.show,.offcanvas.showing{visibility:visible}.offcanvas-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade{opacity:0}.offcanvas-backdrop.show{opacity:.5}.offcanvas-header{display:flex;align-items:center;justify-content:space-between;padding:var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)}.offcanvas-header .btn-close{padding:calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);margin-top:calc(-.5 * var(--bs-offcanvas-padding-y));margin-right:calc(-.5 * var(--bs-offcanvas-padding-x));margin-bottom:calc(-.5 * var(--bs-offcanvas-padding-y))}.offcanvas-title{margin-bottom:0;line-height:var(--bs-offcanvas-title-line-height)}.offcanvas-body{flex-grow:1;padding:var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);overflow-y:auto}.placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentcolor;opacity:.5}.placeholder.btn::before{display:inline-block;content:\"\"}.placeholder-xs{min-height:.6em}.placeholder-sm{min-height:.8em}.placeholder-lg{min-height:1.2em}.placeholder-glow .placeholder{animation:placeholder-glow 2s ease-in-out infinite}@keyframes placeholder-glow{50%{opacity:.2}}.placeholder-wave{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;animation:placeholder-wave 2s linear infinite}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0%;mask-position:-200% 0%}}.clearfix::after{display:block;clear:both;content:\"\"}.text-bg-primary{color:#fff!important;background-color:RGBA(var(--bs-primary-rgb),var(--bs-bg-opacity,1))!important}.text-bg-secondary{color:#fff!important;background-color:RGBA(var(--bs-secondary-rgb),var(--bs-bg-opacity,1))!important}.text-bg-success{color:#fff!important;background-color:RGBA(var(--bs-success-rgb),var(--bs-bg-opacity,1))!important}.text-bg-info{color:#000!important;background-color:RGBA(var(--bs-info-rgb),var(--bs-bg-opacity,1))!important}.text-bg-warning{color:#000!important;background-color:RGBA(var(--bs-warning-rgb),var(--bs-bg-opacity,1))!important}.text-bg-danger{color:#fff!important;background-color:RGBA(var(--bs-danger-rgb),var(--bs-bg-opacity,1))!important}.text-bg-light{color:#000!important;background-color:RGBA(var(--bs-light-rgb),var(--bs-bg-opacity,1))!important}.text-bg-dark{color:#fff!important;background-color:RGBA(var(--bs-dark-rgb),var(--bs-bg-opacity,1))!important}.link-primary{color:RGBA(var(--bs-primary-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-primary-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-primary-rgb),var(--bs-link-underline-opacity,1))!important}.link-primary:focus,.link-primary:hover{color:RGBA(10,88,202,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(10,88,202,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(10,88,202,var(--bs-link-underline-opacity,1))!important}.link-secondary{color:RGBA(var(--bs-secondary-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-secondary-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-secondary-rgb),var(--bs-link-underline-opacity,1))!important}.link-secondary:focus,.link-secondary:hover{color:RGBA(86,94,100,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(86,94,100,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(86,94,100,var(--bs-link-underline-opacity,1))!important}.link-success{color:RGBA(var(--bs-success-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-success-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-success-rgb),var(--bs-link-underline-opacity,1))!important}.link-success:focus,.link-success:hover{color:RGBA(20,108,67,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(20,108,67,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(20,108,67,var(--bs-link-underline-opacity,1))!important}.link-info{color:RGBA(var(--bs-info-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-info-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-info-rgb),var(--bs-link-underline-opacity,1))!important}.link-info:focus,.link-info:hover{color:RGBA(61,213,243,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(61,213,243,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(61,213,243,var(--bs-link-underline-opacity,1))!important}.link-warning{color:RGBA(var(--bs-warning-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-warning-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-warning-rgb),var(--bs-link-underline-opacity,1))!important}.link-warning:focus,.link-warning:hover{color:RGBA(255,205,57,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(255,205,57,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(255,205,57,var(--bs-link-underline-opacity,1))!important}.link-danger{color:RGBA(var(--bs-danger-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-danger-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-danger-rgb),var(--bs-link-underline-opacity,1))!important}.link-danger:focus,.link-danger:hover{color:RGBA(176,42,55,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(176,42,55,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(176,42,55,var(--bs-link-underline-opacity,1))!important}.link-light{color:RGBA(var(--bs-light-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-light-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-light-rgb),var(--bs-link-underline-opacity,1))!important}.link-light:focus,.link-light:hover{color:RGBA(249,250,251,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(249,250,251,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(249,250,251,var(--bs-link-underline-opacity,1))!important}.link-dark{color:RGBA(var(--bs-dark-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-dark-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-dark-rgb),var(--bs-link-underline-opacity,1))!important}.link-dark:focus,.link-dark:hover{color:RGBA(26,30,33,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(26,30,33,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(26,30,33,var(--bs-link-underline-opacity,1))!important}.link-body-emphasis{color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,1))!important}.link-body-emphasis:focus,.link-body-emphasis:hover{color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-opacity,.75))!important;-webkit-text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,0.75))!important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,0.75))!important}.focus-ring:focus{outline:0;box-shadow:var(--bs-focus-ring-x,0) var(--bs-focus-ring-y,0) var(--bs-focus-ring-blur,0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)}.icon-link{display:inline-flex;gap:.375rem;align-items:center;-webkit-text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,0.5));text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,0.5));text-underline-offset:0.25em;-webkit-backface-visibility:hidden;backface-visibility:hidden}.icon-link>.bi{flex-shrink:0;width:1em;height:1em;fill:currentcolor;transition:.2s ease-in-out transform}@media (prefers-reduced-motion:reduce){.icon-link>.bi{transition:none}}.icon-link-hover:focus-visible>.bi,.icon-link-hover:hover>.bi{transform:var(--bs-icon-link-transform,translate3d(.25em,0,0))}.ratio{position:relative;width:100%}.ratio::before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>*{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1{--bs-aspect-ratio:100%}.ratio-4x3{--bs-aspect-ratio:75%}.ratio-16x9{--bs-aspect-ratio:56.25%}.ratio-21x9{--bs-aspect-ratio:42.8571428571%}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}@media (min-width:576px){.sticky-sm-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-sm-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:768px){.sticky-md-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-md-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-lg-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-xl-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-xxl-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}.hstack{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden,.visually-hidden-focusable:not(:focus):not(:focus-within){width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption),.visually-hidden:not(caption){position:absolute!important}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr{display:inline-block;align-self:stretch;width:var(--bs-border-width);min-height:1em;background-color:currentcolor;opacity:.25}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.float-start{float:left!important}.float-end{float:right!important}.float-none{float:none!important}.object-fit-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-none{-o-object-fit:none!important;object-fit:none!important}.opacity-0{opacity:0!important}.opacity-25{opacity:.25!important}.opacity-50{opacity:.5!important}.opacity-75{opacity:.75!important}.opacity-100{opacity:1!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.overflow-visible{overflow:visible!important}.overflow-scroll{overflow:scroll!important}.overflow-x-auto{overflow-x:auto!important}.overflow-x-hidden{overflow-x:hidden!important}.overflow-x-visible{overflow-x:visible!important}.overflow-x-scroll{overflow-x:scroll!important}.overflow-y-auto{overflow-y:auto!important}.overflow-y-hidden{overflow-y:hidden!important}.overflow-y-visible{overflow-y:visible!important}.overflow-y-scroll{overflow-y:scroll!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-grid{display:grid!important}.d-inline-grid{display:inline-grid!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}.d-none{display:none!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.focus-ring-primary{--bs-focus-ring-color:rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-secondary{--bs-focus-ring-color:rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-success{--bs-focus-ring-color:rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))}.focus-ring-info{--bs-focus-ring-color:rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))}.focus-ring-warning{--bs-focus-ring-color:rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))}.focus-ring-danger{--bs-focus-ring-color:rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))}.focus-ring-light{--bs-focus-ring-color:rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))}.focus-ring-dark{--bs-focus-ring-color:rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.top-0{top:0!important}.top-50{top:50%!important}.top-100{top:100%!important}.bottom-0{bottom:0!important}.bottom-50{bottom:50%!important}.bottom-100{bottom:100%!important}.start-0{left:0!important}.start-50{left:50%!important}.start-100{left:100%!important}.end-0{right:0!important}.end-50{right:50%!important}.end-100{right:100%!important}.translate-middle{transform:translate(-50%,-50%)!important}.translate-middle-x{transform:translateX(-50%)!important}.translate-middle-y{transform:translateY(-50%)!important}.border{border:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-0{border:0!important}.border-top{border-top:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-top-0{border-top:0!important}.border-end{border-right:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-end-0{border-right:0!important}.border-bottom{border-bottom:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-bottom-0{border-bottom:0!important}.border-start{border-left:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-start-0{border-left:0!important}.border-primary{--bs-border-opacity:1;border-color:rgba(var(--bs-primary-rgb),var(--bs-border-opacity))!important}.border-secondary{--bs-border-opacity:1;border-color:rgba(var(--bs-secondary-rgb),var(--bs-border-opacity))!important}.border-success{--bs-border-opacity:1;border-color:rgba(var(--bs-success-rgb),var(--bs-border-opacity))!important}.border-info{--bs-border-opacity:1;border-color:rgba(var(--bs-info-rgb),var(--bs-border-opacity))!important}.border-warning{--bs-border-opacity:1;border-color:rgba(var(--bs-warning-rgb),var(--bs-border-opacity))!important}.border-danger{--bs-border-opacity:1;border-color:rgba(var(--bs-danger-rgb),var(--bs-border-opacity))!important}.border-light{--bs-border-opacity:1;border-color:rgba(var(--bs-light-rgb),var(--bs-border-opacity))!important}.border-dark{--bs-border-opacity:1;border-color:rgba(var(--bs-dark-rgb),var(--bs-border-opacity))!important}.border-black{--bs-border-opacity:1;border-color:rgba(var(--bs-black-rgb),var(--bs-border-opacity))!important}.border-white{--bs-border-opacity:1;border-color:rgba(var(--bs-white-rgb),var(--bs-border-opacity))!important}.border-primary-subtle{border-color:var(--bs-primary-border-subtle)!important}.border-secondary-subtle{border-color:var(--bs-secondary-border-subtle)!important}.border-success-subtle{border-color:var(--bs-success-border-subtle)!important}.border-info-subtle{border-color:var(--bs-info-border-subtle)!important}.border-warning-subtle{border-color:var(--bs-warning-border-subtle)!important}.border-danger-subtle{border-color:var(--bs-danger-border-subtle)!important}.border-light-subtle{border-color:var(--bs-light-border-subtle)!important}.border-dark-subtle{border-color:var(--bs-dark-border-subtle)!important}.border-1{border-width:1px!important}.border-2{border-width:2px!important}.border-3{border-width:3px!important}.border-4{border-width:4px!important}.border-5{border-width:5px!important}.border-opacity-10{--bs-border-opacity:0.1}.border-opacity-25{--bs-border-opacity:0.25}.border-opacity-50{--bs-border-opacity:0.5}.border-opacity-75{--bs-border-opacity:0.75}.border-opacity-100{--bs-border-opacity:1}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.mw-100{max-width:100%!important}.vw-100{width:100vw!important}.min-vw-100{min-width:100vw!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mh-100{max-height:100%!important}.vh-100{height:100vh!important}.min-vh-100{min-height:100vh!important}.flex-fill{flex:1 1 auto!important}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-grow-0{flex-grow:0!important}.flex-grow-1{flex-grow:1!important}.flex-shrink-0{flex-shrink:0!important}.flex-shrink-1{flex-shrink:1!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.justify-content-evenly{justify-content:space-evenly!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}.order-first{order:-1!important}.order-0{order:0!important}.order-1{order:1!important}.order-2{order:2!important}.order-3{order:3!important}.order-4{order:4!important}.order-5{order:5!important}.order-last{order:6!important}.m-0{margin:0!important}.m-1{margin:.25rem!important}.m-2{margin:.5rem!important}.m-3{margin:1rem!important}.m-4{margin:1.5rem!important}.m-5{margin:3rem!important}.m-auto{margin:auto!important}.mx-0{margin-right:0!important;margin-left:0!important}.mx-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3{margin-right:1rem!important;margin-left:1rem!important}.mx-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5{margin-right:3rem!important;margin-left:3rem!important}.mx-auto{margin-right:auto!important;margin-left:auto!important}.my-0{margin-top:0!important;margin-bottom:0!important}.my-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-0{margin-top:0!important}.mt-1{margin-top:.25rem!important}.mt-2{margin-top:.5rem!important}.mt-3{margin-top:1rem!important}.mt-4{margin-top:1.5rem!important}.mt-5{margin-top:3rem!important}.mt-auto{margin-top:auto!important}.me-0{margin-right:0!important}.me-1{margin-right:.25rem!important}.me-2{margin-right:.5rem!important}.me-3{margin-right:1rem!important}.me-4{margin-right:1.5rem!important}.me-5{margin-right:3rem!important}.me-auto{margin-right:auto!important}.mb-0{margin-bottom:0!important}.mb-1{margin-bottom:.25rem!important}.mb-2{margin-bottom:.5rem!important}.mb-3{margin-bottom:1rem!important}.mb-4{margin-bottom:1.5rem!important}.mb-5{margin-bottom:3rem!important}.mb-auto{margin-bottom:auto!important}.ms-0{margin-left:0!important}.ms-1{margin-left:.25rem!important}.ms-2{margin-left:.5rem!important}.ms-3{margin-left:1rem!important}.ms-4{margin-left:1.5rem!important}.ms-5{margin-left:3rem!important}.ms-auto{margin-left:auto!important}.p-0{padding:0!important}.p-1{padding:.25rem!important}.p-2{padding:.5rem!important}.p-3{padding:1rem!important}.p-4{padding:1.5rem!important}.p-5{padding:3rem!important}.px-0{padding-right:0!important;padding-left:0!important}.px-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-3{padding-right:1rem!important;padding-left:1rem!important}.px-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5{padding-right:3rem!important;padding-left:3rem!important}.py-0{padding-top:0!important;padding-bottom:0!important}.py-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0{padding-top:0!important}.pt-1{padding-top:.25rem!important}.pt-2{padding-top:.5rem!important}.pt-3{padding-top:1rem!important}.pt-4{padding-top:1.5rem!important}.pt-5{padding-top:3rem!important}.pe-0{padding-right:0!important}.pe-1{padding-right:.25rem!important}.pe-2{padding-right:.5rem!important}.pe-3{padding-right:1rem!important}.pe-4{padding-right:1.5rem!important}.pe-5{padding-right:3rem!important}.pb-0{padding-bottom:0!important}.pb-1{padding-bottom:.25rem!important}.pb-2{padding-bottom:.5rem!important}.pb-3{padding-bottom:1rem!important}.pb-4{padding-bottom:1.5rem!important}.pb-5{padding-bottom:3rem!important}.ps-0{padding-left:0!important}.ps-1{padding-left:.25rem!important}.ps-2{padding-left:.5rem!important}.ps-3{padding-left:1rem!important}.ps-4{padding-left:1.5rem!important}.ps-5{padding-left:3rem!important}.gap-0{gap:0!important}.gap-1{gap:.25rem!important}.gap-2{gap:.5rem!important}.gap-3{gap:1rem!important}.gap-4{gap:1.5rem!important}.gap-5{gap:3rem!important}.row-gap-0{row-gap:0!important}.row-gap-1{row-gap:.25rem!important}.row-gap-2{row-gap:.5rem!important}.row-gap-3{row-gap:1rem!important}.row-gap-4{row-gap:1.5rem!important}.row-gap-5{row-gap:3rem!important}.column-gap-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.font-monospace{font-family:var(--bs-font-monospace)!important}.fs-1{font-size:calc(1.375rem + 1.5vw)!important}.fs-2{font-size:calc(1.325rem + .9vw)!important}.fs-3{font-size:calc(1.3rem + .6vw)!important}.fs-4{font-size:calc(1.275rem + .3vw)!important}.fs-5{font-size:1.25rem!important}.fs-6{font-size:1rem!important}.fst-italic{font-style:italic!important}.fst-normal{font-style:normal!important}.fw-lighter{font-weight:lighter!important}.fw-light{font-weight:300!important}.fw-normal{font-weight:400!important}.fw-medium{font-weight:500!important}.fw-semibold{font-weight:600!important}.fw-bold{font-weight:700!important}.fw-bolder{font-weight:bolder!important}.lh-1{line-height:1!important}.lh-sm{line-height:1.25!important}.lh-base{line-height:1.5!important}.lh-lg{line-height:2!important}.text-start{text-align:left!important}.text-end{text-align:right!important}.text-center{text-align:center!important}.text-decoration-none{text-decoration:none!important}.text-decoration-underline{text-decoration:underline!important}.text-decoration-line-through{text-decoration:line-through!important}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-break{word-wrap:break-word!important;word-break:break-word!important}.text-primary{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted{--bs-text-opacity:1;color:var(--bs-secondary-color)!important}.text-black-50{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50{--bs-text-opacity:1;color:rgba(255,255,255,.5)!important}.text-body-secondary{--bs-text-opacity:1;color:var(--bs-secondary-color)!important}.text-body-tertiary{--bs-text-opacity:1;color:var(--bs-tertiary-color)!important}.text-body-emphasis{--bs-text-opacity:1;color:var(--bs-emphasis-color)!important}.text-reset{--bs-text-opacity:1;color:inherit!important}.text-opacity-25{--bs-text-opacity:0.25}.text-opacity-50{--bs-text-opacity:0.5}.text-opacity-75{--bs-text-opacity:0.75}.text-opacity-100{--bs-text-opacity:1}.text-primary-emphasis{color:var(--bs-primary-text-emphasis)!important}.text-secondary-emphasis{color:var(--bs-secondary-text-emphasis)!important}.text-success-emphasis{color:var(--bs-success-text-emphasis)!important}.text-info-emphasis{color:var(--bs-info-text-emphasis)!important}.text-warning-emphasis{color:var(--bs-warning-text-emphasis)!important}.text-danger-emphasis{color:var(--bs-danger-text-emphasis)!important}.text-light-emphasis{color:var(--bs-light-text-emphasis)!important}.text-dark-emphasis{color:var(--bs-dark-text-emphasis)!important}.link-opacity-10{--bs-link-opacity:0.1}.link-opacity-10-hover:hover{--bs-link-opacity:0.1}.link-opacity-25{--bs-link-opacity:0.25}.link-opacity-25-hover:hover{--bs-link-opacity:0.25}.link-opacity-50{--bs-link-opacity:0.5}.link-opacity-50-hover:hover{--bs-link-opacity:0.5}.link-opacity-75{--bs-link-opacity:0.75}.link-opacity-75-hover:hover{--bs-link-opacity:0.75}.link-opacity-100{--bs-link-opacity:1}.link-opacity-100-hover:hover{--bs-link-opacity:1}.link-offset-1{text-underline-offset:0.125em!important}.link-offset-1-hover:hover{text-underline-offset:0.125em!important}.link-offset-2{text-underline-offset:0.25em!important}.link-offset-2-hover:hover{text-underline-offset:0.25em!important}.link-offset-3{text-underline-offset:0.375em!important}.link-offset-3-hover:hover{text-underline-offset:0.375em!important}.link-underline-primary{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-primary-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-primary-rgb),var(--bs-link-underline-opacity))!important}.link-underline-secondary{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-secondary-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-secondary-rgb),var(--bs-link-underline-opacity))!important}.link-underline-success{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-success-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-success-rgb),var(--bs-link-underline-opacity))!important}.link-underline-info{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-info-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-info-rgb),var(--bs-link-underline-opacity))!important}.link-underline-warning{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-warning-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-warning-rgb),var(--bs-link-underline-opacity))!important}.link-underline-danger{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-danger-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-danger-rgb),var(--bs-link-underline-opacity))!important}.link-underline-light{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-light-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-light-rgb),var(--bs-link-underline-opacity))!important}.link-underline-dark{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-dark-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-dark-rgb),var(--bs-link-underline-opacity))!important}.link-underline{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-underline-opacity,1))!important}.link-underline-opacity-0{--bs-link-underline-opacity:0}.link-underline-opacity-0-hover:hover{--bs-link-underline-opacity:0}.link-underline-opacity-10{--bs-link-underline-opacity:0.1}.link-underline-opacity-10-hover:hover{--bs-link-underline-opacity:0.1}.link-underline-opacity-25{--bs-link-underline-opacity:0.25}.link-underline-opacity-25-hover:hover{--bs-link-underline-opacity:0.25}.link-underline-opacity-50{--bs-link-underline-opacity:0.5}.link-underline-opacity-50-hover:hover{--bs-link-underline-opacity:0.5}.link-underline-opacity-75{--bs-link-underline-opacity:0.75}.link-underline-opacity-75-hover:hover{--bs-link-underline-opacity:0.75}.link-underline-opacity-100{--bs-link-underline-opacity:1}.link-underline-opacity-100-hover:hover{--bs-link-underline-opacity:1}.bg-primary{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent{--bs-bg-opacity:1;background-color:transparent!important}.bg-body-secondary{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-bg-rgb),var(--bs-bg-opacity))!important}.bg-body-tertiary{--bs-bg-opacity:1;background-color:rgba(var(--bs-tertiary-bg-rgb),var(--bs-bg-opacity))!important}.bg-opacity-10{--bs-bg-opacity:0.1}.bg-opacity-25{--bs-bg-opacity:0.25}.bg-opacity-50{--bs-bg-opacity:0.5}.bg-opacity-75{--bs-bg-opacity:0.75}.bg-opacity-100{--bs-bg-opacity:1}.bg-primary-subtle{background-color:var(--bs-primary-bg-subtle)!important}.bg-secondary-subtle{background-color:var(--bs-secondary-bg-subtle)!important}.bg-success-subtle{background-color:var(--bs-success-bg-subtle)!important}.bg-info-subtle{background-color:var(--bs-info-bg-subtle)!important}.bg-warning-subtle{background-color:var(--bs-warning-bg-subtle)!important}.bg-danger-subtle{background-color:var(--bs-danger-bg-subtle)!important}.bg-light-subtle{background-color:var(--bs-light-bg-subtle)!important}.bg-dark-subtle{background-color:var(--bs-dark-bg-subtle)!important}.bg-gradient{background-image:var(--bs-gradient)!important}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none{pointer-events:none!important}.pe-auto{pointer-events:auto!important}.rounded{border-radius:var(--bs-border-radius)!important}.rounded-0{border-radius:0!important}.rounded-1{border-radius:var(--bs-border-radius-sm)!important}.rounded-2{border-radius:var(--bs-border-radius)!important}.rounded-3{border-radius:var(--bs-border-radius-lg)!important}.rounded-4{border-radius:var(--bs-border-radius-xl)!important}.rounded-5{border-radius:var(--bs-border-radius-xxl)!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:var(--bs-border-radius-pill)!important}.rounded-top{border-top-left-radius:var(--bs-border-radius)!important;border-top-right-radius:var(--bs-border-radius)!important}.rounded-top-0{border-top-left-radius:0!important;border-top-right-radius:0!important}.rounded-top-1{border-top-left-radius:var(--bs-border-radius-sm)!important;border-top-right-radius:var(--bs-border-radius-sm)!important}.rounded-top-2{border-top-left-radius:var(--bs-border-radius)!important;border-top-right-radius:var(--bs-border-radius)!important}.rounded-top-3{border-top-left-radius:var(--bs-border-radius-lg)!important;border-top-right-radius:var(--bs-border-radius-lg)!important}.rounded-top-4{border-top-left-radius:var(--bs-border-radius-xl)!important;border-top-right-radius:var(--bs-border-radius-xl)!important}.rounded-top-5{border-top-left-radius:var(--bs-border-radius-xxl)!important;border-top-right-radius:var(--bs-border-radius-xxl)!important}.rounded-top-circle{border-top-left-radius:50%!important;border-top-right-radius:50%!important}.rounded-top-pill{border-top-left-radius:var(--bs-border-radius-pill)!important;border-top-right-radius:var(--bs-border-radius-pill)!important}.rounded-end{border-top-right-radius:var(--bs-border-radius)!important;border-bottom-right-radius:var(--bs-border-radius)!important}.rounded-end-0{border-top-right-radius:0!important;border-bottom-right-radius:0!important}.rounded-end-1{border-top-right-radius:var(--bs-border-radius-sm)!important;border-bottom-right-radius:var(--bs-border-radius-sm)!important}.rounded-end-2{border-top-right-radius:var(--bs-border-radius)!important;border-bottom-right-radius:var(--bs-border-radius)!important}.rounded-end-3{border-top-right-radius:var(--bs-border-radius-lg)!important;border-bottom-right-radius:var(--bs-border-radius-lg)!important}.rounded-end-4{border-top-right-radius:var(--bs-border-radius-xl)!important;border-bottom-right-radius:var(--bs-border-radius-xl)!important}.rounded-end-5{border-top-right-radius:var(--bs-border-radius-xxl)!important;border-bottom-right-radius:var(--bs-border-radius-xxl)!important}.rounded-end-circle{border-top-right-radius:50%!important;border-bottom-right-radius:50%!important}.rounded-end-pill{border-top-right-radius:var(--bs-border-radius-pill)!important;border-bottom-right-radius:var(--bs-border-radius-pill)!important}.rounded-bottom{border-bottom-right-radius:var(--bs-border-radius)!important;border-bottom-left-radius:var(--bs-border-radius)!important}.rounded-bottom-0{border-bottom-right-radius:0!important;border-bottom-left-radius:0!important}.rounded-bottom-1{border-bottom-right-radius:var(--bs-border-radius-sm)!important;border-bottom-left-radius:var(--bs-border-radius-sm)!important}.rounded-bottom-2{border-bottom-right-radius:var(--bs-border-radius)!important;border-bottom-left-radius:var(--bs-border-radius)!important}.rounded-bottom-3{border-bottom-right-radius:var(--bs-border-radius-lg)!important;border-bottom-left-radius:var(--bs-border-radius-lg)!important}.rounded-bottom-4{border-bottom-right-radius:var(--bs-border-radius-xl)!important;border-bottom-left-radius:var(--bs-border-radius-xl)!important}.rounded-bottom-5{border-bottom-right-radius:var(--bs-border-radius-xxl)!important;border-bottom-left-radius:var(--bs-border-radius-xxl)!important}.rounded-bottom-circle{border-bottom-right-radius:50%!important;border-bottom-left-radius:50%!important}.rounded-bottom-pill{border-bottom-right-radius:var(--bs-border-radius-pill)!important;border-bottom-left-radius:var(--bs-border-radius-pill)!important}.rounded-start{border-bottom-left-radius:var(--bs-border-radius)!important;border-top-left-radius:var(--bs-border-radius)!important}.rounded-start-0{border-bottom-left-radius:0!important;border-top-left-radius:0!important}.rounded-start-1{border-bottom-left-radius:var(--bs-border-radius-sm)!important;border-top-left-radius:var(--bs-border-radius-sm)!important}.rounded-start-2{border-bottom-left-radius:var(--bs-border-radius)!important;border-top-left-radius:var(--bs-border-radius)!important}.rounded-start-3{border-bottom-left-radius:var(--bs-border-radius-lg)!important;border-top-left-radius:var(--bs-border-radius-lg)!important}.rounded-start-4{border-bottom-left-radius:var(--bs-border-radius-xl)!important;border-top-left-radius:var(--bs-border-radius-xl)!important}.rounded-start-5{border-bottom-left-radius:var(--bs-border-radius-xxl)!important;border-top-left-radius:var(--bs-border-radius-xxl)!important}.rounded-start-circle{border-bottom-left-radius:50%!important;border-top-left-radius:50%!important}.rounded-start-pill{border-bottom-left-radius:var(--bs-border-radius-pill)!important;border-top-left-radius:var(--bs-border-radius-pill)!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}.z-n1{z-index:-1!important}.z-0{z-index:0!important}.z-1{z-index:1!important}.z-2{z-index:2!important}.z-3{z-index:3!important}@media (min-width:576px){.float-sm-start{float:left!important}.float-sm-end{float:right!important}.float-sm-none{float:none!important}.object-fit-sm-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-sm-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-sm-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-sm-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-sm-none{-o-object-fit:none!important;object-fit:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-grid{display:grid!important}.d-sm-inline-grid{display:inline-grid!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}.d-sm-none{display:none!important}.flex-sm-fill{flex:1 1 auto!important}.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-grow-0{flex-grow:0!important}.flex-sm-grow-1{flex-grow:1!important}.flex-sm-shrink-0{flex-shrink:0!important}.flex-sm-shrink-1{flex-shrink:1!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.justify-content-sm-evenly{justify-content:space-evenly!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{align-self:stretch!important}.order-sm-first{order:-1!important}.order-sm-0{order:0!important}.order-sm-1{order:1!important}.order-sm-2{order:2!important}.order-sm-3{order:3!important}.order-sm-4{order:4!important}.order-sm-5{order:5!important}.order-sm-last{order:6!important}.m-sm-0{margin:0!important}.m-sm-1{margin:.25rem!important}.m-sm-2{margin:.5rem!important}.m-sm-3{margin:1rem!important}.m-sm-4{margin:1.5rem!important}.m-sm-5{margin:3rem!important}.m-sm-auto{margin:auto!important}.mx-sm-0{margin-right:0!important;margin-left:0!important}.mx-sm-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto{margin-right:auto!important;margin-left:auto!important}.my-sm-0{margin-top:0!important;margin-bottom:0!important}.my-sm-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0{margin-top:0!important}.mt-sm-1{margin-top:.25rem!important}.mt-sm-2{margin-top:.5rem!important}.mt-sm-3{margin-top:1rem!important}.mt-sm-4{margin-top:1.5rem!important}.mt-sm-5{margin-top:3rem!important}.mt-sm-auto{margin-top:auto!important}.me-sm-0{margin-right:0!important}.me-sm-1{margin-right:.25rem!important}.me-sm-2{margin-right:.5rem!important}.me-sm-3{margin-right:1rem!important}.me-sm-4{margin-right:1.5rem!important}.me-sm-5{margin-right:3rem!important}.me-sm-auto{margin-right:auto!important}.mb-sm-0{margin-bottom:0!important}.mb-sm-1{margin-bottom:.25rem!important}.mb-sm-2{margin-bottom:.5rem!important}.mb-sm-3{margin-bottom:1rem!important}.mb-sm-4{margin-bottom:1.5rem!important}.mb-sm-5{margin-bottom:3rem!important}.mb-sm-auto{margin-bottom:auto!important}.ms-sm-0{margin-left:0!important}.ms-sm-1{margin-left:.25rem!important}.ms-sm-2{margin-left:.5rem!important}.ms-sm-3{margin-left:1rem!important}.ms-sm-4{margin-left:1.5rem!important}.ms-sm-5{margin-left:3rem!important}.ms-sm-auto{margin-left:auto!important}.p-sm-0{padding:0!important}.p-sm-1{padding:.25rem!important}.p-sm-2{padding:.5rem!important}.p-sm-3{padding:1rem!important}.p-sm-4{padding:1.5rem!important}.p-sm-5{padding:3rem!important}.px-sm-0{padding-right:0!important;padding-left:0!important}.px-sm-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0{padding-top:0!important;padding-bottom:0!important}.py-sm-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0{padding-top:0!important}.pt-sm-1{padding-top:.25rem!important}.pt-sm-2{padding-top:.5rem!important}.pt-sm-3{padding-top:1rem!important}.pt-sm-4{padding-top:1.5rem!important}.pt-sm-5{padding-top:3rem!important}.pe-sm-0{padding-right:0!important}.pe-sm-1{padding-right:.25rem!important}.pe-sm-2{padding-right:.5rem!important}.pe-sm-3{padding-right:1rem!important}.pe-sm-4{padding-right:1.5rem!important}.pe-sm-5{padding-right:3rem!important}.pb-sm-0{padding-bottom:0!important}.pb-sm-1{padding-bottom:.25rem!important}.pb-sm-2{padding-bottom:.5rem!important}.pb-sm-3{padding-bottom:1rem!important}.pb-sm-4{padding-bottom:1.5rem!important}.pb-sm-5{padding-bottom:3rem!important}.ps-sm-0{padding-left:0!important}.ps-sm-1{padding-left:.25rem!important}.ps-sm-2{padding-left:.5rem!important}.ps-sm-3{padding-left:1rem!important}.ps-sm-4{padding-left:1.5rem!important}.ps-sm-5{padding-left:3rem!important}.gap-sm-0{gap:0!important}.gap-sm-1{gap:.25rem!important}.gap-sm-2{gap:.5rem!important}.gap-sm-3{gap:1rem!important}.gap-sm-4{gap:1.5rem!important}.gap-sm-5{gap:3rem!important}.row-gap-sm-0{row-gap:0!important}.row-gap-sm-1{row-gap:.25rem!important}.row-gap-sm-2{row-gap:.5rem!important}.row-gap-sm-3{row-gap:1rem!important}.row-gap-sm-4{row-gap:1.5rem!important}.row-gap-sm-5{row-gap:3rem!important}.column-gap-sm-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-sm-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-sm-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-sm-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-sm-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-sm-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-sm-start{text-align:left!important}.text-sm-end{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.float-md-start{float:left!important}.float-md-end{float:right!important}.float-md-none{float:none!important}.object-fit-md-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-md-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-md-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-md-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-md-none{-o-object-fit:none!important;object-fit:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-grid{display:grid!important}.d-md-inline-grid{display:inline-grid!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}.d-md-none{display:none!important}.flex-md-fill{flex:1 1 auto!important}.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-grow-0{flex-grow:0!important}.flex-md-grow-1{flex-grow:1!important}.flex-md-shrink-0{flex-shrink:0!important}.flex-md-shrink-1{flex-shrink:1!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.justify-content-md-evenly{justify-content:space-evenly!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{align-self:stretch!important}.order-md-first{order:-1!important}.order-md-0{order:0!important}.order-md-1{order:1!important}.order-md-2{order:2!important}.order-md-3{order:3!important}.order-md-4{order:4!important}.order-md-5{order:5!important}.order-md-last{order:6!important}.m-md-0{margin:0!important}.m-md-1{margin:.25rem!important}.m-md-2{margin:.5rem!important}.m-md-3{margin:1rem!important}.m-md-4{margin:1.5rem!important}.m-md-5{margin:3rem!important}.m-md-auto{margin:auto!important}.mx-md-0{margin-right:0!important;margin-left:0!important}.mx-md-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto{margin-right:auto!important;margin-left:auto!important}.my-md-0{margin-top:0!important;margin-bottom:0!important}.my-md-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0{margin-top:0!important}.mt-md-1{margin-top:.25rem!important}.mt-md-2{margin-top:.5rem!important}.mt-md-3{margin-top:1rem!important}.mt-md-4{margin-top:1.5rem!important}.mt-md-5{margin-top:3rem!important}.mt-md-auto{margin-top:auto!important}.me-md-0{margin-right:0!important}.me-md-1{margin-right:.25rem!important}.me-md-2{margin-right:.5rem!important}.me-md-3{margin-right:1rem!important}.me-md-4{margin-right:1.5rem!important}.me-md-5{margin-right:3rem!important}.me-md-auto{margin-right:auto!important}.mb-md-0{margin-bottom:0!important}.mb-md-1{margin-bottom:.25rem!important}.mb-md-2{margin-bottom:.5rem!important}.mb-md-3{margin-bottom:1rem!important}.mb-md-4{margin-bottom:1.5rem!important}.mb-md-5{margin-bottom:3rem!important}.mb-md-auto{margin-bottom:auto!important}.ms-md-0{margin-left:0!important}.ms-md-1{margin-left:.25rem!important}.ms-md-2{margin-left:.5rem!important}.ms-md-3{margin-left:1rem!important}.ms-md-4{margin-left:1.5rem!important}.ms-md-5{margin-left:3rem!important}.ms-md-auto{margin-left:auto!important}.p-md-0{padding:0!important}.p-md-1{padding:.25rem!important}.p-md-2{padding:.5rem!important}.p-md-3{padding:1rem!important}.p-md-4{padding:1.5rem!important}.p-md-5{padding:3rem!important}.px-md-0{padding-right:0!important;padding-left:0!important}.px-md-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3{padding-right:1rem!important;padding-left:1rem!important}.px-md-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5{padding-right:3rem!important;padding-left:3rem!important}.py-md-0{padding-top:0!important;padding-bottom:0!important}.py-md-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0{padding-top:0!important}.pt-md-1{padding-top:.25rem!important}.pt-md-2{padding-top:.5rem!important}.pt-md-3{padding-top:1rem!important}.pt-md-4{padding-top:1.5rem!important}.pt-md-5{padding-top:3rem!important}.pe-md-0{padding-right:0!important}.pe-md-1{padding-right:.25rem!important}.pe-md-2{padding-right:.5rem!important}.pe-md-3{padding-right:1rem!important}.pe-md-4{padding-right:1.5rem!important}.pe-md-5{padding-right:3rem!important}.pb-md-0{padding-bottom:0!important}.pb-md-1{padding-bottom:.25rem!important}.pb-md-2{padding-bottom:.5rem!important}.pb-md-3{padding-bottom:1rem!important}.pb-md-4{padding-bottom:1.5rem!important}.pb-md-5{padding-bottom:3rem!important}.ps-md-0{padding-left:0!important}.ps-md-1{padding-left:.25rem!important}.ps-md-2{padding-left:.5rem!important}.ps-md-3{padding-left:1rem!important}.ps-md-4{padding-left:1.5rem!important}.ps-md-5{padding-left:3rem!important}.gap-md-0{gap:0!important}.gap-md-1{gap:.25rem!important}.gap-md-2{gap:.5rem!important}.gap-md-3{gap:1rem!important}.gap-md-4{gap:1.5rem!important}.gap-md-5{gap:3rem!important}.row-gap-md-0{row-gap:0!important}.row-gap-md-1{row-gap:.25rem!important}.row-gap-md-2{row-gap:.5rem!important}.row-gap-md-3{row-gap:1rem!important}.row-gap-md-4{row-gap:1.5rem!important}.row-gap-md-5{row-gap:3rem!important}.column-gap-md-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-md-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-md-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-md-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-md-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-md-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-md-start{text-align:left!important}.text-md-end{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.float-lg-start{float:left!important}.float-lg-end{float:right!important}.float-lg-none{float:none!important}.object-fit-lg-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-lg-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-lg-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-lg-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-lg-none{-o-object-fit:none!important;object-fit:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-grid{display:grid!important}.d-lg-inline-grid{display:inline-grid!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}.d-lg-none{display:none!important}.flex-lg-fill{flex:1 1 auto!important}.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-grow-0{flex-grow:0!important}.flex-lg-grow-1{flex-grow:1!important}.flex-lg-shrink-0{flex-shrink:0!important}.flex-lg-shrink-1{flex-shrink:1!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.justify-content-lg-evenly{justify-content:space-evenly!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{align-self:stretch!important}.order-lg-first{order:-1!important}.order-lg-0{order:0!important}.order-lg-1{order:1!important}.order-lg-2{order:2!important}.order-lg-3{order:3!important}.order-lg-4{order:4!important}.order-lg-5{order:5!important}.order-lg-last{order:6!important}.m-lg-0{margin:0!important}.m-lg-1{margin:.25rem!important}.m-lg-2{margin:.5rem!important}.m-lg-3{margin:1rem!important}.m-lg-4{margin:1.5rem!important}.m-lg-5{margin:3rem!important}.m-lg-auto{margin:auto!important}.mx-lg-0{margin-right:0!important;margin-left:0!important}.mx-lg-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto{margin-right:auto!important;margin-left:auto!important}.my-lg-0{margin-top:0!important;margin-bottom:0!important}.my-lg-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0{margin-top:0!important}.mt-lg-1{margin-top:.25rem!important}.mt-lg-2{margin-top:.5rem!important}.mt-lg-3{margin-top:1rem!important}.mt-lg-4{margin-top:1.5rem!important}.mt-lg-5{margin-top:3rem!important}.mt-lg-auto{margin-top:auto!important}.me-lg-0{margin-right:0!important}.me-lg-1{margin-right:.25rem!important}.me-lg-2{margin-right:.5rem!important}.me-lg-3{margin-right:1rem!important}.me-lg-4{margin-right:1.5rem!important}.me-lg-5{margin-right:3rem!important}.me-lg-auto{margin-right:auto!important}.mb-lg-0{margin-bottom:0!important}.mb-lg-1{margin-bottom:.25rem!important}.mb-lg-2{margin-bottom:.5rem!important}.mb-lg-3{margin-bottom:1rem!important}.mb-lg-4{margin-bottom:1.5rem!important}.mb-lg-5{margin-bottom:3rem!important}.mb-lg-auto{margin-bottom:auto!important}.ms-lg-0{margin-left:0!important}.ms-lg-1{margin-left:.25rem!important}.ms-lg-2{margin-left:.5rem!important}.ms-lg-3{margin-left:1rem!important}.ms-lg-4{margin-left:1.5rem!important}.ms-lg-5{margin-left:3rem!important}.ms-lg-auto{margin-left:auto!important}.p-lg-0{padding:0!important}.p-lg-1{padding:.25rem!important}.p-lg-2{padding:.5rem!important}.p-lg-3{padding:1rem!important}.p-lg-4{padding:1.5rem!important}.p-lg-5{padding:3rem!important}.px-lg-0{padding-right:0!important;padding-left:0!important}.px-lg-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0{padding-top:0!important;padding-bottom:0!important}.py-lg-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0{padding-top:0!important}.pt-lg-1{padding-top:.25rem!important}.pt-lg-2{padding-top:.5rem!important}.pt-lg-3{padding-top:1rem!important}.pt-lg-4{padding-top:1.5rem!important}.pt-lg-5{padding-top:3rem!important}.pe-lg-0{padding-right:0!important}.pe-lg-1{padding-right:.25rem!important}.pe-lg-2{padding-right:.5rem!important}.pe-lg-3{padding-right:1rem!important}.pe-lg-4{padding-right:1.5rem!important}.pe-lg-5{padding-right:3rem!important}.pb-lg-0{padding-bottom:0!important}.pb-lg-1{padding-bottom:.25rem!important}.pb-lg-2{padding-bottom:.5rem!important}.pb-lg-3{padding-bottom:1rem!important}.pb-lg-4{padding-bottom:1.5rem!important}.pb-lg-5{padding-bottom:3rem!important}.ps-lg-0{padding-left:0!important}.ps-lg-1{padding-left:.25rem!important}.ps-lg-2{padding-left:.5rem!important}.ps-lg-3{padding-left:1rem!important}.ps-lg-4{padding-left:1.5rem!important}.ps-lg-5{padding-left:3rem!important}.gap-lg-0{gap:0!important}.gap-lg-1{gap:.25rem!important}.gap-lg-2{gap:.5rem!important}.gap-lg-3{gap:1rem!important}.gap-lg-4{gap:1.5rem!important}.gap-lg-5{gap:3rem!important}.row-gap-lg-0{row-gap:0!important}.row-gap-lg-1{row-gap:.25rem!important}.row-gap-lg-2{row-gap:.5rem!important}.row-gap-lg-3{row-gap:1rem!important}.row-gap-lg-4{row-gap:1.5rem!important}.row-gap-lg-5{row-gap:3rem!important}.column-gap-lg-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-lg-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-lg-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-lg-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-lg-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-lg-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-lg-start{text-align:left!important}.text-lg-end{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.float-xl-start{float:left!important}.float-xl-end{float:right!important}.float-xl-none{float:none!important}.object-fit-xl-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-xl-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-xl-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-xl-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-xl-none{-o-object-fit:none!important;object-fit:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-grid{display:grid!important}.d-xl-inline-grid{display:inline-grid!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}.d-xl-none{display:none!important}.flex-xl-fill{flex:1 1 auto!important}.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-grow-0{flex-grow:0!important}.flex-xl-grow-1{flex-grow:1!important}.flex-xl-shrink-0{flex-shrink:0!important}.flex-xl-shrink-1{flex-shrink:1!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.justify-content-xl-evenly{justify-content:space-evenly!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{align-self:stretch!important}.order-xl-first{order:-1!important}.order-xl-0{order:0!important}.order-xl-1{order:1!important}.order-xl-2{order:2!important}.order-xl-3{order:3!important}.order-xl-4{order:4!important}.order-xl-5{order:5!important}.order-xl-last{order:6!important}.m-xl-0{margin:0!important}.m-xl-1{margin:.25rem!important}.m-xl-2{margin:.5rem!important}.m-xl-3{margin:1rem!important}.m-xl-4{margin:1.5rem!important}.m-xl-5{margin:3rem!important}.m-xl-auto{margin:auto!important}.mx-xl-0{margin-right:0!important;margin-left:0!important}.mx-xl-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto{margin-right:auto!important;margin-left:auto!important}.my-xl-0{margin-top:0!important;margin-bottom:0!important}.my-xl-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0{margin-top:0!important}.mt-xl-1{margin-top:.25rem!important}.mt-xl-2{margin-top:.5rem!important}.mt-xl-3{margin-top:1rem!important}.mt-xl-4{margin-top:1.5rem!important}.mt-xl-5{margin-top:3rem!important}.mt-xl-auto{margin-top:auto!important}.me-xl-0{margin-right:0!important}.me-xl-1{margin-right:.25rem!important}.me-xl-2{margin-right:.5rem!important}.me-xl-3{margin-right:1rem!important}.me-xl-4{margin-right:1.5rem!important}.me-xl-5{margin-right:3rem!important}.me-xl-auto{margin-right:auto!important}.mb-xl-0{margin-bottom:0!important}.mb-xl-1{margin-bottom:.25rem!important}.mb-xl-2{margin-bottom:.5rem!important}.mb-xl-3{margin-bottom:1rem!important}.mb-xl-4{margin-bottom:1.5rem!important}.mb-xl-5{margin-bottom:3rem!important}.mb-xl-auto{margin-bottom:auto!important}.ms-xl-0{margin-left:0!important}.ms-xl-1{margin-left:.25rem!important}.ms-xl-2{margin-left:.5rem!important}.ms-xl-3{margin-left:1rem!important}.ms-xl-4{margin-left:1.5rem!important}.ms-xl-5{margin-left:3rem!important}.ms-xl-auto{margin-left:auto!important}.p-xl-0{padding:0!important}.p-xl-1{padding:.25rem!important}.p-xl-2{padding:.5rem!important}.p-xl-3{padding:1rem!important}.p-xl-4{padding:1.5rem!important}.p-xl-5{padding:3rem!important}.px-xl-0{padding-right:0!important;padding-left:0!important}.px-xl-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0{padding-top:0!important;padding-bottom:0!important}.py-xl-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0{padding-top:0!important}.pt-xl-1{padding-top:.25rem!important}.pt-xl-2{padding-top:.5rem!important}.pt-xl-3{padding-top:1rem!important}.pt-xl-4{padding-top:1.5rem!important}.pt-xl-5{padding-top:3rem!important}.pe-xl-0{padding-right:0!important}.pe-xl-1{padding-right:.25rem!important}.pe-xl-2{padding-right:.5rem!important}.pe-xl-3{padding-right:1rem!important}.pe-xl-4{padding-right:1.5rem!important}.pe-xl-5{padding-right:3rem!important}.pb-xl-0{padding-bottom:0!important}.pb-xl-1{padding-bottom:.25rem!important}.pb-xl-2{padding-bottom:.5rem!important}.pb-xl-3{padding-bottom:1rem!important}.pb-xl-4{padding-bottom:1.5rem!important}.pb-xl-5{padding-bottom:3rem!important}.ps-xl-0{padding-left:0!important}.ps-xl-1{padding-left:.25rem!important}.ps-xl-2{padding-left:.5rem!important}.ps-xl-3{padding-left:1rem!important}.ps-xl-4{padding-left:1.5rem!important}.ps-xl-5{padding-left:3rem!important}.gap-xl-0{gap:0!important}.gap-xl-1{gap:.25rem!important}.gap-xl-2{gap:.5rem!important}.gap-xl-3{gap:1rem!important}.gap-xl-4{gap:1.5rem!important}.gap-xl-5{gap:3rem!important}.row-gap-xl-0{row-gap:0!important}.row-gap-xl-1{row-gap:.25rem!important}.row-gap-xl-2{row-gap:.5rem!important}.row-gap-xl-3{row-gap:1rem!important}.row-gap-xl-4{row-gap:1.5rem!important}.row-gap-xl-5{row-gap:3rem!important}.column-gap-xl-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-xl-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-xl-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-xl-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-xl-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-xl-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-xl-start{text-align:left!important}.text-xl-end{text-align:right!important}.text-xl-center{text-align:center!important}}@media (min-width:1400px){.float-xxl-start{float:left!important}.float-xxl-end{float:right!important}.float-xxl-none{float:none!important}.object-fit-xxl-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-xxl-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-xxl-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-xxl-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-xxl-none{-o-object-fit:none!important;object-fit:none!important}.d-xxl-inline{display:inline!important}.d-xxl-inline-block{display:inline-block!important}.d-xxl-block{display:block!important}.d-xxl-grid{display:grid!important}.d-xxl-inline-grid{display:inline-grid!important}.d-xxl-table{display:table!important}.d-xxl-table-row{display:table-row!important}.d-xxl-table-cell{display:table-cell!important}.d-xxl-flex{display:flex!important}.d-xxl-inline-flex{display:inline-flex!important}.d-xxl-none{display:none!important}.flex-xxl-fill{flex:1 1 auto!important}.flex-xxl-row{flex-direction:row!important}.flex-xxl-column{flex-direction:column!important}.flex-xxl-row-reverse{flex-direction:row-reverse!important}.flex-xxl-column-reverse{flex-direction:column-reverse!important}.flex-xxl-grow-0{flex-grow:0!important}.flex-xxl-grow-1{flex-grow:1!important}.flex-xxl-shrink-0{flex-shrink:0!important}.flex-xxl-shrink-1{flex-shrink:1!important}.flex-xxl-wrap{flex-wrap:wrap!important}.flex-xxl-nowrap{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xxl-start{justify-content:flex-start!important}.justify-content-xxl-end{justify-content:flex-end!important}.justify-content-xxl-center{justify-content:center!important}.justify-content-xxl-between{justify-content:space-between!important}.justify-content-xxl-around{justify-content:space-around!important}.justify-content-xxl-evenly{justify-content:space-evenly!important}.align-items-xxl-start{align-items:flex-start!important}.align-items-xxl-end{align-items:flex-end!important}.align-items-xxl-center{align-items:center!important}.align-items-xxl-baseline{align-items:baseline!important}.align-items-xxl-stretch{align-items:stretch!important}.align-content-xxl-start{align-content:flex-start!important}.align-content-xxl-end{align-content:flex-end!important}.align-content-xxl-center{align-content:center!important}.align-content-xxl-between{align-content:space-between!important}.align-content-xxl-around{align-content:space-around!important}.align-content-xxl-stretch{align-content:stretch!important}.align-self-xxl-auto{align-self:auto!important}.align-self-xxl-start{align-self:flex-start!important}.align-self-xxl-end{align-self:flex-end!important}.align-self-xxl-center{align-self:center!important}.align-self-xxl-baseline{align-self:baseline!important}.align-self-xxl-stretch{align-self:stretch!important}.order-xxl-first{order:-1!important}.order-xxl-0{order:0!important}.order-xxl-1{order:1!important}.order-xxl-2{order:2!important}.order-xxl-3{order:3!important}.order-xxl-4{order:4!important}.order-xxl-5{order:5!important}.order-xxl-last{order:6!important}.m-xxl-0{margin:0!important}.m-xxl-1{margin:.25rem!important}.m-xxl-2{margin:.5rem!important}.m-xxl-3{margin:1rem!important}.m-xxl-4{margin:1.5rem!important}.m-xxl-5{margin:3rem!important}.m-xxl-auto{margin:auto!important}.mx-xxl-0{margin-right:0!important;margin-left:0!important}.mx-xxl-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto{margin-right:auto!important;margin-left:auto!important}.my-xxl-0{margin-top:0!important;margin-bottom:0!important}.my-xxl-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0{margin-top:0!important}.mt-xxl-1{margin-top:.25rem!important}.mt-xxl-2{margin-top:.5rem!important}.mt-xxl-3{margin-top:1rem!important}.mt-xxl-4{margin-top:1.5rem!important}.mt-xxl-5{margin-top:3rem!important}.mt-xxl-auto{margin-top:auto!important}.me-xxl-0{margin-right:0!important}.me-xxl-1{margin-right:.25rem!important}.me-xxl-2{margin-right:.5rem!important}.me-xxl-3{margin-right:1rem!important}.me-xxl-4{margin-right:1.5rem!important}.me-xxl-5{margin-right:3rem!important}.me-xxl-auto{margin-right:auto!important}.mb-xxl-0{margin-bottom:0!important}.mb-xxl-1{margin-bottom:.25rem!important}.mb-xxl-2{margin-bottom:.5rem!important}.mb-xxl-3{margin-bottom:1rem!important}.mb-xxl-4{margin-bottom:1.5rem!important}.mb-xxl-5{margin-bottom:3rem!important}.mb-xxl-auto{margin-bottom:auto!important}.ms-xxl-0{margin-left:0!important}.ms-xxl-1{margin-left:.25rem!important}.ms-xxl-2{margin-left:.5rem!important}.ms-xxl-3{margin-left:1rem!important}.ms-xxl-4{margin-left:1.5rem!important}.ms-xxl-5{margin-left:3rem!important}.ms-xxl-auto{margin-left:auto!important}.p-xxl-0{padding:0!important}.p-xxl-1{padding:.25rem!important}.p-xxl-2{padding:.5rem!important}.p-xxl-3{padding:1rem!important}.p-xxl-4{padding:1.5rem!important}.p-xxl-5{padding:3rem!important}.px-xxl-0{padding-right:0!important;padding-left:0!important}.px-xxl-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0{padding-top:0!important;padding-bottom:0!important}.py-xxl-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0{padding-top:0!important}.pt-xxl-1{padding-top:.25rem!important}.pt-xxl-2{padding-top:.5rem!important}.pt-xxl-3{padding-top:1rem!important}.pt-xxl-4{padding-top:1.5rem!important}.pt-xxl-5{padding-top:3rem!important}.pe-xxl-0{padding-right:0!important}.pe-xxl-1{padding-right:.25rem!important}.pe-xxl-2{padding-right:.5rem!important}.pe-xxl-3{padding-right:1rem!important}.pe-xxl-4{padding-right:1.5rem!important}.pe-xxl-5{padding-right:3rem!important}.pb-xxl-0{padding-bottom:0!important}.pb-xxl-1{padding-bottom:.25rem!important}.pb-xxl-2{padding-bottom:.5rem!important}.pb-xxl-3{padding-bottom:1rem!important}.pb-xxl-4{padding-bottom:1.5rem!important}.pb-xxl-5{padding-bottom:3rem!important}.ps-xxl-0{padding-left:0!important}.ps-xxl-1{padding-left:.25rem!important}.ps-xxl-2{padding-left:.5rem!important}.ps-xxl-3{padding-left:1rem!important}.ps-xxl-4{padding-left:1.5rem!important}.ps-xxl-5{padding-left:3rem!important}.gap-xxl-0{gap:0!important}.gap-xxl-1{gap:.25rem!important}.gap-xxl-2{gap:.5rem!important}.gap-xxl-3{gap:1rem!important}.gap-xxl-4{gap:1.5rem!important}.gap-xxl-5{gap:3rem!important}.row-gap-xxl-0{row-gap:0!important}.row-gap-xxl-1{row-gap:.25rem!important}.row-gap-xxl-2{row-gap:.5rem!important}.row-gap-xxl-3{row-gap:1rem!important}.row-gap-xxl-4{row-gap:1.5rem!important}.row-gap-xxl-5{row-gap:3rem!important}.column-gap-xxl-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-xxl-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-xxl-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-xxl-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-xxl-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-xxl-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-xxl-start{text-align:left!important}.text-xxl-end{text-align:right!important}.text-xxl-center{text-align:center!important}}@media (min-width:1200px){.fs-1{font-size:2.5rem!important}.fs-2{font-size:2rem!important}.fs-3{font-size:1.75rem!important}.fs-4{font-size:1.5rem!important}}@media print{.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-grid{display:grid!important}.d-print-inline-grid{display:inline-grid!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}.d-print-none{display:none!important}}";
n(css$q,{});

/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
function TwoRadioSelection(_ref) {
  let {
    name,
    label,
    firstOption,
    firstOptionId,
    secondOption,
    secondOptionId,
    onSelectionChange,
    large,
    required
  } = _ref;
  const [selectedValue, setSelectedValue] = useState({
    name,
    value: firstOptionId
  });
  function handleChange(event) {
    setSelectedValue({
      name,
      value: event.target.id
    });
    onSelectionChange({
      name,
      value: event.target.id
    });
  }
  useEffect(() => {
    onSelectionChange(selectedValue);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_341490ba.formGroup, " ").concat(modules_341490ba.twoRadioContainer)
  }, label && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("b", null, label), required && /*#__PURE__*/React.createElement("span", {
    className: modules_341490ba.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: large ? "".concat(modules_341490ba.twoRadioSelection, " ").concat(modules_341490ba.large) : modules_341490ba.twoRadioSelection
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: firstOptionId,
    id: firstOptionId,
    checked: firstOptionId === selectedValue.value,
    value: firstOption,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: firstOptionId,
    className: "".concat(modules_341490ba.option, " ").concat(modules_341490ba.option1)
  }, /*#__PURE__*/React.createElement("span", null, firstOption)), large ? /*#__PURE__*/React.createElement("span", {
    className: modules_341490ba.divider
  }, "or") : '', /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: secondOptionId,
    id: secondOptionId,
    checked: secondOptionId === selectedValue.value,
    value: secondOption,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: secondOptionId,
    className: "".concat(modules_341490ba.option, " ").concat(modules_341490ba.option2)
  }, /*#__PURE__*/React.createElement("span", null, secondOption))));
}
TwoRadioSelection.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  large: PropTypes.bool,
  firstOption: PropTypes.string,
  firstOptionId: PropTypes.string,
  secondOption: PropTypes.string,
  secondOptionId: PropTypes.string,
  onSelectionChange: PropTypes.func,
  required: PropTypes.bool
};
TwoRadioSelection.defaultProps = {
  name: 'TwoRadioSelection',
  label: '',
  large: false,
  firstOption: 'Option 1',
  firstOptionId: 'option-1',
  secondOption: 'Option 2',
  secondOptionId: 'option-2',
  onSelectionChange: () => {},
  required: false
};

var css$p = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac.threeRadioSelection_module_formGroup__2dc0d6ac {\n  margin: auto;\n  margin-bottom: 30px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac {\n  display: inline-flex;\n  min-width: 300px;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  padding: 6px;\n  background: #f3f3f3;\n  gap: 6px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac {\n  height: 100%;\n  width: 100%;\n  max-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-family: Rubik;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac::nth-of-type(odd) {\n  margin-right: 6px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac span {\n  font-size: 14px;\n  color: #000;\n  padding: 6px 20px;\n  min-width: 130px;\n  text-align: center;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_divider__2dc0d6ac {\n  position: relative;\n  padding: 0px 90px;\n  font-weight: 600;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_divider__2dc0d6ac:before, .threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_divider__2dc0d6ac:after {\n  content: \" \";\n  background: #dadada;\n  width: 50px;\n  height: 1px;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_divider__2dc0d6ac:before {\n  left: 0%;\n  margin-left: 20px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac .threeRadioSelection_module_divider__2dc0d6ac:after {\n  right: 0%;\n  margin-right: 20px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac input[type=radio] {\n  display: none;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac.threeRadioSelection_module_large__2dc0d6ac {\n  padding: 20px 15px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac.threeRadioSelection_module_large__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac {\n  margin: 0 10px;\n  padding: 0 10px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac.threeRadioSelection_module_large__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac::nth-of-type(odd) {\n  margin-right: 0px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac.threeRadioSelection_module_large__2dc0d6ac .threeRadioSelection_module_option__2dc0d6ac span {\n  font-size: 20px;\n  padding: 12px 20px;\n}\n.threeRadioSelection_module_twoRadioContainer__2dc0d6ac .threeRadioSelection_module_twoRadioSelection__2dc0d6ac input:checked:checked + label {\n  border: 2px solid #0279a3;\n  background: #fff;\n}";
var modules_cc997f5e = {"twoRadioContainer":"threeRadioSelection_module_twoRadioContainer__2dc0d6ac","formGroup":"threeRadioSelection_module_formGroup__2dc0d6ac","twoRadioSelection":"threeRadioSelection_module_twoRadioSelection__2dc0d6ac","option":"threeRadioSelection_module_option__2dc0d6ac","divider":"threeRadioSelection_module_divider__2dc0d6ac","large":"threeRadioSelection_module_large__2dc0d6ac"};
n(css$p,{});

/* eslint-disable jsx-a11y/label-has-associated-control */
function ThreeRadioSelection(_ref) {
  let {
    name,
    label,
    options,
    onSelectionChange,
    large,
    required,
    selectedValue
  } = _ref;
  function handleChange(event) {
    onSelectionChange({
      name,
      value: event.target.id
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_cc997f5e.formGroup, " ").concat(modules_cc997f5e.twoRadioContainer)
  }, label && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("b", null, label), required && /*#__PURE__*/React.createElement("span", {
    className: modules_cc997f5e.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: large ? "".concat(modules_cc997f5e.twoRadioSelection, " ").concat(modules_cc997f5e.large) : modules_cc997f5e.twoRadioSelection
  }, options.map((option, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: option.id
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    id: option.id,
    checked: option.id === selectedValue,
    value: option.label,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: option.id,
    className: "".concat(modules_cc997f5e.option, " ").concat(modules_cc997f5e.option).concat(index + 1)
  }, /*#__PURE__*/React.createElement("span", null, option.label)), large && index < options.length - 1 ? /*#__PURE__*/React.createElement("span", {
    className: modules_cc997f5e.divider
  }, "or") : ''))));
}
ThreeRadioSelection.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  large: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string
  })),
  onSelectionChange: PropTypes.func,
  required: PropTypes.bool,
  selectedValue: PropTypes.string // Added prop type for controlled selected value
};
ThreeRadioSelection.defaultProps = {
  name: 'ThreeRadioSelection',
  label: '',
  large: false,
  options: [{
    id: 'morning',
    label: 'Morning'
  }, {
    id: 'afternoon',
    label: 'Afternoon'
  }, {
    id: 'evening',
    label: 'Evening'
  }],
  onSelectionChange: () => {},
  required: false,
  selectedValue: 'morning' // Default value if needed
};

var css$o = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 {\n  display: inline-flex;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  padding: 26px;\n  background: #f3f3f3;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 .verticalRadioSelection_module_option__e72a1712 {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: normal;\n  font-family: Rubik;\n  border: 2px solid transparent;\n  background: #fff;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 .verticalRadioSelection_module_option__e72a1712::nth-of-type(odd) {\n  margin-right: 6px;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 .verticalRadioSelection_module_option__e72a1712 span {\n  font-size: 14px;\n  color: #000;\n  padding: 6px 20px;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 input[type=radio] {\n  display: none;\n}\n.verticalRadioSelection_module_verticalRadioContainer__e72a1712 .verticalRadioSelection_module_verticalRadioSelection__e72a1712 input:checked:checked + label {\n  border: 2px solid #0279a3;\n  background: #fff;\n}";
var modules_d4036662 = {"verticalRadioContainer":"verticalRadioSelection_module_verticalRadioContainer__e72a1712","verticalRadioSelection":"verticalRadioSelection_module_verticalRadioSelection__e72a1712","option":"verticalRadioSelection_module_option__e72a1712"};
n(css$o,{});

/* eslint-disable jsx-a11y/label-has-associated-control */
function VerticalRadioSelection(_ref) {
  let {
    name,
    label,
    onVerticalSelectChange,
    required,
    items
  } = _ref;
  const [selectedValue, setSelectedValue] = useState(null);
  function handleChange(event) {
    setSelectedValue(event.target.value);
    onVerticalSelectChange({
      name,
      value: event.target.value
    });
  }
  useEffect(() => {
    onVerticalSelectChange(selectedValue);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_d4036662.formGroup, " ").concat(modules_d4036662.verticalRadioContainer)
  }, label && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("b", null, label), required && /*#__PURE__*/React.createElement("span", {
    className: modules_d4036662.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: modules_d4036662.verticalRadioSelection
  }, items.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: item.id,
    id: item.id,
    checked: item.id === selectedValue,
    value: item.id,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: item.id,
    className: "".concat(modules_d4036662.option, " ").concat(modules_d4036662.option1)
  }, /*#__PURE__*/React.createElement("span", null, item.text))))));
}
VerticalRadioSelection.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  // subtitle: PropTypes.string,
  onVerticalSelectChange: PropTypes.func,
  required: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array
};
VerticalRadioSelection.defaultProps = {
  name: 'verticalRadioSelection',
  label: 'This is a title',
  // subtitle: 'This is a subtitle',
  onVerticalSelectChange: () => {},
  required: false,
  items: [{
    id: 'verticalSelect3',
    text: 'No, make this a new booking'
  }]
};

const BookingContext = /*#__PURE__*/createContext();
function BookingProvider(_ref) {
  let {
    children
  } = _ref;
  const [bookingData, setBookingData] = useState([]);
  const [bookingDataTotal, setBookingDataTotal] = useState(0);
  const [bookingDataTotalDiscount, setBookingDataTotalDiscount] = useState(0);
  const [services, setServices] = useState([]);
  const [specialists, setSpecialists] = useState([]);
  const [servicesAndSpecialists, setServicesAndSpecialists] = useState([]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [bookingStep, setBookingStep] = useState('services');
  const [currentBookingId, setCurrentBookingId] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [selectedServiceCategories, setSelectedServiceCategories] = useState([]);
  const [selectedSpecialistCategories, setSelectedSpecialistCategories] = useState([]);
  const [selectedLocationCategory, setSelectedLocationCategory] = useState('London');
  const [discountCodeResponse, setDiscountCodeResponse] = useState({});
  const [benefitPointsToUse, setBenefitPointsToUse] = useState(0);
  const [userHasChosenLocation, setUserHasChosenLocation] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Load saved bookingData from localStorage
  useEffect(() => {
    const savedBookingData = JSON.parse(localStorage.getItem('bookingData'));
    const expiryTime = localStorage.getItem('bookingDataExpiry');
    const currentTime = new Date().getTime();
    if (savedBookingData && expiryTime && currentTime < expiryTime) {
      setBookingData(savedBookingData);
    }
    setIsLoading(false);
  }, []);

  // Save bookingData to localStorage with a 24-hour expiry
  useEffect(() => {
    if (!isLoading) {
      const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours from now
      localStorage.setItem('bookingData', JSON.stringify(bookingData));
      localStorage.setItem('bookingDataExpiry', expiryTime);
    }
  }, [bookingData, isLoading]);
  const contextValue = useMemo(() => ({
    services,
    setServices,
    specialists,
    setSpecialists,
    servicesAndSpecialists,
    setServicesAndSpecialists,
    serviceCategories,
    setServiceCategories,
    selectedLocationCategory,
    setSelectedLocationCategory,
    bookingStep,
    setBookingStep,
    bookingData,
    setBookingData,
    bookingDataTotal,
    setBookingDataTotal,
    bookingDataTotalDiscount,
    setBookingDataTotalDiscount,
    filteredData,
    setFilteredData,
    currentBookingId,
    setCurrentBookingId,
    selectedServiceCategories,
    setSelectedServiceCategories,
    selectedSpecialistCategories,
    setSelectedSpecialistCategories,
    discountCodeResponse,
    setDiscountCodeResponse,
    benefitPointsToUse,
    setBenefitPointsToUse,
    userHasChosenLocation,
    setUserHasChosenLocation
  }), [services, setServices, specialists, setSpecialists, servicesAndSpecialists, setServicesAndSpecialists, serviceCategories, setServiceCategories, selectedLocationCategory, setSelectedLocationCategory, bookingStep, setBookingStep, bookingData, setBookingData, bookingDataTotal, setBookingDataTotal, bookingDataTotalDiscount, setBookingDataTotalDiscount, filteredData, setFilteredData, currentBookingId, setCurrentBookingId, selectedServiceCategories, setSelectedServiceCategories, selectedSpecialistCategories, setSelectedSpecialistCategories, discountCodeResponse, setDiscountCodeResponse, benefitPointsToUse, setBenefitPointsToUse, userHasChosenLocation, setUserHasChosenLocation]);
  return /*#__PURE__*/React.createElement(BookingContext.Provider, {
    value: contextValue
  }, children);
}
BookingProvider.propTypes = {
  children: PropTypes.node.isRequired
};

var css$n = ".cartSummary_module_cartSummary__d4786588 {\n  position: relative;\n  max-width: 500px;\n  width: 100%;\n  background: #fff;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.0196078431);\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_productImg__d4786588 {\n  max-width: 42px;\n  border-radius: 42px;\n}\n.cartSummary_module_cartSummary__d4786588 h2 {\n  padding: 25px 25px 0 25px;\n}\n.cartSummary_module_cartSummary__d4786588 p {\n  padding: 0 25px;\n}\n.cartSummary_module_cartSummary__d4786588 li {\n  border-bottom: 1px solid #e4e4e4;\n  display: flex;\n  align-items: center;\n  padding: 16px 25px;\n}\n.cartSummary_module_cartSummary__d4786588 label {\n  display: none;\n}\n.cartSummary_module_cartSummary__d4786588 button {\n  background: none;\n  border: none;\n  margin-left: 10px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_name__d4786588 {\n  flex-grow: 1;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_priceContainer__d4786588 {\n  display: flex;\n  flex-direction: column;\n  max-width: 136px;\n  width: 100%;\n  gap: 5px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_priceContainer__d4786588 .cartSummary_module_discount__d4786588 {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  padding: 0;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 14px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_priceContainer__d4786588 .cartSummary_module_price__d4786588 {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  padding: 0;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 16px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_total__d4786588 {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  justify-content: space-between;\n  margin-right: 22px;\n  height: 100%;\n  padding: 25px 25px 0 25px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_removeConfirmation__d4786588 ~ .cartSummary_module_cartSummaryInner__d4786588 {\n  filter: blur(3px);\n  transition: 0.1s;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_removeConfirmation__d4786588 {\n  box-shadow: 0px 6px 60px 20px rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  padding: 12px;\n  width: 80%;\n  position: absolute;\n  background: #fff;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 999;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_removeConfirmation__d4786588 h3 {\n  font-size: 20px;\n  padding: 10px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_removeConfirmation__d4786588 p {\n  font-weight: 600;\n  padding: 0 10px;\n}\n.cartSummary_module_cartSummary__d4786588 .cartSummary_module_removeConfirmation__d4786588 .cartSummary_module_buttons__d4786588 {\n  display: inline;\n  float: right;\n}\n.cartSummary_module_cartSummary__d4786588:after {\n  background: linear-gradient(-45deg, transparent 16px, #ffffff 0), linear-gradient(45deg, transparent 16px, #ffffff 0);\n  background-repeat: repeat-x;\n  background-position: left bottom;\n  background-size: 22px 13px;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 32px;\n  position: relative;\n  top: 10px;\n  left: 0px;\n}";
var modules_4b78aa2a = {"cartSummary":"cartSummary_module_cartSummary__d4786588","productImg":"cartSummary_module_productImg__d4786588","name":"cartSummary_module_name__d4786588","priceContainer":"cartSummary_module_priceContainer__d4786588","discount":"cartSummary_module_discount__d4786588","price":"cartSummary_module_price__d4786588","total":"cartSummary_module_total__d4786588","removeConfirmation":"cartSummary_module_removeConfirmation__d4786588","cartSummaryInner":"cartSummary_module_cartSummaryInner__d4786588","buttons":"cartSummary_module_buttons__d4786588"};
n(css$n,{});

var img$7 = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect y='0.707107' width='1' height='18' transform='rotate(-45 0 0.707107)' fill='black'/%3e%3crect x='0.707031' y='13.4351' width='1' height='18' transform='rotate(-135 0.707031 13.4351)' fill='black'/%3e%3c/svg%3e";

/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
function CartSummary(_ref) {
  let {
    membershipData,
    services,
    specialists,
    onPrevStep,
    hideRemove
  } = _ref;
  const {
    setBookingStep,
    bookingData,
    setBookingData,
    bookingDataTotal,
    setBookingDataTotal,
    bookingDataTotalDiscount,
    setBookingDataTotalDiscount,
    currentBookingId
  } = useContext(BookingContext);
  const [bookingIdToRemove, setBookingIdToRemove] = useState(null);
  const [bookingNameToRemove, setBookingNameToRemove] = useState(null);

  // Match and append price and cart-friendly name to bookingData item
  useEffect(() => {
    if (!services || !specialists) {
      return;
    }
    const bookingDataWithPrice = bookingData.map(item => {
      let newItem = {
        ...item
      };
      if (item.specialistId) {
        const specialist = specialists.find(matchSpecialist => matchSpecialist.user_id === item.specialistId);
        if (specialist) {
          newItem = {
            ...newItem,
            price: specialist.metadata.price !== null && specialist.metadata.price !== undefined ? Number(specialist.metadata.price) : 125,
            // There is no price in metadata for specialists
            cartName: "".concat(specialist.metadata.first_name, " ").concat(specialist.metadata.last_name),
            avatar: specialist.metadata.avatar
          };
        }
      }
      if (item.service.serviceId) {
        const service = services.find(matchService => matchService.service_code === item.service.serviceId);
        if (service) {
          newItem = {
            ...newItem,
            price: service.service_price,
            cartName: service.service_name,
            icon: service.service_icon
          };
        }
      }
      return newItem;
    });
    setBookingData(bookingDataWithPrice);
  }, [services, specialists]);
  const total = Math.max(bookingData.reduce((subtotal, _ref2) => {
    let {
      service
    } = _ref2;
    return subtotal + service.price;
  },
  // * item.service.quantity, <!-- Quantity to be implemented
  0), 0);
  const handleRemoveClick = bookingId => {
    const itemToRemove = bookingData.find(item => item.booking.bookingId === bookingId);
    setBookingNameToRemove(itemToRemove.service.serviceName);
    setBookingIdToRemove(bookingId);
  };
  const handleCancelRemoveClick = () => {
    setBookingIdToRemove(null);
  };
  const handleConfirmRemoveClick = () => {
    // Remove the item from bookingData
    const updatedBookingData = bookingData.filter(item => item.booking.bookingId !== bookingIdToRemove);

    // Calculate the total price of the remaining items
    const newTotal = updatedBookingData.reduce((subtotal, item) => subtotal + item.service.price, 0);

    // Calculate the discount based on the new subtotal
    let discount = 0;
    if (membershipData && membershipData.service_discount) {
      // Apply the membership discount percentage
      discount = newTotal * membershipData.service_discount / 100;
    }

    // Update bookingDataTotalDiscount in the context
    setBookingDataTotalDiscount(discount);

    // Update bookingDataTotal in the context
    setBookingDataTotal(Math.max(0, newTotal - discount));
    setBookingData(updatedBookingData);
    setBookingIdToRemove(null);
  };
  const tooltipContents = /*#__PURE__*/React.createElement("span", null, "Members receive 10% off the total order, plus lots more ", /*#__PURE__*/React.createElement("a", {
    href: "https://sirkkahealth.com"
  }, "members benefits"), "!");
  return /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.cartSummary
  }, bookingIdToRemove && /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.removeConfirmation
  }, /*#__PURE__*/React.createElement("h3", null, "Remove from order"), /*#__PURE__*/React.createElement("p", null, "Are you sure you want to remove ", bookingNameToRemove, "?"), /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "border",
    label: "Cancel",
    onClick: handleCancelRemoveClick
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Remove",
    onClick: handleConfirmRemoveClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.cartSummaryInner
  }, /*#__PURE__*/React.createElement("h2", null, "Your order"), /*#__PURE__*/React.createElement("p", null, "Become a Sirkka Health member to receive a discounted price", /*#__PURE__*/React.createElement(Tooltip, {
    contents: tooltipContents
  })), /*#__PURE__*/React.createElement("ul", null, bookingData.map(item => {
    const itemPrice = item.service.price && !Number.isNaN(item.service.price) ? (item.service.price / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }) : null;
    return /*#__PURE__*/React.createElement("li", {
      key: item.service.bookingId
    }, /*#__PURE__*/React.createElement("img", {
      className: modules_4b78aa2a.productImg,
      src: item.service.icon ? "/img/icon/".concat(item.service.icon, ".png") : "/img/doctor/".concat(item.service.avatar),
      alt: item.service.serviceName
    }), /*#__PURE__*/React.createElement("div", {
      className: modules_4b78aa2a.name
    }, item.service.serviceName), /*#__PURE__*/React.createElement("label", {
      htmlFor: item.service.serviceName
    }, "Quantity:"), /*#__PURE__*/React.createElement("div", {
      className: modules_4b78aa2a.price,
      style: hideRemove ? {
        paddingRight: '20px'
      } : null
    }, ' ', itemPrice, ' '), hideRemove ? null : /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => handleRemoveClick(item.booking.bookingId)
    }, /*#__PURE__*/React.createElement("img", {
      src: img$7,
      alt: "remove from cart"
    })));
  }))), /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.total
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "border",
    label: "Add another service",
    onClick: onPrevStep
  }), /*#__PURE__*/React.createElement("div", {
    className: modules_4b78aa2a.priceContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: modules_4b78aa2a.discount
  }, Boolean(bookingDataTotal + bookingDataTotalDiscount && !Number.isNaN(bookingDataTotal + bookingDataTotalDiscount)) && /*#__PURE__*/React.createElement("span", null, "Subtotal:"), Boolean(bookingDataTotal + bookingDataTotalDiscount && !Number.isNaN(bookingDataTotal + bookingDataTotalDiscount)) && /*#__PURE__*/React.createElement("span", null, ((bookingDataTotal + bookingDataTotalDiscount) / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))), /*#__PURE__*/React.createElement("span", {
    className: modules_4b78aa2a.discount
  }, Boolean(bookingDataTotalDiscount && !Number.isNaN(bookingDataTotalDiscount)) && /*#__PURE__*/React.createElement("span", null, "Discount:"), Boolean(bookingDataTotalDiscount && !Number.isNaN(bookingDataTotalDiscount)) && /*#__PURE__*/React.createElement("span", null, "-", (bookingDataTotalDiscount / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))), /*#__PURE__*/React.createElement("span", {
    className: modules_4b78aa2a.price
  }, "Total:", /*#__PURE__*/React.createElement("span", null, ((bookingDataTotal !== null && bookingDataTotal !== undefined ? bookingDataTotal : total) / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))))));
}

var css$m = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.datePicker_module_label__648fed1f {\n  color: #333;\n  margin: 20px auto 10px auto;\n  text-align: center;\n}\n\n.datePicker_module_datePicker__648fed1f {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  padding: 12px 40px;\n  background: #f3f3f3;\n  position: relative;\n  width: 100%;\n}\n.datePicker_module_datePicker__648fed1f.datePicker_module_formGroup__648fed1f {\n  max-width: 470px;\n  margin: auto;\n  margin-bottom: 30px;\n}\n.datePicker_module_datePicker__648fed1f input[type=radio] {\n  display: none;\n}\n.datePicker_module_datePicker__648fed1f input[type=radio] + label {\n  cursor: pointer;\n  font-size: 14px;\n  color: #000;\n  min-width: 60px;\n  text-align: center;\n  border: 2px solid transparent;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  padding: 12px 0;\n  margin-right: 12px;\n  background: #fff;\n}\n.datePicker_module_datePicker__648fed1f input[type=radio]:checked + label {\n  border: 2px solid #0279a3;\n  background: #fff;\n}\n.datePicker_module_datePicker__648fed1f input[type=radio]:disabled + label {\n  background: #e4e4e4;\n}\n.datePicker_module_datePicker__648fed1f .datePicker_module_dateSlider__648fed1f {\n  display: flex;\n}\n.datePicker_module_datePicker__648fed1f .datePicker_module_dateControl__648fed1f {\n  background: #fff;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  border: none;\n  border: 2px solid transparent;\n  box-shadow: -2px 2px 3px rgba(0, 0, 0, 0.0901960784);\n}\n.datePicker_module_datePicker__648fed1f .datePicker_module_dateControl__648fed1f.datePicker_module_left__648fed1f {\n  left: -10px;\n}\n.datePicker_module_datePicker__648fed1f .datePicker_module_dateControl__648fed1f.datePicker_module_right__648fed1f {\n  right: -10px;\n}\n.datePicker_module_datePicker__648fed1f .datePicker_module_dateControl__648fed1f.datePicker_module_dateControl__648fed1f:hover {\n  border: 2px solid #0279a3;\n  transition: 0.3s;\n}";
var modules_406a9d33 = {"label":"datePicker_module_label__648fed1f","datePicker":"datePicker_module_datePicker__648fed1f","formGroup":"datePicker_module_formGroup__648fed1f","dateSlider":"datePicker_module_dateSlider__648fed1f","dateControl":"datePicker_module_dateControl__648fed1f","left":"datePicker_module_left__648fed1f","right":"datePicker_module_right__648fed1f"};
n(css$m,{});

/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
function formatDate(dateString) {
  const date = new Date(dateString);
  const dayOfMonth = date.getDate();
  const month = new Intl.DateTimeFormat('en-GB', {
    month: 'short'
  }).format(date);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, dayOfMonth), /*#__PURE__*/React.createElement("span", null, month));
}
function DatePicker(_ref) {
  let {
    name,
    onDateChange,
    availabilityData,
    label,
    required,
    clearSelectedDate,
    setClearSelectedDate
  } = _ref;
  const [cardsToShow, setCardsToShow] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState('');
  const [availabilityDate, setAvailabilityDate] = useState(availabilityData);
  useEffect(() => {
    setAvailabilityDate(availabilityData);
  }, [availabilityData]);

  // Once availabilityDate is set, attempt to select the first available date by default
  useEffect(() => {
    const newDates = Object.keys(availabilityDate);
    if (newDates.length > 0 && !selectedDate) {
      const firstOpenDate = newDates.find(date => availabilityDate[date].businessOpen);
      const defaultDate = firstOpenDate || newDates[0];
      setSelectedDate(defaultDate);
      onDateChange({
        name,
        value: defaultDate
      });
    }
  }, [availabilityDate, selectedDate, onDateChange, name]);
  const dates = Object.keys(availabilityDate);
  const handleNext = () => {
    setStartIndex(startIndex + cardsToShow);
  };
  const handlePrev = () => {
    setStartIndex(startIndex - cardsToShow);
  };
  const handleDateSelection = e => {
    setSelectedDate(e.target.value);
    onDateChange({
      name,
      value: e.target.value
    });
  };
  useEffect(() => {
    if (clearSelectedDate) {
      setSelectedDate('');
      setClearSelectedDate(false);
    }
  }, [clearSelectedDate]);
  useEffect(() => {
    onDateChange({
      name,
      value: selectedDate
    });
  }, [selectedDate]);
  useEffect(() => {
    function handleResize() {
      const datePickerElement = document.querySelector(".".concat(modules_406a9d33.datePicker));
      const formGroupElement = document.querySelector(".formGroup");
      const cardElement = document.querySelector(".".concat(modules_406a9d33.datePicker, " input[type=radio] + label"));
      if (datePickerElement && formGroupElement && cardElement) {
        const datePickerPadding = parseFloat(window.getComputedStyle(datePickerElement).paddingLeft) * 2;
        const containerWidth = formGroupElement.offsetWidth;
        const cardWidth = cardElement.offsetWidth + parseFloat(window.getComputedStyle(cardElement).marginRight);
        const availableSpace = containerWidth - datePickerPadding;
        const cardsPerRow = Math.floor(availableSpace / cardWidth);
        setCardsToShow(cardsPerRow);
        const selectedIndex = dates.findIndex(date => date === selectedDate);
        const newStartIndex = selectedIndex !== -1 ? Math.floor(selectedIndex / cardsPerRow) * cardsPerRow : 0;
        setStartIndex(newStartIndex);
      }
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [availabilityDate, selectedDate]);
  const renderDates = () => {
    if (Object.keys(availabilityDate).length === 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "py-4"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#333',
          marginBottom: 0
        }
      }, "Sorry, we are currently fully booked at this location."));
    }
    return dates.slice(startIndex, startIndex + cardsToShow).map(date => /*#__PURE__*/React.createElement("div", {
      key: date
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      id: date,
      name: "date",
      value: date,
      checked: selectedDate === date,
      onChange: handleDateSelection,
      disabled: !availabilityDate[date].businessOpen
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: date
    }, formatDate(date)))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "formGroup",
    style: {
      maxWidth: '670px',
      margin: 'auto',
      marginBottom: '30px'
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    className: modules_406a9d33.label,
    htmlFor: "appointmentDate"
  }, /*#__PURE__*/React.createElement("b", null, label), required && /*#__PURE__*/React.createElement("span", {
    className: modules_406a9d33.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: modules_406a9d33.datePicker
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(modules_406a9d33.dateControl, " ").concat(modules_406a9d33.left),
    onClick: handlePrev,
    disabled: startIndex === 0
  }, ' ', "<", ' '), /*#__PURE__*/React.createElement("div", {
    className: modules_406a9d33.dateSlider
  }, renderDates()), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(modules_406a9d33.dateControl, " ").concat(modules_406a9d33.right),
    onClick: handleNext,
    disabled: startIndex >= dates.length - cardsToShow
  }, ">")));
}
DatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onDateChange: PropTypes.func,
  availabilityData: PropTypes.shape({}),
  required: PropTypes.bool,
  clearSelectedDate: PropTypes.bool,
  setClearSelectedDate: PropTypes.func
};
DatePicker.defaultProps = {
  name: 'DatePicker',
  label: 'Choose a date',
  availabilityData: null,
  onDateChange: null,
  required: false,
  clearSelectedDate: false,
  setClearSelectedDate: () => {}
};

var css$l = ".Filter_module_resetFilters__aa36be4a {\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n  position: relative;\n  margin: 10px 20px 10px 0;\n  padding: 16px 22px;\n  border-radius: 12px;\n  align-items: center;\n  border: 1px solid #eaeef2;\n}\n@media screen and (max-width: 768px) {\n  .Filter_module_resetFilters__aa36be4a {\n    margin: 10px 0;\n  }\n}\n.Filter_module_resetFilters__aa36be4a h5 {\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0;\n  line-height: normal;\n}\n\n.Filter_module_serviceCards__aa36be4a {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 1 calc(70% - 20px);\n  margin: 10px 20px 10px 0;\n  align-content: baseline;\n}\n.Filter_module_serviceCards__aa36be4a .Filter_module_serviceCard__aa36be4a {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  transition: 0.3s;\n  flex: 0 1 calc(50% - 20px);\n  margin: 0px 20px 20px 0;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n}\n.Filter_module_serviceCards__aa36be4a .Filter_module_serviceCard__aa36be4a .Filter_module_cardTop__aa36be4a {\n  display: flex;\n}\n.Filter_module_serviceCards__aa36be4a .Filter_module_serviceCard__aa36be4a .Filter_module_cardTop__aa36be4a .Filter_module_name__aa36be4a {\n  margin-left: 16px;\n}\n.Filter_module_serviceCards__aa36be4a .Filter_module_serviceCard__aa36be4a .Filter_module_cardTop__aa36be4a .Filter_module_avatar__aa36be4a {\n  border-radius: 50%;\n  height: 60px;\n  margin: auto;\n  overflow: hidden;\n  width: 60px;\n}\n.Filter_module_serviceCards__aa36be4a .Filter_module_serviceCard__aa36be4a .Filter_module_tag__aa36be4a {\n  border: 1px solid black;\n  padding: 1px 6px;\n  border-radius: 6px;\n  margin: 12x 5px 12px 0;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 12px;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.Filter_module_filters__aa36be4a {\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid rgba(203, 205, 215, 0.231372549);\n}\n\n.Filter_module_accordionContainer__aa36be4a {\n  border-radius: 12px;\n  overflow: hidden;\n  max-width: 500px;\n  flex: 0 1 calc(30% - 20px);\n  margin: 10px 20px 10px 0;\n}\n@media screen and (max-width: 768px) {\n  .Filter_module_accordionContainer__aa36be4a {\n    margin: 10px 0;\n  }\n}\n.Filter_module_accordionContainer__aa36be4a .Filter_module_accordionContent__aa36be4a {\n  background-color: #fff;\n}\n\n.Filter_module_accordionHeader__aa36be4a {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  width: 100%;\n  background: #eaeef3;\n  padding: 18px 28px 20px 26px;\n  margin-bottom: -1px;\n  position: relative;\n}\n\n.Filter_module_chevron__aa36be4a {\n  border: solid #333;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 5px;\n  transform: rotate(227deg);\n  transition: transform 0.3s ease;\n}\n\n.Filter_module_chevronexpanded__aa36be4a {\n  transform: rotate(45deg);\n}\n\n.Filter_module_filterItem__aa36be4a {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 16px 26px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  background: #fff;\n  margin-bottom: 16px;\n  border: 1px solid rgba(203, 205, 215, 0.231372549);\n  border-top: 0;\n  border-bottom-right-radius: 12px;\n  border-bottom-left-radius: 12px;\n}\n.Filter_module_filterItem__aa36be4a ul {\n  width: 100%;\n}\n.Filter_module_filterItem__aa36be4a h5 {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n}\n\n.Filter_module_filterCategory__aa36be4a:first-child label {\n  border-top: none;\n}\n.Filter_module_filterCategory__aa36be4a label {\n  width: 100%;\n  box-sizing: border-box;\n  border-top: 1px solid lightgray;\n  padding: 16px 26px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #000;\n}\n.Filter_module_filterCategory__aa36be4a label:hover input[type=checkbox] ~ .Filter_module_checkmark__aa36be4a {\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.Filter_module_filterCategory__aa36be4a label input[type=checkbox]:checked ~ .Filter_module_checkmark__aa36be4a {\n  background-color: #0279a3;\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.Filter_module_filterCategory__aa36be4a label h5 {\n  width: 100%;\n  border-radius: 6px;\n  padding: 2px 10px;\n}\n.Filter_module_filterCategory__aa36be4a label input[type=checkbox]:checked ~ h5 {\n  background-color: #0279a3;\n  color: #fff;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_filterSubcategory__aa36be4a {\n  color: #737373;\n  border: none;\n  padding: 2px 26px 10px 29px;\n  justify-content: flex-start;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_filterSubcategory__aa36be4a input {\n  margin-right: 8px;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_filterSubcategory__aa36be4a input:checked ~ .Filter_module_description__aa36be4a {\n  background-color: #0279a3;\n  color: #fff;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_filterSubcategory__aa36be4a:nth-child(2) {\n  padding-top: 0px;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_filterSubcategory__aa36be4a:last-child {\n  padding-bottom: 20px;\n}\n.Filter_module_filterCategory__aa36be4a input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.Filter_module_filterCategory__aa36be4a input:checked ~ .Filter_module_checkmark__aa36be4a:after {\n  display: block;\n}\n.Filter_module_filterCategory__aa36be4a .Filter_module_checkmark__aa36be4a:after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.Filter_module_filter__aa36be4a h5 {\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0;\n  line-height: normal;\n}\n\n#Filter_module_filtersHeader__aa36be4a {\n  background: #4d9ec2;\n  color: #fff;\n  padding: 16px 0 16px 20px;\n  border-radius: 6px;\n}\n\n.Filter_module_filterSubcategory__aa36be4a {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.Filter_module_filterSubcategory__aa36be4a .Filter_module_description__aa36be4a {\n  margin-left: 10px;\n  margin-top: 3px;\n}\n.Filter_module_filterSubcategory__aa36be4a input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.Filter_module_filterSubcategory__aa36be4a input:checked ~ .Filter_module_checkmark__aa36be4a {\n  background-color: #0279a3;\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.Filter_module_filterSubcategory__aa36be4a input:checked ~ .Filter_module_checkmark__aa36be4a:after {\n  display: block;\n}\n.Filter_module_filterSubcategory__aa36be4a:hover input ~ .Filter_module_checkmark__aa36be4a {\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.Filter_module_filterSubcategory__aa36be4a .Filter_module_checkmark__aa36be4a:after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.Filter_module_checkmark__aa36be4a {\n  position: relative;\n  height: 17px;\n  width: 17px;\n  background-color: transparent;\n  border-radius: 3px;\n  box-shadow: 0px 0px 0px 2px #b0b0b0;\n  margin-top: 3px;\n}\n.Filter_module_checkmark__aa36be4a:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #002845;\n  font-family: Rubik, sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 0;\n  text-transform: normal;\n}\n\nbody {\n  background-color: #f6f7fb;\n  color: #000;\n  font-family: Rubik, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.Filter_module_mt1__aa36be4a {\n  margin-top: 0.25rem !important;\n}\n\n.Filter_module_p0__aa36be4a {\n  padding: 0 !important;\n}\n\n.Filter_module_accordion__aa36be4a {\n  background-color: #eaeef4;\n  color: #444;\n  cursor: pointer;\n  padding: 18px;\n  width: 100%;\n  text-align: left;\n  border: none;\n  outline: none;\n  transition: 0.4s;\n  max-width: 500px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n}\n.Filter_module_accordion__aa36be4a:after {\n  content: \" \";\n  float: right;\n  border: solid #000000;\n  border-width: 0 3px 3px 0;\n  height: 9px;\n  transform: rotate(45deg);\n  width: 9px;\n  margin-right: 10px;\n}\n.Filter_module_accordion__aa36be4a:hover {\n  background-color: #eaeef4;\n}\n\n.Filter_module_active__aa36be4a {\n  background-color: #eaeef4;\n}\n.Filter_module_active__aa36be4a:after {\n  transform: rotate(225deg);\n  margin-top: 6px;\n}\n\n.Filter_module_panel__aa36be4a {\n  padding: 0 18px;\n  background-color: white;\n  overflow: hidden;\n  max-height: 1000px;\n  transition: max-height 0.2s ease-out;\n}";
var modules_a7530715 = {"resetFilters":"Filter_module_resetFilters__aa36be4a","serviceCards":"Filter_module_serviceCards__aa36be4a","serviceCard":"Filter_module_serviceCard__aa36be4a","cardTop":"Filter_module_cardTop__aa36be4a","name":"Filter_module_name__aa36be4a","avatar":"Filter_module_avatar__aa36be4a","tag":"Filter_module_tag__aa36be4a","filters":"Filter_module_filters__aa36be4a","accordionContainer":"Filter_module_accordionContainer__aa36be4a","accordionContent":"Filter_module_accordionContent__aa36be4a","accordionHeader":"Filter_module_accordionHeader__aa36be4a","chevron":"Filter_module_chevron__aa36be4a","chevronexpanded":"Filter_module_chevronexpanded__aa36be4a","filterItem":"Filter_module_filterItem__aa36be4a","filterCategory":"Filter_module_filterCategory__aa36be4a","checkmark":"Filter_module_checkmark__aa36be4a","filterSubcategory":"Filter_module_filterSubcategory__aa36be4a","description":"Filter_module_description__aa36be4a","filter":"Filter_module_filter__aa36be4a","filtersHeader":"Filter_module_filtersHeader__aa36be4a","mt1":"Filter_module_mt1__aa36be4a","p0":"Filter_module_p0__aa36be4a","accordion":"Filter_module_accordion__aa36be4a","active":"Filter_module_active__aa36be4a","panel":"Filter_module_panel__aa36be4a"};
n(css$l,{});

/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
function FilterOption(_ref) {
  let {
    categoryData,
    optionTitle,
    subOptions,
    setSelectedFilters,
    isSpecialist,
    isLocationFilter
  } = _ref;
  const [allSelected, setAllSelected] = useState(false);
  const {
    selectedServiceCategories,
    setSelectedServiceCategories,
    selectedSpecialistCategories,
    setSelectedSpecialistCategories
  } = useContext(BookingContext);
  const handleAllSelected = () => {
    if (isSpecialist) {
      const newAllSelected = !allSelected;
      setAllSelected(newAllSelected);
      if (newAllSelected) {
        const categoriesToAdd = subOptions.map(_ref2 => {
          let {
            category
          } = _ref2;
          return category.category_name;
        });
        setSelectedSpecialistCategories([...selectedSpecialistCategories, ...categoriesToAdd]);
      } else {
        const categoriesToRemove = subOptions.map(_ref3 => {
          let {
            category
          } = _ref3;
          return category.category_name;
        });
        setSelectedSpecialistCategories(selectedServiceCategories.filter(item => !categoriesToRemove.includes(item)));
      }
    } else {
      const newAllSelected = !allSelected;
      setAllSelected(newAllSelected);
      if (newAllSelected) {
        const categoriesToAdd = subOptions.map(_ref4 => {
          let {
            category
          } = _ref4;
          return category.category_name;
        });
        setSelectedServiceCategories([...selectedServiceCategories, ...categoriesToAdd]);
      } else {
        const categoriesToRemove = subOptions.map(_ref5 => {
          let {
            category
          } = _ref5;
          return category.category_name;
        });
        setSelectedServiceCategories(selectedServiceCategories.filter(item => !categoriesToRemove.includes(item)));
      }
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: modules_a7530715.filterCategory
  }, /*#__PURE__*/React.createElement("label", null, Boolean(subOptions.length) && /*#__PURE__*/React.createElement(SelectAllToggle, {
    allSelected: allSelected,
    onClick: handleAllSelected
  }), !subOptions.length && /*#__PURE__*/React.createElement(Checkbox, {
    label: optionTitle,
    only: true,
    isSpecialist: isSpecialist,
    isLocationFilter: isLocationFilter,
    checked: isLocationFilter ? categoryData.checked : isSpecialist ? selectedSpecialistCategories.includes(optionTitle) : selectedServiceCategories.includes(optionTitle),
    setSelectedFilters: setSelectedFilters
  }), /*#__PURE__*/React.createElement("h5", null, optionTitle)), subOptions.map(_ref6 => {
    let {
      category
    } = _ref6;
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: category.category_name,
      checked: selectedSpecialistCategories.includes(category.category_name),
      label: category.category_name,
      isSpecialist: isSpecialist,
      isLocationFilter: isLocationFilter
    });
  }));
}
function SelectAllToggle(_ref7) {
  let {
    allSelected,
    onClick
  } = _ref7;
  const text = allSelected ? 'Unselect all' : 'Select all';
  return /*#__PURE__*/React.createElement("span", {
    onClick: onClick
  }, text);
}
function Checkbox(_ref8) {
  let {
    isSpecialist,
    isLocationFilter,
    label,
    only,
    checked,
    setSelectedFilters
  } = _ref8;
  const {
    selectedServiceCategories,
    setSelectedServiceCategories,
    selectedSpecialistCategories,
    setSelectedSpecialistCategories
  } = useContext(BookingContext);
  const handleChange = event => {
    if (isLocationFilter) {
      setSelectedFilters(label);
    } else {
      const setSelectedCategories = isSpecialist ? setSelectedSpecialistCategories : setSelectedServiceCategories;
      const selectedCategories = isSpecialist ? selectedSpecialistCategories : selectedServiceCategories;
      if (event.target.checked) {
        setSelectedCategories([...selectedCategories, label]);
      } else {
        setSelectedCategories(selectedCategories.filter(item => item !== label));
      }
    }
  };
  if (only) {
    return /*#__PURE__*/React.createElement(Box, {
      checked: checked,
      handleChange: handleChange
    });
  }
  return /*#__PURE__*/React.createElement("label", {
    key: label,
    className: modules_a7530715.filterSubcategory
  }, /*#__PURE__*/React.createElement(Box, {
    checked: checked,
    handleChange: handleChange
  }), /*#__PURE__*/React.createElement("span", {
    className: modules_a7530715.description
  }, label));
}
function Box(_ref9) {
  let {
    checked,
    handleChange
  } = _ref9;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: handleChange
  }));
}

/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
function FilterPanel(_ref) {
  let {
    title,
    filterOptions,
    setSelectedFilters,
    isLocationFilter
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PanelWrapper, null, /*#__PURE__*/React.createElement("h5", null, title), filterOptions.map(optionsData => /*#__PURE__*/React.createElement(FilterOption, {
    key: optionsData.category.category_id,
    categoryData: optionsData.category,
    optionTitle: optionsData.category.category_name,
    subOptions: optionsData.subcategories,
    setSelectedFilters: setSelectedFilters,
    isSpecialist: title === 'Specialist',
    isLocationFilter: isLocationFilter
  }))));
}
function PanelWrapper(_ref2) {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_a7530715.filter, " ").concat(modules_a7530715.accordionContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_a7530715.p0, " ").concat(modules_a7530715.accordionContent)
  }, /*#__PURE__*/React.createElement("ul", null, children)));
}

/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
function Filter(_ref) {
  let {
    data,
    setSelectedFilters,
    isResetButton,
    handleResetFilters,
    isLocationFilter
  } = _ref;
  if (isResetButton === true) {
    return /*#__PURE__*/React.createElement("div", {
      className: modules_a7530715.resetFilters
    }, /*#__PURE__*/React.createElement("h5", null, "Filters"), /*#__PURE__*/React.createElement(Button, {
      label: "Reset",
      variant: "borderFilter",
      onClick: handleResetFilters
    }, "Reset"));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: 'flex'
    }
  }, Array.isArray(data) && data.map(categoryData => /*#__PURE__*/React.createElement(FilterPanel, {
    key: categoryData.category.category_id,
    title: categoryData.category.category_name,
    filterOptions: categoryData.subcategories,
    setSelectedFilters: setSelectedFilters,
    isLocationFilter: isLocationFilter
  })));
}

var css$k = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.hero_module_homeHero__e10c9cdb h1 {\n  font-size: 36px;\n  font-family: Rubik, sans-serif;\n  letter-spacing: -0.3px;\n  line-height: 1.1em;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n.hero_module_homeHero__e10c9cdb h4 {\n  font-size: 18px;\n  font-style: italic;\n}\n.hero_module_homeHero__e10c9cdb p {\n  line-height: 1.5em;\n  color: #000;\n  font-size: 16px;\n  font-weight: 400;\n}\n.hero_module_homeHero__e10c9cdb .hero_module_homeHeroImage__e10c9cdb {\n  border-radius: 20px;\n  height: 100%;\n  min-height: 200px;\n  overflow: hidden;\n}\n.hero_module_homeHero__e10c9cdb .hero_module_homeHeroImage__e10c9cdb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 20px;\n}\n.hero_module_homeHero__e10c9cdb .hero_module_locationSelect__e10c9cdb {\n  display: flex;\n}\n.hero_module_homeHero__e10c9cdb .hero_module_locationSelect__e10c9cdb .hero_module_formSelect__e10c9cdb {\n  width: auto;\n  display: inline-block;\n  margin-right: 10px;\n  line-height: 2em;\n  position: relative;\n  border-radius: 12px;\n  flex-grow: 1;\n  padding: 6px 12px;\n}\n@media screen and (max-width: 768px) {\n  .hero_module_homeHero__e10c9cdb .hero_module_locationSelect__e10c9cdb {\n    margin-bottom: 20px;\n  }\n  .hero_module_homeHero__e10c9cdb .hero_module_locationSelect__e10c9cdb .hero_module_formSelect__e10c9cdb {\n    padding: 6px 0px;\n    text-align: center;\n  }\n}";
var modules_d64e5bf7 = {"homeHero":"hero_module_homeHero__e10c9cdb","homeHeroImage":"hero_module_homeHeroImage__e10c9cdb","locationSelect":"hero_module_locationSelect__e10c9cdb","formSelect":"hero_module_formSelect__e10c9cdb"};
n(css$k,{});

/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
function LocationSelect(_ref) {
  let {
    locations = [],
    defaultUrl = '/booking/London'
  } = _ref;
  const {
    selectedLocationCategory
  } = useContext(BookingContext);
  const [url, setUrl] = useState(defaultUrl);
  return /*#__PURE__*/React.createElement("div", {
    className: modules_d64e5bf7.locationSelect
  }, /*#__PURE__*/React.createElement("select", {
    className: modules_d64e5bf7.formSelect,
    "aria-label": "Choose location",
    value: "/booking/".concat(selectedLocationCategory),
    onChange: e => {
      setUrl(e.target.value);
    }
  }, Array.isArray(locations) && locations.map(location => /*#__PURE__*/React.createElement("option", {
    value: "/booking/".concat(location),
    key: location
  }, location))), /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Book an appointment",
    large: true
  })));
}
function Hero(_ref2) {
  let {
    locations
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_d64e5bf7.homeHero, " pt-5 px-3 px-sm-0")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-lg-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h1", null, "Simplifying Healthcare -", /*#__PURE__*/React.createElement("br", null), "Tailored Private Care for All"), /*#__PURE__*/React.createElement("h4", null, "\"Health is the greatest possession\""), /*#__PURE__*/React.createElement("h4", {
    className: "mb-3"
  }, "Detect, Address, Prevent: In control of your health"), /*#__PURE__*/React.createElement("p", {
    className: "text-dark pr-sm-100"
  }, "Welcome to Sirkka Health, a trusted healthcare partner in the UK. Our mission is to provide affordable, accurate diagnostic tests and rapid referrals to world-class specialists via our proprietary digital platform."), /*#__PURE__*/React.createElement("p", {
    className: "text-dark pr-sm-100"
  }, "For a pro-active, preventative approach to your health, our health screening and diagnostic tests will help you gain a better understanding of your health. We also offer occupational health assessments and bespoke testing for specific issues and/or symptoms. Tests can be done in our clinics or at home/workplace. All test results are presented in a comprehensive and easy-to-understand report that includes any potential risks, heart health lifestyle tips and follow-up recommendations where appropriate. We work with a carefully selected group of world-leading specialists, especially oncologists, cardiologists, gut health and mental health professionals, to fast track your follow-up appointment requests if needed."), /*#__PURE__*/React.createElement("p", {
    className: "text-dark pr-sm-100"
  }, "Everyone's wellbeing and patient-centricity are at the heart of what we do!"), /*#__PURE__*/React.createElement("p", {
    className: "text-dark pr-sm-100"
  }, "Need something more specific that you cannot find on our website? Get in touch via customers@sirkkaltd.com or +44 (0)3300 882538. We have you covered with tailor-made testing packages and occupational health assessments.")), Boolean(locations && locations.length) && /*#__PURE__*/React.createElement(LocationSelect, {
    locations: locations
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-lg-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_d64e5bf7.homeHeroImage, " pos-rel")
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://sirkkahealth.com/img/home/sirkka-health-private-healthcare.jpg",
    alt: ""
  }))))));
}

var bootstrap_bundle = {exports: {}};

/*!
  * Bootstrap v5.3.1 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function (module, exports) {
  (function (global, factory) {
    module.exports = factory() ;
  })(commonjsGlobal, function () {

    /**
     * --------------------------------------------------------------------------
     * Bootstrap dom/data.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */
    const elementMap = new Map();
    const Data = {
      set(element, key, instance) {
        if (!elementMap.has(element)) {
          elementMap.set(element, new Map());
        }
        const instanceMap = elementMap.get(element);

        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
          // eslint-disable-next-line no-console
          console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
          return;
        }
        instanceMap.set(key, instance);
      },
      get(element, key) {
        if (elementMap.has(element)) {
          return elementMap.get(element).get(key) || null;
        }
        return null;
      },
      remove(element, key) {
        if (!elementMap.has(element)) {
          return;
        }
        const instanceMap = elementMap.get(element);
        instanceMap.delete(key);

        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) {
          elementMap.delete(element);
        }
      }
    };

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/index.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = 'transitionend';

    /**
     * Properly escape IDs selectors to handle weird IDs
     * @param {string} selector
     * @returns {string}
     */
    const parseSelector = selector => {
      if (selector && window.CSS && window.CSS.escape) {
        // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id) => "#".concat(CSS.escape(id)));
      }
      return selector;
    };

    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = object => {
      if (object === null || object === undefined) {
        return "".concat(object);
      }
      return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };

    /**
     * Public Util API
     */

    const getUID = prefix => {
      do {
        prefix += Math.floor(Math.random() * MAX_UID);
      } while (document.getElementById(prefix));
      return prefix;
    };
    const getTransitionDurationFromElement = element => {
      if (!element) {
        return 0;
      }

      // Get transition-duration of the element
      let {
        transitionDuration,
        transitionDelay
      } = window.getComputedStyle(element);
      const floatTransitionDuration = Number.parseFloat(transitionDuration);
      const floatTransitionDelay = Number.parseFloat(transitionDelay);

      // Return 0 if element or transition duration is not found
      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      }

      // If multiple durations are defined, take the first
      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = element => {
      element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement$1 = object => {
      if (!object || typeof object !== 'object') {
        return false;
      }
      if (typeof object.jquery !== 'undefined') {
        object = object[0];
      }
      return typeof object.nodeType !== 'undefined';
    };
    const getElement = object => {
      // it's a jQuery object or a node element
      if (isElement$1(object)) {
        return object.jquery ? object[0] : object;
      }
      if (typeof object === 'string' && object.length > 0) {
        return document.querySelector(parseSelector(object));
      }
      return null;
    };
    const isVisible = element => {
      if (!isElement$1(element) || element.getClientRects().length === 0) {
        return false;
      }
      const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
      // Handle `details` element as its content may falsie appear visible when it is closed
      const closedDetails = element.closest('details:not([open])');
      if (!closedDetails) {
        return elementIsVisible;
      }
      if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) {
          return false;
        }
        if (summary === null) {
          return false;
        }
      }
      return elementIsVisible;
    };
    const isDisabled = element => {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return true;
      }
      if (element.classList.contains('disabled')) {
        return true;
      }
      if (typeof element.disabled !== 'undefined') {
        return element.disabled;
      }
      return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
    };
    const findShadowRoot = element => {
      if (!document.documentElement.attachShadow) {
        return null;
      }

      // Can find the shadow root otherwise it'll return the document
      if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }
      if (element instanceof ShadowRoot) {
        return element;
      }

      // when we don't find a shadow root
      if (!element.parentNode) {
        return null;
      }
      return findShadowRoot(element.parentNode);
    };
    const noop = () => {};

    /**
     * Trick to restart an element's animation
     *
     * @param {HTMLElement} element
     * @return void
     *
     * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
     */
    const reflow = element => {
      element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = () => {
      if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) {
        return window.jQuery;
      }
      return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = callback => {
      if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!DOMContentLoadedCallbacks.length) {
          document.addEventListener('DOMContentLoaded', () => {
            for (const callback of DOMContentLoadedCallbacks) {
              callback();
            }
          });
        }
        DOMContentLoadedCallbacks.push(callback);
      } else {
        callback();
      }
    };
    const isRTL = () => document.documentElement.dir === 'rtl';
    const defineJQueryPlugin = plugin => {
      onDOMContentLoaded(() => {
        const $ = getjQuery();
        /* istanbul ignore if */
        if ($) {
          const name = plugin.NAME;
          const JQUERY_NO_CONFLICT = $.fn[name];
          $.fn[name] = plugin.jQueryInterface;
          $.fn[name].Constructor = plugin;
          $.fn[name].noConflict = () => {
            $.fn[name] = JQUERY_NO_CONFLICT;
            return plugin.jQueryInterface;
          };
        }
      });
    };
    const execute = function (possibleCallback) {
      let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : possibleCallback;
      return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue;
    };
    const executeAfterTransition = function (callback, transitionElement) {
      let waitForTransition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!waitForTransition) {
        execute(callback);
        return;
      }
      const durationPadding = 5;
      const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
      let called = false;
      const handler = _ref6 => {
        let {
          target
        } = _ref6;
        if (target !== transitionElement) {
          return;
        }
        called = true;
        transitionElement.removeEventListener(TRANSITION_END, handler);
        execute(callback);
      };
      transitionElement.addEventListener(TRANSITION_END, handler);
      setTimeout(() => {
        if (!called) {
          triggerTransitionEnd(transitionElement);
        }
      }, emulatedDuration);
    };

    /**
     * Return the previous/next element of a list.
     *
     * @param {array} list    The list of elements
     * @param activeElement   The active element
     * @param shouldGetNext   Choose to get next or previous element
     * @param isCycleAllowed
     * @return {Element|elem} The proper element
     */
    const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed) => {
      const listLength = list.length;
      let index = list.indexOf(activeElement);

      // if the element does not exist in the list return an element
      // depending on the direction and if cycle is allowed
      if (index === -1) {
        return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
      }
      index += shouldGetNext ? 1 : -1;
      if (isCycleAllowed) {
        index = (index + listLength) % listLength;
      }
      return list[Math.max(0, Math.min(index, listLength - 1))];
    };

    /**
     * --------------------------------------------------------------------------
     * Bootstrap dom/event-handler.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
      mouseenter: 'mouseover',
      mouseleave: 'mouseout'
    };
    const nativeEvents = new Set(['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll']);

    /**
     * Private methods
     */

    function makeEventUid(element, uid) {
      return uid && "".concat(uid, "::").concat(uidEvent++) || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
      const uid = makeEventUid(element);
      element.uidEvent = uid;
      eventRegistry[uid] = eventRegistry[uid] || {};
      return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
      return function handler(event) {
        hydrateObj(event, {
          delegateTarget: element
        });
        if (handler.oneOff) {
          EventHandler.off(element, event.type, fn);
        }
        return fn.apply(element, [event]);
      };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
      return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for (let {
          target
        } = event; target && target !== this; target = target.parentNode) {
          for (const domElement of domElements) {
            if (domElement !== target) {
              continue;
            }
            hydrateObj(event, {
              delegateTarget: target
            });
            if (handler.oneOff) {
              EventHandler.off(element, event.type, selector, fn);
            }
            return fn.apply(target, [event]);
          }
        }
      };
    }
    function findHandler(events, callable) {
      let delegationSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return Object.values(events).find(event => event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
      const isDelegated = typeof handler === 'string';
      // TODO: tooltip passes `false` instead of selector, so we need to check
      const callable = isDelegated ? delegationFunction : handler || delegationFunction;
      let typeEvent = getTypeEvent(originalTypeEvent);
      if (!nativeEvents.has(typeEvent)) {
        typeEvent = originalTypeEvent;
      }
      return [isDelegated, callable, typeEvent];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
      if (typeof originalTypeEvent !== 'string' || !element) {
        return;
      }
      let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);

      // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
      // this prevents the handler from being dispatched the same way as mouseover or mouseout does
      if (originalTypeEvent in customEvents) {
        const wrapFunction = fn => {
          return function (event) {
            if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) {
              return fn.call(this, event);
            }
          };
        };
        callable = wrapFunction(callable);
      }
      const events = getElementEvents(element);
      const handlers = events[typeEvent] || (events[typeEvent] = {});
      const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
      if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
      }
      const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
      const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
      fn.delegationSelector = isDelegated ? handler : null;
      fn.callable = callable;
      fn.oneOff = oneOff;
      fn.uidEvent = uid;
      handlers[uid] = fn;
      element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
      const fn = findHandler(events[typeEvent], handler, delegationSelector);
      if (!fn) {
        return;
      }
      element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
      delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
      const storeElementEvent = events[typeEvent] || {};
      for (const [handlerKey, event] of Object.entries(storeElementEvent)) {
        if (handlerKey.includes(namespace)) {
          removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
      }
    }
    function getTypeEvent(event) {
      // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
      event = event.replace(stripNameRegex, '');
      return customEvents[event] || event;
    }
    const EventHandler = {
      on(element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, false);
      },
      one(element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, true);
      },
      off(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) {
          return;
        }
        const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
          // Simplest case: handler is passed, remove that listener ONLY.
          if (!Object.keys(storeElementEvent).length) {
            return;
          }
          removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
          return;
        }
        if (isNamespace) {
          for (const elementEvent of Object.keys(events)) {
            removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
          }
        }
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)) {
          const handlerKey = keyHandlers.replace(stripUidRegex, '');
          if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
            removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
          }
        }
      },
      trigger(element, event, args) {
        if (typeof event !== 'string' || !element) {
          return null;
        }
        const $ = getjQuery();
        const typeEvent = getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
          jQueryEvent = $.Event(event, args);
          $(element).trigger(jQueryEvent);
          bubbles = !jQueryEvent.isPropagationStopped();
          nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
          defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = hydrateObj(new Event(event, {
          bubbles,
          cancelable: true
        }), args);
        if (defaultPrevented) {
          evt.preventDefault();
        }
        if (nativeDispatch) {
          element.dispatchEvent(evt);
        }
        if (evt.defaultPrevented && jQueryEvent) {
          jQueryEvent.preventDefault();
        }
        return evt;
      }
    };
    function hydrateObj(obj) {
      let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      for (const [key, value] of Object.entries(meta)) {
        try {
          obj[key] = value;
        } catch (_unused) {
          Object.defineProperty(obj, key, {
            configurable: true,
            get() {
              return value;
            }
          });
        }
      }
      return obj;
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap dom/manipulator.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    function normalizeData(value) {
      if (value === 'true') {
        return true;
      }
      if (value === 'false') {
        return false;
      }
      if (value === Number(value).toString()) {
        return Number(value);
      }
      if (value === '' || value === 'null') {
        return null;
      }
      if (typeof value !== 'string') {
        return value;
      }
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch (_unused) {
        return value;
      }
    }
    function normalizeDataKey(key) {
      return key.replace(/[A-Z]/g, chr => "-".concat(chr.toLowerCase()));
    }
    const Manipulator = {
      setDataAttribute(element, key, value) {
        element.setAttribute("data-bs-".concat(normalizeDataKey(key)), value);
      },
      removeDataAttribute(element, key) {
        element.removeAttribute("data-bs-".concat(normalizeDataKey(key)));
      },
      getDataAttributes(element) {
        if (!element) {
          return {};
        }
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter(key => key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys) {
          let pureKey = key.replace(/^bs/, '');
          pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
          attributes[pureKey] = normalizeData(element.dataset[key]);
        }
        return attributes;
      },
      getDataAttribute(element, key) {
        return normalizeData(element.getAttribute("data-bs-".concat(normalizeDataKey(key))));
      }
    };

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/config.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Class definition
     */

    class Config {
      // Getters
      static get Default() {
        return {};
      }
      static get DefaultType() {
        return {};
      }
      static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
      }
      _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
      }
      _configAfterMerge(config) {
        return config;
      }
      _mergeConfigObj(config, element) {
        const jsonConfig = isElement$1(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse

        return {
          ...this.constructor.Default,
          ...(typeof jsonConfig === 'object' ? jsonConfig : {}),
          ...(isElement$1(element) ? Manipulator.getDataAttributes(element) : {}),
          ...(typeof config === 'object' ? config : {})
        };
      }
      _typeCheckConfig(config) {
        let configTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.constructor.DefaultType;
        for (const [property, expectedTypes] of Object.entries(configTypes)) {
          const value = config[property];
          const valueType = isElement$1(value) ? 'element' : toType(value);
          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ": Option \"").concat(property, "\" provided type \"").concat(valueType, "\" but expected type \"").concat(expectedTypes, "\"."));
          }
        }
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap base-component.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const VERSION = '5.3.1';

    /**
     * Class definition
     */

    class BaseComponent extends Config {
      constructor(element, config) {
        super();
        element = getElement(element);
        if (!element) {
          return;
        }
        this._element = element;
        this._config = this._getConfig(config);
        Data.set(this._element, this.constructor.DATA_KEY, this);
      }

      // Public
      dispose() {
        Data.remove(this._element, this.constructor.DATA_KEY);
        EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this)) {
          this[propertyName] = null;
        }
      }
      _queueCallback(callback, element) {
        let isAnimated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        executeAfterTransition(callback, element, isAnimated);
      }
      _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
      }

      // Static
      static getInstance(element) {
        return Data.get(getElement(element), this.DATA_KEY);
      }
      static getOrCreateInstance(element) {
        let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
      }
      static get VERSION() {
        return VERSION;
      }
      static get DATA_KEY() {
        return "bs.".concat(this.NAME);
      }
      static get EVENT_KEY() {
        return ".".concat(this.DATA_KEY);
      }
      static eventName(name) {
        return "".concat(name).concat(this.EVENT_KEY);
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap dom/selector-engine.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    const getSelector = element => {
      let selector = element.getAttribute('data-bs-target');
      if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');

        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) {
          return null;
        }

        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) {
          hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        }
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
      }
      return parseSelector(selector);
    };
    const SelectorEngine = {
      find(selector) {
        let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
      },
      findOne(selector) {
        let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
      },
      children(element, selector) {
        return [].concat(...element.children).filter(child => child.matches(selector));
      },
      parents(element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while (ancestor) {
          parents.push(ancestor);
          ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
      },
      prev(element, selector) {
        let previous = element.previousElementSibling;
        while (previous) {
          if (previous.matches(selector)) {
            return [previous];
          }
          previous = previous.previousElementSibling;
        }
        return [];
      },
      // TODO: this is now unused; remove later along with prev()
      next(element, selector) {
        let next = element.nextElementSibling;
        while (next) {
          if (next.matches(selector)) {
            return [next];
          }
          next = next.nextElementSibling;
        }
        return [];
      },
      focusableChildren(element) {
        const focusables = ['a', 'button', 'input', 'textarea', 'select', 'details', '[tabindex]', '[contenteditable="true"]'].map(selector => "".concat(selector, ":not([tabindex^=\"-\"])")).join(',');
        return this.find(focusables, element).filter(el => !isDisabled(el) && isVisible(el));
      },
      getSelectorFromElement(element) {
        const selector = getSelector(element);
        if (selector) {
          return SelectorEngine.findOne(selector) ? selector : null;
        }
        return null;
      },
      getElementFromSelector(element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.findOne(selector) : null;
      },
      getMultipleElementsFromSelector(element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.find(selector) : [];
      }
    };

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/component-functions.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    const enableDismissTrigger = function (component) {
      let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hide';
      const clickEvent = "click.dismiss".concat(component.EVENT_KEY);
      const name = component.NAME;
      EventHandler.on(document, clickEvent, "[data-bs-dismiss=\"".concat(name, "\"]"), function (event) {
        if (['A', 'AREA'].includes(this.tagName)) {
          event.preventDefault();
        }
        if (isDisabled(this)) {
          return;
        }
        const target = SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        const instance = component.getOrCreateInstance(target);

        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
      });
    };

    /**
     * --------------------------------------------------------------------------
     * Bootstrap alert.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$f = 'alert';
    const DATA_KEY$a = 'bs.alert';
    const EVENT_KEY$b = ".".concat(DATA_KEY$a);
    const EVENT_CLOSE = "close".concat(EVENT_KEY$b);
    const EVENT_CLOSED = "closed".concat(EVENT_KEY$b);
    const CLASS_NAME_FADE$5 = 'fade';
    const CLASS_NAME_SHOW$8 = 'show';

    /**
     * Class definition
     */

    class Alert extends BaseComponent {
      // Getters
      static get NAME() {
        return NAME$f;
      }

      // Public
      close() {
        const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
        if (closeEvent.defaultPrevented) {
          return;
        }
        this._element.classList.remove(CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
        this._queueCallback(() => this._destroyElement(), this._element, isAnimated);
      }

      // Private
      _destroyElement() {
        this._element.remove();
        EventHandler.trigger(this._element, EVENT_CLOSED);
        this.dispose();
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Alert.getOrCreateInstance(this);
          if (typeof config !== 'string') {
            return;
          }
          if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config](this);
        });
      }
    }

    /**
     * Data API implementation
     */

    enableDismissTrigger(Alert, 'close');

    /**
     * jQuery
     */

    defineJQueryPlugin(Alert);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap button.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$e = 'button';
    const DATA_KEY$9 = 'bs.button';
    const EVENT_KEY$a = ".".concat(DATA_KEY$9);
    const DATA_API_KEY$6 = '.data-api';
    const CLASS_NAME_ACTIVE$3 = 'active';
    const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    const EVENT_CLICK_DATA_API$6 = "click".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);

    /**
     * Class definition
     */

    class Button extends BaseComponent {
      // Getters
      static get NAME() {
        return NAME$e;
      }

      // Public
      toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Button.getOrCreateInstance(this);
          if (config === 'toggle') {
            data[config]();
          }
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, event => {
      event.preventDefault();
      const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
      const data = Button.getOrCreateInstance(button);
      data.toggle();
    });

    /**
     * jQuery
     */

    defineJQueryPlugin(Button);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/swipe.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$d = 'swipe';
    const EVENT_KEY$9 = '.bs.swipe';
    const EVENT_TOUCHSTART = "touchstart".concat(EVENT_KEY$9);
    const EVENT_TOUCHMOVE = "touchmove".concat(EVENT_KEY$9);
    const EVENT_TOUCHEND = "touchend".concat(EVENT_KEY$9);
    const EVENT_POINTERDOWN = "pointerdown".concat(EVENT_KEY$9);
    const EVENT_POINTERUP = "pointerup".concat(EVENT_KEY$9);
    const POINTER_TYPE_TOUCH = 'touch';
    const POINTER_TYPE_PEN = 'pen';
    const CLASS_NAME_POINTER_EVENT = 'pointer-event';
    const SWIPE_THRESHOLD = 40;
    const Default$c = {
      endCallback: null,
      leftCallback: null,
      rightCallback: null
    };
    const DefaultType$c = {
      endCallback: '(function|null)',
      leftCallback: '(function|null)',
      rightCallback: '(function|null)'
    };

    /**
     * Class definition
     */

    class Swipe extends Config {
      constructor(element, config) {
        super();
        this._element = element;
        if (!element || !Swipe.isSupported()) {
          return;
        }
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
      }

      // Getters
      static get Default() {
        return Default$c;
      }
      static get DefaultType() {
        return DefaultType$c;
      }
      static get NAME() {
        return NAME$d;
      }

      // Public
      dispose() {
        EventHandler.off(this._element, EVENT_KEY$9);
      }

      // Private
      _start(event) {
        if (!this._supportPointerEvents) {
          this._deltaX = event.touches[0].clientX;
          return;
        }
        if (this._eventIsPointerPenTouch(event)) {
          this._deltaX = event.clientX;
        }
      }
      _end(event) {
        if (this._eventIsPointerPenTouch(event)) {
          this._deltaX = event.clientX - this._deltaX;
        }
        this._handleSwipe();
        execute(this._config.endCallback);
      }
      _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
      }
      _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= SWIPE_THRESHOLD) {
          return;
        }
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) {
          return;
        }
        execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
      }
      _initEvents() {
        if (this._supportPointerEvents) {
          EventHandler.on(this._element, EVENT_POINTERDOWN, event => this._start(event));
          EventHandler.on(this._element, EVENT_POINTERUP, event => this._end(event));
          this._element.classList.add(CLASS_NAME_POINTER_EVENT);
        } else {
          EventHandler.on(this._element, EVENT_TOUCHSTART, event => this._start(event));
          EventHandler.on(this._element, EVENT_TOUCHMOVE, event => this._move(event));
          EventHandler.on(this._element, EVENT_TOUCHEND, event => this._end(event));
        }
      }
      _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
      }

      // Static
      static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap carousel.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$c = 'carousel';
    const DATA_KEY$8 = 'bs.carousel';
    const EVENT_KEY$8 = ".".concat(DATA_KEY$8);
    const DATA_API_KEY$5 = '.data-api';
    const ARROW_LEFT_KEY$1 = 'ArrowLeft';
    const ARROW_RIGHT_KEY$1 = 'ArrowRight';
    const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

    const ORDER_NEXT = 'next';
    const ORDER_PREV = 'prev';
    const DIRECTION_LEFT = 'left';
    const DIRECTION_RIGHT = 'right';
    const EVENT_SLIDE = "slide".concat(EVENT_KEY$8);
    const EVENT_SLID = "slid".concat(EVENT_KEY$8);
    const EVENT_KEYDOWN$1 = "keydown".concat(EVENT_KEY$8);
    const EVENT_MOUSEENTER$1 = "mouseenter".concat(EVENT_KEY$8);
    const EVENT_MOUSELEAVE$1 = "mouseleave".concat(EVENT_KEY$8);
    const EVENT_DRAG_START = "dragstart".concat(EVENT_KEY$8);
    const EVENT_LOAD_DATA_API$3 = "load".concat(EVENT_KEY$8).concat(DATA_API_KEY$5);
    const EVENT_CLICK_DATA_API$5 = "click".concat(EVENT_KEY$8).concat(DATA_API_KEY$5);
    const CLASS_NAME_CAROUSEL = 'carousel';
    const CLASS_NAME_ACTIVE$2 = 'active';
    const CLASS_NAME_SLIDE = 'slide';
    const CLASS_NAME_END = 'carousel-item-end';
    const CLASS_NAME_START = 'carousel-item-start';
    const CLASS_NAME_NEXT = 'carousel-item-next';
    const CLASS_NAME_PREV = 'carousel-item-prev';
    const SELECTOR_ACTIVE = '.active';
    const SELECTOR_ITEM = '.carousel-item';
    const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    const SELECTOR_ITEM_IMG = '.carousel-item img';
    const SELECTOR_INDICATORS = '.carousel-indicators';
    const SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
    const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    const KEY_TO_DIRECTION = {
      [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
      [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
    };
    const Default$b = {
      interval: 5000,
      keyboard: true,
      pause: 'hover',
      ride: false,
      touch: true,
      wrap: true
    };
    const DefaultType$b = {
      interval: '(number|boolean)',
      // TODO:v6 remove boolean support
      keyboard: 'boolean',
      pause: '(string|boolean)',
      ride: '(boolean|string)',
      touch: 'boolean',
      wrap: 'boolean'
    };

    /**
     * Class definition
     */

    class Carousel extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === CLASS_NAME_CAROUSEL) {
          this.cycle();
        }
      }

      // Getters
      static get Default() {
        return Default$b;
      }
      static get DefaultType() {
        return DefaultType$b;
      }
      static get NAME() {
        return NAME$c;
      }

      // Public
      next() {
        this._slide(ORDER_NEXT);
      }
      nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && isVisible(this._element)) {
          this.next();
        }
      }
      prev() {
        this._slide(ORDER_PREV);
      }
      pause() {
        if (this._isSliding) {
          triggerTransitionEnd(this._element);
        }
        this._clearInterval();
      }
      cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
      }
      _maybeEnableCycle() {
        if (!this._config.ride) {
          return;
        }
        if (this._isSliding) {
          EventHandler.one(this._element, EVENT_SLID, () => this.cycle());
          return;
        }
        this.cycle();
      }
      to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) {
          return;
        }
        if (this._isSliding) {
          EventHandler.one(this._element, EVENT_SLID, () => this.to(index));
          return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) {
          return;
        }
        const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
        this._slide(order, items[index]);
      }
      dispose() {
        if (this._swipeHelper) {
          this._swipeHelper.dispose();
        }
        super.dispose();
      }

      // Private
      _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
      }
      _addEventListeners() {
        if (this._config.keyboard) {
          EventHandler.on(this._element, EVENT_KEYDOWN$1, event => this._keydown(event));
        }
        if (this._config.pause === 'hover') {
          EventHandler.on(this._element, EVENT_MOUSEENTER$1, () => this.pause());
          EventHandler.on(this._element, EVENT_MOUSELEAVE$1, () => this._maybeEnableCycle());
        }
        if (this._config.touch && Swipe.isSupported()) {
          this._addTouchEventListeners();
        }
      }
      _addTouchEventListeners() {
        for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element)) {
          EventHandler.on(img, EVENT_DRAG_START, event => event.preventDefault());
        }
        const endCallBack = () => {
          if (this._config.pause !== 'hover') {
            return;
          }

          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling

          this.pause();
          if (this.touchTimeout) {
            clearTimeout(this.touchTimeout);
          }
          this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
          leftCallback: () => this._slide(this._directionToOrder(DIRECTION_LEFT)),
          rightCallback: () => this._slide(this._directionToOrder(DIRECTION_RIGHT)),
          endCallback: endCallBack
        };
        this._swipeHelper = new Swipe(this._element, swipeConfig);
      }
      _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) {
          return;
        }
        const direction = KEY_TO_DIRECTION[event.key];
        if (direction) {
          event.preventDefault();
          this._slide(this._directionToOrder(direction));
        }
      }
      _getItemIndex(element) {
        return this._getItems().indexOf(element);
      }
      _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) {
          return;
        }
        const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = SelectorEngine.findOne("[data-bs-slide-to=\"".concat(index, "\"]"), this._indicatorsElement);
        if (newActiveIndicator) {
          newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
          newActiveIndicator.setAttribute('aria-current', 'true');
        }
      }
      _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) {
          return;
        }
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
      }
      _slide(order) {
        let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (this._isSliding) {
          return;
        }
        const activeElement = this._getActive();
        const isNext = order === ORDER_NEXT;
        const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) {
          return;
        }
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = eventName => {
          return EventHandler.trigger(this._element, eventName, {
            relatedTarget: nextElement,
            direction: this._orderToDirection(order),
            from: this._getItemIndex(activeElement),
            to: nextElementIndex
          });
        };
        const slideEvent = triggerEvent(EVENT_SLIDE);
        if (slideEvent.defaultPrevented) {
          return;
        }
        if (!activeElement || !nextElement) {
          // Some weirdness is happening, so we bail
          // TODO: change tests that use empty divs to avoid this check
          return;
        }
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
        const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = () => {
          nextElement.classList.remove(directionalClassName, orderClassName);
          nextElement.classList.add(CLASS_NAME_ACTIVE$2);
          activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
          this._isSliding = false;
          triggerEvent(EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) {
          this.cycle();
        }
      }
      _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_SLIDE);
      }
      _getActive() {
        return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
      }
      _getItems() {
        return SelectorEngine.find(SELECTOR_ITEM, this._element);
      }
      _clearInterval() {
        if (this._interval) {
          clearInterval(this._interval);
          this._interval = null;
        }
      }
      _directionToOrder(direction) {
        if (isRTL()) {
          return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
        }
        return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
      }
      _orderToDirection(order) {
        if (isRTL()) {
          return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
        }
        return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Carousel.getOrCreateInstance(this, config);
          if (typeof config === 'number') {
            data.to(config);
            return;
          }
          if (typeof config === 'string') {
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
              throw new TypeError("No method named \"".concat(config, "\""));
            }
            data[config]();
          }
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function (event) {
      const target = SelectorEngine.getElementFromSelector(this);
      if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) {
        return;
      }
      event.preventDefault();
      const carousel = Carousel.getOrCreateInstance(target);
      const slideIndex = this.getAttribute('data-bs-slide-to');
      if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
      }
      if (Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
      }
      carousel.prev();
      carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, () => {
      const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
      for (const carousel of carousels) {
        Carousel.getOrCreateInstance(carousel);
      }
    });

    /**
     * jQuery
     */

    defineJQueryPlugin(Carousel);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap collapse.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$b = 'collapse';
    const DATA_KEY$7 = 'bs.collapse';
    const EVENT_KEY$7 = ".".concat(DATA_KEY$7);
    const DATA_API_KEY$4 = '.data-api';
    const EVENT_SHOW$6 = "show".concat(EVENT_KEY$7);
    const EVENT_SHOWN$6 = "shown".concat(EVENT_KEY$7);
    const EVENT_HIDE$6 = "hide".concat(EVENT_KEY$7);
    const EVENT_HIDDEN$6 = "hidden".concat(EVENT_KEY$7);
    const EVENT_CLICK_DATA_API$4 = "click".concat(EVENT_KEY$7).concat(DATA_API_KEY$4);
    const CLASS_NAME_SHOW$7 = 'show';
    const CLASS_NAME_COLLAPSE = 'collapse';
    const CLASS_NAME_COLLAPSING = 'collapsing';
    const CLASS_NAME_COLLAPSED = 'collapsed';
    const CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat(CLASS_NAME_COLLAPSE, " .").concat(CLASS_NAME_COLLAPSE);
    const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
    const WIDTH = 'width';
    const HEIGHT = 'height';
    const SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
    const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    const Default$a = {
      parent: null,
      toggle: true
    };
    const DefaultType$a = {
      parent: '(null|element)',
      toggle: 'boolean'
    };

    /**
     * Class definition
     */

    class Collapse extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList) {
          const selector = SelectorEngine.getSelectorFromElement(elem);
          const filterElement = SelectorEngine.find(selector).filter(foundElement => foundElement === this._element);
          if (selector !== null && filterElement.length) {
            this._triggerArray.push(elem);
          }
        }
        this._initializeChildren();
        if (!this._config.parent) {
          this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        }
        if (this._config.toggle) {
          this.toggle();
        }
      }

      // Getters
      static get Default() {
        return Default$a;
      }
      static get DefaultType() {
        return DefaultType$a;
      }
      static get NAME() {
        return NAME$b;
      }

      // Public
      toggle() {
        if (this._isShown()) {
          this.hide();
        } else {
          this.show();
        }
      }
      show() {
        if (this._isTransitioning || this._isShown()) {
          return;
        }
        let activeChildren = [];

        // find active children
        if (this._config.parent) {
          activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter(element => element !== this._element).map(element => Collapse.getOrCreateInstance(element, {
            toggle: false
          }));
        }
        if (activeChildren.length && activeChildren[0]._isTransitioning) {
          return;
        }
        const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
        if (startEvent.defaultPrevented) {
          return;
        }
        for (const activeInstance of activeChildren) {
          activeInstance.hide();
        }
        const dimension = this._getDimension();
        this._element.classList.remove(CLASS_NAME_COLLAPSE);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = () => {
          this._isTransitioning = false;
          this._element.classList.remove(CLASS_NAME_COLLAPSING);
          this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
          this._element.style[dimension] = '';
          EventHandler.trigger(this._element, EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = "scroll".concat(capitalizedDimension);
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
      }
      hide() {
        if (this._isTransitioning || !this._isShown()) {
          return;
        }
        const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
        if (startEvent.defaultPrevented) {
          return;
        }
        const dimension = this._getDimension();
        this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray) {
          const element = SelectorEngine.getElementFromSelector(trigger);
          if (element && !this._isShown(element)) {
            this._addAriaAndCollapsedClass([trigger], false);
          }
        }
        this._isTransitioning = true;
        const complete = () => {
          this._isTransitioning = false;
          this._element.classList.remove(CLASS_NAME_COLLAPSING);
          this._element.classList.add(CLASS_NAME_COLLAPSE);
          EventHandler.trigger(this._element, EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
      }
      _isShown() {
        let element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._element;
        return element.classList.contains(CLASS_NAME_SHOW$7);
      }

      // Private
      _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = getElement(config.parent);
        return config;
      }
      _getDimension() {
        return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
      }
      _initializeChildren() {
        if (!this._config.parent) {
          return;
        }
        const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
        for (const element of children) {
          const selected = SelectorEngine.getElementFromSelector(element);
          if (selected) {
            this._addAriaAndCollapsedClass([element], this._isShown(selected));
          }
        }
      }
      _getFirstLevelChildren(selector) {
        const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return SelectorEngine.find(selector, this._config.parent).filter(element => !children.includes(element));
      }
      _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) {
          return;
        }
        for (const element of triggerArray) {
          element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
          element.setAttribute('aria-expanded', isOpen);
        }
      }

      // Static
      static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) {
          _config.toggle = false;
        }
        return this.each(function () {
          const data = Collapse.getOrCreateInstance(this, _config);
          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"".concat(config, "\""));
            }
            data[config]();
          }
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function (event) {
      // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
      if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') {
        event.preventDefault();
      }
      for (const element of SelectorEngine.getMultipleElementsFromSelector(this)) {
        Collapse.getOrCreateInstance(element, {
          toggle: false
        }).toggle();
      }
    });

    /**
     * jQuery
     */

    defineJQueryPlugin(Collapse);
    var top = 'top';
    var bottom = 'bottom';
    var right = 'right';
    var left = 'left';
    var auto = 'auto';
    var basePlacements = [top, bottom, right, left];
    var start = 'start';
    var end = 'end';
    var clippingParents = 'clippingParents';
    var viewport = 'viewport';
    var popper = 'popper';
    var reference = 'reference';
    var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
      return acc.concat([placement + "-" + start, placement + "-" + end]);
    }, []);
    var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
      return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
    }, []); // modifiers that need to read the DOM

    var beforeRead = 'beforeRead';
    var read = 'read';
    var afterRead = 'afterRead'; // pure-logic modifiers

    var beforeMain = 'beforeMain';
    var main = 'main';
    var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

    var beforeWrite = 'beforeWrite';
    var write = 'write';
    var afterWrite = 'afterWrite';
    var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
    function getNodeName(element) {
      return element ? (element.nodeName || '').toLowerCase() : null;
    }
    function getWindow(node) {
      if (node == null) {
        return window;
      }
      if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
      }
      return node;
    }
    function isElement(node) {
      var OwnElement = getWindow(node).Element;
      return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
      var OwnElement = getWindow(node).HTMLElement;
      return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
      // IE 11 has no ShadowRoot
      if (typeof ShadowRoot === 'undefined') {
        return false;
      }
      var OwnElement = getWindow(node).ShadowRoot;
      return node instanceof OwnElement || node instanceof ShadowRoot;
    }

    // and applies them to the HTMLElements such as popper and arrow

    function applyStyles(_ref) {
      var state = _ref.state;
      Object.keys(state.elements).forEach(function (name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        } // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (name) {
          var value = attributes[name];
          if (value === false) {
            element.removeAttribute(name);
          } else {
            element.setAttribute(name, value === true ? '' : value);
          }
        });
      });
    }
    function effect$2(_ref2) {
      var state = _ref2.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;
      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      }
      return function () {
        Object.keys(state.elements).forEach(function (name) {
          var element = state.elements[name];
          var attributes = state.attributes[name] || {};
          var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

          var style = styleProperties.reduce(function (style, property) {
            style[property] = '';
            return style;
          }, {}); // arrow is optional + virtual elements

          if (!isHTMLElement(element) || !getNodeName(element)) {
            return;
          }
          Object.assign(element.style, style);
          Object.keys(attributes).forEach(function (attribute) {
            element.removeAttribute(attribute);
          });
        });
      };
    } // eslint-disable-next-line import/no-unused-modules

    const applyStyles$1 = {
      name: 'applyStyles',
      enabled: true,
      phase: 'write',
      fn: applyStyles,
      effect: effect$2,
      requires: ['computeStyles']
    };
    function getBasePlacement(placement) {
      return placement.split('-')[0];
    }
    var max = Math.max;
    var min = Math.min;
    var round = Math.round;
    function getUAString() {
      var uaData = navigator.userAgentData;
      if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
        return uaData.brands.map(function (item) {
          return item.brand + "/" + item.version;
        }).join(' ');
      }
      return navigator.userAgent;
    }
    function isLayoutViewport() {
      return !/^((?!chrome|android).)*safari/i.test(getUAString());
    }
    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
      if (includeScale === void 0) {
        includeScale = false;
      }
      if (isFixedStrategy === void 0) {
        isFixedStrategy = false;
      }
      var clientRect = element.getBoundingClientRect();
      var scaleX = 1;
      var scaleY = 1;
      if (includeScale && isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
      }
      var _ref = isElement(element) ? getWindow(element) : window,
        visualViewport = _ref.visualViewport;
      var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
      var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
      var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
      var width = clientRect.width / scaleX;
      var height = clientRect.height / scaleY;
      return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
      };
    }

    // means it doesn't take into account transforms.

    function getLayoutRect(element) {
      var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
      // Fixes https://github.com/popperjs/popper-core/issues/1223

      var width = element.offsetWidth;
      var height = element.offsetHeight;
      if (Math.abs(clientRect.width - width) <= 1) {
        width = clientRect.width;
      }
      if (Math.abs(clientRect.height - height) <= 1) {
        height = clientRect.height;
      }
      return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
      };
    }
    function contains(parent, child) {
      var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

      if (parent.contains(child)) {
        return true;
      } // then fallback to custom implementation with Shadow DOM support
      else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...

          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false

      return false;
    }
    function getComputedStyle$1(element) {
      return getWindow(element).getComputedStyle(element);
    }
    function isTableElement(element) {
      return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
    }
    function getDocumentElement(element) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return ((isElement(element) ? element.ownerDocument :
      // $FlowFixMe[prop-missing]
      element.document) || window.document).documentElement;
    }
    function getParentNode(element) {
      if (getNodeName(element) === 'html') {
        return element;
      }
      return (
        // this is a quicker (but less type safe) way to save quite some bytes from the bundle
        // $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot ||
        // step into the shadow DOM of the parent of a slotted node
        element.parentNode || (
        // DOM Element detected
        isShadowRoot(element) ? element.host : null) ||
        // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
      );
    }
    function getTrueOffsetParent(element) {
      if (!isHTMLElement(element) ||
      // https://github.com/popperjs/popper-core/issues/837
      getComputedStyle$1(element).position === 'fixed') {
        return null;
      }
      return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block

    function getContainingBlock(element) {
      var isFirefox = /firefox/i.test(getUAString());
      var isIE = /Trident/i.test(getUAString());
      if (isIE && isHTMLElement(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = getComputedStyle$1(element);
        if (elementCss.position === 'fixed') {
          return null;
        }
      }
      var currentNode = getParentNode(element);
      if (isShadowRoot(currentNode)) {
        currentNode = currentNode.host;
      }
      while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
        var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
          return currentNode;
        } else {
          currentNode = currentNode.parentNode;
        }
      }
      return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.

    function getOffsetParent(element) {
      var window = getWindow(element);
      var offsetParent = getTrueOffsetParent(element);
      while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
        offsetParent = getTrueOffsetParent(offsetParent);
      }
      if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
        return window;
      }
      return offsetParent || getContainingBlock(element) || window;
    }
    function getMainAxisFromPlacement(placement) {
      return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
    }
    function within(min$1, value, max$1) {
      return max(min$1, min(value, max$1));
    }
    function withinMaxClamp(min, value, max) {
      var v = within(min, value, max);
      return v > max ? max : v;
    }
    function getFreshSideObject() {
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }
    function mergePaddingObject(paddingObject) {
      return Object.assign({}, getFreshSideObject(), paddingObject);
    }
    function expandToHashMap(value, keys) {
      return keys.reduce(function (hashMap, key) {
        hashMap[key] = value;
        return hashMap;
      }, {});
    }
    var toPaddingObject = function toPaddingObject(padding, state) {
      padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
      })) : padding;
      return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    };
    function arrow(_ref) {
      var _state$modifiersData$;
      var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
      var arrowElement = state.elements.arrow;
      var popperOffsets = state.modifiersData.popperOffsets;
      var basePlacement = getBasePlacement(state.placement);
      var axis = getMainAxisFromPlacement(basePlacement);
      var isVertical = [left, right].indexOf(basePlacement) >= 0;
      var len = isVertical ? 'height' : 'width';
      if (!arrowElement || !popperOffsets) {
        return;
      }
      var paddingObject = toPaddingObject(options.padding, state);
      var arrowRect = getLayoutRect(arrowElement);
      var minProp = axis === 'y' ? top : left;
      var maxProp = axis === 'y' ? bottom : right;
      var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
      var startDiff = popperOffsets[axis] - state.rects.reference[axis];
      var arrowOffsetParent = getOffsetParent(arrowElement);
      var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
      var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
      // outside of the popper bounds

      var min = paddingObject[minProp];
      var max = clientSize - arrowRect[len] - paddingObject[maxProp];
      var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
      var offset = within(min, center, max); // Prevents breaking syntax highlighting...

      var axisProp = axis;
      state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function effect$1(_ref2) {
      var state = _ref2.state,
        options = _ref2.options;
      var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
      if (arrowElement == null) {
        return;
      } // CSS selector

      if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) {
          return;
        }
      }
      if (!contains(state.elements.popper, arrowElement)) {
        return;
      }
      state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules

    const arrow$1 = {
      name: 'arrow',
      enabled: true,
      phase: 'main',
      fn: arrow,
      effect: effect$1,
      requires: ['popperOffsets'],
      requiresIfExists: ['preventOverflow']
    };
    function getVariation(placement) {
      return placement.split('-')[1];
    }
    var unsetSides = {
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      left: 'auto'
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.

    function roundOffsetsByDPR(_ref, win) {
      var x = _ref.x,
        y = _ref.y;
      var dpr = win.devicePixelRatio || 1;
      return {
        x: round(x * dpr) / dpr || 0,
        y: round(y * dpr) / dpr || 0
      };
    }
    function mapToStyles(_ref2) {
      var _Object$assign2;
      var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
      var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;
      var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
      }) : {
        x: x,
        y: y
      };
      x = _ref3.x;
      y = _ref3.y;
      var hasX = offsets.hasOwnProperty('x');
      var hasY = offsets.hasOwnProperty('y');
      var sideX = left;
      var sideY = top;
      var win = window;
      if (adaptive) {
        var offsetParent = getOffsetParent(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === getWindow(popper)) {
          offsetParent = getDocumentElement(popper);
          if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
            heightProp = 'scrollHeight';
            widthProp = 'scrollWidth';
          }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

        offsetParent = offsetParent;
        if (placement === top || (placement === left || placement === right) && variation === end) {
          sideY = bottom;
          var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
          // $FlowFixMe[prop-missing]
          offsetParent[heightProp];
          y -= offsetY - popperRect.height;
          y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === left || (placement === top || placement === bottom) && variation === end) {
          sideX = right;
          var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
          // $FlowFixMe[prop-missing]
          offsetParent[widthProp];
          x -= offsetX - popperRect.width;
          x *= gpuAcceleration ? 1 : -1;
        }
      }
      var commonStyles = Object.assign({
        position: position
      }, adaptive && unsetSides);
      var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
      }, getWindow(popper)) : {
        x: x,
        y: y
      };
      x = _ref4.x;
      y = _ref4.y;
      if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
      }
      return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function computeStyles(_ref5) {
      var state = _ref5.state,
        options = _ref5.options;
      var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
      var commonStyles = {
        placement: getBasePlacement(state.placement),
        variation: getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
      };
      if (state.modifiersData.popperOffsets != null) {
        state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
          offsets: state.modifiersData.popperOffsets,
          position: state.options.strategy,
          adaptive: adaptive,
          roundOffsets: roundOffsets
        })));
      }
      if (state.modifiersData.arrow != null) {
        state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
          offsets: state.modifiersData.arrow,
          position: 'absolute',
          adaptive: false,
          roundOffsets: roundOffsets
        })));
      }
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
      });
    } // eslint-disable-next-line import/no-unused-modules

    const computeStyles$1 = {
      name: 'computeStyles',
      enabled: true,
      phase: 'beforeWrite',
      fn: computeStyles,
      data: {}
    };
    var passive = {
      passive: true
    };
    function effect(_ref) {
      var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
      var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
      var window = getWindow(state.elements.popper);
      var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.addEventListener('scroll', instance.update, passive);
        });
      }
      if (resize) {
        window.addEventListener('resize', instance.update, passive);
      }
      return function () {
        if (scroll) {
          scrollParents.forEach(function (scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
          });
        }
        if (resize) {
          window.removeEventListener('resize', instance.update, passive);
        }
      };
    } // eslint-disable-next-line import/no-unused-modules

    const eventListeners = {
      name: 'eventListeners',
      enabled: true,
      phase: 'write',
      fn: function fn() {},
      effect: effect,
      data: {}
    };
    var hash$1 = {
      left: 'right',
      right: 'left',
      bottom: 'top',
      top: 'bottom'
    };
    function getOppositePlacement(placement) {
      return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash$1[matched];
      });
    }
    var hash = {
      start: 'end',
      end: 'start'
    };
    function getOppositeVariationPlacement(placement) {
      return placement.replace(/start|end/g, function (matched) {
        return hash[matched];
      });
    }
    function getWindowScroll(node) {
      var win = getWindow(node);
      var scrollLeft = win.pageXOffset;
      var scrollTop = win.pageYOffset;
      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
    function getWindowScrollBarX(element) {
      // If <html> has a CSS width greater than the viewport, then this will be
      // incorrect for RTL.
      // Popper 1 is broken in this case and never had a bug report so let's assume
      // it's not an issue. I don't think anyone ever specifies width on <html>
      // anyway.
      // Browsers where the left scrollbar doesn't cause an issue report `0` for
      // this (e.g. Edge 2019, IE11, Safari)
      return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
    }
    function getViewportRect(element, strategy) {
      var win = getWindow(element);
      var html = getDocumentElement(element);
      var visualViewport = win.visualViewport;
      var width = html.clientWidth;
      var height = html.clientHeight;
      var x = 0;
      var y = 0;
      if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
          x = visualViewport.offsetLeft;
          y = visualViewport.offsetTop;
        }
      }
      return {
        width: width,
        height: height,
        x: x + getWindowScrollBarX(element),
        y: y
      };
    }

    // of the `<html>` and `<body>` rect bounds if horizontally scrollable

    function getDocumentRect(element) {
      var _element$ownerDocumen;
      var html = getDocumentElement(element);
      var winScroll = getWindowScroll(element);
      var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
      var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
      var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
      var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
      var y = -winScroll.scrollTop;
      if (getComputedStyle$1(body || html).direction === 'rtl') {
        x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
      }
      return {
        width: width,
        height: height,
        x: x,
        y: y
      };
    }
    function isScrollParent(element) {
      // Firefox wants us to check `-x` and `-y` variations as well
      var _getComputedStyle = getComputedStyle$1(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;
      return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
    function getScrollParent(node) {
      if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
      }
      if (isHTMLElement(node) && isScrollParent(node)) {
        return node;
      }
      return getScrollParent(getParentNode(node));
    }

    /*
    given a DOM element, return the list of all scroll parents, up the list of ancesors
    until we get to the top window object. This list is what we attach scroll listeners
    to, because if any of these parent elements scroll, we'll need to re-calculate the
    reference element's position.
    */

    function listScrollParents(element, list) {
      var _element$ownerDocumen;
      if (list === void 0) {
        list = [];
      }
      var scrollParent = getScrollParent(element);
      var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
      var win = getWindow(scrollParent);
      var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
      var updatedList = list.concat(target);
      return isBody ? updatedList :
      // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
      updatedList.concat(listScrollParents(getParentNode(target)));
    }
    function rectToClientRect(rect) {
      return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
      });
    }
    function getInnerBoundingClientRect(element, strategy) {
      var rect = getBoundingClientRect(element, false, strategy === 'fixed');
      rect.top = rect.top + element.clientTop;
      rect.left = rect.left + element.clientLeft;
      rect.bottom = rect.top + element.clientHeight;
      rect.right = rect.left + element.clientWidth;
      rect.width = element.clientWidth;
      rect.height = element.clientHeight;
      rect.x = rect.left;
      rect.y = rect.top;
      return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
      return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`

    function getClippingParents(element) {
      var clippingParents = listScrollParents(getParentNode(element));
      var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
      var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
      if (!isElement(clipperElement)) {
        return [];
      } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

      return clippingParents.filter(function (clippingParent) {
        return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
      });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents

    function getClippingRect(element, boundary, rootBoundary, strategy) {
      var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
      var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
      var firstClippingParent = clippingParents[0];
      var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = max(rect.top, accRect.top);
        accRect.right = min(rect.right, accRect.right);
        accRect.bottom = min(rect.bottom, accRect.bottom);
        accRect.left = max(rect.left, accRect.left);
        return accRect;
      }, getClientRectFromMixedType(element, firstClippingParent, strategy));
      clippingRect.width = clippingRect.right - clippingRect.left;
      clippingRect.height = clippingRect.bottom - clippingRect.top;
      clippingRect.x = clippingRect.left;
      clippingRect.y = clippingRect.top;
      return clippingRect;
    }
    function computeOffsets(_ref) {
      var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
      var basePlacement = placement ? getBasePlacement(placement) : null;
      var variation = placement ? getVariation(placement) : null;
      var commonX = reference.x + reference.width / 2 - element.width / 2;
      var commonY = reference.y + reference.height / 2 - element.height / 2;
      var offsets;
      switch (basePlacement) {
        case top:
          offsets = {
            x: commonX,
            y: reference.y - element.height
          };
          break;
        case bottom:
          offsets = {
            x: commonX,
            y: reference.y + reference.height
          };
          break;
        case right:
          offsets = {
            x: reference.x + reference.width,
            y: commonY
          };
          break;
        case left:
          offsets = {
            x: reference.x - element.width,
            y: commonY
          };
          break;
        default:
          offsets = {
            x: reference.x,
            y: reference.y
          };
      }
      var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
      if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch (variation) {
          case start:
            offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
            break;
          case end:
            offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
            break;
        }
      }
      return offsets;
    }
    function detectOverflow(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$strategy = _options.strategy,
        strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
      var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
      var altContext = elementContext === popper ? reference : popper;
      var popperRect = state.rects.popper;
      var element = state.elements[altBoundary ? altContext : elementContext];
      var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
      var referenceClientRect = getBoundingClientRect(state.elements.reference);
      var popperOffsets = computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
      });
      var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
      var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
      // 0 or negative = within the clipping rect

      var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
      };
      var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

      if (elementContext === popper && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function (key) {
          var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
          var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
          overflowOffsets[key] += offset[axis] * multiply;
        });
      }
      return overflowOffsets;
    }
    function computeAutoPlacement(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
      var variation = getVariation(placement);
      var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
        return getVariation(placement) === variation;
      }) : basePlacements;
      var allowedPlacements = placements$1.filter(function (placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
      });
      if (allowedPlacements.length === 0) {
        allowedPlacements = placements$1;
      } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

      var overflows = allowedPlacements.reduce(function (acc, placement) {
        acc[placement] = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          padding: padding
        })[getBasePlacement(placement)];
        return acc;
      }, {});
      return Object.keys(overflows).sort(function (a, b) {
        return overflows[a] - overflows[b];
      });
    }
    function getExpandedFallbackPlacements(placement) {
      if (getBasePlacement(placement) === auto) {
        return [];
      }
      var oppositePlacement = getOppositePlacement(placement);
      return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
    }
    function flip(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      if (state.modifiersData[name]._skip) {
        return;
      }
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
      var preferredPlacement = state.options.placement;
      var basePlacement = getBasePlacement(preferredPlacement);
      var isBasePlacement = basePlacement === preferredPlacement;
      var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
      var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
        return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          padding: padding,
          flipVariations: flipVariations,
          allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
      }, []);
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var checksMap = new Map();
      var makeFallbackChecks = true;
      var firstFittingPlacement = placements[0];
      for (var i = 0; i < placements.length; i++) {
        var placement = placements[i];
        var _basePlacement = getBasePlacement(placement);
        var isStartVariation = getVariation(placement) === start;
        var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          altBoundary: altBoundary,
          padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
        if (referenceRect[len] > popperRect[len]) {
          mainVariationSide = getOppositePlacement(mainVariationSide);
        }
        var altVariationSide = getOppositePlacement(mainVariationSide);
        var checks = [];
        if (checkMainAxis) {
          checks.push(overflow[_basePlacement] <= 0);
        }
        if (checkAltAxis) {
          checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        }
        if (checks.every(function (check) {
          return check;
        })) {
          firstFittingPlacement = placement;
          makeFallbackChecks = false;
          break;
        }
        checksMap.set(placement, checks);
      }
      if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
          var fittingPlacement = placements.find(function (placement) {
            var checks = checksMap.get(placement);
            if (checks) {
              return checks.slice(0, _i).every(function (check) {
                return check;
              });
            }
          });
          if (fittingPlacement) {
            firstFittingPlacement = fittingPlacement;
            return "break";
          }
        };
        for (var _i = numberOfChecks; _i > 0; _i--) {
          var _ret = _loop(_i);
          if (_ret === "break") break;
        }
      }
      if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
      }
    } // eslint-disable-next-line import/no-unused-modules

    const flip$1 = {
      name: 'flip',
      enabled: true,
      phase: 'main',
      fn: flip,
      requiresIfExists: ['offset'],
      data: {
        _skip: false
      }
    };
    function getSideOffsets(overflow, rect, preventedOffsets) {
      if (preventedOffsets === void 0) {
        preventedOffsets = {
          x: 0,
          y: 0
        };
      }
      return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
      };
    }
    function isAnySideFullyClipped(overflow) {
      return [top, right, bottom, left].some(function (side) {
        return overflow[side] >= 0;
      });
    }
    function hide(_ref) {
      var state = _ref.state,
        name = _ref.name;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var preventedOffsets = state.modifiersData.preventOverflow;
      var referenceOverflow = detectOverflow(state, {
        elementContext: 'reference'
      });
      var popperAltOverflow = detectOverflow(state, {
        altBoundary: true
      });
      var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
      var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
      var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
      var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
      state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
      };
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
      });
    } // eslint-disable-next-line import/no-unused-modules

    const hide$1 = {
      name: 'hide',
      enabled: true,
      phase: 'main',
      requiresIfExists: ['preventOverflow'],
      fn: hide
    };
    function distanceAndSkiddingToXY(placement, rects, offset) {
      var basePlacement = getBasePlacement(placement);
      var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
      var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
          placement: placement
        })) : offset,
        skidding = _ref[0],
        distance = _ref[1];
      skidding = skidding || 0;
      distance = (distance || 0) * invertDistance;
      return [left, right].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
      } : {
        x: skidding,
        y: distance
      };
    }
    function offset(_ref2) {
      var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
      var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
      var data = placements.reduce(function (acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
      }, {});
      var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;
      if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    const offset$1 = {
      name: 'offset',
      enabled: true,
      phase: 'main',
      requires: ['popperOffsets'],
      fn: offset
    };
    function popperOffsets(_ref) {
      var state = _ref.state,
        name = _ref.name;
      // Offsets are the actual position the popper needs to have to be
      // properly positioned near its reference element
      // This is the most basic placement, and will be adjusted by
      // the modifiers in the next step
      state.modifiersData[name] = computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
      });
    } // eslint-disable-next-line import/no-unused-modules

    const popperOffsets$1 = {
      name: 'popperOffsets',
      enabled: true,
      phase: 'read',
      fn: popperOffsets,
      data: {}
    };
    function getAltAxis(axis) {
      return axis === 'x' ? 'y' : 'x';
    }
    function preventOverflow(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
      var overflow = detectOverflow(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
      });
      var basePlacement = getBasePlacement(state.placement);
      var variation = getVariation(state.placement);
      var isBasePlacement = !variation;
      var mainAxis = getMainAxisFromPlacement(basePlacement);
      var altAxis = getAltAxis(mainAxis);
      var popperOffsets = state.modifiersData.popperOffsets;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
      })) : tetherOffset;
      var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
      } : Object.assign({
        mainAxis: 0,
        altAxis: 0
      }, tetherOffsetValue);
      var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
      var data = {
        x: 0,
        y: 0
      };
      if (!popperOffsets) {
        return;
      }
      if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? top : left;
        var altSide = mainAxis === 'y' ? bottom : right;
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min$1 = offset + overflow[mainSide];
        var max$1 = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === start ? referenceRect[len] : popperRect[len];
        var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds

        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
          width: 0,
          height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)

        var arrowLen = within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
      }
      if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? top : left;
        var _altSide = mainAxis === 'x' ? bottom : right;
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    const preventOverflow$1 = {
      name: 'preventOverflow',
      enabled: true,
      phase: 'main',
      fn: preventOverflow,
      requiresIfExists: ['offset']
    };
    function getHTMLElementScroll(element) {
      return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      };
    }
    function getNodeScroll(node) {
      if (node === getWindow(node) || !isHTMLElement(node)) {
        return getWindowScroll(node);
      } else {
        return getHTMLElementScroll(node);
      }
    }
    function isElementScaled(element) {
      var rect = element.getBoundingClientRect();
      var scaleX = round(rect.width) / element.offsetWidth || 1;
      var scaleY = round(rect.height) / element.offsetHeight || 1;
      return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.

    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
      if (isFixed === void 0) {
        isFixed = false;
      }
      var isOffsetParentAnElement = isHTMLElement(offsetParent);
      var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
      var documentElement = getDocumentElement(offsetParent);
      var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
      var scroll = {
        scrollLeft: 0,
        scrollTop: 0
      };
      var offsets = {
        x: 0,
        y: 0
      };
      if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== 'body' ||
        // https://github.com/popperjs/popper-core/issues/1078
        isScrollParent(documentElement)) {
          scroll = getNodeScroll(offsetParent);
        }
        if (isHTMLElement(offsetParent)) {
          offsets = getBoundingClientRect(offsetParent, true);
          offsets.x += offsetParent.clientLeft;
          offsets.y += offsetParent.clientTop;
        } else if (documentElement) {
          offsets.x = getWindowScrollBarX(documentElement);
        }
      }
      return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
      };
    }
    function order(modifiers) {
      var map = new Map();
      var visited = new Set();
      var result = [];
      modifiers.forEach(function (modifier) {
        map.set(modifier.name, modifier);
      }); // On visiting object, check for its dependencies and visit them recursively

      function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function (dep) {
          if (!visited.has(dep)) {
            var depModifier = map.get(dep);
            if (depModifier) {
              sort(depModifier);
            }
          }
        });
        result.push(modifier);
      }
      modifiers.forEach(function (modifier) {
        if (!visited.has(modifier.name)) {
          // check for visited object
          sort(modifier);
        }
      });
      return result;
    }
    function orderModifiers(modifiers) {
      // order based on dependencies
      var orderedModifiers = order(modifiers); // order based on phase

      return modifierPhases.reduce(function (acc, phase) {
        return acc.concat(orderedModifiers.filter(function (modifier) {
          return modifier.phase === phase;
        }));
      }, []);
    }
    function debounce(fn) {
      var pending;
      return function () {
        if (!pending) {
          pending = new Promise(function (resolve) {
            Promise.resolve().then(function () {
              pending = undefined;
              resolve(fn());
            });
          });
        }
        return pending;
      };
    }
    function mergeByName(modifiers) {
      var merged = modifiers.reduce(function (merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
          options: Object.assign({}, existing.options, current.options),
          data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
      }, {}); // IE11 does not support Object.values

      return Object.keys(merged).map(function (key) {
        return merged[key];
      });
    }
    var DEFAULT_OPTIONS = {
      placement: 'bottom',
      modifiers: [],
      strategy: 'absolute'
    };
    function areValidElements() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return !args.some(function (element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
      });
    }
    function popperGenerator(generatorOptions) {
      if (generatorOptions === void 0) {
        generatorOptions = {};
      }
      var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
      return function createPopper(reference, popper, options) {
        if (options === void 0) {
          options = defaultOptions;
        }
        var state = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
          modifiersData: {},
          elements: {
            reference: reference,
            popper: popper
          },
          attributes: {},
          styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
          state: state,
          setOptions: function setOptions(setOptionsAction) {
            var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
            cleanupModifierEffects();
            state.options = Object.assign({}, defaultOptions, state.options, options);
            state.scrollParents = {
              reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
              popper: listScrollParents(popper)
            }; // Orders the modifiers based on their dependencies and `phase`
            // properties

            var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

            state.orderedModifiers = orderedModifiers.filter(function (m) {
              return m.enabled;
            });
            runModifierEffects();
            return instance.update();
          },
          // Sync update – it will always be executed, even if not necessary. This
          // is useful for low frequency updates where sync behavior simplifies the
          // logic.
          // For high frequency updates (e.g. `resize` and `scroll` events), always
          // prefer the async Popper#update method
          forceUpdate: function forceUpdate() {
            if (isDestroyed) {
              return;
            }
            var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
            // anymore

            if (!areValidElements(reference, popper)) {
              return;
            } // Store the reference and popper rects to be read by modifiers

            state.rects = {
              reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
              popper: getLayoutRect(popper)
            }; // Modifiers have the ability to reset the current update cycle. The
            // most common use case for this is the `flip` modifier changing the
            // placement, which then needs to re-run all the modifiers, because the
            // logic was previously ran for the previous placement and is therefore
            // stale/incorrect

            state.reset = false;
            state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
            // is filled with the initial data specified by the modifier. This means
            // it doesn't persist and is fresh on each update.
            // To ensure persistent data, use `${name}#persistent`

            state.orderedModifiers.forEach(function (modifier) {
              return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
            });
            for (var index = 0; index < state.orderedModifiers.length; index++) {
              if (state.reset === true) {
                state.reset = false;
                index = -1;
                continue;
              }
              var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;
              if (typeof fn === 'function') {
                state = fn({
                  state: state,
                  options: _options,
                  name: name,
                  instance: instance
                }) || state;
              }
            }
          },
          // Async and optimistically optimized update – it will not be executed if
          // not necessary (debounced to run at most once-per-tick)
          update: debounce(function () {
            return new Promise(function (resolve) {
              instance.forceUpdate();
              resolve(state);
            });
          }),
          destroy: function destroy() {
            cleanupModifierEffects();
            isDestroyed = true;
          }
        };
        if (!areValidElements(reference, popper)) {
          return instance;
        }
        instance.setOptions(options).then(function (state) {
          if (!isDestroyed && options.onFirstUpdate) {
            options.onFirstUpdate(state);
          }
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.

        function runModifierEffects() {
          state.orderedModifiers.forEach(function (_ref) {
            var name = _ref.name,
              _ref$options = _ref.options,
              options = _ref$options === void 0 ? {} : _ref$options,
              effect = _ref.effect;
            if (typeof effect === 'function') {
              var cleanupFn = effect({
                state: state,
                name: name,
                instance: instance,
                options: options
              });
              var noopFn = function noopFn() {};
              effectCleanupFns.push(cleanupFn || noopFn);
            }
          });
        }
        function cleanupModifierEffects() {
          effectCleanupFns.forEach(function (fn) {
            return fn();
          });
          effectCleanupFns = [];
        }
        return instance;
      };
    }
    var createPopper$2 = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules

    var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
    var createPopper$1 = /*#__PURE__*/popperGenerator({
      defaultModifiers: defaultModifiers$1
    }); // eslint-disable-next-line import/no-unused-modules

    var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
    var createPopper = /*#__PURE__*/popperGenerator({
      defaultModifiers: defaultModifiers
    }); // eslint-disable-next-line import/no-unused-modules

    const Popper = /*#__PURE__*/Object.freeze( /*#__PURE__*/Object.defineProperty({
      __proto__: null,
      afterMain,
      afterRead,
      afterWrite,
      applyStyles: applyStyles$1,
      arrow: arrow$1,
      auto,
      basePlacements,
      beforeMain,
      beforeRead,
      beforeWrite,
      bottom,
      clippingParents,
      computeStyles: computeStyles$1,
      createPopper,
      createPopperBase: createPopper$2,
      createPopperLite: createPopper$1,
      detectOverflow,
      end,
      eventListeners,
      flip: flip$1,
      hide: hide$1,
      left,
      main,
      modifierPhases,
      offset: offset$1,
      placements,
      popper,
      popperGenerator,
      popperOffsets: popperOffsets$1,
      preventOverflow: preventOverflow$1,
      read,
      reference,
      right,
      start,
      top,
      variationPlacements,
      viewport,
      write
    }, Symbol.toStringTag, {
      value: 'Module'
    }));

    /**
     * --------------------------------------------------------------------------
     * Bootstrap dropdown.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$a = 'dropdown';
    const DATA_KEY$6 = 'bs.dropdown';
    const EVENT_KEY$6 = ".".concat(DATA_KEY$6);
    const DATA_API_KEY$3 = '.data-api';
    const ESCAPE_KEY$2 = 'Escape';
    const TAB_KEY$1 = 'Tab';
    const ARROW_UP_KEY$1 = 'ArrowUp';
    const ARROW_DOWN_KEY$1 = 'ArrowDown';
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button

    const EVENT_HIDE$5 = "hide".concat(EVENT_KEY$6);
    const EVENT_HIDDEN$5 = "hidden".concat(EVENT_KEY$6);
    const EVENT_SHOW$5 = "show".concat(EVENT_KEY$6);
    const EVENT_SHOWN$5 = "shown".concat(EVENT_KEY$6);
    const EVENT_CLICK_DATA_API$3 = "click".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    const EVENT_KEYDOWN_DATA_API = "keydown".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    const EVENT_KEYUP_DATA_API = "keyup".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    const CLASS_NAME_SHOW$6 = 'show';
    const CLASS_NAME_DROPUP = 'dropup';
    const CLASS_NAME_DROPEND = 'dropend';
    const CLASS_NAME_DROPSTART = 'dropstart';
    const CLASS_NAME_DROPUP_CENTER = 'dropup-center';
    const CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
    const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = "".concat(SELECTOR_DATA_TOGGLE$3, ".").concat(CLASS_NAME_SHOW$6);
    const SELECTOR_MENU = '.dropdown-menu';
    const SELECTOR_NAVBAR = '.navbar';
    const SELECTOR_NAVBAR_NAV = '.navbar-nav';
    const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
    const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
    const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
    const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
    const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
    const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
    const PLACEMENT_TOPCENTER = 'top';
    const PLACEMENT_BOTTOMCENTER = 'bottom';
    const Default$9 = {
      autoClose: true,
      boundary: 'clippingParents',
      display: 'dynamic',
      offset: [0, 2],
      popperConfig: null,
      reference: 'toggle'
    };
    const DefaultType$9 = {
      autoClose: '(boolean|string)',
      boundary: '(string|element)',
      display: 'string',
      offset: '(array|string|function)',
      popperConfig: '(null|object|function)',
      reference: '(string|element|object)'
    };

    /**
     * Class definition
     */

    class Dropdown extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
      }

      // Getters
      static get Default() {
        return Default$9;
      }
      static get DefaultType() {
        return DefaultType$9;
      }
      static get NAME() {
        return NAME$a;
      }

      // Public
      toggle() {
        return this._isShown() ? this.hide() : this.show();
      }
      show() {
        if (isDisabled(this._element) || this._isShown()) {
          return;
        }
        const relatedTarget = {
          relatedTarget: this._element
        };
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) {
          return;
        }
        this._createPopper();

        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) {
          for (const element of [].concat(...document.body.children)) {
            EventHandler.on(element, 'mouseover', noop);
          }
        }
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add(CLASS_NAME_SHOW$6);
        this._element.classList.add(CLASS_NAME_SHOW$6);
        EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
      }
      hide() {
        if (isDisabled(this._element) || !this._isShown()) {
          return;
        }
        const relatedTarget = {
          relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
      }
      dispose() {
        if (this._popper) {
          this._popper.destroy();
        }
        super.dispose();
      }
      update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) {
          this._popper.update();
        }
      }

      // Private
      _completeHide(relatedTarget) {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) {
          return;
        }

        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) {
          for (const element of [].concat(...document.body.children)) {
            EventHandler.off(element, 'mouseover', noop);
          }
        }
        if (this._popper) {
          this._popper.destroy();
        }
        this._menu.classList.remove(CLASS_NAME_SHOW$6);
        this._element.classList.remove(CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        Manipulator.removeDataAttribute(this._menu, 'popper');
        EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
      }
      _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !isElement$1(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') {
          // Popper virtual elements require a getBoundingClientRect method
          throw new TypeError("".concat(NAME$a.toUpperCase(), ": Option \"reference\" provided type \"object\" without a required \"getBoundingClientRect\" method."));
        }
        return config;
      }
      _createPopper() {
        if (typeof Popper === 'undefined') {
          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        }
        let referenceElement = this._element;
        if (this._config.reference === 'parent') {
          referenceElement = this._parent;
        } else if (isElement$1(this._config.reference)) {
          referenceElement = getElement(this._config.reference);
        } else if (typeof this._config.reference === 'object') {
          referenceElement = this._config.reference;
        }
        const popperConfig = this._getPopperConfig();
        this._popper = createPopper(referenceElement, this._menu, popperConfig);
      }
      _isShown() {
        return this._menu.classList.contains(CLASS_NAME_SHOW$6);
      }
      _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) {
          return PLACEMENT_RIGHT;
        }
        if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) {
          return PLACEMENT_LEFT;
        }
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) {
          return PLACEMENT_TOPCENTER;
        }
        if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) {
          return PLACEMENT_BOTTOMCENTER;
        }

        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) {
          return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
        }
        return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
      }
      _detectNavbar() {
        return this._element.closest(SELECTOR_NAVBAR) !== null;
      }
      _getOffset() {
        const {
          offset
        } = this._config;
        if (typeof offset === 'string') {
          return offset.split(',').map(value => Number.parseInt(value, 10));
        }
        if (typeof offset === 'function') {
          return popperData => offset(popperData, this._element);
        }
        return offset;
      }
      _getPopperConfig() {
        const defaultBsPopperConfig = {
          placement: this._getPlacement(),
          modifiers: [{
            name: 'preventOverflow',
            options: {
              boundary: this._config.boundary
            }
          }, {
            name: 'offset',
            options: {
              offset: this._getOffset()
            }
          }]
        };

        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
          Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
          defaultBsPopperConfig.modifiers = [{
            name: 'applyStyles',
            enabled: false
          }];
        }
        return {
          ...defaultBsPopperConfig,
          ...execute(this._config.popperConfig, [defaultBsPopperConfig])
        };
      }
      _selectMenuItem(_ref7) {
        let {
          key,
          target
        } = _ref7;
        const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(element => isVisible(element));
        if (!items.length) {
          return;
        }

        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Dropdown.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config]();
        });
      }
      static clearMenus(event) {
        if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1) {
          return;
        }
        const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles) {
          const context = Dropdown.getInstance(toggle);
          if (!context || context._config.autoClose === false) {
            continue;
          }
          const composedPath = event.composedPath();
          const isMenuTarget = composedPath.includes(context._menu);
          if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) {
            continue;
          }

          // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
          if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) {
            continue;
          }
          const relatedTarget = {
            relatedTarget: context._element
          };
          if (event.type === 'click') {
            relatedTarget.clickEvent = event;
          }
          context._completeHide(relatedTarget);
        }
      }
      static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command

        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === ESCAPE_KEY$2;
        const isUpOrDownEvent = [ARROW_UP_KEY$1, ARROW_DOWN_KEY$1].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) {
          return;
        }
        if (isInput && !isEscapeEvent) {
          return;
        }
        event.preventDefault();

        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = Dropdown.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
          event.stopPropagation();
          instance.show();
          instance._selectMenuItem(event);
          return;
        }
        if (instance._isShown()) {
          // else is escape and we check if it is shown
          event.stopPropagation();
          instance.hide();
          getToggleButton.focus();
        }
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
      event.preventDefault();
      Dropdown.getOrCreateInstance(this).toggle();
    });

    /**
     * jQuery
     */

    defineJQueryPlugin(Dropdown);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/backdrop.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$9 = 'backdrop';
    const CLASS_NAME_FADE$4 = 'fade';
    const CLASS_NAME_SHOW$5 = 'show';
    const EVENT_MOUSEDOWN = "mousedown.bs.".concat(NAME$9);
    const Default$8 = {
      className: 'modal-backdrop',
      clickCallback: null,
      isAnimated: false,
      isVisible: true,
      // if false, we use the backdrop helper without adding any element to the dom
      rootElement: 'body' // give the choice to place backdrop under different elements
    };
    const DefaultType$8 = {
      className: 'string',
      clickCallback: '(function|null)',
      isAnimated: 'boolean',
      isVisible: 'boolean',
      rootElement: '(element|string)'
    };

    /**
     * Class definition
     */

    class Backdrop extends Config {
      constructor(config) {
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
      }

      // Getters
      static get Default() {
        return Default$8;
      }
      static get DefaultType() {
        return DefaultType$8;
      }
      static get NAME() {
        return NAME$9;
      }

      // Public
      show(callback) {
        if (!this._config.isVisible) {
          execute(callback);
          return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) {
          reflow(element);
        }
        element.classList.add(CLASS_NAME_SHOW$5);
        this._emulateAnimation(() => {
          execute(callback);
        });
      }
      hide(callback) {
        if (!this._config.isVisible) {
          execute(callback);
          return;
        }
        this._getElement().classList.remove(CLASS_NAME_SHOW$5);
        this._emulateAnimation(() => {
          this.dispose();
          execute(callback);
        });
      }
      dispose() {
        if (!this._isAppended) {
          return;
        }
        EventHandler.off(this._element, EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
      }

      // Private
      _getElement() {
        if (!this._element) {
          const backdrop = document.createElement('div');
          backdrop.className = this._config.className;
          if (this._config.isAnimated) {
            backdrop.classList.add(CLASS_NAME_FADE$4);
          }
          this._element = backdrop;
        }
        return this._element;
      }
      _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = getElement(config.rootElement);
        return config;
      }
      _append() {
        if (this._isAppended) {
          return;
        }
        const element = this._getElement();
        this._config.rootElement.append(element);
        EventHandler.on(element, EVENT_MOUSEDOWN, () => {
          execute(this._config.clickCallback);
        });
        this._isAppended = true;
      }
      _emulateAnimation(callback) {
        executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/focustrap.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$8 = 'focustrap';
    const DATA_KEY$5 = 'bs.focustrap';
    const EVENT_KEY$5 = ".".concat(DATA_KEY$5);
    const EVENT_FOCUSIN$2 = "focusin".concat(EVENT_KEY$5);
    const EVENT_KEYDOWN_TAB = "keydown.tab".concat(EVENT_KEY$5);
    const TAB_KEY = 'Tab';
    const TAB_NAV_FORWARD = 'forward';
    const TAB_NAV_BACKWARD = 'backward';
    const Default$7 = {
      autofocus: true,
      trapElement: null // The element to trap focus inside of
    };
    const DefaultType$7 = {
      autofocus: 'boolean',
      trapElement: 'element'
    };

    /**
     * Class definition
     */

    class FocusTrap extends Config {
      constructor(config) {
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
      }

      // Getters
      static get Default() {
        return Default$7;
      }
      static get DefaultType() {
        return DefaultType$7;
      }
      static get NAME() {
        return NAME$8;
      }

      // Public
      activate() {
        if (this._isActive) {
          return;
        }
        if (this._config.autofocus) {
          this._config.trapElement.focus();
        }
        EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
        EventHandler.on(document, EVENT_FOCUSIN$2, event => this._handleFocusin(event));
        EventHandler.on(document, EVENT_KEYDOWN_TAB, event => this._handleKeydown(event));
        this._isActive = true;
      }
      deactivate() {
        if (!this._isActive) {
          return;
        }
        this._isActive = false;
        EventHandler.off(document, EVENT_KEY$5);
      }

      // Private
      _handleFocusin(event) {
        const {
          trapElement
        } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) {
          return;
        }
        const elements = SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) {
          trapElement.focus();
        } else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) {
          elements[elements.length - 1].focus();
        } else {
          elements[0].focus();
        }
      }
      _handleKeydown(event) {
        if (event.key !== TAB_KEY) {
          return;
        }
        this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/scrollBar.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    const SELECTOR_STICKY_CONTENT = '.sticky-top';
    const PROPERTY_PADDING = 'padding-right';
    const PROPERTY_MARGIN = 'margin-right';

    /**
     * Class definition
     */

    class ScrollBarHelper {
      constructor() {
        this._element = document.body;
      }

      // Public
      getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
      }
      hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, PROPERTY_PADDING, calculatedValue => calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, calculatedValue => calculatedValue + width);
        this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, calculatedValue => calculatedValue - width);
      }
      reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
      }
      isOverflowing() {
        return this.getWidth() > 0;
      }

      // Private
      _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
      }
      _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = element => {
          if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) {
            return;
          }
          this._saveInitialAttribute(element, styleProperty);
          const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
          element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
      }
      _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) {
          Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
      }
      _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = element => {
          const value = Manipulator.getDataAttribute(element, styleProperty);
          // We only want to remove the property if the value is `null`; the value can also be zero
          if (value === null) {
            element.style.removeProperty(styleProperty);
            return;
          }
          Manipulator.removeDataAttribute(element, styleProperty);
          element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
      }
      _applyManipulationCallback(selector, callBack) {
        if (isElement$1(selector)) {
          callBack(selector);
          return;
        }
        for (const sel of SelectorEngine.find(selector, this._element)) {
          callBack(sel);
        }
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap modal.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$7 = 'modal';
    const DATA_KEY$4 = 'bs.modal';
    const EVENT_KEY$4 = ".".concat(DATA_KEY$4);
    const DATA_API_KEY$2 = '.data-api';
    const ESCAPE_KEY$1 = 'Escape';
    const EVENT_HIDE$4 = "hide".concat(EVENT_KEY$4);
    const EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat(EVENT_KEY$4);
    const EVENT_HIDDEN$4 = "hidden".concat(EVENT_KEY$4);
    const EVENT_SHOW$4 = "show".concat(EVENT_KEY$4);
    const EVENT_SHOWN$4 = "shown".concat(EVENT_KEY$4);
    const EVENT_RESIZE$1 = "resize".concat(EVENT_KEY$4);
    const EVENT_CLICK_DISMISS = "click.dismiss".concat(EVENT_KEY$4);
    const EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat(EVENT_KEY$4);
    const EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat(EVENT_KEY$4);
    const EVENT_CLICK_DATA_API$2 = "click".concat(EVENT_KEY$4).concat(DATA_API_KEY$2);
    const CLASS_NAME_OPEN = 'modal-open';
    const CLASS_NAME_FADE$3 = 'fade';
    const CLASS_NAME_SHOW$4 = 'show';
    const CLASS_NAME_STATIC = 'modal-static';
    const OPEN_SELECTOR$1 = '.modal.show';
    const SELECTOR_DIALOG = '.modal-dialog';
    const SELECTOR_MODAL_BODY = '.modal-body';
    const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    const Default$6 = {
      backdrop: true,
      focus: true,
      keyboard: true
    };
    const DefaultType$6 = {
      backdrop: '(boolean|string)',
      focus: 'boolean',
      keyboard: 'boolean'
    };

    /**
     * Class definition
     */

    class Modal extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new ScrollBarHelper();
        this._addEventListeners();
      }

      // Getters
      static get Default() {
        return Default$6;
      }
      static get DefaultType() {
        return DefaultType$6;
      }
      static get NAME() {
        return NAME$7;
      }

      // Public
      toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
      }
      show(relatedTarget) {
        if (this._isShown || this._isTransitioning) {
          return;
        }
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
          relatedTarget
        });
        if (showEvent.defaultPrevented) {
          return;
        }
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add(CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(() => this._showElement(relatedTarget));
      }
      hide() {
        if (!this._isShown || this._isTransitioning) {
          return;
        }
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) {
          return;
        }
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove(CLASS_NAME_SHOW$4);
        this._queueCallback(() => this._hideModal(), this._element, this._isAnimated());
      }
      dispose() {
        EventHandler.off(window, EVENT_KEY$4);
        EventHandler.off(this._dialog, EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
      }
      handleUpdate() {
        this._adjustDialog();
      }

      // Private
      _initializeBackDrop() {
        return new Backdrop({
          isVisible: Boolean(this._config.backdrop),
          // 'static' option will be translated to true, and booleans will keep their value,
          isAnimated: this._isAnimated()
        });
      }
      _initializeFocusTrap() {
        return new FocusTrap({
          trapElement: this._element
        });
      }
      _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) {
          document.body.append(this._element);
        }
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) {
          modalBody.scrollTop = 0;
        }
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW$4);
        const transitionComplete = () => {
          if (this._config.focus) {
            this._focustrap.activate();
          }
          this._isTransitioning = false;
          EventHandler.trigger(this._element, EVENT_SHOWN$4, {
            relatedTarget
          });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
      }
      _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, event => {
          if (event.key !== ESCAPE_KEY$1) {
            return;
          }
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          this._triggerBackdropTransition();
        });
        EventHandler.on(window, EVENT_RESIZE$1, () => {
          if (this._isShown && !this._isTransitioning) {
            this._adjustDialog();
          }
        });
        EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, event => {
          // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
          EventHandler.one(this._element, EVENT_CLICK_DISMISS, event2 => {
            if (this._element !== event.target || this._element !== event2.target) {
              return;
            }
            if (this._config.backdrop === 'static') {
              this._triggerBackdropTransition();
              return;
            }
            if (this._config.backdrop) {
              this.hide();
            }
          });
        });
      }
      _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(() => {
          document.body.classList.remove(CLASS_NAME_OPEN);
          this._resetAdjustments();
          this._scrollBar.reset();
          EventHandler.trigger(this._element, EVENT_HIDDEN$4);
        });
      }
      _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_FADE$3);
      }
      _triggerBackdropTransition() {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) {
          return;
        }
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) {
          return;
        }
        if (!isModalOverflowing) {
          this._element.style.overflowY = 'hidden';
        }
        this._element.classList.add(CLASS_NAME_STATIC);
        this._queueCallback(() => {
          this._element.classList.remove(CLASS_NAME_STATIC);
          this._queueCallback(() => {
            this._element.style.overflowY = initialOverflowY;
          }, this._dialog);
        }, this._dialog);
        this._element.focus();
      }

      /**
       * The following methods are used to handle overflowing modals
       */

      _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
          const property = isRTL() ? 'paddingLeft' : 'paddingRight';
          this._element.style[property] = "".concat(scrollbarWidth, "px");
        }
        if (!isBodyOverflowing && isModalOverflowing) {
          const property = isRTL() ? 'paddingRight' : 'paddingLeft';
          this._element.style[property] = "".concat(scrollbarWidth, "px");
        }
      }
      _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
      }

      // Static
      static jQueryInterface(config, relatedTarget) {
        return this.each(function () {
          const data = Modal.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config](relatedTarget);
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
      const target = SelectorEngine.getElementFromSelector(this);
      if (['A', 'AREA'].includes(this.tagName)) {
        event.preventDefault();
      }
      EventHandler.one(target, EVENT_SHOW$4, showEvent => {
        if (showEvent.defaultPrevented) {
          // only register focus restorer if modal will actually get shown
          return;
        }
        EventHandler.one(target, EVENT_HIDDEN$4, () => {
          if (isVisible(this)) {
            this.focus();
          }
        });
      });

      // avoid conflict when clicking modal toggler while another one is open
      const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
      if (alreadyOpen) {
        Modal.getInstance(alreadyOpen).hide();
      }
      const data = Modal.getOrCreateInstance(target);
      data.toggle(this);
    });
    enableDismissTrigger(Modal);

    /**
     * jQuery
     */

    defineJQueryPlugin(Modal);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap offcanvas.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$6 = 'offcanvas';
    const DATA_KEY$3 = 'bs.offcanvas';
    const EVENT_KEY$3 = ".".concat(DATA_KEY$3);
    const DATA_API_KEY$1 = '.data-api';
    const EVENT_LOAD_DATA_API$2 = "load".concat(EVENT_KEY$3).concat(DATA_API_KEY$1);
    const ESCAPE_KEY = 'Escape';
    const CLASS_NAME_SHOW$3 = 'show';
    const CLASS_NAME_SHOWING$1 = 'showing';
    const CLASS_NAME_HIDING = 'hiding';
    const CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
    const OPEN_SELECTOR = '.offcanvas.show';
    const EVENT_SHOW$3 = "show".concat(EVENT_KEY$3);
    const EVENT_SHOWN$3 = "shown".concat(EVENT_KEY$3);
    const EVENT_HIDE$3 = "hide".concat(EVENT_KEY$3);
    const EVENT_HIDE_PREVENTED = "hidePrevented".concat(EVENT_KEY$3);
    const EVENT_HIDDEN$3 = "hidden".concat(EVENT_KEY$3);
    const EVENT_RESIZE = "resize".concat(EVENT_KEY$3);
    const EVENT_CLICK_DATA_API$1 = "click".concat(EVENT_KEY$3).concat(DATA_API_KEY$1);
    const EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat(EVENT_KEY$3);
    const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    const Default$5 = {
      backdrop: true,
      keyboard: true,
      scroll: false
    };
    const DefaultType$5 = {
      backdrop: '(boolean|string)',
      keyboard: 'boolean',
      scroll: 'boolean'
    };

    /**
     * Class definition
     */

    class Offcanvas extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
      }

      // Getters
      static get Default() {
        return Default$5;
      }
      static get DefaultType() {
        return DefaultType$5;
      }
      static get NAME() {
        return NAME$6;
      }

      // Public
      toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
      }
      show(relatedTarget) {
        if (this._isShown) {
          return;
        }
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
          relatedTarget
        });
        if (showEvent.defaultPrevented) {
          return;
        }
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) {
          new ScrollBarHelper().hide();
        }
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add(CLASS_NAME_SHOWING$1);
        const completeCallBack = () => {
          if (!this._config.scroll || this._config.backdrop) {
            this._focustrap.activate();
          }
          this._element.classList.add(CLASS_NAME_SHOW$3);
          this._element.classList.remove(CLASS_NAME_SHOWING$1);
          EventHandler.trigger(this._element, EVENT_SHOWN$3, {
            relatedTarget
          });
        };
        this._queueCallback(completeCallBack, this._element, true);
      }
      hide() {
        if (!this._isShown) {
          return;
        }
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) {
          return;
        }
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add(CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = () => {
          this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
          this._element.removeAttribute('aria-modal');
          this._element.removeAttribute('role');
          if (!this._config.scroll) {
            new ScrollBarHelper().reset();
          }
          EventHandler.trigger(this._element, EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
      }
      dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
      }

      // Private
      _initializeBackDrop() {
        const clickCallback = () => {
          if (this._config.backdrop === 'static') {
            EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            return;
          }
          this.hide();
        };

        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new Backdrop({
          className: CLASS_NAME_BACKDROP,
          isVisible,
          isAnimated: true,
          rootElement: this._element.parentNode,
          clickCallback: isVisible ? clickCallback : null
        });
      }
      _initializeFocusTrap() {
        return new FocusTrap({
          trapElement: this._element
        });
      }
      _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, event => {
          if (event.key !== ESCAPE_KEY) {
            return;
          }
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
        });
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Offcanvas.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config](this);
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
      const target = SelectorEngine.getElementFromSelector(this);
      if (['A', 'AREA'].includes(this.tagName)) {
        event.preventDefault();
      }
      if (isDisabled(this)) {
        return;
      }
      EventHandler.one(target, EVENT_HIDDEN$3, () => {
        // focus on trigger when it is closed
        if (isVisible(this)) {
          this.focus();
        }
      });

      // avoid conflict when clicking a toggler of an offcanvas, while another is open
      const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
      if (alreadyOpen && alreadyOpen !== target) {
        Offcanvas.getInstance(alreadyOpen).hide();
      }
      const data = Offcanvas.getOrCreateInstance(target);
      data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, () => {
      for (const selector of SelectorEngine.find(OPEN_SELECTOR)) {
        Offcanvas.getOrCreateInstance(selector).show();
      }
    });
    EventHandler.on(window, EVENT_RESIZE, () => {
      for (const element of SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')) {
        if (getComputedStyle(element).position !== 'fixed') {
          Offcanvas.getOrCreateInstance(element).hide();
        }
      }
    });
    enableDismissTrigger(Offcanvas);

    /**
     * jQuery
     */

    defineJQueryPlugin(Offcanvas);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/sanitizer.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
      // Global attributes allowed on any supplied element below.
      '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
      a: ['target', 'href', 'title', 'rel'],
      area: [],
      b: [],
      br: [],
      col: [],
      code: [],
      div: [],
      em: [],
      hr: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      i: [],
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
      li: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      u: [],
      ul: []
    };
    // js-docs-end allow-list

    const uriAttributes = new Set(['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href']);

    /**
     * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
     * contexts.
     *
     * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
     */
    // eslint-disable-next-line unicorn/better-regex
    const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList) => {
      const attributeName = attribute.nodeName.toLowerCase();
      if (allowedAttributeList.includes(attributeName)) {
        if (uriAttributes.has(attributeName)) {
          return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
        }
        return true;
      }

      // Check if a regular expression validates the attribute.
      return allowedAttributeList.filter(attributeRegex => attributeRegex instanceof RegExp).some(regex => regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
      if (!unsafeHtml.length) {
        return unsafeHtml;
      }
      if (sanitizeFunction && typeof sanitizeFunction === 'function') {
        return sanitizeFunction(unsafeHtml);
      }
      const domParser = new window.DOMParser();
      const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
      const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
      for (const element of elements) {
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
          element.remove();
          continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList) {
          if (!allowedAttribute(attribute, allowedAttributes)) {
            element.removeAttribute(attribute.nodeName);
          }
        }
      }
      return createdDocument.body.innerHTML;
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap util/template-factory.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$5 = 'TemplateFactory';
    const Default$4 = {
      allowList: DefaultAllowlist,
      content: {},
      // { selector : text ,  selector2 : text2 , }
      extraClass: '',
      html: false,
      sanitize: true,
      sanitizeFn: null,
      template: '<div></div>'
    };
    const DefaultType$4 = {
      allowList: 'object',
      content: 'object',
      extraClass: '(string|function)',
      html: 'boolean',
      sanitize: 'boolean',
      sanitizeFn: '(null|function)',
      template: 'string'
    };
    const DefaultContentType = {
      entry: '(string|element|function|null)',
      selector: '(string|element)'
    };

    /**
     * Class definition
     */

    class TemplateFactory extends Config {
      constructor(config) {
        super();
        this._config = this._getConfig(config);
      }

      // Getters
      static get Default() {
        return Default$4;
      }
      static get DefaultType() {
        return DefaultType$4;
      }
      static get NAME() {
        return NAME$5;
      }

      // Public
      getContent() {
        return Object.values(this._config.content).map(config => this._resolvePossibleFunction(config)).filter(Boolean);
      }
      hasContent() {
        return this.getContent().length > 0;
      }
      changeContent(content) {
        this._checkContent(content);
        this._config.content = {
          ...this._config.content,
          ...content
        };
        return this;
      }
      toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content)) {
          this._setContent(templateWrapper, text, selector);
        }
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) {
          template.classList.add(...extraClass.split(' '));
        }
        return template;
      }

      // Private
      _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
      }
      _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg)) {
          super._typeCheckConfig({
            selector,
            entry: content
          }, DefaultContentType);
        }
      }
      _setContent(template, content, selector) {
        const templateElement = SelectorEngine.findOne(selector, template);
        if (!templateElement) {
          return;
        }
        content = this._resolvePossibleFunction(content);
        if (!content) {
          templateElement.remove();
          return;
        }
        if (isElement$1(content)) {
          this._putElementInTemplate(getElement(content), templateElement);
          return;
        }
        if (this._config.html) {
          templateElement.innerHTML = this._maybeSanitize(content);
          return;
        }
        templateElement.textContent = content;
      }
      _maybeSanitize(arg) {
        return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
      }
      _resolvePossibleFunction(arg) {
        return execute(arg, [this]);
      }
      _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
          templateElement.innerHTML = '';
          templateElement.append(element);
          return;
        }
        templateElement.textContent = element.textContent;
      }
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap tooltip.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$4 = 'tooltip';
    const DISALLOWED_ATTRIBUTES = new Set(['sanitize', 'allowList', 'sanitizeFn']);
    const CLASS_NAME_FADE$2 = 'fade';
    const CLASS_NAME_MODAL = 'modal';
    const CLASS_NAME_SHOW$2 = 'show';
    const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
    const SELECTOR_MODAL = ".".concat(CLASS_NAME_MODAL);
    const EVENT_MODAL_HIDE = 'hide.bs.modal';
    const TRIGGER_HOVER = 'hover';
    const TRIGGER_FOCUS = 'focus';
    const TRIGGER_CLICK = 'click';
    const TRIGGER_MANUAL = 'manual';
    const EVENT_HIDE$2 = 'hide';
    const EVENT_HIDDEN$2 = 'hidden';
    const EVENT_SHOW$2 = 'show';
    const EVENT_SHOWN$2 = 'shown';
    const EVENT_INSERTED = 'inserted';
    const EVENT_CLICK$1 = 'click';
    const EVENT_FOCUSIN$1 = 'focusin';
    const EVENT_FOCUSOUT$1 = 'focusout';
    const EVENT_MOUSEENTER = 'mouseenter';
    const EVENT_MOUSELEAVE = 'mouseleave';
    const AttachmentMap = {
      AUTO: 'auto',
      TOP: 'top',
      RIGHT: isRTL() ? 'left' : 'right',
      BOTTOM: 'bottom',
      LEFT: isRTL() ? 'right' : 'left'
    };
    const Default$3 = {
      allowList: DefaultAllowlist,
      animation: true,
      boundary: 'clippingParents',
      container: false,
      customClass: '',
      delay: 0,
      fallbackPlacements: ['top', 'right', 'bottom', 'left'],
      html: false,
      offset: [0, 6],
      placement: 'top',
      popperConfig: null,
      sanitize: true,
      sanitizeFn: null,
      selector: false,
      template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-arrow"></div>' + '<div class="tooltip-inner"></div>' + '</div>',
      title: '',
      trigger: 'hover focus'
    };
    const DefaultType$3 = {
      allowList: 'object',
      animation: 'boolean',
      boundary: '(string|element)',
      container: '(string|element|boolean)',
      customClass: '(string|function)',
      delay: '(number|object)',
      fallbackPlacements: 'array',
      html: 'boolean',
      offset: '(array|string|function)',
      placement: '(string|function)',
      popperConfig: '(null|object|function)',
      sanitize: 'boolean',
      sanitizeFn: '(null|function)',
      selector: '(string|boolean)',
      template: 'string',
      title: '(string|element|function)',
      trigger: 'string'
    };

    /**
     * Class definition
     */

    class Tooltip extends BaseComponent {
      constructor(element, config) {
        if (typeof Popper === 'undefined') {
          throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        }
        super(element, config);

        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;

        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) {
          this._fixTitle();
        }
      }

      // Getters
      static get Default() {
        return Default$3;
      }
      static get DefaultType() {
        return DefaultType$3;
      }
      static get NAME() {
        return NAME$4;
      }

      // Public
      enable() {
        this._isEnabled = true;
      }
      disable() {
        this._isEnabled = false;
      }
      toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      }
      toggle() {
        if (!this._isEnabled) {
          return;
        }
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
          this._leave();
          return;
        }
        this._enter();
      }
      dispose() {
        clearTimeout(this._timeout);
        EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) {
          this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        }
        this._disposePopper();
        super.dispose();
      }
      show() {
        if (this._element.style.display === 'none') {
          throw new Error('Please use show on visible elements');
        }
        if (!(this._isWithContent() && this._isEnabled)) {
          return;
        }
        const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
        const shadowRoot = findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) {
          return;
        }

        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const {
          container
        } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
          container.append(tip);
          EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add(CLASS_NAME_SHOW$2);

        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) {
          for (const element of [].concat(...document.body.children)) {
            EventHandler.on(element, 'mouseover', noop);
          }
        }
        const complete = () => {
          EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
          if (this._isHovered === false) {
            this._leave();
          }
          this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
      }
      hide() {
        if (!this._isShown()) {
          return;
        }
        const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) {
          return;
        }
        const tip = this._getTipElement();
        tip.classList.remove(CLASS_NAME_SHOW$2);

        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) {
          for (const element of [].concat(...document.body.children)) {
            EventHandler.off(element, 'mouseover', noop);
          }
        }
        this._activeTrigger[TRIGGER_CLICK] = false;
        this._activeTrigger[TRIGGER_FOCUS] = false;
        this._activeTrigger[TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering

        const complete = () => {
          if (this._isWithActiveTrigger()) {
            return;
          }
          if (!this._isHovered) {
            this._disposePopper();
          }
          this._element.removeAttribute('aria-describedby');
          EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
      }
      update() {
        if (this._popper) {
          this._popper.update();
        }
      }

      // Protected
      _isWithContent() {
        return Boolean(this._getTitle());
      }
      _getTipElement() {
        if (!this.tip) {
          this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        }
        return this.tip;
      }
      _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();

        // TODO: remove this check in v6
        if (!tip) {
          return null;
        }
        tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
        const tipId = getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) {
          tip.classList.add(CLASS_NAME_FADE$2);
        }
        return tip;
      }
      setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
          this._disposePopper();
          this.show();
        }
      }
      _getTemplateFactory(content) {
        if (this._templateFactory) {
          this._templateFactory.changeContent(content);
        } else {
          this._templateFactory = new TemplateFactory({
            ...this._config,
            // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
          });
        }
        return this._templateFactory;
      }
      _getContentForTemplate() {
        return {
          [SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
      }
      _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
      }

      // Private
      _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
      }
      _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
      }
      _isShown() {
        return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
      }
      _createPopper(tip) {
        const placement = execute(this._config.placement, [this, tip, this._element]);
        const attachment = AttachmentMap[placement.toUpperCase()];
        return createPopper(this._element, tip, this._getPopperConfig(attachment));
      }
      _getOffset() {
        const {
          offset
        } = this._config;
        if (typeof offset === 'string') {
          return offset.split(',').map(value => Number.parseInt(value, 10));
        }
        if (typeof offset === 'function') {
          return popperData => offset(popperData, this._element);
        }
        return offset;
      }
      _resolvePossibleFunction(arg) {
        return execute(arg, [this._element]);
      }
      _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
          placement: attachment,
          modifiers: [{
            name: 'flip',
            options: {
              fallbackPlacements: this._config.fallbackPlacements
            }
          }, {
            name: 'offset',
            options: {
              offset: this._getOffset()
            }
          }, {
            name: 'preventOverflow',
            options: {
              boundary: this._config.boundary
            }
          }, {
            name: 'arrow',
            options: {
              element: ".".concat(this.constructor.NAME, "-arrow")
            }
          }, {
            name: 'preSetPlacement',
            enabled: true,
            phase: 'beforeMain',
            fn: data => {
              // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
              // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
              this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
            }
          }]
        };
        return {
          ...defaultBsPopperConfig,
          ...execute(this._config.popperConfig, [defaultBsPopperConfig])
        };
      }
      _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers) {
          if (trigger === 'click') {
            EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, event => {
              const context = this._initializeOnDelegatedTarget(event);
              context.toggle();
            });
          } else if (trigger !== TRIGGER_MANUAL) {
            const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
            const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
            EventHandler.on(this._element, eventIn, this._config.selector, event => {
              const context = this._initializeOnDelegatedTarget(event);
              context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
              context._enter();
            });
            EventHandler.on(this._element, eventOut, this._config.selector, event => {
              const context = this._initializeOnDelegatedTarget(event);
              context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
              context._leave();
            });
          }
        }
        this._hideModalHandler = () => {
          if (this._element) {
            this.hide();
          }
        };
        EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
      }
      _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) {
          return;
        }
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) {
          this._element.setAttribute('aria-label', title);
        }
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
      }
      _enter() {
        if (this._isShown() || this._isHovered) {
          this._isHovered = true;
          return;
        }
        this._isHovered = true;
        this._setTimeout(() => {
          if (this._isHovered) {
            this.show();
          }
        }, this._config.delay.show);
      }
      _leave() {
        if (this._isWithActiveTrigger()) {
          return;
        }
        this._isHovered = false;
        this._setTimeout(() => {
          if (!this._isHovered) {
            this.hide();
          }
        }, this._config.delay.hide);
      }
      _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
      }
      _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
      }
      _getConfig(config) {
        const dataAttributes = Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes)) {
          if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) {
            delete dataAttributes[dataAttribute];
          }
        }
        config = {
          ...dataAttributes,
          ...(typeof config === 'object' && config ? config : {})
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
      }
      _configAfterMerge(config) {
        config.container = config.container === false ? document.body : getElement(config.container);
        if (typeof config.delay === 'number') {
          config.delay = {
            show: config.delay,
            hide: config.delay
          };
        }
        if (typeof config.title === 'number') {
          config.title = config.title.toString();
        }
        if (typeof config.content === 'number') {
          config.content = config.content.toString();
        }
        return config;
      }
      _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config)) {
          if (this.constructor.Default[key] !== value) {
            config[key] = value;
          }
        }
        config.selector = false;
        config.trigger = 'manual';

        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
      }
      _disposePopper() {
        if (this._popper) {
          this._popper.destroy();
          this._popper = null;
        }
        if (this.tip) {
          this.tip.remove();
          this.tip = null;
        }
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Tooltip.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config]();
        });
      }
    }

    /**
     * jQuery
     */

    defineJQueryPlugin(Tooltip);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap popover.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$3 = 'popover';
    const SELECTOR_TITLE = '.popover-header';
    const SELECTOR_CONTENT = '.popover-body';
    const Default$2 = {
      ...Tooltip.Default,
      content: '',
      offset: [0, 8],
      placement: 'right',
      template: '<div class="popover" role="tooltip">' + '<div class="popover-arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div>' + '</div>',
      trigger: 'click'
    };
    const DefaultType$2 = {
      ...Tooltip.DefaultType,
      content: '(null|string|element|function)'
    };

    /**
     * Class definition
     */

    class Popover extends Tooltip {
      // Getters
      static get Default() {
        return Default$2;
      }
      static get DefaultType() {
        return DefaultType$2;
      }
      static get NAME() {
        return NAME$3;
      }

      // Overrides
      _isWithContent() {
        return this._getTitle() || this._getContent();
      }

      // Private
      _getContentForTemplate() {
        return {
          [SELECTOR_TITLE]: this._getTitle(),
          [SELECTOR_CONTENT]: this._getContent()
        };
      }
      _getContent() {
        return this._resolvePossibleFunction(this._config.content);
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Popover.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config]();
        });
      }
    }

    /**
     * jQuery
     */

    defineJQueryPlugin(Popover);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap scrollspy.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$2 = 'scrollspy';
    const DATA_KEY$2 = 'bs.scrollspy';
    const EVENT_KEY$2 = ".".concat(DATA_KEY$2);
    const DATA_API_KEY = '.data-api';
    const EVENT_ACTIVATE = "activate".concat(EVENT_KEY$2);
    const EVENT_CLICK = "click".concat(EVENT_KEY$2);
    const EVENT_LOAD_DATA_API$1 = "load".concat(EVENT_KEY$2).concat(DATA_API_KEY);
    const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
    const CLASS_NAME_ACTIVE$1 = 'active';
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_TARGET_LINKS = '[href]';
    const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    const SELECTOR_NAV_LINKS = '.nav-link';
    const SELECTOR_NAV_ITEMS = '.nav-item';
    const SELECTOR_LIST_ITEMS = '.list-group-item';
    const SELECTOR_LINK_ITEMS = "".concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_NAV_ITEMS, " > ").concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_LIST_ITEMS);
    const SELECTOR_DROPDOWN = '.dropdown';
    const SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
    const Default$1 = {
      offset: null,
      // TODO: v6 @deprecated, keep it for backwards compatibility reasons
      rootMargin: '0px 0px -25%',
      smoothScroll: false,
      target: null,
      threshold: [0.1, 0.5, 1]
    };
    const DefaultType$1 = {
      offset: '(number|null)',
      // TODO v6 @deprecated, keep it for backwards compatibility reasons
      rootMargin: 'string',
      smoothScroll: 'boolean',
      target: 'element',
      threshold: 'array'
    };

    /**
     * Class definition
     */

    class ScrollSpy extends BaseComponent {
      constructor(element, config) {
        super(element, config);

        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
          visibleEntryTop: 0,
          parentScrollTop: 0
        };
        this.refresh(); // initialize
      }

      // Getters
      static get Default() {
        return Default$1;
      }
      static get DefaultType() {
        return DefaultType$1;
      }
      static get NAME() {
        return NAME$2;
      }

      // Public
      refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) {
          this._observer.disconnect();
        } else {
          this._observer = this._getNewObserver();
        }
        for (const section of this._observableSections.values()) {
          this._observer.observe(section);
        }
      }
      dispose() {
        this._observer.disconnect();
        super.dispose();
      }

      // Private
      _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = getElement(config.target) || document.body;

        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
        if (typeof config.threshold === 'string') {
          config.threshold = config.threshold.split(',').map(value => Number.parseFloat(value));
        }
        return config;
      }
      _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) {
          return;
        }

        // unregister any previous listeners
        EventHandler.off(this._config.target, EVENT_CLICK);
        EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, event => {
          const observableSection = this._observableSections.get(event.target.hash);
          if (observableSection) {
            event.preventDefault();
            const root = this._rootElement || window;
            const height = observableSection.offsetTop - this._element.offsetTop;
            if (root.scrollTo) {
              root.scrollTo({
                top: height,
                behavior: 'smooth'
              });
              return;
            }

            // Chrome 60 doesn't support `scrollTo`
            root.scrollTop = height;
          }
        });
      }
      _getNewObserver() {
        const options = {
          root: this._rootElement,
          threshold: this._config.threshold,
          rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver(entries => this._observerCallback(entries), options);
      }

      // The logic of selection
      _observerCallback(entries) {
        const targetElement = entry => this._targetLinks.get("#".concat(entry.target.id));
        const activate = entry => {
          this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
          this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries) {
          if (!entry.isIntersecting) {
            this._activeTarget = null;
            this._clearActiveClass(targetElement(entry));
            continue;
          }
          const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
          // if we are scrolling down, pick the bigger offsetTop
          if (userScrollsDown && entryIsLowerThanPrevious) {
            activate(entry);
            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
            if (!parentScrollTop) {
              return;
            }
            continue;
          }

          // if we are scrolling up, pick the smallest offsetTop
          if (!userScrollsDown && !entryIsLowerThanPrevious) {
            activate(entry);
          }
        }
      }
      _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks) {
          // ensure that the anchor has an id and is not disabled
          if (!anchor.hash || isDisabled(anchor)) {
            continue;
          }
          const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);

          // ensure that the observableSection exists & is visible
          if (isVisible(observableSection)) {
            this._targetLinks.set(decodeURI(anchor.hash), anchor);
            this._observableSections.set(anchor.hash, observableSection);
          }
        }
      }
      _process(target) {
        if (this._activeTarget === target) {
          return;
        }
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add(CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        EventHandler.trigger(this._element, EVENT_ACTIVATE, {
          relatedTarget: target
        });
      }
      _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
          SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
          return;
        }
        for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP)) {
          // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
          for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS)) {
            item.classList.add(CLASS_NAME_ACTIVE$1);
          }
        }
      }
      _clearActiveClass(parent) {
        parent.classList.remove(CLASS_NAME_ACTIVE$1);
        const activeNodes = SelectorEngine.find("".concat(SELECTOR_TARGET_LINKS, ".").concat(CLASS_NAME_ACTIVE$1), parent);
        for (const node of activeNodes) {
          node.classList.remove(CLASS_NAME_ACTIVE$1);
        }
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = ScrollSpy.getOrCreateInstance(this, config);
          if (typeof config !== 'string') {
            return;
          }
          if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config]();
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(window, EVENT_LOAD_DATA_API$1, () => {
      for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY)) {
        ScrollSpy.getOrCreateInstance(spy);
      }
    });

    /**
     * jQuery
     */

    defineJQueryPlugin(ScrollSpy);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap tab.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME$1 = 'tab';
    const DATA_KEY$1 = 'bs.tab';
    const EVENT_KEY$1 = ".".concat(DATA_KEY$1);
    const EVENT_HIDE$1 = "hide".concat(EVENT_KEY$1);
    const EVENT_HIDDEN$1 = "hidden".concat(EVENT_KEY$1);
    const EVENT_SHOW$1 = "show".concat(EVENT_KEY$1);
    const EVENT_SHOWN$1 = "shown".concat(EVENT_KEY$1);
    const EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY$1);
    const EVENT_KEYDOWN = "keydown".concat(EVENT_KEY$1);
    const EVENT_LOAD_DATA_API = "load".concat(EVENT_KEY$1);
    const ARROW_LEFT_KEY = 'ArrowLeft';
    const ARROW_RIGHT_KEY = 'ArrowRight';
    const ARROW_UP_KEY = 'ArrowUp';
    const ARROW_DOWN_KEY = 'ArrowDown';
    const HOME_KEY = 'Home';
    const END_KEY = 'End';
    const CLASS_NAME_ACTIVE = 'active';
    const CLASS_NAME_FADE$1 = 'fade';
    const CLASS_NAME_SHOW$1 = 'show';
    const CLASS_DROPDOWN = 'dropdown';
    const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    const SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
    const NOT_SELECTOR_DROPDOWN_TOGGLE = ':not(.dropdown-toggle)';
    const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    const SELECTOR_OUTER = '.nav-item, .list-group-item';
    const SELECTOR_INNER = ".nav-link".concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ", [role=\"tab\"]").concat(NOT_SELECTOR_DROPDOWN_TOGGLE);
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    const SELECTOR_INNER_ELEM = "".concat(SELECTOR_INNER, ", ").concat(SELECTOR_DATA_TOGGLE);
    const SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat(CLASS_NAME_ACTIVE, "[data-bs-toggle=\"tab\"], .").concat(CLASS_NAME_ACTIVE, "[data-bs-toggle=\"pill\"], .").concat(CLASS_NAME_ACTIVE, "[data-bs-toggle=\"list\"]");

    /**
     * Class definition
     */

    class Tab extends BaseComponent {
      constructor(element) {
        super(element);
        this._parent = this._element.closest(SELECTOR_TAB_PANEL);
        if (!this._parent) {
          return;
          // TODO: should throw exception in v6
          // throw new TypeError(`${element.outerHTML} has not a valid parent ${SELECTOR_INNER_ELEM}`)
        }

        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        EventHandler.on(this._element, EVENT_KEYDOWN, event => this._keydown(event));
      }

      // Getters
      static get NAME() {
        return NAME$1;
      }

      // Public
      show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) {
          return;
        }

        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
          relatedTarget: innerElem
        }) : null;
        const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
          relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) {
          return;
        }
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
      }

      // Private
      _activate(element, relatedElem) {
        if (!element) {
          return;
        }
        element.classList.add(CLASS_NAME_ACTIVE);
        this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section

        const complete = () => {
          if (element.getAttribute('role') !== 'tab') {
            element.classList.add(CLASS_NAME_SHOW$1);
            return;
          }
          element.removeAttribute('tabindex');
          element.setAttribute('aria-selected', true);
          this._toggleDropDown(element, true);
          EventHandler.trigger(element, EVENT_SHOWN$1, {
            relatedTarget: relatedElem
          });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
      }
      _deactivate(element, relatedElem) {
        if (!element) {
          return;
        }
        element.classList.remove(CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too

        const complete = () => {
          if (element.getAttribute('role') !== 'tab') {
            element.classList.remove(CLASS_NAME_SHOW$1);
            return;
          }
          element.setAttribute('aria-selected', false);
          element.setAttribute('tabindex', '-1');
          this._toggleDropDown(element, false);
          EventHandler.trigger(element, EVENT_HIDDEN$1, {
            relatedTarget: relatedElem
          });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
      }
      _keydown(event) {
        if (![ARROW_LEFT_KEY, ARROW_RIGHT_KEY, ARROW_UP_KEY, ARROW_DOWN_KEY, HOME_KEY, END_KEY].includes(event.key)) {
          return;
        }
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter(element => !isDisabled(element));
        let nextActiveElement;
        if ([HOME_KEY, END_KEY].includes(event.key)) {
          nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
        } else {
          const isNext = [ARROW_RIGHT_KEY, ARROW_DOWN_KEY].includes(event.key);
          nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
          nextActiveElement.focus({
            preventScroll: true
          });
          Tab.getOrCreateInstance(nextActiveElement).show();
        }
      }
      _getChildren() {
        // collection of inner elements
        return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
      }
      _getActiveElem() {
        return this._getChildren().find(child => this._elemIsActive(child)) || null;
      }
      _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children) {
          this._setInitialAttributesOnChild(child);
        }
      }
      _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) {
          this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        }
        if (!isActive) {
          child.setAttribute('tabindex', '-1');
        }
        this._setAttributeIfNotExists(child, 'role', 'tab');

        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
      }
      _setInitialAttributesOnTargetPanel(child) {
        const target = SelectorEngine.getElementFromSelector(child);
        if (!target) {
          return;
        }
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) {
          this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
        }
      }
      _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains(CLASS_DROPDOWN)) {
          return;
        }
        const toggle = (selector, className) => {
          const element = SelectorEngine.findOne(selector, outerElem);
          if (element) {
            element.classList.toggle(className, open);
          }
        };
        toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
        toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
      }
      _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) {
          element.setAttribute(attribute, value);
        }
      }
      _elemIsActive(elem) {
        return elem.classList.contains(CLASS_NAME_ACTIVE);
      }

      // Try to get the inner element (usually the .nav-link)
      _getInnerElement(elem) {
        return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
      }

      // Try to get the outer element (usually the .nav-item)
      _getOuterElement(elem) {
        return elem.closest(SELECTOR_OUTER) || elem;
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Tab.getOrCreateInstance(this);
          if (typeof config !== 'string') {
            return;
          }
          if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }
          data[config]();
        });
      }
    }

    /**
     * Data API implementation
     */

    EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
      if (['A', 'AREA'].includes(this.tagName)) {
        event.preventDefault();
      }
      if (isDisabled(this)) {
        return;
      }
      Tab.getOrCreateInstance(this).show();
    });

    /**
     * Initialize on focus
     */
    EventHandler.on(window, EVENT_LOAD_DATA_API, () => {
      for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE)) {
        Tab.getOrCreateInstance(element);
      }
    });
    /**
     * jQuery
     */

    defineJQueryPlugin(Tab);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap toast.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    /**
     * Constants
     */

    const NAME = 'toast';
    const DATA_KEY = 'bs.toast';
    const EVENT_KEY = ".".concat(DATA_KEY);
    const EVENT_MOUSEOVER = "mouseover".concat(EVENT_KEY);
    const EVENT_MOUSEOUT = "mouseout".concat(EVENT_KEY);
    const EVENT_FOCUSIN = "focusin".concat(EVENT_KEY);
    const EVENT_FOCUSOUT = "focusout".concat(EVENT_KEY);
    const EVENT_HIDE = "hide".concat(EVENT_KEY);
    const EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
    const EVENT_SHOW = "show".concat(EVENT_KEY);
    const EVENT_SHOWN = "shown".concat(EVENT_KEY);
    const CLASS_NAME_FADE = 'fade';
    const CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_SHOWING = 'showing';
    const DefaultType = {
      animation: 'boolean',
      autohide: 'boolean',
      delay: 'number'
    };
    const Default = {
      animation: true,
      autohide: true,
      delay: 5000
    };

    /**
     * Class definition
     */

    class Toast extends BaseComponent {
      constructor(element, config) {
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
      }

      // Getters
      static get Default() {
        return Default;
      }
      static get DefaultType() {
        return DefaultType;
      }
      static get NAME() {
        return NAME;
      }

      // Public
      show() {
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
        if (showEvent.defaultPrevented) {
          return;
        }
        this._clearTimeout();
        if (this._config.animation) {
          this._element.classList.add(CLASS_NAME_FADE);
        }
        const complete = () => {
          this._element.classList.remove(CLASS_NAME_SHOWING);
          EventHandler.trigger(this._element, EVENT_SHOWN);
          this._maybeScheduleHide();
        };
        this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
      }
      hide() {
        if (!this.isShown()) {
          return;
        }
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
        if (hideEvent.defaultPrevented) {
          return;
        }
        const complete = () => {
          this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
          this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
          EventHandler.trigger(this._element, EVENT_HIDDEN);
        };
        this._element.classList.add(CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
      }
      dispose() {
        this._clearTimeout();
        if (this.isShown()) {
          this._element.classList.remove(CLASS_NAME_SHOW);
        }
        super.dispose();
      }
      isShown() {
        return this._element.classList.contains(CLASS_NAME_SHOW);
      }

      // Private

      _maybeScheduleHide() {
        if (!this._config.autohide) {
          return;
        }
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) {
          return;
        }
        this._timeout = setTimeout(() => {
          this.hide();
        }, this._config.delay);
      }
      _onInteraction(event, isInteracting) {
        switch (event.type) {
          case 'mouseover':
          case 'mouseout':
            {
              this._hasMouseInteraction = isInteracting;
              break;
            }
          case 'focusin':
          case 'focusout':
            {
              this._hasKeyboardInteraction = isInteracting;
              break;
            }
        }
        if (isInteracting) {
          this._clearTimeout();
          return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) {
          return;
        }
        this._maybeScheduleHide();
      }
      _setListeners() {
        EventHandler.on(this._element, EVENT_MOUSEOVER, event => this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_MOUSEOUT, event => this._onInteraction(event, false));
        EventHandler.on(this._element, EVENT_FOCUSIN, event => this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_FOCUSOUT, event => this._onInteraction(event, false));
      }
      _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
      }

      // Static
      static jQueryInterface(config) {
        return this.each(function () {
          const data = Toast.getOrCreateInstance(this, config);
          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"".concat(config, "\""));
            }
            data[config](this);
          }
        });
      }
    }

    /**
     * Data API implementation
     */

    enableDismissTrigger(Toast);

    /**
     * jQuery
     */

    defineJQueryPlugin(Toast);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap index.umd.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     * --------------------------------------------------------------------------
     */

    const index_umd = {
      Alert,
      Button,
      Carousel,
      Collapse,
      Dropdown,
      Modal,
      Offcanvas,
      Popover,
      ScrollSpy,
      Tab,
      Toast,
      Tooltip
    };
    return index_umd;
  });
})(bootstrap_bundle);

var css$j = ".modal-header,\n.modal-footer {\n  border: 0;\n}\n\n.modal-header .btn {\n  padding: 0 7px;\n}";
n(css$j,{});

var img$6 = "data:image/svg+xml,%3csvg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0.293945 7.29374C-0.0966797 7.68437 -0.0966797 8.31874 0.293945 8.70937L5.29394 13.7094C5.68457 14.1 6.31894 14.1 6.70957 13.7094C7.10019 13.3187 7.10019 12.6844 6.70957 12.2937L3.41269 8.99999H13.0002C13.5533 8.99999 14.0002 8.55312 14.0002 7.99999C14.0002 7.44687 13.5533 6.99999 13.0002 6.99999H3.41582L6.70645 3.70624C7.09707 3.31562 7.09707 2.68124 6.70645 2.29062C6.31582 1.89999 5.68145 1.89999 5.29082 2.29062L0.29082 7.29062L0.293945 7.29374Z' fill='black'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='22' height='23' viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cline x1='6.4165' y1='16.4877' x2='16.0022' y2='6.90197' stroke='black' stroke-width='2' stroke-linecap='round'/%3e%3cline x1='16.0023' y1='16.0686' x2='6.41657' y2='6.48287' stroke='black' stroke-width='2' stroke-linecap='round'/%3e%3c/svg%3e";

var css$i = "html,\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.places-container {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  width: 300px;\n}\n\n.map-container {\n  width: 100%;\n  height: 100vh;\n}\n\n.combobox-input {\n  width: 100%;\n  padding: 0.5rem;\n}";
n(css$i,{});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;
var invariant = function (condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }
  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};
var invariant_1 = invariant;
var invariant$1 = /*@__PURE__*/getDefaultExportFromCjs(invariant_1);
var MapContext = /*#__PURE__*/createContext(null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forEach(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

/* global google */
function applyUpdaterToNextProps(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var map = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var iter = function (fn, key) {
    var nextValue = nextProps[key];
    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };
  forEach(updaterMap, iter);
  return map;
}
function registerEvents(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);
  return registeredList;
}
function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}
function unregisterEvents(events) {
  if (events === void 0) {
    events = [];
  }
  events.forEach(unregisterEvent);
}
function applyUpdatersToPropsAndRegisterEvents(_a) {
  var updaterMap = _a.updaterMap,
    eventMap = _a.eventMap,
    prevProps = _a.prevProps,
    nextProps = _a.nextProps,
    instance = _a.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}
var eventMap$i = {
  onDblClick: 'dblclick',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMapTypeIdChanged: 'maptypeid_changed',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onTilesLoaded: 'tilesloaded',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDrag: 'drag',
  onHeadingChanged: 'heading_changed',
  onIdle: 'idle',
  onProjectionChanged: 'projection_changed',
  onResize: 'resize',
  onTiltChanged: 'tilt_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$i = {
  extraMapTypes: function (map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function (map, center) {
    map.setCenter(center);
  },
  clickableIcons: function (map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function (map, heading) {
    map.setHeading(heading);
  },
  mapTypeId: function (map, mapTypeId) {
    map.setMapTypeId(mapTypeId);
  },
  options: function (map, options) {
    map.setOptions(options);
  },
  streetView: function (map, streetView) {
    map.setStreetView(streetView);
  },
  tilt: function (map, tilt) {
    map.setTilt(tilt);
  },
  zoom: function (map, zoom) {
    map.setZoom(zoom);
  }
};
var GoogleMap = /** @class */function (_super) {
  __extends(GoogleMap, _super);
  function GoogleMap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      map: null
    };
    _this.registeredEvents = [];
    _this.mapRef = null;
    _this.getInstance = function () {
      if (_this.mapRef === null) {
        return null;
      }
      return new google.maps.Map(_this.mapRef, _this.props.options);
    };
    _this.panTo = function (latLng) {
      var map = _this.getInstance();
      if (map) {
        map.panTo(latLng);
      }
    };
    _this.setMapCallback = function () {
      if (_this.state.map !== null) {
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.map);
        }
      }
    };
    _this.getRef = function (ref) {
      _this.mapRef = ref;
    };
    return _this;
  }
  GoogleMap.prototype.componentDidMount = function () {
    var map = this.getInstance();
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$i,
      eventMap: eventMap$i,
      prevProps: {},
      nextProps: this.props,
      instance: map
    });
    this.setState(function setMap() {
      return {
        map: map
      };
    }, this.setMapCallback);
  };
  GoogleMap.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.map !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.map
      });
    }
  };
  GoogleMap.prototype.componentWillUnmount = function () {
    if (this.state.map !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.map);
      }
      unregisterEvents(this.registeredEvents);
    }
  };
  GoogleMap.prototype.render = function () {
    return jsx("div", {
      id: this.props.id,
      ref: this.getRef,
      style: this.props.mapContainerStyle,
      className: this.props.mapContainerClassName,
      children: jsx(MapContext.Provider, {
        value: this.state.map,
        children: this.state.map !== null ? this.props.children : null
      })
    });
  };
  return GoogleMap;
}(PureComponent);
var isBrowser = typeof document !== 'undefined';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function injectScript(_a) {
  var url = _a.url,
    id = _a.id,
    nonce = _a.nonce;
  if (!isBrowser) {
    return Promise.reject(new Error('document is undefined'));
  }
  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;
    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');
      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap_1 = windowWithGoogleMap.initMap;
          var originalErrorCallback_1 = existingScript.onerror;
          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap_1) {
              originalInitMap_1();
            }
            resolve(id);
          };
          existingScript.onerror = function (err) {
            if (originalErrorCallback_1) {
              originalErrorCallback_1(err);
            }
            reject(err);
          };
          return;
        }
      }
      // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
        existingScript.remove();
      }
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;
    script.nonce = nonce || '';
    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };
    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };
    document.head.appendChild(script);
  }).catch(function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
}
function isGoogleFontStyle(element) {
  // 'Roboto' or 'Google Sans Text' font download
  var href = element.href;
  if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) {
    return true;
  }
  // font style elements
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet.cssText &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  }
  // font style elements for other browsers
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.innerHTML &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML = '';
    return true;
  }
  // when google tries to add empty style
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !element.styleSheet &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !element.innerHTML) {
    return true;
  }
  return false;
}
// Preventing the Google Maps library from downloading an extra font
function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  if (head) {
    var trueInsertBefore_1 = head.insertBefore.bind(head);
    // TODO: adding return before reflect solves the TS issue
    head.insertBefore = function insertBefore(newElement, referenceElement) {
      if (!isGoogleFontStyle(newElement)) {
        Reflect.apply(trueInsertBefore_1, head, [newElement, referenceElement]);
      }
      return newElement;
    };
    var trueAppend_1 = head.appendChild.bind(head);
    // TODO: adding return before reflect solves the TS issue
    head.appendChild = function appendChild(textNode) {
      if (!isGoogleFontStyle(textNode)) {
        Reflect.apply(trueAppend_1, head, [textNode]);
      }
      return textNode;
    };
  }
}
function makeLoadScriptUrl(_a) {
  var googleMapsApiKey = _a.googleMapsApiKey,
    googleMapsClientId = _a.googleMapsClientId,
    _b = _a.version,
    version = _b === void 0 ? 'weekly' : _b,
    language = _a.language,
    region = _a.region,
    libraries = _a.libraries,
    channel = _a.channel,
    mapIds = _a.mapIds,
    authReferrerPolicy = _a.authReferrerPolicy;
  var params = [];
  invariant$1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');
  if (googleMapsApiKey) {
    params.push("key=".concat(googleMapsApiKey));
  } else if (googleMapsClientId) {
    params.push("client=".concat(googleMapsClientId));
  }
  if (version) {
    params.push("v=".concat(version));
  }
  if (language) {
    params.push("language=".concat(language));
  }
  if (region) {
    params.push("region=".concat(region));
  }
  if (libraries && libraries.length) {
    params.push("libraries=".concat(libraries.sort().join(',')));
  }
  if (channel) {
    params.push("channel=".concat(channel));
  }
  if (mapIds && mapIds.length) {
    params.push("map_ids=".concat(mapIds.join(',')));
  }
  if (authReferrerPolicy) {
    params.push("auth_referrer_policy=".concat(authReferrerPolicy));
  }
  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?".concat(params.join('&'));
}
var cleaningUp = false;
function DefaultLoadingElement() {
  return jsx("div", {
    children: "Loading..."
  });
}
var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};
/** @class */(function (_super) {
  __extends(LoadScript, _super);
  function LoadScript() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.check = /*#__PURE__*/createRef();
    _this.state = {
      loaded: false
    };
    _this.cleanupCallback = function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete window.google.maps;
      _this.injectScript();
    };
    _this.isCleaningUp = function () {
      return __awaiter$1(_this, void 0, void 0, function () {
        function promiseCallback(resolve) {
          if (!cleaningUp) {
            resolve();
          } else {
            if (isBrowser) {
              var timer_1 = window.setInterval(function interval() {
                if (!cleaningUp) {
                  window.clearInterval(timer_1);
                  resolve();
                }
              }, 1);
            }
          }
          return;
        }
        return __generator(this, function (_a) {
          return [2 /*return*/, new Promise(promiseCallback)];
        });
      });
    };
    _this.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this.props.id);
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
        return typeof script.src === 'string' && script.src.includes('maps.googleapis');
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
        return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };
    _this.injectScript = function () {
      if (_this.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }
      invariant$1(!!_this.props.id, 'LoadScript requires "id" prop to be a string: %s', _this.props.id);
      var injectScriptOptions = {
        id: _this.props.id,
        nonce: _this.props.nonce,
        url: makeLoadScriptUrl(_this.props)
      };
      injectScript(injectScriptOptions).then(function () {
        if (_this.props.onLoad) {
          _this.props.onLoad();
        }
        _this.setState(function setLoaded() {
          return {
            loaded: true
          };
        });
        return;
      }).catch(function (err) {
        if (_this.props.onError) {
          _this.props.onError(err);
        }
        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this.props.googleMapsApiKey || '-', ") or Client ID (").concat(_this.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
      });
    };
    return _this;
  }
  LoadScript.prototype.componentDidMount = function () {
    if (isBrowser) {
      if (window.google && window.google.maps && !cleaningUp) {
        console.error('google api is already presented');
        return;
      }
      this.isCleaningUp().then(this.injectScript).catch(function error(err) {
        console.error('Error at injecting script after cleaning up: ', err);
      });
    }
  };
  LoadScript.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.libraries !== prevProps.libraries) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }
    if (isBrowser && prevProps.language !== this.props.language) {
      this.cleanup();
      // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
      this.setState(function setLoaded() {
        return {
          loaded: false
        };
      }, this.cleanupCallback);
    }
  };
  LoadScript.prototype.componentWillUnmount = function () {
    var _this = this;
    if (isBrowser) {
      this.cleanup();
      var timeoutCallback = function () {
        if (!_this.check.current) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          delete window.google;
          cleaningUp = false;
        }
      };
      window.setTimeout(timeoutCallback, 1);
      if (this.props.onUnmount) {
        this.props.onUnmount();
      }
    }
  };
  LoadScript.prototype.render = function () {
    return jsxs(Fragment, {
      children: [jsx("div", {
        ref: this.check
      }), this.state.loaded ? this.props.children : this.props.loadingElement || jsx(DefaultLoadingElement, {})]
    });
  };
  LoadScript.defaultProps = defaultLoadScriptProps;
  return LoadScript;
})(PureComponent);

/* eslint-disable filenames/match-regex */
var previouslyLoadedUrl;
function useLoadScript(_a) {
  var _b = _a.id,
    id = _b === void 0 ? defaultLoadScriptProps.id : _b,
    _c = _a.version,
    version = _c === void 0 ? defaultLoadScriptProps.version : _c,
    nonce = _a.nonce,
    googleMapsApiKey = _a.googleMapsApiKey,
    googleMapsClientId = _a.googleMapsClientId,
    language = _a.language,
    region = _a.region,
    libraries = _a.libraries,
    preventGoogleFontsLoading = _a.preventGoogleFontsLoading,
    channel = _a.channel,
    mapIds = _a.mapIds,
    authReferrerPolicy = _a.authReferrerPolicy;
  var isMounted = useRef(false);
  var _d = useState(false),
    isLoaded = _d[0],
    setLoaded = _d[1];
  var _e = useState(undefined),
    loadError = _e[0],
    setLoadError = _e[1];
  useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  useEffect(function validateLoadedState() {
    if (isLoaded) {
      invariant$1(!!window.google, 'useLoadScript was marked as loaded, but window.google is not present. Something went wrong.');
    }
  }, [isLoaded]);
  var url = makeLoadScriptUrl({
    version: version,
    googleMapsApiKey: googleMapsApiKey,
    googleMapsClientId: googleMapsClientId,
    language: language,
    region: region,
    libraries: libraries,
    channel: channel,
    mapIds: mapIds,
    authReferrerPolicy: authReferrerPolicy
  });
  useEffect(function loadScriptAndModifyLoadedState() {
    if (!isBrowser) {
      return;
    }
    function setLoadedIfMounted() {
      if (isMounted.current) {
        setLoaded(true);
        previouslyLoadedUrl = url;
      }
    }
    if (window.google && window.google.maps && previouslyLoadedUrl === url) {
      setLoadedIfMounted();
      return;
    }
    injectScript({
      id: id,
      url: url,
      nonce: nonce
    }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
      if (isMounted.current) {
        setLoadError(err);
      }
      console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || '-', ") or Client ID (").concat(googleMapsClientId || '-', ")\n        Otherwise it is a Network issue.\n      "));
      console.error(err);
    });
  }, [id, url, nonce]);
  var prevLibraries = useRef();
  useEffect(function checkPerformance() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }
    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError,
    url: url
  };
}
jsx(DefaultLoadingElement, {});
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
  LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
  LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
  LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
var eventMap$h = {};
var updaterMap$h = {
  options: function (instance, options) {
    instance.setOptions(options);
  }
};
/** @class */(function (_super) {
  __extends(TrafficLayer, _super);
  function TrafficLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      trafficLayer: null
    };
    _this.setTrafficLayerCallback = function () {
      if (_this.state.trafficLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.trafficLayer);
      }
    };
    _this.registeredEvents = [];
    return _this;
  }
  TrafficLayer.prototype.componentDidMount = function () {
    var trafficLayer = new google.maps.TrafficLayer(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$h,
      eventMap: eventMap$h,
      prevProps: {},
      nextProps: this.props,
      instance: trafficLayer
    });
    this.setState(function setTrafficLayer() {
      return {
        trafficLayer: trafficLayer
      };
    }, this.setTrafficLayerCallback);
  };
  TrafficLayer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.trafficLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.trafficLayer
      });
    }
  };
  TrafficLayer.prototype.componentWillUnmount = function () {
    if (this.state.trafficLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.trafficLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.trafficLayer.setMap(null);
    }
  };
  TrafficLayer.prototype.render = function () {
    return null;
  };
  TrafficLayer.contextType = MapContext;
  return TrafficLayer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(BicyclingLayer, _super);
  function BicyclingLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      bicyclingLayer: null
    };
    _this.setBicyclingLayerCallback = function () {
      if (_this.state.bicyclingLayer !== null) {
        _this.state.bicyclingLayer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.bicyclingLayer);
        }
      }
    };
    return _this;
  }
  BicyclingLayer.prototype.componentDidMount = function () {
    var bicyclingLayer = new google.maps.BicyclingLayer();
    this.setState(function () {
      return {
        bicyclingLayer: bicyclingLayer
      };
    }, this.setBicyclingLayerCallback);
  };
  BicyclingLayer.prototype.componentWillUnmount = function () {
    if (this.state.bicyclingLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.bicyclingLayer);
      }
      this.state.bicyclingLayer.setMap(null);
    }
  };
  BicyclingLayer.prototype.render = function () {
    return null;
  };
  BicyclingLayer.contextType = MapContext;
  return BicyclingLayer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(TransitLayer, _super);
  function TransitLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      transitLayer: null
    };
    _this.setTransitLayerCallback = function () {
      if (_this.state.transitLayer !== null) {
        _this.state.transitLayer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.transitLayer);
        }
      }
    };
    return _this;
  }
  TransitLayer.prototype.componentDidMount = function () {
    var transitLayer = new google.maps.TransitLayer();
    this.setState(function setTransitLayer() {
      return {
        transitLayer: transitLayer
      };
    }, this.setTransitLayerCallback);
  };
  TransitLayer.prototype.componentWillUnmount = function () {
    if (this.state.transitLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.transitLayer);
      }
      this.state.transitLayer.setMap(null);
    }
  };
  TransitLayer.prototype.render = function () {
    return null;
  };
  TransitLayer.contextType = MapContext;
  return TransitLayer;
})(PureComponent);
var eventMap$g = {
  onCircleComplete: 'circlecomplete',
  onMarkerComplete: 'markercomplete',
  onOverlayComplete: 'overlaycomplete',
  onPolygonComplete: 'polygoncomplete',
  onPolylineComplete: 'polylinecomplete',
  onRectangleComplete: 'rectanglecomplete'
};
var updaterMap$g = {
  drawingMode: function (instance, drawingMode) {
    instance.setDrawingMode(drawingMode);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  }
};
/** @class */(function (_super) {
  __extends(DrawingManager, _super);
  function DrawingManager(props) {
    var _this = _super.call(this, props) || this;
    _this.registeredEvents = [];
    _this.state = {
      drawingManager: null
    };
    _this.setDrawingManagerCallback = function () {
      if (_this.state.drawingManager !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.drawingManager);
      }
    };
    invariant$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    return _this;
  }
  DrawingManager.prototype.componentDidMount = function () {
    var drawingManager = new google.maps.drawing.DrawingManager(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$g,
      eventMap: eventMap$g,
      prevProps: {},
      nextProps: this.props,
      instance: drawingManager
    });
    this.setState(function setDrawingManager() {
      return {
        drawingManager: drawingManager
      };
    }, this.setDrawingManagerCallback);
  };
  DrawingManager.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.drawingManager !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.drawingManager
      });
    }
  };
  DrawingManager.prototype.componentWillUnmount = function () {
    if (this.state.drawingManager !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.drawingManager);
      }
      unregisterEvents(this.registeredEvents);
      this.state.drawingManager.setMap(null);
    }
  };
  DrawingManager.prototype.render = function () {
    return null;
  };
  DrawingManager.contextType = MapContext;
  return DrawingManager;
})(PureComponent);
var eventMap$f = {
  onAnimationChanged: 'animation_changed',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onCursorChanged: 'cursor_changed',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDraggableChanged: 'draggable_changed',
  onDragStart: 'dragstart',
  onFlatChanged: 'flat_changed',
  onIconChanged: 'icon_changed',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onPositionChanged: 'position_changed',
  onRightClick: 'rightclick',
  onShapeChanged: 'shape_changed',
  onTitleChanged: 'title_changed',
  onVisibleChanged: 'visible_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$f = {
  animation: function (instance, animation) {
    instance.setAnimation(animation);
  },
  clickable: function (instance, clickable) {
    instance.setClickable(clickable);
  },
  cursor: function (instance, cursor) {
    instance.setCursor(cursor);
  },
  draggable: function (instance, draggable) {
    instance.setDraggable(draggable);
  },
  icon: function (instance, icon) {
    instance.setIcon(icon);
  },
  label: function (instance, label) {
    instance.setLabel(label);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  opacity: function (instance, opacity) {
    instance.setOpacity(opacity);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  position: function (instance, position) {
    instance.setPosition(position);
  },
  shape: function (instance, shape) {
    instance.setShape(shape);
  },
  title: function (instance, title) {
    instance.setTitle(title);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  },
  zIndex: function (instance, zIndex) {
    instance.setZIndex(zIndex);
  }
};
var defaultOptions$5 = {};
var Marker = /** @class */function (_super) {
  __extends(Marker, _super);
  function Marker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    return _this;
  }
  Marker.prototype.componentDidMount = function () {
    var markerOptions = __assign(__assign(__assign({}, this.props.options || defaultOptions$5), this.props.clusterer ? defaultOptions$5 : {
      map: this.context
    }), {
      position: this.props.position
    });
    // Unfortunately we can't just do this in the contstructor, because the
    // `MapContext` might not be filled in yet.
    this.marker = new google.maps.Marker(markerOptions);
    if (this.props.clusterer) {
      this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
    } else {
      this.marker.setMap(this.context);
    }
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$f,
      eventMap: eventMap$f,
      prevProps: {},
      nextProps: this.props,
      instance: this.marker
    });
    if (this.props.onLoad) {
      this.props.onLoad(this.marker);
    }
  };
  Marker.prototype.componentDidUpdate = function (prevProps) {
    if (this.marker) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.marker
      });
    }
  };
  Marker.prototype.componentWillUnmount = function () {
    if (this.marker) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.marker);
      }
      unregisterEvents(this.registeredEvents);
      if (this.props.clusterer) {
        this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
      } else {
        this.marker && this.marker.setMap(null);
      }
    }
  };
  Marker.prototype.render = function () {
    var _this = this;
    var children = null;
    if (this.props.children) {
      children = Children.map(this.props.children, function (child) {
        if (! /*#__PURE__*/isValidElement(child)) {
          return child;
        }
        var elementChild = child;
        return /*#__PURE__*/cloneElement(elementChild, {
          anchor: _this.marker
        });
      });
    }
    return children || null;
  };
  Marker.contextType = MapContext;
  return Marker;
}(PureComponent);
var ClusterIcon = /** @class */function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.clusterClassName = this.cluster.getClusterer().getClusterClass();
    this.className = this.clusterClassName;
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0';
    this.cMouseDownInCluster = null;
    this.cDraggingMapByCluster = null;
    this.timeOut = null;
    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
    this.onBoundsChanged = this.onBoundsChanged.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.draw = this.draw.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.useStyle = this.useStyle.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
  }
  ClusterIcon.prototype.onBoundsChanged = function () {
    this.cDraggingMapByCluster = this.cMouseDownInCluster;
  };
  ClusterIcon.prototype.onMouseDown = function () {
    this.cMouseDownInCluster = true;
    this.cDraggingMapByCluster = false;
  };
  ClusterIcon.prototype.onClick = function (event) {
    this.cMouseDownInCluster = false;
    if (!this.cDraggingMapByCluster) {
      var markerClusterer_1 = this.cluster.getClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(markerClusterer_1, 'click', this.cluster);
      google.maps.event.trigger(markerClusterer_1, 'clusterclick', this.cluster); // deprecated name
      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (markerClusterer_1.getZoomOnClick()) {
        // Zoom into the cluster.
        var maxZoom_1 = markerClusterer_1.getMaxZoom();
        var bounds_1 = this.cluster.getBounds();
        var map = markerClusterer_1.getMap();
        if (map !== null && 'fitBounds' in map) {
          map.fitBounds(bounds_1);
        }
        // There is a fix for Issue 170 here:
        this.timeOut = window.setTimeout(function () {
          var map = markerClusterer_1.getMap();
          if (map !== null) {
            if ('fitBounds' in map) {
              map.fitBounds(bounds_1);
            }
            var zoom = map.getZoom() || 0;
            // Don't zoom beyond the max zoom level
            if (maxZoom_1 !== null && zoom > maxZoom_1) {
              map.setZoom(maxZoom_1 + 1);
            }
          }
        }, 100);
      }
      // Prevent event propagation to the map:
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    }
  };
  ClusterIcon.prototype.onMouseOver = function () {
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseover', this.cluster);
  };
  ClusterIcon.prototype.onMouseOut = function () {
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseout', this.cluster);
  };
  ClusterIcon.prototype.onAdd = function () {
    var _a;
    this.div = document.createElement('div');
    this.div.className = this.className;
    if (this.visible) {
      this.show();
    }
    (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a.overlayMouseTarget.appendChild(this.div);
    var map = this.getMap();
    if (map !== null) {
      // Fix for Issue 157
      this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', this.onBoundsChanged);
      this.div.addEventListener('mousedown', this.onMouseDown);
      this.div.addEventListener('click', this.onClick);
      this.div.addEventListener('mouseover', this.onMouseOver);
      this.div.addEventListener('mouseout', this.onMouseOut);
    }
  };
  ClusterIcon.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.hide();
      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }
      this.div.removeEventListener('mousedown', this.onMouseDown);
      this.div.removeEventListener('click', this.onClick);
      this.div.removeEventListener('mouseover', this.onMouseOver);
      this.div.removeEventListener('mouseout', this.onMouseOut);
      this.div.parentNode.removeChild(this.div);
      if (this.timeOut !== null) {
        window.clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.div = null;
    }
  };
  ClusterIcon.prototype.draw = function () {
    if (this.visible && this.div !== null && this.center) {
      var pos = this.getPosFromLatLng(this.center);
      this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
      this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
    }
  };
  ClusterIcon.prototype.hide = function () {
    if (this.div) {
      this.div.style.display = 'none';
    }
    this.visible = false;
  };
  ClusterIcon.prototype.show = function () {
    var _a, _b, _c, _d, _e, _f;
    if (this.div && this.center) {
      var divTitle = this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '' ? this.cluster.getClusterer().getTitle() : this.sums.title;
      // NOTE: values must be specified in px units
      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(((_a = bp[0]) === null || _a === void 0 ? void 0 : _a.replace(/^\s+|\s+$/g, '')) || '0', 10);
      var spriteV = parseInt(((_b = bp[1]) === null || _b === void 0 ? void 0 : _b.replace(/^\s+|\s+$/g, '')) || '0', 10);
      var pos = this.getPosFromLatLng(this.center);
      this.div.className = this.className;
      this.div.setAttribute('style', "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : '0', "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : '0', "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
      var img = document.createElement('img');
      img.alt = divTitle;
      img.src = this.url;
      img.width = this.width;
      img.height = this.height;
      img.setAttribute('style', "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
      }
      var textElm = document.createElement('div');
      textElm.setAttribute('style', "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
      if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.text) textElm.innerText = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.text);
      if ((_e = this.sums) === null || _e === void 0 ? void 0 : _e.html) textElm.innerHTML = "".concat((_f = this.sums) === null || _f === void 0 ? void 0 : _f.html);
      this.div.innerHTML = '';
      this.div.appendChild(img);
      this.div.appendChild(textElm);
      this.div.title = divTitle;
      this.div.style.display = '';
    }
    this.visible = true;
  };
  ClusterIcon.prototype.useStyle = function (sums) {
    this.sums = sums;
    var styles = this.cluster.getClusterer().getStyles();
    var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
    if (style) {
      this.url = style.url;
      this.height = style.height;
      this.width = style.width;
      if (style.className) {
        this.className = "".concat(this.clusterClassName, " ").concat(style.className);
      }
      this.anchorText = style.anchorText || [0, 0];
      this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
      this.textColor = style.textColor || 'black';
      this.textSize = style.textSize || 11;
      this.textDecoration = style.textDecoration || 'none';
      this.fontWeight = style.fontWeight || 'bold';
      this.fontStyle = style.fontStyle || 'normal';
      this.fontFamily = style.fontFamily || 'Arial,sans-serif';
      this.backgroundPosition = style.backgroundPosition || '0 0';
    }
  };
  ClusterIcon.prototype.setCenter = function (center) {
    this.center = center;
  };
  ClusterIcon.prototype.getPosFromLatLng = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    if (pos !== null) {
      pos.x -= this.anchorIcon[1];
      pos.y -= this.anchorIcon[0];
    }
    return pos;
  };
  return ClusterIcon;
}();

/* global google */
var Cluster$1 = /** @class */function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer;
    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
    this.getSize = this.getSize.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.getMap = this.getMap.bind(this);
    this.getClusterer = this.getClusterer.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.remove = this.remove.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
    this.calculateBounds = this.calculateBounds.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
  }
  Cluster.prototype.getSize = function () {
    return this.markers.length;
  };
  Cluster.prototype.getMarkers = function () {
    return this.markers;
  };
  Cluster.prototype.getCenter = function () {
    return this.center;
  };
  Cluster.prototype.getMap = function () {
    return this.map;
  };
  Cluster.prototype.getClusterer = function () {
    return this.markerClusterer;
  };
  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();
    for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
      var marker = markers_1[_i];
      var position = marker.getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    return bounds;
  };
  Cluster.prototype.remove = function () {
    this.clusterIcon.setMap(null);
    this.markers = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete this.markers;
  };
  Cluster.prototype.addMarker = function (marker) {
    var _a;
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }
    if (!this.center) {
      var position = marker.getPosition();
      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var position = marker.getPosition();
        if (position) {
          var length_1 = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
          this.calculateBounds();
        }
      }
    }
    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var _i = 0, _b = this.markers; _i < _b.length; _i++) {
        var markerElement = _b[_i];
        markerElement.setMap(null);
      }
    } else {
      marker.setMap(null);
    }
    return true;
  };
  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();
      if (position) {
        return this.bounds.contains(position);
      }
    }
    return false;
  };
  Cluster.prototype.calculateBounds = function () {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };
  Cluster.prototype.updateIcon = function () {
    var _a;
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      this.clusterIcon.hide();
      return;
    }
    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }
    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }
    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };
  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers.includes) {
      return this.markers.includes(marker);
    }
    for (var i = 0; i < this.markers.length; i++) {
      if (marker === this.markers[i]) {
        return true;
      }
    }
    return false;
  };
  return Cluster;
}();

/* global google */
/**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */
function CALCULATOR(markers, numStyles) {
  var count = markers.length;
  var numberOfDigits = count.toString().length;
  var index = Math.min(numberOfDigits, numStyles);
  return {
    text: count.toString(),
    index: index,
    title: ''
  };
}
var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';
var Clusterer = /** @class */function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }
    if (optOptions === void 0) {
      optOptions = {};
    }
    this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
    this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
    this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
    this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
    this.addToClosestCluster = this.addToClosestCluster.bind(this);
    this.getImageExtension = this.getImageExtension.bind(this);
    this.setImageExtension = this.setImageExtension.bind(this);
    this.getExtendedBounds = this.getExtendedBounds.bind(this);
    this.getAverageCenter = this.getAverageCenter.bind(this);
    this.setAverageCenter = this.setAverageCenter.bind(this);
    this.getTotalClusters = this.getTotalClusters.bind(this);
    this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
    this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
    this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
    this.getClusterClass = this.getClusterClass.bind(this);
    this.setClusterClass = this.setClusterClass.bind(this);
    this.getTotalMarkers = this.getTotalMarkers.bind(this);
    this.getZoomOnClick = this.getZoomOnClick.bind(this);
    this.setZoomOnClick = this.setZoomOnClick.bind(this);
    this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
    this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
    this.createClusters = this.createClusters.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.getImageSizes = this.getImageSizes.bind(this);
    this.setImageSizes = this.setImageSizes.bind(this);
    this.getCalculator = this.getCalculator.bind(this);
    this.setCalculator = this.setCalculator.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this);
    this.resetViewport = this.resetViewport.bind(this);
    this.getImagePath = this.getImagePath.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.pushMarkerTo = this.pushMarkerTo.bind(this);
    this.removeMarker = this.removeMarker.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.setupStyles = this.setupStyles.bind(this);
    this.getGridSize = this.getGridSize.bind(this);
    this.setGridSize = this.setGridSize.bind(this);
    this.getClusters = this.getClusters.bind(this);
    this.getMaxZoom = this.getMaxZoom.bind(this);
    this.setMaxZoom = this.setMaxZoom.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.addMarkers = this.addMarkers.bind(this);
    this.getStyles = this.getStyles.bind(this);
    this.setStyles = this.setStyles.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.repaint = this.repaint.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.redraw = this.redraw.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.draw = this.draw.bind(this);
    this.extend = this.extend.bind(this);
    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;
    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }
    this.averageCenter = false;
    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }
    this.ignoreHidden = false;
    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }
    this.enableRetinaIcons = false;
    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }
    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;
    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }
    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true);
    this.setMap(map); // Note: this causes onAdd to be called
  }
  Clusterer.prototype.onZoomChanged = function () {
    var _a, _b;
    this.resetViewport(false);
    // Workaround for this Google bug: when map is at level 0 and "-" of
    // zoom slider is clicked, a "zoom_changed" event is fired even though
    // the map doesn't zoom out any further. In this situation, no "idle"
    // event is triggered so the cluster markers that have been removed
    // do not get redrawn. Same goes for a zoom in at maxZoom.
    if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get('minZoom') || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get('maxZoom')) {
      google.maps.event.trigger(this, 'idle');
    }
  };
  Clusterer.prototype.onIdle = function () {
    this.redraw();
  };
  Clusterer.prototype.onAdd = function () {
    var map = this.getMap();
    this.activeMap = map;
    this.ready = true;
    this.repaint();
    if (map !== null) {
      // Add the map event listeners
      this.listeners = [google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged), google.maps.event.addListener(map, 'idle', this.onIdle)];
    }
  };
  Clusterer.prototype.onRemove = function () {
    // Put all the managed markers back on the map:
    for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
      var marker = _a[_i];
      if (marker.getMap() !== this.activeMap) {
        marker.setMap(this.activeMap);
      }
    }
    // Remove all clusters:
    for (var _b = 0, _c = this.clusters; _b < _c.length; _b++) {
      var cluster = _c[_b];
      cluster.remove();
    }
    this.clusters = [];
    // Remove map event listeners:
    for (var _d = 0, _e = this.listeners; _d < _e.length; _d++) {
      var listener = _e[_d];
      google.maps.event.removeListener(listener);
    }
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  };
  Clusterer.prototype.draw = function () {
    return;
  };
  Clusterer.prototype.getMap = function () {
    return null;
  };
  Clusterer.prototype.getPanes = function () {
    return null;
  };
  Clusterer.prototype.getProjection = function () {
    return {
      fromContainerPixelToLatLng: function () {
        return null;
      },
      fromDivPixelToLatLng: function () {
        return null;
      },
      fromLatLngToContainerPixel: function () {
        return null;
      },
      fromLatLngToDivPixel: function () {
        return null;
      },
      getVisibleRegion: function () {
        return null;
      },
      getWorldWidth: function () {
        return 0;
      }
    };
  };
  Clusterer.prototype.setMap = function () {
    return;
  };
  Clusterer.prototype.addListener = function () {
    return {
      remove: function () {
        return;
      }
    };
  };
  Clusterer.prototype.bindTo = function () {
    return;
  };
  Clusterer.prototype.get = function () {
    return;
  };
  Clusterer.prototype.notify = function () {
    return;
  };
  Clusterer.prototype.set = function () {
    return;
  };
  Clusterer.prototype.setValues = function () {
    return;
  };
  Clusterer.prototype.unbind = function () {
    return;
  };
  Clusterer.prototype.unbindAll = function () {
    return;
  };
  Clusterer.prototype.setupStyles = function () {
    if (this.styles.length > 0) {
      return;
    }
    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
        height: this.imageSizes[i] || 0,
        width: this.imageSizes[i] || 0
      });
    }
  };
  Clusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
      var marker = markers_1[_i];
      var position = marker.getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    var map = this.getMap();
    if (map !== null && 'fitBounds' in map) {
      map.fitBounds(bounds);
    }
  };
  Clusterer.prototype.getGridSize = function () {
    return this.gridSize;
  };
  Clusterer.prototype.setGridSize = function (gridSize) {
    this.gridSize = gridSize;
  };
  Clusterer.prototype.getMinimumClusterSize = function () {
    return this.minClusterSize;
  };
  Clusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };
  Clusterer.prototype.getMaxZoom = function () {
    return this.maxZoom;
  };
  Clusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom = maxZoom;
  };
  Clusterer.prototype.getStyles = function () {
    return this.styles;
  };
  Clusterer.prototype.setStyles = function (styles) {
    this.styles = styles;
  };
  Clusterer.prototype.getTitle = function () {
    return this.title;
  };
  Clusterer.prototype.setTitle = function (title) {
    this.title = title;
  };
  Clusterer.prototype.getZoomOnClick = function () {
    return this.zoomOnClick;
  };
  Clusterer.prototype.setZoomOnClick = function (zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };
  Clusterer.prototype.getAverageCenter = function () {
    return this.averageCenter;
  };
  Clusterer.prototype.setAverageCenter = function (averageCenter) {
    this.averageCenter = averageCenter;
  };
  Clusterer.prototype.getIgnoreHidden = function () {
    return this.ignoreHidden;
  };
  Clusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };
  Clusterer.prototype.getEnableRetinaIcons = function () {
    return this.enableRetinaIcons;
  };
  Clusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };
  Clusterer.prototype.getImageExtension = function () {
    return this.imageExtension;
  };
  Clusterer.prototype.setImageExtension = function (imageExtension) {
    this.imageExtension = imageExtension;
  };
  Clusterer.prototype.getImagePath = function () {
    return this.imagePath;
  };
  Clusterer.prototype.setImagePath = function (imagePath) {
    this.imagePath = imagePath;
  };
  Clusterer.prototype.getImageSizes = function () {
    return this.imageSizes;
  };
  Clusterer.prototype.setImageSizes = function (imageSizes) {
    this.imageSizes = imageSizes;
  };
  Clusterer.prototype.getCalculator = function () {
    return this.calculator;
  };
  Clusterer.prototype.setCalculator = function (calculator) {
    this.calculator = calculator;
  };
  Clusterer.prototype.getBatchSizeIE = function () {
    return this.batchSizeIE;
  };
  Clusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };
  Clusterer.prototype.getClusterClass = function () {
    return this.clusterClass;
  };
  Clusterer.prototype.setClusterClass = function (clusterClass) {
    this.clusterClass = clusterClass;
  };
  Clusterer.prototype.getMarkers = function () {
    return this.markers;
  };
  Clusterer.prototype.getTotalMarkers = function () {
    return this.markers.length;
  };
  Clusterer.prototype.getClusters = function () {
    return this.clusters;
  };
  Clusterer.prototype.getTotalClusters = function () {
    return this.clusters.length;
  };
  Clusterer.prototype.addMarker = function (marker, optNoDraw) {
    this.pushMarkerTo(marker);
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.addMarkers = function (markers, optNoDraw) {
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        var marker = markers[key];
        if (marker) {
          this.pushMarkerTo(marker);
        }
      }
    }
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.pushMarkerTo = function (marker) {
    var _this = this;
    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this.ready) {
          marker.isAdded = false;
          _this.repaint();
        }
      });
    }
    marker.isAdded = false;
    this.markers.push(marker);
  };
  Clusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }
    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }
    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers
    return true;
  };
  Clusterer.prototype.removeMarker = function (marker, optNoDraw) {
    var removed = this.removeMarker_(marker);
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.removeMarkers = function (markers, optNoDraw) {
    var removed = false;
    for (var _i = 0, markers_2 = markers; _i < markers_2.length; _i++) {
      var marker = markers_2[_i];
      removed = removed || this.removeMarker_(marker);
    }
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers = [];
  };
  Clusterer.prototype.repaint = function () {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw();
    // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.
    setTimeout(function timeout() {
      for (var _i = 0, oldClusters_1 = oldClusters; _i < oldClusters_1.length; _i++) {
        var oldCluster = oldClusters_1[_i];
        oldCluster.remove();
      }
    }, 0);
  };
  Clusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();
    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
    if (trPix !== null) {
      trPix.x += this.gridSize;
      trPix.y -= this.gridSize;
    }
    var blPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
    if (blPix !== null) {
      blPix.x -= this.gridSize;
      blPix.y += this.gridSize;
    }
    // Extend the bounds to contain the new bounds.
    if (trPix !== null) {
      // Convert the pixel points back to LatLng nw
      var point1 = projection.fromDivPixelToLatLng(trPix);
      if (point1 !== null) {
        bounds.extend(point1);
      }
    }
    if (blPix !== null) {
      // Convert the pixel points back to LatLng sw
      var point2 = projection.fromDivPixelToLatLng(blPix);
      if (point2 !== null) {
        bounds.extend(point2);
      }
    }
    return bounds;
  };
  Clusterer.prototype.redraw = function () {
    // Redraws all the clusters.
    this.createClusters(0);
  };
  Clusterer.prototype.resetViewport = function (optHide) {
    // Remove all the clusters
    for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
      var cluster = _a[_i];
      cluster.remove();
    }
    this.clusters = [];
    // Reset the markers to not be added and to be removed from the map.
    for (var _b = 0, _c = this.markers; _b < _c.length; _b++) {
      var marker = _c[_b];
      marker.isAdded = false;
      if (optHide) {
        marker.setMap(null);
      }
    }
  };
  Clusterer.prototype.distanceBetweenPoints = function (p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };
  Clusterer.prototype.isMarkerInBounds = function (marker, bounds) {
    var position = marker.getPosition();
    if (position) {
      return bounds.contains(position);
    }
    return false;
  };
  Clusterer.prototype.addToClosestCluster = function (marker) {
    var cluster;
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
      var clusterElement = _a[_i];
      cluster = clusterElement;
      var center = cluster.getCenter();
      var position = marker.getPosition();
      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);
        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }
    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster$1(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };
  Clusterer.prototype.createClusters = function (iFirst) {
    var _this = this;
    if (!this.ready) {
      return;
    }
    // Cancel previous batch processing if we're working on the first batch:
    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);
      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.timerRefStatic;
      }
    }
    var map = this.getMap();
    var bounds = map !== null && 'getBounds' in map ? map.getBounds() : null;
    var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
    var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var extendedMapBounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];
      if (marker && !marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) {
        this.addToClosestCluster(marker);
      }
    }
    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout(function () {
        _this.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringend', this);
      for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
        var cluster = _a[_i];
        cluster.updateIcon();
      }
    }
  };
  Clusterer.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        var prop = property;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.prototype[prop] = object.prototype[prop];
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return Clusterer;
}();
var eventMap$e = {
  onClick: 'click',
  onClusteringBegin: 'clusteringbegin',
  onClusteringEnd: 'clusteringend',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover'
};
var updaterMap$e = {
  averageCenter: function (instance, averageCenter) {
    instance.setAverageCenter(averageCenter);
  },
  batchSizeIE: function (instance, batchSizeIE) {
    instance.setBatchSizeIE(batchSizeIE);
  },
  calculator: function (instance, calculator) {
    instance.setCalculator(calculator);
  },
  clusterClass: function (instance, clusterClass) {
    instance.setClusterClass(clusterClass);
  },
  enableRetinaIcons: function (instance, enableRetinaIcons) {
    instance.setEnableRetinaIcons(enableRetinaIcons);
  },
  gridSize: function (instance, gridSize) {
    instance.setGridSize(gridSize);
  },
  ignoreHidden: function (instance, ignoreHidden) {
    instance.setIgnoreHidden(ignoreHidden);
  },
  imageExtension: function (instance, imageExtension) {
    instance.setImageExtension(imageExtension);
  },
  imagePath: function (instance, imagePath) {
    instance.setImagePath(imagePath);
  },
  imageSizes: function (instance, imageSizes) {
    instance.setImageSizes(imageSizes);
  },
  maxZoom: function (instance, maxZoom) {
    instance.setMaxZoom(maxZoom);
  },
  minimumClusterSize: function (instance, minimumClusterSize) {
    instance.setMinimumClusterSize(minimumClusterSize);
  },
  styles: function (instance, styles) {
    instance.setStyles(styles);
  },
  title: function (instance, title) {
    instance.setTitle(title);
  },
  zoomOnClick: function (instance, zoomOnClick) {
    instance.setZoomOnClick(zoomOnClick);
  }
};
/** @class */(function (_super) {
  __extends(ClustererComponent, _super);
  function ClustererComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      markerClusterer: null
    };
    _this.setClustererCallback = function () {
      if (_this.state.markerClusterer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.markerClusterer);
      }
    };
    return _this;
  }
  ClustererComponent.prototype.componentDidMount = function () {
    if (this.context) {
      var markerClusterer_1 = new Clusterer(this.context, [], this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$e,
        eventMap: eventMap$e,
        prevProps: {},
        nextProps: this.props,
        instance: markerClusterer_1
      });
      this.setState(function () {
        return {
          markerClusterer: markerClusterer_1
        };
      }, this.setClustererCallback);
    }
  };
  ClustererComponent.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.markerClusterer) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$e,
        eventMap: eventMap$e,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.markerClusterer
      });
    }
  };
  ClustererComponent.prototype.componentWillUnmount = function () {
    if (this.state.markerClusterer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.markerClusterer);
      }
      unregisterEvents(this.registeredEvents);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.state.markerClusterer.setMap(null);
    }
  };
  ClustererComponent.prototype.render = function () {
    return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
  };
  ClustererComponent.contextType = MapContext;
  return ClustererComponent;
})(PureComponent);

// This handler prevents an event in the InfoBox from being passed on to the map.
function cancelHandler(event) {
  event.cancelBubble = true;
  if (event.stopPropagation) {
    event.stopPropagation();
  }
}
var InfoBox = /** @class */function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }
    this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
    this.addClickHandler = this.addClickHandler.bind(this);
    this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
    this.getBoxWidths = this.getBoxWidths.bind(this);
    this.setBoxStyle = this.setBoxStyle.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.setOptions = this.setOptions.bind(this);
    this.setContent = this.setContent.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.getContent = this.getContent.bind(this);
    this.getVisible = this.getVisible.bind(this);
    this.setZIndex = this.setZIndex.bind(this);
    this.getZIndex = this.getZIndex.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.panBox = this.panBox.bind(this);
    this.extend = this.extend.bind(this);
    this.close = this.close.bind(this);
    this.draw = this.draw.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.open = this.open.bind(this);
    this.extend(InfoBox, google.maps.OverlayView);
    // Standard options (in common with google.maps.InfoWindow):
    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null;
    // Additional options (unique to InfoBox):
    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';
    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }
    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }
    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }
  InfoBox.prototype.createInfoBoxDiv = function () {
    var _this = this;
    // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.
    var ignoreHandler = function (event) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };
    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();
      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      }
      var panes = this.getPanes();
      if (panes !== null) {
        panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
      }
      this.addClickHandler();
      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }
      this.panBox(this.disableAutoPan);
      if (!this.enableEventPropagation) {
        this.eventListeners = [];
        // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)
        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
          var event_1 = events_1[_i];
          this.eventListeners.push(google.maps.event.addListener(this.div, event_1, cancelHandler));
        }
        // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.
        this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }
      this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */
      google.maps.event.trigger(this, 'domready');
    }
  };
  InfoBox.prototype.getCloseBoxImg = function () {
    var img = '';
    if (this.closeBoxURL !== '') {
      img = '<img alt=""';
      img += ' aria-hidden="true"';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'
      img += " style='";
      img += ' position: relative;'; // Required by MSIE
      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }
    return img;
  };
  InfoBox.prototype.addClickHandler = function () {
    this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== '' ? google.maps.event.addListener(this.div.firstChild, 'click', this.getCloseClickHandler()) : null;
  };
  InfoBox.prototype.closeClickHandler = function (event) {
    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    event.cancelBubble = true;
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(this, 'closeclick');
    this.close();
  };
  InfoBox.prototype.getCloseClickHandler = function () {
    return this.closeClickHandler;
  };
  InfoBox.prototype.panBox = function (disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var map = this.getMap();
      // Only pan if attached to map, not panorama
      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();
        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }
        var mapDiv = map.getDiv();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapWidth = mapDiv.offsetWidth;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);
        if (pixPosition !== null) {
          if (pixPosition.x < -iwOffsetX + padX) {
            xOffset = pixPosition.x + iwOffsetX - padX;
          } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
            xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
          }
          if (this.alignBottom) {
            if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
              yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
            } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
            }
          } else {
            if (pixPosition.y < -iwOffsetY + padY) {
              yOffset = pixPosition.y + iwOffsetY - padY;
            } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
            }
          }
        }
        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };
  InfoBox.prototype.setBoxStyle = function () {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass;
      // Clear existing inline style values:
      this.div.style.cssText = '';
      // Apply style values defined in the boxStyle parameter:
      var boxStyle = this.boxStyle;
      for (var i in boxStyle) {
        if (Object.prototype.hasOwnProperty.call(boxStyle, i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      }
      // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
      this.div.style.webkitTransform = 'translateZ(0)';
      // Fix up opacity style for benefit of MSIE
      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || '');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      }
      // Apply required styles
      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';
      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }
      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };
  InfoBox.prototype.getBoxWidths = function () {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    if (!this.div) {
      return bw;
    }
    if (document.defaultView) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;
      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var currentStyle = this.div.currentStyle;
      if (currentStyle) {
        // The current styles may not be in pixel units, but assume they are (bad!)
        bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
      }
    }
    return bw;
  };
  InfoBox.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };
  InfoBox.prototype.draw = function () {
    this.createInfoBoxDiv();
    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);
      if (pixPosition !== null) {
        this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';
        if (this.alignBottom) {
          this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
        } else {
          this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
        }
      }
      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };
  InfoBox.prototype.setOptions = function (options) {
    if (options === void 0) {
      options = {};
    }
    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }
    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }
    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }
    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }
    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }
    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }
    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }
    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }
    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }
    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }
    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }
    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }
    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }
    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }
    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }
    if (this.div) {
      this.draw();
    }
  };
  InfoBox.prototype.setContent = function (content) {
    this.content = content;
    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      }
      // Odd code required to make things work with MSIE.
      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }
      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      }
      // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)
      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';
        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }
      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */
    google.maps.event.trigger(this, 'content_changed');
  };
  InfoBox.prototype.setPosition = function (latLng) {
    this.position = latLng;
    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */
    google.maps.event.trigger(this, 'position_changed');
  };
  InfoBox.prototype.setVisible = function (isVisible) {
    this.isHidden = !isVisible;
    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };
  InfoBox.prototype.setZIndex = function (index) {
    this.zIndex = index;
    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */
    google.maps.event.trigger(this, 'zindex_changed');
  };
  InfoBox.prototype.getContent = function () {
    return this.content;
  };
  InfoBox.prototype.getPosition = function () {
    return this.position;
  };
  InfoBox.prototype.getZIndex = function () {
    return this.zIndex;
  };
  InfoBox.prototype.getVisible = function () {
    var map = this.getMap();
    return typeof map === 'undefined' || map === null ? false : !this.isHidden;
  };
  InfoBox.prototype.show = function () {
    this.isHidden = false;
    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };
  InfoBox.prototype.hide = function () {
    this.isHidden = true;
    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };
  InfoBox.prototype.open = function (map, anchor) {
    var _this = this;
    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var position = anchor.getPosition();
        _this.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _this.setMap(anchor.map);
      });
    }
    this.setMap(map);
    if (this.div) {
      this.panBox();
    }
  };
  InfoBox.prototype.close = function () {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }
    if (this.eventListeners) {
      for (var _i = 0, _a = this.eventListeners; _i < _a.length; _i++) {
        var eventListener = _a[_i];
        google.maps.event.removeListener(eventListener);
      }
      this.eventListeners = null;
    }
    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }
    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.setMap(null);
  };
  InfoBox.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        if (!Object.prototype.hasOwnProperty.call(this, property)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return InfoBox;
}();
var eventMap$d = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$d = {
  options: function (instance, options) {
    instance.setOptions(options);
  },
  position: function (instance, position) {
    if (position instanceof google.maps.LatLng) {
      instance.setPosition(position);
    } else {
      instance.setPosition(new google.maps.LatLng(position.lat, position.lng));
    }
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  },
  zIndex: function (instance, zIndex) {
    instance.setZIndex(zIndex);
  }
};
/** @class */(function (_super) {
  __extends(InfoBoxComponent, _super);
  function InfoBoxComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoBox: null
    };
    _this.open = function (infoBox, anchor) {
      if (anchor) {
        if (_this.context !== null) {
          infoBox.open(_this.context, anchor);
        }
      } else if (infoBox.getPosition()) {
        if (_this.context !== null) {
          infoBox.open(_this.context);
        }
      } else {
        invariant$1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
    };
    _this.setInfoBoxCallback = function () {
      if (_this.state.infoBox !== null && _this.containerElement !== null) {
        _this.state.infoBox.setContent(_this.containerElement);
        _this.open(_this.state.infoBox, _this.props.anchor);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.infoBox);
        }
      }
    };
    return _this;
  }
  InfoBoxComponent.prototype.componentDidMount = function () {
    var _a = this.props.options || {},
      position = _a.position,
      infoBoxOptions = __rest$1(_a, ["position"]);
    var positionLatLng;
    if (position && !(position instanceof google.maps.LatLng)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      positionLatLng = new google.maps.LatLng(position.lat, position.lng);
    }
    var infoBox = new InfoBox(__assign(__assign({}, infoBoxOptions), positionLatLng ? {
      position: positionLatLng
    } : {}));
    this.containerElement = document.createElement('div');
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$d,
      eventMap: eventMap$d,
      prevProps: {},
      nextProps: this.props,
      instance: infoBox
    });
    this.setState({
      infoBox: infoBox
    }, this.setInfoBoxCallback);
  };
  InfoBoxComponent.prototype.componentDidUpdate = function (prevProps) {
    var infoBox = this.state.infoBox;
    if (infoBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: prevProps,
        nextProps: this.props,
        instance: infoBox
      });
    }
  };
  InfoBoxComponent.prototype.componentWillUnmount = function () {
    var onUnmount = this.props.onUnmount;
    var infoBox = this.state.infoBox;
    if (infoBox !== null) {
      if (onUnmount) {
        onUnmount(infoBox);
      }
      unregisterEvents(this.registeredEvents);
      infoBox.close();
    }
  };
  InfoBoxComponent.prototype.render = function () {
    return this.containerElement ? /*#__PURE__*/createPortal(Children.only(this.props.children), this.containerElement) : null;
  };
  InfoBoxComponent.contextType = MapContext;
  return InfoBoxComponent;
})(PureComponent);

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MarkerClustererEvents;
(function (MarkerClustererEvents) {
  MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
  MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
  MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
var eventMap$c = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$c = {
  options: function (instance, options) {
    instance.setOptions(options);
  },
  position: function (instance, position) {
    instance.setPosition(position);
  },
  zIndex: function (instance, zIndex) {
    instance.setZIndex(zIndex);
  }
};
/** @class */(function (_super) {
  __extends(InfoWindow, _super);
  function InfoWindow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoWindow: null
    };
    _this.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this.context, anchor);
      } else if (infoWindow.getPosition()) {
        infoWindow.open(_this.context);
      } else {
        invariant$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
      }
    };
    _this.setInfoWindowCallback = function () {
      if (_this.state.infoWindow !== null && _this.containerElement !== null) {
        _this.state.infoWindow.setContent(_this.containerElement);
        _this.open(_this.state.infoWindow, _this.props.anchor);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.infoWindow);
        }
      }
    };
    return _this;
  }
  InfoWindow.prototype.componentDidMount = function () {
    var infoWindow = new google.maps.InfoWindow(__assign({}, this.props.options || {}));
    this.containerElement = document.createElement('div');
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$c,
      eventMap: eventMap$c,
      prevProps: {},
      nextProps: this.props,
      instance: infoWindow
    });
    this.setState(function () {
      return {
        infoWindow: infoWindow
      };
    }, this.setInfoWindowCallback);
  };
  InfoWindow.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.infoWindow
      });
    }
  };
  InfoWindow.prototype.componentWillUnmount = function () {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.infoWindow);
      }
      this.state.infoWindow.close();
    }
  };
  InfoWindow.prototype.render = function () {
    return this.containerElement ? ( /*#__PURE__*/createPortal(Children.only(this.props.children), this.containerElement)) : null;
  };
  InfoWindow.contextType = MapContext;
  return InfoWindow;
})(PureComponent);
var eventMap$b = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$b = {
  draggable: function (instance, draggable) {
    instance.setDraggable(draggable);
  },
  editable: function (instance, editable) {
    instance.setEditable(editable);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  path: function (instance, path) {
    instance.setPath(path);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  }
};
/** @class */(function (_super) {
  __extends(Polyline, _super);
  function Polyline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polyline: null
    };
    _this.setPolylineCallback = function () {
      if (_this.state.polyline !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polyline);
      }
    };
    return _this;
  }
  Polyline.prototype.componentDidMount = function () {
    var polyline = new google.maps.Polyline(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$b,
      eventMap: eventMap$b,
      prevProps: {},
      nextProps: this.props,
      instance: polyline
    });
    this.setState(function setPolyline() {
      return {
        polyline: polyline
      };
    }, this.setPolylineCallback);
  };
  Polyline.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.polyline !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polyline
      });
    }
  };
  Polyline.prototype.componentWillUnmount = function () {
    if (this.state.polyline !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polyline);
      }
      unregisterEvents(this.registeredEvents);
      this.state.polyline.setMap(null);
    }
  };
  Polyline.prototype.render = function () {
    return null;
  };
  Polyline.contextType = MapContext;
  return Polyline;
})(PureComponent);
var eventMap$a = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$a = {
  draggable: function (instance, draggable) {
    instance.setDraggable(draggable);
  },
  editable: function (instance, editable) {
    instance.setEditable(editable);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  path: function (instance, path) {
    instance.setPath(path);
  },
  paths: function (instance, paths) {
    instance.setPaths(paths);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  }
};
/** @class */(function (_super) {
  __extends(Polygon, _super);
  function Polygon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polygon: null
    };
    _this.setPolygonCallback = function () {
      if (_this.state.polygon !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polygon);
      }
    };
    return _this;
  }
  Polygon.prototype.componentDidMount = function () {
    var polygon = new google.maps.Polygon(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$a,
      eventMap: eventMap$a,
      prevProps: {},
      nextProps: this.props,
      instance: polygon
    });
    this.setState(function setPolygon() {
      return {
        polygon: polygon
      };
    }, this.setPolygonCallback);
  };
  Polygon.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.polygon !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polygon
      });
    }
  };
  Polygon.prototype.componentWillUnmount = function () {
    if (this.state.polygon !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polygon);
      }
      unregisterEvents(this.registeredEvents);
      this.state.polygon && this.state.polygon.setMap(null);
    }
  };
  Polygon.prototype.render = function () {
    return null;
  };
  Polygon.contextType = MapContext;
  return Polygon;
})(PureComponent);
var eventMap$9 = {
  onBoundsChanged: 'bounds_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$9 = {
  bounds: function (instance, bounds) {
    instance.setBounds(bounds);
  },
  draggable: function (instance, draggable) {
    instance.setDraggable(draggable);
  },
  editable: function (instance, editable) {
    instance.setEditable(editable);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  }
};
/** @class */(function (_super) {
  __extends(Rectangle, _super);
  function Rectangle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      rectangle: null
    };
    _this.setRectangleCallback = function () {
      if (_this.state.rectangle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.rectangle);
      }
    };
    return _this;
  }
  Rectangle.prototype.componentDidMount = function () {
    var rectangle = new google.maps.Rectangle(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$9,
      eventMap: eventMap$9,
      prevProps: {},
      nextProps: this.props,
      instance: rectangle
    });
    this.setState(function setRectangle() {
      return {
        rectangle: rectangle
      };
    }, this.setRectangleCallback);
  };
  Rectangle.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.rectangle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.rectangle
      });
    }
  };
  Rectangle.prototype.componentWillUnmount = function () {
    if (this.state.rectangle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.rectangle);
      }
      unregisterEvents(this.registeredEvents);
      this.state.rectangle.setMap(null);
    }
  };
  Rectangle.prototype.render = function () {
    return null;
  };
  Rectangle.contextType = MapContext;
  return Rectangle;
})(PureComponent);
var eventMap$8 = {
  onCenterChanged: 'center_changed',
  onRadiusChanged: 'radius_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$8 = {
  center: function (instance, center) {
    instance.setCenter(center);
  },
  draggable: function (instance, draggable) {
    instance.setDraggable(draggable);
  },
  editable: function (instance, editable) {
    instance.setEditable(editable);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  radius: function (instance, radius) {
    instance.setRadius(radius);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  }
};
/** @class */(function (_super) {
  __extends(Circle, _super);
  function Circle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      circle: null
    };
    _this.setCircleCallback = function () {
      if (_this.state.circle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.circle);
      }
    };
    return _this;
  }
  Circle.prototype.componentDidMount = function () {
    var circle = new google.maps.Circle(__assign(__assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$8,
      eventMap: eventMap$8,
      prevProps: {},
      nextProps: this.props,
      instance: circle
    });
    this.setState(function setCircle() {
      return {
        circle: circle
      };
    }, this.setCircleCallback);
  };
  Circle.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.circle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.circle
      });
    }
  };
  Circle.prototype.componentWillUnmount = function () {
    var _a;
    if (this.state.circle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.circle);
      }
      unregisterEvents(this.registeredEvents);
      (_a = this.state.circle) === null || _a === void 0 ? void 0 : _a.setMap(null);
    }
  };
  Circle.prototype.render = function () {
    return null;
  };
  Circle.contextType = MapContext;
  return Circle;
})(PureComponent);
var eventMap$7 = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onAddFeature: 'addfeature',
  onRemoveFeature: 'removefeature',
  onRemoveProperty: 'removeproperty',
  onSetGeometry: 'setgeometry',
  onSetProperty: 'setproperty'
};
var updaterMap$7 = {
  add: function (instance, feature) {
    instance.add(feature);
  },
  addgeojson: function (instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function (instance, feature) {
    instance.contains(feature);
  },
  foreach: function (instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function (instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function (instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function (instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function (instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function (instance, controlPosition) {
    instance.setControlPosition(controlPosition);
  },
  controls: function (instance, controls) {
    instance.setControls(controls);
  },
  drawingmode: function (instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  style: function (instance, style) {
    instance.setStyle(style);
  },
  togeojson: function (instance, callback) {
    instance.toGeoJson(callback);
  }
};
/** @class */(function (_super) {
  __extends(Data, _super);
  function Data() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      data: null
    };
    _this.setDataCallback = function () {
      if (_this.state.data !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.data);
      }
    };
    return _this;
  }
  Data.prototype.componentDidMount = function () {
    if (this.context !== null) {
      var data_1 = new google.maps.Data(__assign(__assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$7,
        eventMap: eventMap$7,
        prevProps: {},
        nextProps: this.props,
        instance: data_1
      });
      this.setState(function () {
        return {
          data: data_1
        };
      }, this.setDataCallback);
    }
  };
  Data.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.data !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$7,
        eventMap: eventMap$7,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.data
      });
    }
  };
  Data.prototype.componentWillUnmount = function () {
    if (this.state.data !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.data);
      }
      unregisterEvents(this.registeredEvents);
      if (this.state.data) {
        this.state.data.setMap(null);
      }
    }
  };
  Data.prototype.render = function () {
    return null;
  };
  Data.contextType = MapContext;
  return Data;
})(PureComponent);
var eventMap$6 = {
  onClick: 'click',
  onDefaultViewportChanged: 'defaultviewport_changed',
  onStatusChanged: 'status_changed'
};
var updaterMap$6 = {
  options: function (instance, options) {
    instance.setOptions(options);
  },
  url: function (instance, url) {
    instance.setUrl(url);
  },
  zIndex: function (instance, zIndex) {
    instance.setZIndex(zIndex);
  }
};
/** @class */(function (_super) {
  __extends(KmlLayer, _super);
  function KmlLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      kmlLayer: null
    };
    _this.setKmlLayerCallback = function () {
      if (_this.state.kmlLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.kmlLayer);
      }
    };
    return _this;
  }
  KmlLayer.prototype.componentDidMount = function () {
    var kmlLayer = new google.maps.KmlLayer(__assign(__assign({}, this.props.options), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$6,
      eventMap: eventMap$6,
      prevProps: {},
      nextProps: this.props,
      instance: kmlLayer
    });
    this.setState(function setLmlLayer() {
      return {
        kmlLayer: kmlLayer
      };
    }, this.setKmlLayerCallback);
  };
  KmlLayer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.kmlLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.kmlLayer
      });
    }
  };
  KmlLayer.prototype.componentWillUnmount = function () {
    if (this.state.kmlLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.kmlLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.kmlLayer.setMap(null);
    }
  };
  KmlLayer.prototype.render = function () {
    return null;
  };
  KmlLayer.contextType = MapContext;
  return KmlLayer;
})(PureComponent);
function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
    x: 0,
    y: 0
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ensureOfType(inst,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
factory
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  return inst instanceof type ? inst : factory(inst, type);
}
function ensureOfTypeBounds(inst,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
factory
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  return inst instanceof type ? inst : factory(inst, type);
}
function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  if (ne && sw) {
    return {
      left: "".concat(sw.x + offset.x, "px"),
      top: "".concat(ne.y + offset.y, "px"),
      width: "".concat(ne.x - sw.x - offset.x, "px"),
      height: "".concat(sw.y - ne.y - offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
  if (point) {
    var x = point.x,
      y = point.y;
    return {
      left: "".concat(x + offset.x, "px"),
      top: "".concat(y + offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}
function arePositionsEqual(currentPosition, previousPosition) {
  return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function convertToLatLngString(latLngLike) {
  if (!latLngLike) {
    return '';
  }
  var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
  return latLng + '';
}
function convertToLatLngBoundsString(latLngBoundsLike) {
  if (!latLngBoundsLike) {
    return '';
  }
  var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
  return latLngBounds + '';
}
/** @class */(function (_super) {
  __extends(OverlayView, _super);
  function OverlayView(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: 'absolute'
      }
    };
    _this.updatePane = function () {
      var mapPaneName = _this.props.mapPaneName;
      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
      var mapPanes = _this.overlayView.getPanes();
      invariant$1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
      if (mapPanes) {
        _this.setState({
          paneEl: mapPanes[mapPaneName]
        });
      } else {
        _this.setState({
          paneEl: null
        });
      }
    };
    _this.onAdd = function () {
      var _a, _b;
      _this.updatePane();
      (_b = (_a = _this.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, _this.overlayView);
    };
    _this.onPositionElement = function () {
      var mapCanvasProjection = _this.overlayView.getProjection();
      var offset = __assign({
        x: 0,
        y: 0
      }, _this.containerRef.current ? getOffsetOverride(_this.containerRef.current, _this.props.getPixelPositionOffset) : {});
      var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this.props.bounds, _this.props.position);
      var _a = _this.state.containerStyle,
        left = _a.left,
        top = _a.top,
        width = _a.width,
        height = _a.height;
      if (!arePositionsEqual(layoutStyles, {
        left: left,
        top: top,
        width: width,
        height: height
      })) {
        _this.setState({
          containerStyle: {
            top: layoutStyles.top || 0,
            left: layoutStyles.left || 0,
            width: layoutStyles.width || 0,
            height: layoutStyles.height || 0,
            position: 'absolute'
          }
        });
      }
    };
    _this.draw = function () {
      _this.onPositionElement();
    };
    _this.onRemove = function () {
      var _a, _b;
      _this.setState(function () {
        return {
          paneEl: null
        };
      });
      (_b = (_a = _this.props).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this.overlayView);
    };
    _this.containerRef = /*#__PURE__*/createRef();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    var overlayView = new google.maps.OverlayView();
    overlayView.onAdd = _this.onAdd;
    overlayView.draw = _this.draw;
    overlayView.onRemove = _this.onRemove;
    _this.overlayView = overlayView;
    return _this;
  }
  OverlayView.prototype.componentDidMount = function () {
    this.overlayView.setMap(this.context);
  };
  OverlayView.prototype.componentDidUpdate = function (prevProps) {
    var prevPositionString = convertToLatLngString(prevProps.position);
    var positionString = convertToLatLngString(this.props.position);
    var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
    var boundsString = convertToLatLngBoundsString(this.props.bounds);
    if (prevPositionString !== positionString || prevBoundsString !== boundsString) {
      this.overlayView.draw();
    }
    if (prevProps.mapPaneName !== this.props.mapPaneName) {
      this.updatePane();
    }
  };
  OverlayView.prototype.componentWillUnmount = function () {
    this.overlayView.setMap(null);
  };
  OverlayView.prototype.render = function () {
    var paneEl = this.state.paneEl;
    if (paneEl) {
      return /*#__PURE__*/ReactDOM.createPortal(jsx("div", {
        ref: this.containerRef,
        style: this.state.containerStyle,
        children: Children.only(this.props.children)
      }), paneEl);
    } else {
      return null;
    }
  };
  OverlayView.FLOAT_PANE = "floatPane";
  OverlayView.MAP_PANE = "mapPane";
  OverlayView.MARKER_LAYER = "markerLayer";
  OverlayView.OVERLAY_LAYER = "overlayLayer";
  OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
  OverlayView.contextType = MapContext;
  return OverlayView;
})(PureComponent);
function noop() {
  return;
}
var eventMap$5 = {
  onDblClick: 'dblclick',
  onClick: 'click'
};
var updaterMap$5 = {
  opacity: function (instance, opacity) {
    instance.setOpacity(opacity);
  }
};
/** @class */(function (_super) {
  __extends(GroundOverlay, _super);
  function GroundOverlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      groundOverlay: null
    };
    _this.setGroundOverlayCallback = function () {
      if (_this.state.groundOverlay !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.groundOverlay);
      }
    };
    return _this;
  }
  GroundOverlay.prototype.componentDidMount = function () {
    invariant$1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
    var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, __assign(__assign({}, this.props.options), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$5,
      eventMap: eventMap$5,
      prevProps: {},
      nextProps: this.props,
      instance: groundOverlay
    });
    this.setState(function setGroundOverlay() {
      return {
        groundOverlay: groundOverlay
      };
    }, this.setGroundOverlayCallback);
  };
  GroundOverlay.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.groundOverlay !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.groundOverlay
      });
    }
  };
  GroundOverlay.prototype.componentWillUnmount = function () {
    if (this.state.groundOverlay) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.groundOverlay);
      }
      this.state.groundOverlay.setMap(null);
    }
  };
  GroundOverlay.prototype.render = function () {
    return null;
  };
  GroundOverlay.defaultProps = {
    onLoad: noop
  };
  GroundOverlay.contextType = MapContext;
  return GroundOverlay;
})(PureComponent);
var eventMap$4 = {};
var updaterMap$4 = {
  data: function (instance, data) {
    instance.setData(data);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  }
};
/** @class */(function (_super) {
  __extends(HeatmapLayer, _super);
  function HeatmapLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      heatmapLayer: null
    };
    _this.setHeatmapLayerCallback = function () {
      if (_this.state.heatmapLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.heatmapLayer);
      }
    };
    return _this;
  }
  HeatmapLayer.prototype.componentDidMount = function () {
    invariant$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
    invariant$1(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
    var heatmapLayer = new google.maps.visualization.HeatmapLayer(__assign(__assign({}, this.props.options || {}), {
      data: this.props.data,
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$4,
      eventMap: eventMap$4,
      prevProps: {},
      nextProps: this.props,
      instance: heatmapLayer
    });
    this.setState(function setHeatmapLayer() {
      return {
        heatmapLayer: heatmapLayer
      };
    }, this.setHeatmapLayerCallback);
  };
  HeatmapLayer.prototype.componentDidUpdate = function (prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$4,
      eventMap: eventMap$4,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.heatmapLayer
    });
  };
  HeatmapLayer.prototype.componentWillUnmount = function () {
    if (this.state.heatmapLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.heatmapLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.heatmapLayer.setMap(null);
    }
  };
  HeatmapLayer.prototype.render = function () {
    return null;
  };
  HeatmapLayer.contextType = MapContext;
  return HeatmapLayer;
})(PureComponent);
var eventMap$3 = {
  onCloseClick: 'closeclick',
  onPanoChanged: 'pano_changed',
  onPositionChanged: 'position_changed',
  onPovChanged: 'pov_changed',
  onResize: 'resize',
  onStatusChanged: 'status_changed',
  onVisibleChanged: 'visible_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$3 = {
  register: function (instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function (instance, links) {
    instance.setLinks(links);
  },
  motionTracking: function (instance, motionTracking) {
    instance.setMotionTracking(motionTracking);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  pano: function (instance, pano) {
    instance.setPano(pano);
  },
  position: function (instance, position) {
    instance.setPosition(position);
  },
  pov: function (instance, pov) {
    instance.setPov(pov);
  },
  visible: function (instance, visible) {
    instance.setVisible(visible);
  },
  zoom: function (instance, zoom) {
    instance.setZoom(zoom);
  }
};
/** @class */(function (_super) {
  __extends(StreetViewPanorama, _super);
  function StreetViewPanorama() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      streetViewPanorama: null
    };
    _this.setStreetViewPanoramaCallback = function () {
      if (_this.state.streetViewPanorama !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewPanorama);
      }
    };
    return _this;
  }
  StreetViewPanorama.prototype.componentDidMount = function () {
    var _a, _b;
    var streetViewPanorama = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.getStreetView()) !== null && _b !== void 0 ? _b : null;
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$3,
      eventMap: eventMap$3,
      prevProps: {},
      nextProps: this.props,
      instance: streetViewPanorama
    });
    this.setState(function () {
      return {
        streetViewPanorama: streetViewPanorama
      };
    }, this.setStreetViewPanoramaCallback);
  };
  StreetViewPanorama.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.streetViewPanorama !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.streetViewPanorama
      });
    }
  };
  StreetViewPanorama.prototype.componentWillUnmount = function () {
    if (this.state.streetViewPanorama !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewPanorama);
      }
      unregisterEvents(this.registeredEvents);
      this.state.streetViewPanorama.setVisible(false);
    }
  };
  StreetViewPanorama.prototype.render = function () {
    return null;
  };
  StreetViewPanorama.contextType = MapContext;
  return StreetViewPanorama;
})(PureComponent);
/** @class */(function (_super) {
  __extends(StreetViewService, _super);
  function StreetViewService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      streetViewService: null
    };
    _this.setStreetViewServiceCallback = function () {
      if (_this.state.streetViewService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewService);
      }
    };
    return _this;
  }
  StreetViewService.prototype.componentDidMount = function () {
    var streetViewService = new google.maps.StreetViewService();
    this.setState(function setStreetViewService() {
      return {
        streetViewService: streetViewService
      };
    }, this.setStreetViewServiceCallback);
  };
  StreetViewService.prototype.componentWillUnmount = function () {
    if (this.state.streetViewService !== null && this.props.onUnmount) {
      this.props.onUnmount(this.state.streetViewService);
    }
  };
  StreetViewService.prototype.render = function () {
    return null;
  };
  StreetViewService.contextType = MapContext;
  return StreetViewService;
})(PureComponent);
/** @class */(function (_super) {
  __extends(DirectionsService, _super);
  function DirectionsService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      directionsService: null
    };
    _this.setDirectionsServiceCallback = function () {
      if (_this.state.directionsService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.directionsService);
      }
    };
    return _this;
  }
  DirectionsService.prototype.componentDidMount = function () {
    invariant$1(!!this.props.options, 'DirectionsService expected options object as parameter, but got %s', this.props.options);
    var directionsService = new google.maps.DirectionsService();
    this.setState(function setDirectionsService() {
      return {
        directionsService: directionsService
      };
    }, this.setDirectionsServiceCallback);
  };
  DirectionsService.prototype.componentDidUpdate = function () {
    if (this.state.directionsService !== null) {
      this.state.directionsService.route(this.props.options, this.props.callback);
    }
  };
  DirectionsService.prototype.componentWillUnmount = function () {
    if (this.state.directionsService !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsService);
      }
    }
  };
  DirectionsService.prototype.render = function () {
    return null;
  };
  return DirectionsService;
})(PureComponent);
var eventMap$2 = {
  onDirectionsChanged: 'directions_changed'
};
var updaterMap$2 = {
  directions: function (instance, directions) {
    instance.setDirections(directions);
  },
  map: function (instance, map) {
    instance.setMap(map);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  panel: function (instance, panel) {
    instance.setPanel(panel);
  },
  routeIndex: function (instance, routeIndex) {
    instance.setRouteIndex(routeIndex);
  }
};
/** @class */(function (_super) {
  __extends(DirectionsRenderer, _super);
  function DirectionsRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      directionsRenderer: null
    };
    _this.setDirectionsRendererCallback = function () {
      if (_this.state.directionsRenderer !== null) {
        _this.state.directionsRenderer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.directionsRenderer);
        }
      }
    };
    return _this;
  }
  DirectionsRenderer.prototype.componentDidMount = function () {
    var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$2,
      eventMap: eventMap$2,
      prevProps: {},
      nextProps: this.props,
      instance: directionsRenderer
    });
    this.setState(function setDirectionsRenderer() {
      return {
        directionsRenderer: directionsRenderer
      };
    }, this.setDirectionsRendererCallback);
  };
  DirectionsRenderer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.directionsRenderer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.directionsRenderer
      });
    }
  };
  DirectionsRenderer.prototype.componentWillUnmount = function () {
    if (this.state.directionsRenderer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsRenderer);
      }
      unregisterEvents(this.registeredEvents);
      if (this.state.directionsRenderer) {
        this.state.directionsRenderer.setMap(null);
      }
    }
  };
  DirectionsRenderer.prototype.render = function () {
    return jsx(Fragment, {});
  };
  DirectionsRenderer.contextType = MapContext;
  return DirectionsRenderer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(DistanceMatrixService, _super);
  function DistanceMatrixService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      distanceMatrixService: null
    };
    _this.setDistanceMatrixServiceCallback = function () {
      if (_this.state.distanceMatrixService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.distanceMatrixService);
      }
    };
    return _this;
  }
  DistanceMatrixService.prototype.componentDidMount = function () {
    invariant$1(!!this.props.options, 'DistanceMatrixService expected options object as parameter, but go %s', this.props.options);
    var distanceMatrixService = new google.maps.DistanceMatrixService();
    this.setState(function setDistanceMatrixService() {
      return {
        distanceMatrixService: distanceMatrixService
      };
    }, this.setDistanceMatrixServiceCallback);
  };
  DistanceMatrixService.prototype.componentDidUpdate = function () {
    if (this.state.distanceMatrixService !== null) {
      this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    }
  };
  DistanceMatrixService.prototype.componentWillUnmount = function () {
    if (this.state.distanceMatrixService !== null && this.props.onUnmount) {
      this.props.onUnmount(this.state.distanceMatrixService);
    }
  };
  DistanceMatrixService.prototype.render = function () {
    return null;
  };
  return DistanceMatrixService;
})(PureComponent);
var eventMap$1 = {
  onPlacesChanged: 'places_changed'
};
var updaterMap$1 = {
  bounds: function (instance, bounds) {
    instance.setBounds(bounds);
  }
};
/** @class */(function (_super) {
  __extends(StandaloneSearchBox, _super);
  function StandaloneSearchBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = /*#__PURE__*/createRef();
    _this.state = {
      searchBox: null
    };
    _this.setSearchBoxCallback = function () {
      if (_this.state.searchBox !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.searchBox);
      }
    };
    return _this;
  }
  StandaloneSearchBox.prototype.componentDidMount = function () {
    invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    if (this.containerElement !== null && this.containerElement.current !== null) {
      var input = this.containerElement.current.querySelector('input');
      if (input !== null) {
        var searchBox_1 = new google.maps.places.SearchBox(input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$1,
          eventMap: eventMap$1,
          prevProps: {},
          nextProps: this.props,
          instance: searchBox_1
        });
        this.setState(function setSearchBox() {
          return {
            searchBox: searchBox_1
          };
        }, this.setSearchBoxCallback);
      }
    }
  };
  StandaloneSearchBox.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.searchBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$1,
        eventMap: eventMap$1,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.searchBox
      });
    }
  };
  StandaloneSearchBox.prototype.componentWillUnmount = function () {
    if (this.state.searchBox !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.searchBox);
      }
      unregisterEvents(this.registeredEvents);
    }
  };
  StandaloneSearchBox.prototype.render = function () {
    return jsx("div", {
      ref: this.containerElement,
      children: Children.only(this.props.children)
    });
  };
  StandaloneSearchBox.contextType = MapContext;
  return StandaloneSearchBox;
})(PureComponent);
var eventMap = {
  onPlaceChanged: 'place_changed'
};
var updaterMap = {
  bounds: function (instance, bounds) {
    instance.setBounds(bounds);
  },
  restrictions: function (instance, restrictions) {
    instance.setComponentRestrictions(restrictions);
  },
  fields: function (instance, fields) {
    instance.setFields(fields);
  },
  options: function (instance, options) {
    instance.setOptions(options);
  },
  types: function (instance, types) {
    instance.setTypes(types);
  }
};
/** @class */(function (_super) {
  __extends(Autocomplete, _super);
  function Autocomplete() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = /*#__PURE__*/createRef();
    _this.state = {
      autocomplete: null
    };
    _this.setAutocompleteCallback = function () {
      if (_this.state.autocomplete !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.autocomplete);
      }
    };
    return _this;
  }
  Autocomplete.prototype.componentDidMount = function () {
    var _a;
    invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    // TODO: why current could be equal null?
    var input = (_a = this.containerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    if (input) {
      var autocomplete_1 = new google.maps.places.Autocomplete(input, this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: {},
        nextProps: this.props,
        instance: autocomplete_1
      });
      this.setState(function () {
        return {
          autocomplete: autocomplete_1
        };
      }, this.setAutocompleteCallback);
    }
  };
  Autocomplete.prototype.componentDidUpdate = function (prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap,
      eventMap: eventMap,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.autocomplete
    });
  };
  Autocomplete.prototype.componentWillUnmount = function () {
    if (this.state.autocomplete !== null) {
      unregisterEvents(this.registeredEvents);
    }
  };
  Autocomplete.prototype.render = function () {
    return jsx("div", {
      ref: this.containerElement,
      className: this.props.className,
      children: Children.only(this.props.children)
    });
  };
  Autocomplete.defaultProps = {
    className: ''
  };
  Autocomplete.contextType = MapContext;
  return Autocomplete;
})(PureComponent);

// Map styles are best suited to greyscale such as RouteXL or AG
var mapStyles = [{
  featureType: 'all',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'administrative',
  elementType: 'all',
  stylers: [{
    color: '#f2f2f2'
  }]
}, {
  featureType: 'administrative',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#686868'
  }, {
    visibility: 'on'
  }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    color: '#f2f2f2'
  }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'all',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    lightness: 45
  }]
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    lightness: '-22'
  }, {
    visibility: 'on'
  }, {
    color: '#b4b4b4'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.stroke',
  stylers: [{
    saturation: '-51'
  }, {
    lightness: '11'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.text',
  stylers: [{
    saturation: '3'
  }, {
    lightness: '-56'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.text.fill',
  stylers: [{
    lightness: '-52'
  }, {
    color: '#9094a0'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.text.stroke',
  stylers: [{
    weight: '6.13'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.icon',
  stylers: [{
    weight: '1.24'
  }, {
    saturation: '-100'
  }, {
    lightness: '-10'
  }, {
    gamma: '0.94'
  }, {
    visibility: 'off'
  }]
}, {
  featureType: 'road.highway.controlled_access',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#b4b4b4'
  }, {
    weight: '5.40'
  }, {
    lightness: '7'
  }]
}, {
  featureType: 'road.highway.controlled_access',
  elementType: 'labels.text',
  stylers: [{
    visibility: 'simplified'
  }, {
    color: '#231f1f'
  }]
}, {
  featureType: 'road.highway.controlled_access',
  elementType: 'labels.text.fill',
  stylers: [{
    visibility: 'simplified'
  }, {
    color: '#595151'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'geometry',
  stylers: [{
    lightness: '-16'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#d7d7d7'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.text',
  stylers: [{
    color: '#282626'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.text.fill',
  stylers: [{
    saturation: '-41'
  }, {
    lightness: '-41'
  }, {
    color: '#2a4592'
  }, {
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.text.stroke',
  stylers: [{
    weight: '1.10'
  }, {
    color: '#ffffff'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'road.local',
  elementType: 'geometry.fill',
  stylers: [{
    lightness: '-16'
  }, {
    weight: '0.72'
  }]
}, {
  featureType: 'road.local',
  elementType: 'labels.text.fill',
  stylers: [{
    lightness: '-37'
  }, {
    color: '#2a4592'
  }]
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit.line',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'off'
  }, {
    color: '#eeed6a'
  }]
}, {
  featureType: 'transit.line',
  elementType: 'geometry.stroke',
  stylers: [{
    visibility: 'off'
  }, {
    color: '#0a0808'
  }]
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    color: '#b7e4f4'
  }, {
    visibility: 'on'
  }]
}];

var img$4 = "data:image/svg+xml,%3csvg width='40' height='55' viewBox='0 0 40 55' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_222_1649)'%3e%3cpath d='M20.2986 47L5.31752 19.0937L35.2796 19.0937L20.2986 47Z' fill='%230279A3'/%3e%3ccircle cx='20.2988' cy='15.3403' r='15.3403' fill='%230279A3'/%3e%3cpath d='M20.1775 23.8333C19.9868 23.8333 19.8308 23.7727 19.7095 23.6513C19.6055 23.53 19.5535 23.3827 19.5535 23.2093V9.74133L15.6015 12.7833C15.4455 12.8873 15.2895 12.9307 15.1335 12.9133C14.9775 12.8787 14.8388 12.7833 14.7175 12.6273L13.6255 11.2233C13.5215 11.0673 13.4781 10.9027 13.4955 10.7293C13.5301 10.556 13.6255 10.4173 13.7815 10.3133L19.6055 5.81533C19.7095 5.72866 19.8135 5.67666 19.9175 5.65933C20.0215 5.642 20.1341 5.63333 20.2555 5.63333H22.5435C22.7168 5.63333 22.8641 5.694 22.9855 5.81533C23.1068 5.93666 23.1675 6.084 23.1675 6.25733V23.2093C23.1675 23.3827 23.1068 23.53 22.9855 23.6513C22.8641 23.7727 22.7168 23.8333 22.5435 23.8333H20.1775Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_222_1649' x='0.958496' y='0' width='38.6807' height='55' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='4'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_222_1649'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_222_1649' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='40' height='55' viewBox='0 0 40 55' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_222_1654)'%3e%3cpath d='M20.2986 47L5.31752 19.0937L35.2796 19.0937L20.2986 47Z' fill='%230279A3'/%3e%3ccircle cx='20.2988' cy='15.3403' r='15.3403' fill='%230279A3'/%3e%3cpath d='M13.7382 24.8333C13.5649 24.8333 13.4176 24.7727 13.2962 24.6513C13.1749 24.53 13.1142 24.3827 13.1142 24.2093V22.8833C13.1142 22.7273 13.1489 22.5453 13.2182 22.3373C13.3049 22.112 13.4869 21.8867 13.7642 21.6613L17.8722 17.5793C19.0162 16.678 19.9349 15.9153 20.6282 15.2913C21.3389 14.65 21.8502 14.0693 22.1622 13.5493C22.4916 13.012 22.6562 12.4833 22.6562 11.9633C22.6562 11.1833 22.4396 10.5507 22.0062 10.0653C21.5902 9.58 20.9229 9.33734 20.0042 9.33734C19.3976 9.33734 18.8862 9.46734 18.4702 9.72734C18.0542 9.97 17.7249 10.2993 17.4822 10.7153C17.2569 11.1313 17.1009 11.5907 17.0142 12.0933C16.9796 12.3187 16.8842 12.4747 16.7282 12.5613C16.5722 12.648 16.4162 12.6913 16.2602 12.6913H13.9462C13.7902 12.6913 13.6602 12.6393 13.5562 12.5353C13.4522 12.4313 13.4002 12.31 13.4002 12.1713C13.4176 11.426 13.5736 10.7067 13.8682 10.0133C14.1629 9.30267 14.5876 8.67867 15.1422 8.14134C15.7142 7.58667 16.4076 7.14467 17.2222 6.81534C18.0369 6.486 18.9556 6.32134 19.9782 6.32134C21.4169 6.32134 22.6042 6.564 23.5402 7.04934C24.4936 7.53467 25.2042 8.19334 25.6722 9.02533C26.1576 9.85734 26.4002 10.7933 26.4002 11.8333C26.4002 12.648 26.2442 13.402 25.9322 14.0953C25.6202 14.7713 25.1696 15.43 24.5802 16.0713C23.9909 16.6953 23.2802 17.3367 22.4482 17.9953L18.7562 21.7393H26.1662C26.3569 21.7393 26.5042 21.8 26.6082 21.9213C26.7296 22.0253 26.7902 22.1727 26.7902 22.3633V24.2093C26.7902 24.3827 26.7296 24.53 26.6082 24.6513C26.5042 24.7727 26.3569 24.8333 26.1662 24.8333H13.7382Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_222_1654' x='0.958496' y='0' width='38.6807' height='55' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='4'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_222_1654'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_222_1654' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='40' height='55' viewBox='0 0 40 55' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_222_1658)'%3e%3cpath d='M20.2986 47L5.31752 19.0937L35.2796 19.0937L20.2986 47Z' fill='%230279A3'/%3e%3ccircle cx='20.2988' cy='15.3403' r='15.3403' fill='%230279A3'/%3e%3cpath d='M19.8906 25.0933C18.6772 25.0933 17.6286 24.946 16.7446 24.6513C15.8606 24.3567 15.1239 23.9753 14.5346 23.5073C13.9626 23.022 13.5292 22.502 13.2346 21.9473C12.9399 21.3753 12.7839 20.812 12.7666 20.2573C12.7666 20.1013 12.8186 19.98 12.9226 19.8933C13.0439 19.7893 13.1826 19.7373 13.3386 19.7373H15.6786C15.8519 19.7373 15.9992 19.772 16.1206 19.8413C16.2419 19.9107 16.3459 20.0493 16.4326 20.2573C16.5886 20.7253 16.8399 21.098 17.1866 21.3753C17.5506 21.6527 17.9666 21.852 18.4346 21.9733C18.9026 22.0773 19.3966 22.1293 19.9166 22.1293C20.9566 22.1293 21.7799 21.8867 22.3866 21.4013C23.0106 20.8987 23.3226 20.188 23.3226 19.2693C23.3226 18.3507 23.0366 17.692 22.4646 17.2933C21.8926 16.8773 21.0952 16.6693 20.0726 16.6693H17.3946C17.2039 16.6693 17.0479 16.6173 16.9266 16.5133C16.8052 16.392 16.7446 16.236 16.7446 16.0453V14.9533C16.7446 14.78 16.7792 14.6327 16.8486 14.5113C16.9352 14.3727 17.0219 14.26 17.1086 14.1733L21.7626 9.62334H14.3266C14.1359 9.62334 13.9799 9.56268 13.8586 9.44134C13.7546 9.32001 13.7026 9.17268 13.7026 8.99934V7.28334C13.7026 7.09268 13.7546 6.93668 13.8586 6.81534C13.9799 6.69401 14.1359 6.63334 14.3266 6.63334H25.4806C25.6712 6.63334 25.8272 6.69401 25.9486 6.81534C26.0699 6.93668 26.1306 7.09268 26.1306 7.28334V8.84334C26.1306 8.99934 26.0959 9.13801 26.0266 9.25934C25.9572 9.38068 25.8792 9.48468 25.7926 9.57134L21.2946 14.1993L21.6066 14.2253C22.6639 14.312 23.5999 14.5547 24.4146 14.9533C25.2466 15.3347 25.8879 15.898 26.3386 16.6433C26.8066 17.3887 27.0406 18.3247 27.0406 19.4513C27.0406 20.63 26.7286 21.644 26.1046 22.4933C25.4979 23.3253 24.6572 23.9667 23.5826 24.4173C22.5079 24.868 21.2772 25.0933 19.8906 25.0933Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_222_1658' x='0.958496' y='0' width='38.6807' height='55' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='4'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_222_1658'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_222_1658' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

function Map$1(_ref) {
  let {
    locations
  } = _ref;
  const center = {
    lat: 44.076613,
    lng: -98.362239833
  };
  const zoom = 5;
  const {
    isLoaded
  } = useLoadScript({
    googleMapsApiKey: 'AIzaSyCN92L9mVg4j4t9zdDe0MSixMwdypHeJkA'
  });
  const fitBounds = map => {
    const bounds = new window.google.maps.LatLngBounds();
    locations.map(place => {
      bounds.extend({
        lat: place.latitude,
        lng: place.longitude
      });
      return place.location_id;
    });
    map.fitBounds(bounds);
  };
  const loadHandler = map => {
    fitBounds(map);
  };
  const options = {
    styles: mapStyles,
    disableDefaultUI: true,
    zoomControl: true
  };
  const renderMap = () => /*#__PURE__*/React.createElement(GoogleMap, {
    onLoad: loadHandler,
    options: options,
    center: center,
    zoom: zoom,
    mapContainerStyle: {
      height: '100%',
      width: '100%'
    }
  }, locations.map((place, index) => {
    let marker;
    if (index === 0) {
      marker = img$4;
    } else if (index === 1) {
      marker = img$3;
    } else if (index === 2) {
      marker = img$2;
    }
    return /*#__PURE__*/React.createElement(Marker, {
      key: place.location_id,
      position: {
        lat: place.latitude,
        lng: place.longitude
      },
      icon: marker
    });
  }));
  return isLoaded ? renderMap() : null;
}
var Map$2 = /*#__PURE__*/React.memo(Map$1);
Map$1.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    location_id: PropTypes.number.isRequired,
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    county: PropTypes.string,
    postcode: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
  })).isRequired
};

var css$h = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.locationListingPanel_module_locationListingPanel__70f08e51 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  padding: 20px 25px;\n  background: #f3f3f3;\n  flex-direction: column;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_button__70f08e51 {\n  background: #0279a3;\n  border-radius: 8px;\n  color: #fff;\n  border: 0;\n  width: 100%;\n  padding: 4px;\n  font-weight: 300;\n  text-align: center;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_option__70f08e51 {\n  height: 100%;\n  width: 100%;\n  max-width: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 10px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-family: Rubik;\n  flex-wrap: wrap;\n  padding: 10px;\n  background: #fff;\n  margin-bottom: 30px;\n  position: relative;\n  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.12);\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_option__70f08e51:after {\n  content: \" \";\n  bottom: -18px;\n  position: absolute;\n  border-top: 1px solid #d4d4d4;\n  width: 40px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_option__70f08e51:last-child:after {\n  border: 0;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_option__70f08e51 span {\n  font-size: 14px;\n  color: #000;\n  padding: 0 0 6px 6px;\n  width: calc(100% - 30px);\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 img {\n  max-width: 30px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_divider__70f08e51 {\n  position: relative;\n  padding: 0px 90px;\n  font-weight: 600;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_divider__70f08e51:before, .locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_divider__70f08e51:after {\n  content: \" \";\n  background: #dadada;\n  width: 50px;\n  height: 1px;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_divider__70f08e51:before {\n  left: 0%;\n  margin-left: 20px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 .locationListingPanel_module_divider__70f08e51:after {\n  right: 0%;\n  margin-right: 20px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51 input[type=radio] {\n  display: none;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51.locationListingPanel_module_large__70f08e51 {\n  padding: 20px 15px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51.locationListingPanel_module_large__70f08e51 .locationListingPanel_module_option__70f08e51 {\n  margin: 0 10px;\n  padding: 0 10px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51.locationListingPanel_module_large__70f08e51 .locationListingPanel_module_option__70f08e51::nth-of-type(odd) {\n  margin-right: 0px;\n}\n.locationListingPanel_module_locationListingPanel__70f08e51.locationListingPanel_module_large__70f08e51 .locationListingPanel_module_option__70f08e51 span {\n  font-size: 20px;\n  padding: 12px 20px;\n}\n\n#locationListingPanel_module_option1__70f08e51:checked ~ .locationListingPanel_module_option1__70f08e51,\n#locationListingPanel_module_option2__70f08e51:checked ~ .locationListingPanel_module_option2__70f08e51,\n#locationListingPanel_module_option3__70f08e51:checked ~ .locationListingPanel_module_option3__70f08e51 {\n  border: 2px solid #0279a3;\n  background: #fff;\n}";
var modules_57a82090 = {"locationListingPanel":"locationListingPanel_module_locationListingPanel__70f08e51","button":"locationListingPanel_module_button__70f08e51","option":"locationListingPanel_module_option__70f08e51","divider":"locationListingPanel_module_divider__70f08e51","large":"locationListingPanel_module_large__70f08e51","option1":"locationListingPanel_module_option1__70f08e51","option2":"locationListingPanel_module_option2__70f08e51","option3":"locationListingPanel_module_option3__70f08e51"};
n(css$h,{});

const markers = [img$4, img$3, img$2];
function LocationListingPanel(_ref) {
  let {
    locations,
    onLocationChange
  } = _ref;
  const handleLocationSelection = e => {
    onLocationChange({
      name: 'appointmentLocation',
      value: e.target.value
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: modules_57a82090.locationListingPanel
  }, /*#__PURE__*/React.createElement("ul", null, locations.map((location, index) => /*#__PURE__*/React.createElement("li", {
    key: location.location_id
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "appointmentLocation",
    value: location.location_id,
    id: modules_57a82090["option".concat(location.location_id)],
    onChange: handleLocationSelection
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: modules_57a82090["option".concat(location.location_id)],
    className: "".concat(modules_57a82090.option, " ").concat(modules_57a82090["option".concat(location.location_id)])
  }, /*#__PURE__*/React.createElement("img", {
    src: markers[index],
    alt: "Marker"
  }), /*#__PURE__*/React.createElement("span", null, "".concat(location.street, ", ").concat(location.city, ", ").concat(location.postcode)), /*#__PURE__*/React.createElement("div", {
    className: modules_57a82090.button
  }, "Select clinic"))))));
}
LocationListingPanel.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    location_id: PropTypes.number.isRequired,
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    county: PropTypes.string,
    postcode: PropTypes.string.isRequired
  })).isRequired,
  onLocationChange: PropTypes.func
};
LocationListingPanel.defaultProps = {
  onLocationChange: null
};

function LocationCard(_ref) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "modal fade show",
    id: "exampleModal",
    tabIndex: "-1",
    "aria-labelledby": "exampleModalLabel",
    style: {
      display: 'block'
    },
    "aria-modal": "true",
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-dialog modal-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn",
    "aria-label": "Back"
  }, /*#__PURE__*/React.createElement("img", {
    src: img$6,
    alt: "Back"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("img", {
    src: img$5,
    alt: "Close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "modal-body px-4 py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-5"
  }, /*#__PURE__*/React.createElement(LocationListingPanel, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-7"
  }, /*#__PURE__*/React.createElement(Map$2, null)))), /*#__PURE__*/React.createElement("div", {
    className: "modal-footer p-4"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Book appointment",
    style: {
      padding: '8px 60px'
    }
  }))))), /*#__PURE__*/React.createElement("iframe", {
    src: "http://sirkkahealth.com/doctor",
    title: "sirkka-bg",
    scrolling: "no",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
      border: 'none',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      filter: 'blur(5px) brightness(0.3)',
      transform: 'scale(1.01)'
    }
  }, "Your browser doesnt support iframes"));
}
LocationCard.propTypes = {
  LocationCardType: PropTypes.oneOf(['specialist', 'product']),
  id: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  tags: PropTypes.array
};
LocationCard.defaultProps = {
  LocationCardType: 'specialist',
  id: 'test',
  title: 'Colorectal surgeon',
  name: 'Dr James Kinross',
  tags: ['Bowel', 'Virtual', 'Face-to-face']
};

var css$g = ".loginCard_module_loginCard__2fb24234 {\n  position: relative;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.0196078431);\n  padding: 25px;\n  width: 100%;\n  padding-top: 60px;\n}\n.loginCard_module_loginCard__2fb24234 .loginCard_module_formGroup__2fb24234 {\n  max-width: 470px;\n  margin: auto;\n  margin-bottom: 30px;\n}\n.loginCard_module_loginCard__2fb24234 h6 {\n  margin-top: 30px;\n  margin-bottom: 14px;\n}\n.loginCard_module_loginCard__2fb24234 p {\n  color: #777;\n}\n.loginCard_module_loginCard__2fb24234 .loginCard_module_divider__2fb24234 {\n  position: relative;\n  padding: 20px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.loginCard_module_loginCard__2fb24234 .loginCard_module_divider__2fb24234:before {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 30%;\n  margin-right: 10px;\n}\n.loginCard_module_loginCard__2fb24234 .loginCard_module_divider__2fb24234:after {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 30%;\n  margin-left: 10px;\n}";
var modules_09021504 = {"loginCard":"loginCard_module_loginCard__2fb24234","formGroup":"loginCard_module_formGroup__2fb24234","divider":"loginCard_module_divider__2fb24234"};
n(css$g,{});

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var isCheckBoxInput = element => element.type === 'checkbox';
var isDateObject = value => value instanceof Date;
var isNullOrUndefined = value => value == null;
const isObjectType = value => typeof value === 'object';
var isObject = value => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = event => isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = name => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var isPlainObject = tempObject => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
  let copy;
  const isArray = Array.isArray(data);
  if (data instanceof Date) {
    copy = new Date(data);
  } else if (data instanceof Set) {
    copy = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
    copy = isArray ? [] : {};
    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy;
}
var compact = value => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = val => val === undefined;
var get = (object, path, defaultValue) => {
  if (!path || !isObject(object)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
  return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = value => typeof value === 'boolean';
var isKey = value => /^\w*$/.test(value);
var stringToPath = input => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var set = (object, path, value) => {
  let index = -1;
  const tempPath = isKey(path) ? [path] : stringToPath(path);
  const length = tempPath.length;
  const lastIndex = length - 1;
  while (++index < length) {
    const key = tempPath[index];
    let newValue = value;
    if (index !== lastIndex) {
      const objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }
    if (key === '__proto__') {
      return;
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
};
const EVENTS = {
  BLUR: 'blur',
  FOCUS_OUT: 'focusout',
  CHANGE: 'change'
};
const VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
const INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var getProxyFormState = function (formState, control, localProxyFormState) {
  let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = value => isObject(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const {
    name,
    ...formState
  } = formStateData;
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(key => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = value => Array.isArray(value) ? value : [value];
function useSubscribe(props) {
  const _props = React.useRef(props);
  _props.current = props;
  React.useEffect(() => {
    const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}
var isString = value => typeof value === 'string';
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map(fieldName => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? {
  ...errors[name],
  types: {
    ...(errors[name] && errors[name].types ? errors[name].types : {}),
    [type]: message || true
  }
} : {};
var getValidationModes = mode => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some(watchName => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get(fields, key);
    if (field) {
      const {
        _f,
        ...currentField
      } = field;
      if (_f) {
        if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
          break;
        } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
          break;
        } else {
          iterateFieldsByAction(currentField, action);
        }
      } else if (isObject(currentField)) {
        iterateFieldsByAction(currentField, action);
      }
    }
  }
};
var updateFieldArrayRootError = (errors, error, name) => {
  const fieldArrayErrors = compact(get(errors, name));
  set(fieldArrayErrors, 'root', error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};
var isFileInput = element => element.type === 'file';
var isFunction = value => typeof value === 'function';
var isHTMLElement = value => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = value => isString(value);
var isRadioInput = element => element.type === 'radio';
var isRegex = value => value instanceof RegExp;
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = {
  value: true,
  isValid: true
};
var getCheckboxValue = options => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter(option => option && option.checked && !option.disabled).map(option => option.value);
      return {
        value: values,
        isValid: !!values.length
      };
    }
    return options[0].checked && !options[0].disabled ?
    // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = options => Array.isArray(options) ? options.reduce((previous, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref) {
  let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : '',
      ref
    };
  }
}
var getValueAndMessage = validationData => isObject(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ''
};
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
  const {
    ref,
    refs,
    required,
    maxLength,
    minLength,
    min,
    max,
    pattern,
    validate,
    name,
    valueAsNumber,
    mount,
    disabled
  } = field._f;
  const inputValue = get(formValues, name);
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = message => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
      inputRef.reportValidity();
    }
  };
  const error = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox = isRadio || isCheckBox;
  const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
  const getMinMaxMessage = function (exceedMax, maxLengthMessage, minLengthMessage) {
    let maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
    let minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error[name] = {
      type: exceedMax ? maxType : minType,
      message,
      ref,
      ...appendErrorsCurry(exceedMax ? maxType : minType, message)
    };
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const {
      value,
      message
    } = isMessage(required) ? {
      value: !!required,
      message: required
    } : getValueAndMessage(required);
    if (value) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max);
    const minOutput = getValueAndMessage(min);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      const convertTimeToDate = time => new Date(new Date().toDateString() + ' ' + time);
      const isTime = ref.type == 'time';
      const isWeek = ref.type == 'week';
      if (isString(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if (pattern && !isEmpty && isString(inputValue)) {
    const {
      value: patternValue,
      message
    } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (validate) {
    if (isFunction(validate)) {
      const result = await validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error[name] = {
          ...validateError,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error;
        }
      }
    } else if (isObject(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
        if (validateError) {
          validationResult = {
            ...validateError,
            ...appendErrorsCurry(key, validateError.message)
          };
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error[name] = {
          ref: inputRef,
          ...validationResult
        };
        if (!validateAllFieldCriteria) {
          return error;
        }
      }
    }
  }
  setCustomValidity(true);
  return error;
};
function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index = 0;
  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path) {
  const paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index = paths.length - 1;
  const key = paths[index];
  if (childObject) {
    delete childObject[key];
  }
  if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var createSubject = () => {
  let _observers = [];
  const next = value => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = observer => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter(o => o !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next,
    subscribe,
    unsubscribe
  };
};
var isPrimitive = value => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== 'ref') {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var isMultipleSelect = element => element.type === "select-multiple";
var isRadioOrCheckbox = ref => isRadioInput(ref) || isCheckBoxInput(ref);
var live = ref => isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = data => {
  for (const key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data) {
  let fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : {
            ...markFieldsDirty(data[key])
          };
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value, _ref2) => {
  let {
    valueAsNumber,
    valueAsDate,
    setValueAs
  } = _ref2;
  return isUndefined(value) ? value : valueAsNumber ? value === '' ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
};
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every(ref => ref.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(_ref3 => {
      let {
        value
      } = _ref3;
      return value;
    });
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get(_fields, name);
    field && set(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var getRuleValue = rule => isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = options => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
  const error = get(errors, name);
  if (error || isKey(name)) {
    return {
      error,
      name
    };
  }
  const names = name.split('.');
  while (names.length) {
    const fieldName = names.join('.');
    const field = get(_fields, fieldName);
    const foundError = get(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return {
        name
      };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let _options = {
    ...defaultOptions,
    ...props
  };
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  let _fields = {};
  let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce = callback => wait => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
  const _updateValid = async shouldUpdateValid => {
    if (_proxyFormState.isValid || shouldUpdateValid) {
      const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
      if (isValid !== _formState.isValid) {
        _subjects.state.next({
          isValid
        });
      }
    }
  };
  const _updateIsValidating = (names, isValidating) => {
    if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
      (names || Array.from(_names.mount)).forEach(name => {
        if (name) {
          isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
        }
      });
      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject(_formState.validatingFields)
      });
    }
  };
  const _updateFieldArray = function (name) {
    let values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let method = arguments.length > 2 ? arguments[2] : undefined;
    let args = arguments.length > 3 ? arguments[3] : undefined;
    let shouldSetValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (args && method) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
        const fieldValues = method(get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
        const errors = method(get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
        const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };
  const updateErrors = (name, error) => {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const _setErrors = errors => {
    _formState.errors = errors;
    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get(_fields, name);
    if (field) {
      const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name
    };
    const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }
      const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
      isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
      isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }
    if (isBlurEvent) {
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }
    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name, isValid, error, fieldState) => {
    const previousFieldError = get(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
    if (props.delayError && error) {
      delayErrorCallback = debounce(() => updateErrors(name, error));
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      const updatedFormState = {
        ...fieldState,
        ...(shouldUpdateValid && isBoolean(isValid) ? {
          isValid
        } : {}),
        errors: _formState.errors,
        name
      };
      _formState = {
        ..._formState,
        ...updatedFormState
      };
      _subjects.state.next(updatedFormState);
    }
  };
  const _executeSchema = async name => {
    _updateIsValidating(name, true);
    const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    _updateIsValidating(name);
    return result;
  };
  const executeSchemaAndUpdateState = async names => {
    const {
      errors
    } = await _executeSchema(names);
    if (names) {
      for (const name of names) {
        const error = get(errors, name);
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuiltInValidation = async function (fields, shouldOnlyCheckValid) {
    let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      valid: true
    };
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const {
          _f,
          ...fieldValue
        } = field;
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          _updateIsValidating([name], true);
          const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          _updateIsValidating([name]);
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        fieldValue && (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get(_fields, name);
      field && (field._f.refs ? field._f.refs.every(ref => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = new Set();
  };
  const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
    ...(_state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
      [names]: defaultValue
    } : defaultValue)
  }, isGlobal, defaultValue);
  const _getFieldArray = name => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
  const setFieldValue = function (name, value) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const field = get(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? '' : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach(optionRef => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach(checkboxRef => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find(data => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach(radioRef => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = '';
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name,
              values: {
                ..._formValues
              }
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  const setValues = (name, value, options) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = "".concat(name, ".").concat(fieldKey);
      const field = get(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = function (name, value) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const field = get(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: {
          ..._formValues
        }
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next({
      ..._formState
    });
    _subjects.values.next({
      name: _state.mount ? name : undefined,
      values: {
        ..._formValues
      }
    });
  };
  const onChange = async event => {
    _state.mount = true;
    const target = event.target;
    let name = target.name;
    let isFieldValueUpdated = true;
    const field = get(_fields, name);
    const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
    const _updateIsFieldValueUpdated = fieldValue => {
      isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
    };
    if (field) {
      let error;
      let isValid;
      const fieldValue = getCurrentFieldValue();
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.values.next({
        name,
        type: event.type,
        values: {
          ..._formValues
        }
      });
      if (shouldSkipValidation) {
        _proxyFormState.isValid && _updateValid();
        return shouldRender && _subjects.state.next({
          name,
          ...(watched ? {} : fieldState)
        });
      }
      !isBlurEvent && watched && _subjects.state.next({
        ..._formState
      });
      if (_options.resolver) {
        const {
          errors
        } = await _executeSchema([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
          error = errorLookupResult.error;
          name = errorLookupResult.name;
          isValid = isEmptyObject(errors);
        }
      } else {
        _updateIsValidating([name], true);
        error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        _updateIsValidating([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          if (error) {
            isValid = false;
          } else if (_proxyFormState.isValid) {
            isValid = await executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid, error, fieldState);
      }
    }
  };
  const _focusInput = (ref, key) => {
    if (get(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }
    return;
  };
  const trigger = async function (name) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let isValid;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
      isValid = isEmptyObject(errors);
      validationResult = name ? !fieldNames.some(name => get(errors, name)) : isValid;
    } else if (name) {
      validationResult = (await Promise.all(fieldNames.map(async fieldName => {
        const field = get(_fields, fieldName);
        return await executeBuiltInValidation(field && field._f ? {
          [fieldName]: field
        } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid = await executeBuiltInValidation(_fields);
    }
    _subjects.state.next({
      ...(!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
        name
      }),
      ...(_options.resolver || !name ? {
        isValid
      } : {}),
      errors: _formState.errors
    });
    options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = fieldNames => {
    const values = {
      ...(_state.mount ? _formValues : _defaultValues)
    };
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map(name => get(values, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get((formState || _formState).errors, name),
    isDirty: !!get((formState || _formState).dirtyFields, name),
    isTouched: !!get((formState || _formState).touchedFields, name),
    isValidating: !!get((formState || _formState).validatingFields, name),
    error: get((formState || _formState).errors, name)
  });
  const clearErrors = name => {
    name && convertToArrayPayload(name).forEach(inputName => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  const setError = (name, error, options) => {
    const ref = (get(_fields, name, {
      _f: {}
    })._f || {}).ref;
    const currentError = get(_formState.errors, name) || {};
    // Don't override existing error messages elsewhere in the object tree.
    const {
      ref: currentRef,
      message,
      type,
      ...restOfErrorTree
    } = currentError;
    set(_formState.errors, name, {
      ...restOfErrorTree,
      ...error,
      ref
    });
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction(name) ? _subjects.values.subscribe({
    next: payload => name(_getWatch(undefined, defaultValue), payload)
  }) : _getWatch(name, defaultValue, true);
  const unregister = function (name) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.values.next({
      values: {
        ..._formValues
      }
    });
    _subjects.state.next({
      ..._formState,
      ...(!options.keepDirty ? {} : {
        isDirty: _getDirty()
      })
    });
    !options.keepIsValid && _updateValid();
  };
  const _updateDisabledField = _ref4 => {
    let {
      disabled,
      name,
      field,
      fields,
      value
    } = _ref4;
    if (isBoolean(disabled) && _state.mount || !!disabled) {
      const inputValue = disabled ? undefined : isUndefined(value) ? getFieldValue(field ? field._f : get(fields, name)._f) : value;
      set(_formValues, name, inputValue);
      updateTouchAndDirty(name, inputValue, false, false, true);
    }
  };
  const register = function (name) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let field = get(_fields, name);
    const disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, {
      ...(field || {}),
      _f: {
        ...(field && field._f ? field._f : {
          ref: {
            name
          }
        }),
        name,
        mount: true,
        ...options
      }
    });
    _names.mount.add(name);
    if (field) {
      _updateDisabledField({
        field,
        disabled: options.disabled,
        name,
        value: options.value
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return {
      ...(disabledIsDefined ? {
        disabled: options.disabled
      } : {}),
      ...(_options.progressive ? {
        required: !!options.required,
        min: getRuleValue(options.min),
        max: getRuleValue(options.max),
        minLength: getRuleValue(options.minLength),
        maxLength: getRuleValue(options.maxLength),
        pattern: getRuleValue(options.pattern)
      } : {}),
      name,
      onChange,
      onBlur: onChange,
      ref: ref => {
        if (ref) {
          register(name, options);
          field = get(_fields, name);
          const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find(option => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: {
              ...field._f,
              ...(radioOrCheckbox ? {
                refs: [...refs.filter(live), fieldRef, ...(Array.isArray(get(_defaultValues, name)) ? [{}] : [])],
                ref: {
                  type: fieldRef.type,
                  name
                }
              } : {
                ref: fieldRef
              })
            }
          });
          updateValidAndValue(name, false, undefined, fieldRef);
        } else {
          field = get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      }
    };
  };
  const _focusError = () => _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  const _disableForm = disabled => {
    if (isBoolean(disabled)) {
      _subjects.state.next({
        disabled
      });
      iterateFieldsByAction(_fields, (ref, name) => {
        const currentField = get(_fields, name);
        if (currentField) {
          ref.disabled = currentField._f.disabled || disabled;
          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach(inputRef => {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };
  const handleSubmit = (onValid, onInvalid) => async e => {
    let onValidError = undefined;
    if (e) {
      e.preventDefault && e.preventDefault();
      e.persist && e.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const {
        errors,
        values
      } = await _executeSchema();
      _formState.errors = errors;
      fieldValues = values;
    } else {
      await executeBuiltInValidation(_fields);
    }
    unset(_formState.errors, 'root');
    if (isEmptyObject(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      try {
        await onValid(fieldValues, e);
      } catch (error) {
        onValidError = error;
      }
    } else {
      if (onInvalid) {
        await onInvalid({
          ..._formState.errors
        }, e);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
    if (onValidError) {
      throw onValidError;
    }
  };
  const resetField = function (name) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, cloneObject(get(_defaultValues, name)));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, cloneObject(options.defaultValue));
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next({
        ..._formState
      });
    }
  };
  const _reset = function (formValues) {
    let keepStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const isEmptyResetValues = isEmptyObject(formValues);
    const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        for (const fieldName of _names.mount) {
          get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          for (const name of _names.mount) {
            const field = get(_fields, name);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement(fieldReference)) {
                const form = fieldReference.closest('form');
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        _fields = {};
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
      _subjects.array.next({
        values: {
          ...values
        }
      });
      _subjects.values.next({
        values: {
          ...values
        }
      });
    }
    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
      unMount: new Set(),
      array: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ''
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
    _state.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };
  const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = function (name) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const field = get(_fields, name);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };
  const _updateFormState = updatedFormState => {
    _formState = {
      ..._formState,
      ...updatedFormState
    };
  };
  const _resetDefaultValues = () => isFunction(_options.defaultValues) && _options.defaultValues().then(values => {
    reset(values, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  return {
    control: {
      register,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _updateDisabledField,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _updateFormState,
      _disableForm,
      _subjects,
      _proxyFormState,
      _setErrors,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = {
          ..._options,
          ...value
        };
      }
    },
    trigger,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _formControl = React.useRef();
  const _values = React.useRef();
  const [formState, updateFormState] = React.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: props.errors || {},
    disabled: props.disabled || false,
    defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
  });
  if (!_formControl.current) {
    _formControl.current = {
      ...createFormControl(props),
      formState
    };
  }
  const control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: value => {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
        updateFormState({
          ...control._formState
        });
      }
    }
  });
  React.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
  React.useEffect(() => {
    if (control._proxyFormState.isDirty) {
      const isDirty = control._getDirty();
      if (isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  React.useEffect(() => {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, control._options.resetOptions);
      _values.current = props.values;
      updateFormState(state => ({
        ...state
      }));
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  React.useEffect(() => {
    if (props.errors) {
      control._setErrors(props.errors);
    }
  }, [props.errors, control]);
  React.useEffect(() => {
    if (!control._state.mount) {
      control._updateValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next({
        ...control._formState
      });
    }
    control._removeUnmounted();
  });
  React.useEffect(() => {
    props.shouldUnregister && control._subjects.values.next({
      values: control._getWatch()
    });
  }, [props.shouldUnregister, control]);
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}

var css$f = ".loginBox_module_loginBox__8269844e {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n.loginBox_module_loginBox__8269844e form {\n  background: #fff;\n  border-radius: 20px;\n  max-width: 500px;\n  margin: auto;\n  width: 100%;\n}\n@media only screen and (min-width: 992px) and (max-width: 1200px) {\n  .loginBox_module_loginBox__8269844e form {\n    padding: 50px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .loginBox_module_loginBox__8269844e form {\n    padding: 40px;\n  }\n}\n@media (max-width: 767px) {\n  .loginBox_module_loginBox__8269844e form {\n    padding: 30px;\n  }\n}\n.loginBox_module_loginBox__8269844e form h3 {\n  font-size: 30px;\n}\n.loginBox_module_loginBox__8269844e form input:not(input[type=checkbox]),\n.loginBox_module_loginBox__8269844e form select {\n  width: 100%;\n  height: 60px;\n  border: 2px solid #eaedff;\n  border-radius: 12px;\n  color: #6f7172;\n  padding: 0 20px;\n  margin-bottom: 20px;\n}\n.loginBox_module_loginBox__8269844e form label {\n  color: #222;\n  display: block;\n}\n.loginBox_module_loginBox__8269844e form label span {\n  color: #fe4536;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_loginAction__8269844e {\n  display: flex;\n  justify-content: space-between;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_loginAction__8269844e input {\n  width: inherit;\n  height: auto;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_loginAction__8269844e label {\n  display: inline-block;\n  margin-left: 5px;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_orDivide__8269844e {\n  border-top: 2px solid #eaedff;\n  margin: 40px 0;\n  text-align: center;\n  position: relative;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_orDivide__8269844e span,\n.loginBox_module_loginBox__8269844e form .loginBox_module_orDivide__8269844e .loginBox_module_orLogin__8269844e span {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -9px;\n  background: #fff;\n  display: inline-block;\n  width: 40px;\n  margin: auto;\n  line-height: 1;\n  font-weight: 500;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_orDivide__8269844e .loginBox_module_orLogin__8269844e span {\n  width: 120px;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_forgotLogin__8269844e {\n  padding-bottom: 14px;\n  display: block;\n}\n@media (max-width: 767px) {\n  .loginBox_module_loginBox__8269844e form .loginBox_module_forgotLogin__8269844e {\n    float: none;\n  }\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_forgotLogin__8269844e span {\n  color: #0279a3;\n  cursor: pointer;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_forgotLogin__8269844e span :hover {\n  color: #41b7ea;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_logRem__8269844e {\n  display: flex;\n  gap: 6px;\n}\n@media (max-width: 767px) {\n  .loginBox_module_loginBox__8269844e form .loginBox_module_logRem__8269844e {\n    float: none;\n    margin-bottom: 10px;\n    display: block;\n  }\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_loginBtn__8269844e {\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_loginBtn__8269844e img {\n  width: 50px;\n  height: 50px;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e {\n  border: 3px solid #eaedff;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e .loginBox_module_memberLogin__8269844e {\n  display: flex;\n  justify-content: space-between;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e .loginBox_module_memberLogin__8269844e label {\n  padding-left: 0%;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e .loginBox_module_memberLogin__8269844e button {\n  flex: 1;\n  margin: 2em 0;\n  justify-content: center;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e .loginBox_module_memberLogin__8269844e input {\n  height: 60px;\n  border: 2px solid #eaedff;\n  color: #6f7172;\n  padding: 0 20px;\n  margin-bottom: 20px;\n}\n.loginBox_module_loginBox__8269844e form .loginBox_module_memberLoginContainer__8269844e .loginBox_module_labelInputWrapper__8269844e {\n  width: 49%;\n}";
var modules_600c15f9 = {"loginBox":"loginBox_module_loginBox__8269844e","loginAction":"loginBox_module_loginAction__8269844e","orDivide":"loginBox_module_orDivide__8269844e","orLogin":"loginBox_module_orLogin__8269844e","forgotLogin":"loginBox_module_forgotLogin__8269844e","logRem":"loginBox_module_logRem__8269844e","loginBtn":"loginBox_module_loginBtn__8269844e","memberLogin-container":"loginBox_module_memberLoginContainer__8269844e","memberLogin":"loginBox_module_memberLogin__8269844e","labelInputWrapper":"loginBox_module_labelInputWrapper__8269844e"};
n(css$f,{});

function LoginBox(_ref) {
  let {
    sendPasswordResetEmail,
    onSubmit
  } = _ref;
  const {
    register,
    handleSubmit,
    watch
  } = useForm();
  const [resetLogin, toggleResetLogin] = useState(false);
  const {
    setBookingStep
  } = useContext(BookingContext);
  const heading = resetLogin ? 'Reset your password' : 'Login	to continue';
  return /*#__PURE__*/React.createElement("div", {
    className: modules_600c15f9.loginBox
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      textAlign: 'center',
      marginBottom: '60px'
    }
  }, heading), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "name"
  }, "Email Address ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", _extends({}, register('email'), {
    required: true,
    id: "email",
    type: "text",
    placeholder: "Enter Email address..."
  })), !resetLogin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "pass"
  }, "Password ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", _extends({}, register('password'), {
    required: true,
    id: "pass",
    type: "password",
    placeholder: "Enter password..."
  }))), /*#__PURE__*/React.createElement("div", {
    className: modules_600c15f9.loginAction
  }, !resetLogin && /*#__PURE__*/React.createElement("span", {
    className: modules_600c15f9.logRem
  }, /*#__PURE__*/React.createElement("input", _extends({}, register('remember'), {
    id: "remember",
    type: "checkbox",
    style: {
      width: 'auto',
      height: '20px'
    }
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: "remember"
  }, "Remember me")), /*#__PURE__*/React.createElement("span", {
    className: modules_600c15f9.forgotLogin
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => toggleResetLogin(!resetLogin)
  }, "Lost your password?"))), !resetLogin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    label: "Login",
    variant: "primary",
    type: "submit",
    fullWidth: true,
    large: true
  }), /*#__PURE__*/React.createElement("div", {
    className: modules_600c15f9.orDivide
  }, /*#__PURE__*/React.createElement("span", null, "or")), /*#__PURE__*/React.createElement(Button, {
    label: "Register",
    variant: "secondary",
    onClick: () => {
      setBookingStep('register');
    },
    fullWidth: true,
    large: true
  })), resetLogin && /*#__PURE__*/React.createElement(Button, {
    label: "Send reset email",
    variant: "secondary",
    fullWidth: true,
    large: true,
    onClick: () => sendPasswordResetEmail(watch('email'))
  })));
}
LoginBox.propTypes = {
  sendPasswordResetEmail: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

var dist = {};

var PostcodeLookup = {};

var InputField = {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}
var lodash_uniqueid = uniqueId;

(function (exports) {

  function _typeof(a) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
      return typeof a;
    } : function (a) {
      return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, _typeof(a);
  }
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;
  var _react = _interopRequireWildcard(React),
    _propTypes = _interopRequireDefault(propTypesExports),
    _lodash = _interopRequireDefault(lodash_uniqueid);
  function _interopRequireDefault(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function _getRequireWildcardCache(a) {
    if ("function" != typeof WeakMap) return null;
    var b = new WeakMap(),
      c = new WeakMap();
    return (_getRequireWildcardCache = function (a) {
      return a ? c : b;
    })(a);
  }
  function _interopRequireWildcard(a, b) {
    if (!b && a && a.__esModule) return a;
    if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
      default: a
    };
    var c = _getRequireWildcardCache(b);
    if (c && c.has(a)) return c.get(a);
    var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
    return d.default = a, c && c.set(a, d), d;
  }
  function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(a, b) {
    for (var c, d = 0; d < b.length; d++) c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
  function _createClass(a, b, c) {
    return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), Object.defineProperty(a, "prototype", {
      writable: !1
    }), a;
  }
  function _inherits(a, b) {
    if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), b && _setPrototypeOf(a, b);
  }
  function _setPrototypeOf(a, b) {
    return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
      return a.__proto__ = b, a;
    }, _setPrototypeOf(a, b);
  }
  function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function () {
      var c,
        d = _getPrototypeOf(a);
      if (b) {
        var e = _getPrototypeOf(this).constructor;
        c = Reflect.construct(d, arguments, e);
      } else c = d.apply(this, arguments);
      return _possibleConstructorReturn(this, c);
    };
  }
  function _possibleConstructorReturn(a, b) {
    if (b && ("object" === _typeof(b) || "function" == typeof b)) return b;
    if (void 0 !== b) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(a);
  }
  function _assertThisInitialized(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }
  function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (a) {
      return !1;
    }
  }
  function _getPrototypeOf(a) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, _getPrototypeOf(a);
  }
  function _defineProperty(a, b, c) {
    return b in a ? Object.defineProperty(a, b, {
      value: c,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[b] = c, a;
  }
  var InputField = /*#__PURE__*/function (a) {
    function b() {
      var a;
      _classCallCheck(this, b);
      for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) e[f] = arguments[f];
      return a = c.call.apply(c, [this].concat(e)), _defineProperty(_assertThisInitialized(a), "state", {
        inputId: (0, _lodash.default)("react-address-lookup-id-")
      }), a;
    }
    _inherits(b, a);
    var c = _createSuper(b);
    return _createClass(b, [{
      key: "placeholder",
      value: function placeholder() {
        return !1 === this.props.placeholder ? "" : null == this.props.placeholder ? "e.g. NR14 7PZ" : this.props.placeholder;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
          className: "address-lookup-label",
          htmlFor: this.state.inputId
        }, this.props.labelText), /*#__PURE__*/_react.default.createElement("input", {
          className: "address-lookup-input",
          placeholder: this.placeholder(),
          onChange: this.props.updateInput,
          id: this.state.inputId
        }));
      }
    }]), b;
  }(_react.Component);
  exports.default = InputField, InputField.defaultProps = {
    labelText: "Search for your postcode"
  }, InputField.propTypes = {
    placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
  };
})(InputField);

var SearchButton = {};

(function (exports) {

  function _typeof(a) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
      return typeof a;
    } : function (a) {
      return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, _typeof(a);
  }
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;
  var _react = _interopRequireWildcard(React),
    _propTypes = _interopRequireDefault(propTypesExports);
  function _interopRequireDefault(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function _getRequireWildcardCache(a) {
    if ("function" != typeof WeakMap) return null;
    var b = new WeakMap(),
      c = new WeakMap();
    return (_getRequireWildcardCache = function (a) {
      return a ? c : b;
    })(a);
  }
  function _interopRequireWildcard(a, b) {
    if (!b && a && a.__esModule) return a;
    if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
      default: a
    };
    var c = _getRequireWildcardCache(b);
    if (c && c.has(a)) return c.get(a);
    var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
    return d.default = a, c && c.set(a, d), d;
  }
  function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(a, b) {
    for (var c, d = 0; d < b.length; d++) c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
  function _createClass(a, b, c) {
    return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), Object.defineProperty(a, "prototype", {
      writable: !1
    }), a;
  }
  function _inherits(a, b) {
    if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), b && _setPrototypeOf(a, b);
  }
  function _setPrototypeOf(a, b) {
    return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
      return a.__proto__ = b, a;
    }, _setPrototypeOf(a, b);
  }
  function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function () {
      var c,
        d = _getPrototypeOf(a);
      if (b) {
        var e = _getPrototypeOf(this).constructor;
        c = Reflect.construct(d, arguments, e);
      } else c = d.apply(this, arguments);
      return _possibleConstructorReturn(this, c);
    };
  }
  function _possibleConstructorReturn(a, b) {
    if (b && ("object" === _typeof(b) || "function" == typeof b)) return b;
    if (void 0 !== b) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(a);
  }
  function _assertThisInitialized(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }
  function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (a) {
      return !1;
    }
  }
  function _getPrototypeOf(a) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, _getPrototypeOf(a);
  }
  var SearchButton = /*#__PURE__*/function (a) {
    function b() {
      return _classCallCheck(this, b), c.apply(this, arguments);
    }
    _inherits(b, a);
    var c = _createSuper(b);
    return _createClass(b, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "address-lookup-search-button",
          type: "button",
          onClick: this.props.search
        }, "Search");
      }
    }]), b;
  }(_react.Component);
  exports.default = SearchButton, SearchButton.propTypes = {
    search: _propTypes.default.func.isRequired
  };
})(SearchButton);

var ResultsSelect = {};

(function (exports) {

  function _typeof(a) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
      return typeof a;
    } : function (a) {
      return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, _typeof(a);
  }
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;
  var _react = _interopRequireWildcard(React),
    _propTypes = _interopRequireDefault(propTypesExports);
  function _interopRequireDefault(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function _getRequireWildcardCache(a) {
    if ("function" != typeof WeakMap) return null;
    var b = new WeakMap(),
      c = new WeakMap();
    return (_getRequireWildcardCache = function (a) {
      return a ? c : b;
    })(a);
  }
  function _interopRequireWildcard(a, b) {
    if (!b && a && a.__esModule) return a;
    if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
      default: a
    };
    var c = _getRequireWildcardCache(b);
    if (c && c.has(a)) return c.get(a);
    var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
    return d.default = a, c && c.set(a, d), d;
  }
  function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(a, b) {
    for (var c, d = 0; d < b.length; d++) c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
  function _createClass(a, b, c) {
    return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), Object.defineProperty(a, "prototype", {
      writable: !1
    }), a;
  }
  function _inherits(a, b) {
    if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), b && _setPrototypeOf(a, b);
  }
  function _setPrototypeOf(a, b) {
    return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
      return a.__proto__ = b, a;
    }, _setPrototypeOf(a, b);
  }
  function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function () {
      var c,
        d = _getPrototypeOf(a);
      if (b) {
        var e = _getPrototypeOf(this).constructor;
        c = Reflect.construct(d, arguments, e);
      } else c = d.apply(this, arguments);
      return _possibleConstructorReturn(this, c);
    };
  }
  function _possibleConstructorReturn(a, b) {
    if (b && ("object" === _typeof(b) || "function" == typeof b)) return b;
    if (void 0 !== b) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(a);
  }
  function _assertThisInitialized(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }
  function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (a) {
      return !1;
    }
  }
  function _getPrototypeOf(a) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, _getPrototypeOf(a);
  }
  function _defineProperty(a, b, c) {
    return b in a ? Object.defineProperty(a, b, {
      value: c,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[b] = c, a;
  }
  var ResultsSelect = /*#__PURE__*/function (a) {
    function b() {
      var a;
      _classCallCheck(this, b);
      for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) e[f] = arguments[f];
      return a = c.call.apply(c, [this].concat(e)), _defineProperty(_assertThisInitialized(a), "handleSelect", function (b) {
        null != a.props.addressSelectedCallback && a.props.addressSelectedCallback(a.props.data[b.target.value]);
      }), a;
    }
    _inherits(b, a);
    var c = _createSuper(b);
    return _createClass(b, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("select", {
          className: "address-lookup-select",
          style: {
            display: "block"
          },
          onChange: this.handleSelect,
          defaultValue: "null"
        }, /*#__PURE__*/_react.default.createElement("option", {
          value: "null",
          disabled: !0
        }, "Select an address..."), this.props.data.map(function (a, b) {
          return /*#__PURE__*/_react.default.createElement("option", {
            className: "address-lookup-option",
            key: b,
            value: b
          }, a.summaryline);
        }));
      }
    }]), b;
  }(_react.Component);
  exports.default = ResultsSelect, ResultsSelect.propTypes = {
    data: _propTypes.default.array,
    addressSelectedCallback: _propTypes.default.func
  };
})(ResultsSelect);

(function (exports) {

  function _typeof(a) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
      return typeof a;
    } : function (a) {
      return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, _typeof(a);
  }
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;
  var _react = _interopRequireWildcard(React),
    _InputField = _interopRequireDefault(InputField),
    _SearchButton = _interopRequireDefault(SearchButton),
    _ResultsSelect = _interopRequireDefault(ResultsSelect),
    _propTypes = _interopRequireDefault(propTypesExports);
  function _interopRequireDefault(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function _getRequireWildcardCache(a) {
    if ("function" != typeof WeakMap) return null;
    var b = new WeakMap(),
      c = new WeakMap();
    return (_getRequireWildcardCache = function (a) {
      return a ? c : b;
    })(a);
  }
  function _interopRequireWildcard(a, b) {
    if (!b && a && a.__esModule) return a;
    if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
      default: a
    };
    var c = _getRequireWildcardCache(b);
    if (c && c.has(a)) return c.get(a);
    var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
    return d.default = a, c && c.set(a, d), d;
  }
  function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(a, b) {
    for (var c, d = 0; d < b.length; d++) c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
  function _createClass(a, b, c) {
    return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), Object.defineProperty(a, "prototype", {
      writable: !1
    }), a;
  }
  function _inherits(a, b) {
    if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), b && _setPrototypeOf(a, b);
  }
  function _setPrototypeOf(a, b) {
    return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
      return a.__proto__ = b, a;
    }, _setPrototypeOf(a, b);
  }
  function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function () {
      var c,
        d = _getPrototypeOf(a);
      if (b) {
        var e = _getPrototypeOf(this).constructor;
        c = Reflect.construct(d, arguments, e);
      } else c = d.apply(this, arguments);
      return _possibleConstructorReturn(this, c);
    };
  }
  function _possibleConstructorReturn(a, b) {
    if (b && ("object" === _typeof(b) || "function" == typeof b)) return b;
    if (void 0 !== b) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(a);
  }
  function _assertThisInitialized(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }
  function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (a) {
      return !1;
    }
  }
  function _getPrototypeOf(a) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, _getPrototypeOf(a);
  }
  function _defineProperty(a, b, c) {
    return b in a ? Object.defineProperty(a, b, {
      value: c,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[b] = c, a;
  }
  var PostcodeLookup = /*#__PURE__*/function (a) {
    function b() {
      var a;
      _classCallCheck(this, b);
      for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) e[f] = arguments[f];
      return a = c.call.apply(c, [this].concat(e)), _defineProperty(_assertThisInitialized(a), "state", {
        input: "",
        loading: !1,
        data: []
      }), _defineProperty(_assertThisInitialized(a), "updateInput", function (b) {
        a.setState({
          input: b.target.value
        });
      }), _defineProperty(_assertThisInitialized(a), "search", function () {
        var b = a.props,
          c = b.apiKey,
          d = b.identifier,
          e = b.country;
        e = "" === e ? "UK" : e, a.setState({
          loading: !0
        }), fetch("https://ws.postcoder.com/pcw/".concat(c, "/address/").concat(e, "/").concat(encodeURIComponent(a.state.input), "?format=json&lines=2&identifier=").concat(d)).then(function (a) {
          return a.json();
        }).then(function (b) {
          a.setState({
            data: b,
            loading: !1
          });
        }, function (b) {
          a.setState({
            loading: !1,
            error: b
          });
        });
      }), a;
    }
    _inherits(b, a);
    var c = _createSuper(b);
    return _createClass(b, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "address-lookup-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_InputField.default, {
          updateInput: this.updateInput,
          placeholder: this.props.placeholder,
          labelText: this.props.labelText
        }), /*#__PURE__*/_react.default.createElement(_SearchButton.default, {
          search: this.search
        }), this.state.loading ? /*#__PURE__*/_react.default.createElement("p", null, "Loading...") : "", 0 < this.state.data.length ? /*#__PURE__*/_react.default.createElement(_ResultsSelect.default, {
          data: this.state.data,
          addressSelectedCallback: this.props.addressSelectedCallback
        }) : "");
      }
    }]), b;
  }(_react.Component);
  exports.default = PostcodeLookup, PostcodeLookup.defaultProps = {
    apiKey: "PCW45-12345-12345-1234X",
    identifer: "react-address-lookup",
    country: "UK"
  }, PostcodeLookup.propTypes = {
    apiKey: _propTypes.default.string,
    placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
  };
})(PostcodeLookup);

var css$e = ".square {\r\n    background-color: dodgerblue;\r\n}";
n(css$e,{});

(function (exports) {

  var _propTypes = _interopRequireDefault(propTypesExports);
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = void 0;
  var _react = _interopRequireDefault(React),
    _PostcodeLookup = _interopRequireDefault(PostcodeLookup);
  function _interopRequireDefault(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  var Postcoder = function (a) {
    return /*#__PURE__*/_react.default.createElement(_PostcodeLookup.default, a);
  };
  Postcoder.propTypes = {
    placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
    apiKey: _propTypes.default.string.isRequired,
    addressSelectedCallback: _propTypes.default.func.isRequired,
    labelText: _propTypes.default.string,
    country: _propTypes.default.string
  };
  var _default = Postcoder;
  exports.default = _default;
})(dist);
var Postcoder = /*@__PURE__*/getDefaultExportFromCjs$1(dist);

var css$d = "@charset \"UTF-8\";\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition: background-color 600000s 0s, color 600000s 0s;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.registerForm_module_registerForm__71943199 {\n  position: relative;\n  max-width: 775px;\n  width: 100%;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.02);\n  padding: 25px;\n}\n\n.registerForm_module_idvWaiting__71943199 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n  max-width: 500px;\n  margin: auto;\n  padding: 25px;\n}\n.registerForm_module_idvWaiting__71943199 h1 {\n  font-size: 26px;\n  font-weight: 500;\n}\n.registerForm_module_idvWaiting__71943199 p {\n  width: 100%;\n}\n\n.registerForm_module_tabs__71943199 {\n  display: flex;\n  max-width: 470px;\n  margin: auto;\n  margin-bottom: 20px;\n}\n.registerForm_module_tabs__71943199 .registerForm_module_tab__71943199 {\n  flex: 1 1;\n  text-align: center;\n  padding: 10px;\n  font-weight: 500;\n  background-color: #fff;\n  border-radius: 3px 0 0 3px;\n  border: 1px solid #0279a3;\n}\n.registerForm_module_tabs__71943199 .registerForm_module_tab__71943199.registerForm_module_active__71943199 {\n  background-color: #0279a3;\n  color: #fff;\n}\n\nform .registerForm_module_errorBox__71943199 {\n  border: 2px solid red;\n  border-radius: 6px;\n  padding: 20px;\n  background: #fff6f8;\n  margin-bottom: 24px;\n}\nform .registerForm_module_errorBox__71943199 p:last-child {\n  margin-bottom: 0;\n}\nform .registerForm_module_errorBox__71943199 h3 {\n  color: #b00;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\nform .registerForm_module_errorBox__71943199 a {\n  color: #b00;\n  text-decoration: underline;\n}\nform .registerForm_module_formGroup__71943199 {\n  max-width: 470px;\n  margin: auto;\n  margin-bottom: 30px;\n}\nform .registerForm_module_formGroup__71943199 input:not([type=radio]):not([type=checkbox]),\nform .registerForm_module_formGroup__71943199 select {\n  border: 2px solid #eaedff;\n  border-radius: 12px;\n  color: #6f7172;\n  height: 60px;\n  padding: 0 20px;\n  width: 100%;\n  background: #fff;\n}\nform .registerForm_module_formGroup__71943199 label {\n  display: block;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_required__71943199 {\n  color: red;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_addressInput__71943199 {\n  flex: 1;\n  display: flex;\n  align-items: start;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_addressInput__71943199 input[type=text] {\n  flex: 1;\n  width: 100%;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_addressInput__71943199 button {\n  flex-shrink: 0;\n  background: #0279a3;\n  color: #fff;\n  border: none;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  transition: 0.3s;\n  padding: 0 26px;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_addressInput__71943199 button:hover {\n  background: #0c8dbb;\n}\nform .registerForm_module_formGroup__71943199 .registerForm_module_radioGroup__71943199 label {\n  display: inline;\n}\nform input[type=radio] {\n  opacity: 0;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n}\nform .registerForm_module_radioGroup__71943199 div {\n  position: relative;\n  display: inline-block;\n  margin-right: 20px;\n}\nform .registerForm_module_radioGroup__71943199 div label:before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: 8px;\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  border: 2px solid #eaeefe;\n  background-color: #ffffff;\n}\nform .registerForm_module_radioGroup__71943199 div input[type=radio]:checked + label:before {\n  content: \"✓\";\n  color: #ffffff;\n  background-color: #0279a3;\n  text-align: center;\n  line-height: 20px;\n  display: inline-block;\n  position: relative;\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  border: 2px solid #0279a3;\n  top: 0px;\n  margin-top: 8px;\n  margin-bottom: -3px;\n}\nform .registerForm_module_radioGroup__71943199 div label {\n  font-size: 14px;\n  font-weight: normal;\n  color: #737373;\n}\nform .registerForm_module_required__71943199 {\n  color: red;\n}";
var modules_a372c501 = {"registerForm":"registerForm_module_registerForm__71943199","idvWaiting":"registerForm_module_idvWaiting__71943199","tabs":"registerForm_module_tabs__71943199","tab":"registerForm_module_tab__71943199","active":"registerForm_module_active__71943199","errorBox":"registerForm_module_errorBox__71943199","formGroup":"registerForm_module_formGroup__71943199","required":"registerForm_module_required__71943199","addressInput":"registerForm_module_addressInput__71943199","radioGroup":"registerForm_module_radioGroup__71943199"};
n(css$d,{});

/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
function RegisterForm(_ref) {
  let {
    onRegister
  } = _ref;
  const [visibleAddress, setIsVisibleAddress] = useState(false);
  const [activeTab, setActiveTab] = useState('personal');
  const [formData, setFormData] = useState({
    nameTitle: '',
    firstName: '',
    lastName: '',
    gender: '',
    dob: '',
    phoneNumber: '',
    address: {
      address_line_1: '',
      address_line_2: '',
      city: '',
      postcode: '',
      country: ''
    },
    company: '',
    occupation: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const useAddress = _ref2 => {
    let {
      addressline1,
      addressline2,
      posttown,
      postcode,
      country
    } = _ref2;
    setFormData(prevFormData => ({
      ...prevFormData,
      address: {
        address_line_1: addressline1,
        address_line_2: addressline2 || '',
        city: posttown,
        postcode,
        country: country || 'United Kingdom'
      }
    }));
    setIsVisibleAddress(true);
  };
  const [formErrors, setFormErrors] = useState({});
  const handleInputChange = event => {
    const {
      name,
      value
    } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const config = window.envConfig;
  // const apiUrl = config.REACT_APP_API_URL || '/api';

  // const fullAPIURL = (endpoint) => apiUrl + endpoint;

  // const postRequest = async (url) => {
  // 	const fullUrl = fullAPIURL(url);

  // 	const result = await fetch(fullUrl, {
  // 		method: 'POST',
  // 		headers: { 'Content-Type': 'application/json' },
  // 		body: JSON.stringify(formData),
  // 	})
  // 		.then((response) =>
  // 			// if(response.ok)
  // 			response.json()
  // 		)
  // 		.catch((error) => {
  // 			// handle the error
  // 			console.log('Post error: ', error);
  // 			return error.message;
  // 		});

  // 	return result;
  // };
  // const createAccount = async (data) => postRequest('/auth/signup', data);

  // const onSubmit = async (data) => {
  // 	let errorMessage = null;

  // 	const response = await createAccount(data);
  // 	if (response.status === 'success') {
  // 		// Login redirect
  // 		loginAfterRegister({
  // 			email: formData.email,
  // 			password: formData.password,
  // 		});
  // 	}
  // 	errorMessage = response.message;

  // 	if (errorMessage) {
  // 		console.log('Submit error: ', errorMessage);
  // 	}
  // 	return false;
  // };

  const handleSubmit = event => {
    event.preventDefault();
    window.scrollTo(0, 0);

    // validate form values
    const errors = {};
    if (!formData.nameTitle) {
      errors.nameTitle = 'Please enter your title';
    }
    if (!formData.firstName) {
      errors.firstName = 'Please enter your first name';
    } else if (!/^[a-zA-Z\s-]+$/.test(formData.firstName)) {
      errors.firstName = 'First name can only contain letters, hyphens, and spaces';
    }
    if (!formData.lastName) {
      errors.lastName = 'Please enter your last name';
    } else if (!/^[a-zA-Z\s-]+$/.test(formData.lastName)) {
      errors.lastName = 'Last name can only contain letters, hyphens, and spaces';
    }
    if (!formData.email) {
      errors.email = 'Please enter your email address';
    }
    if (!formData.password) {
      errors.password = 'Please enter your password';
    }
    if (!formData.confirmPassword) {
      errors.confirmPassword = 'Please confirm your password';
    }
    if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }
    if (!formData.dob) {
      errors.dob = 'Please enter your date of birth';
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(formData.dob)) {
      errors.dob = 'Date of birth must be in the format of YYYY-MM-DD';
    }
    if (!formData.gender) {
      errors.gender = 'Please select a gender';
    }
    if (!formData.phoneNumber) {
      errors.phoneNumber = 'Please enter your phone number';
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      errors.phoneNumber = 'Phone number must contain only numbers';
    }
    if (!formData.address.address_line_1) {
      errors.address_line_1 = 'Please enter your address';
    }
    if (!formData.address.city) {
      errors.city = 'Please enter your city';
    }
    if (!formData.address.postcode) {
      errors.postcode = 'Please enter your postcode';
    }
    if (!formData.address.country) {
      errors.country = 'Please enter your country';
    }
    setFormErrors(errors);

    // submit form if no errors
    if (Object.keys(errors).length === 0) {
      if (activeTab === 'business') {
        formData.role = 'staff';
      }
      // Registering API call is handled from web-client and passed as prop
      onRegister(formData);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.registerForm
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-center mb-30"
  }, "Register"), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.tabs
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "tab ".concat(activeTab === 'personal' ? modules_a372c501.active : ''),
    onClick: () => setActiveTab('personal')
  }, "Personal"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "tab ".concat(activeTab === 'business' ? modules_a372c501.active : ''),
    onClick: () => setActiveTab('business')
  }, "Business")), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, Object.keys(formErrors).length !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.errorBox
  }, /*#__PURE__*/React.createElement("h3", null, "Please complete the missing fields below:"), Object.keys(formErrors).map(fieldName => {
    const errorMessage = formErrors[fieldName];
    if (errorMessage) {
      return /*#__PURE__*/React.createElement("p", {
        key: fieldName
      }, /*#__PURE__*/React.createElement("a", {
        href: "#".concat(fieldName)
      }, errorMessage));
    }
    return null;
  }))) : '', /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "nameTitle"
  }, "Title", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("select", {
    id: "nameTitle",
    name: "nameTitle",
    value: formData.nameTitle,
    onChange: handleInputChange
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, "Please select one"), /*#__PURE__*/React.createElement("option", {
    value: "Mr"
  }, "Mr"), /*#__PURE__*/React.createElement("option", {
    value: "Mrs"
  }, "Mrs"), /*#__PURE__*/React.createElement("option", {
    value: "Miss"
  }, "Miss"), /*#__PURE__*/React.createElement("option", {
    value: "Ms"
  }, "Ms"), /*#__PURE__*/React.createElement("option", {
    value: "Dr"
  }, "Dr"))), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "firstName"
  }, "First Name", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "firstName",
    name: "firstName",
    value: formData.firstName,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "lastName"
  }, "Last Name", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "lastName",
    name: "lastName",
    value: formData.lastName,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "gender"
  }, "Gender", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("select", {
    id: "gender",
    name: "gender",
    value: formData.gender,
    onChange: handleInputChange
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, "Please select one"), /*#__PURE__*/React.createElement("option", {
    value: "Male"
  }, "Male"), /*#__PURE__*/React.createElement("option", {
    value: "Female"
  }, "Female"), /*#__PURE__*/React.createElement("option", {
    value: "Other"
  }, "Other"))), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "dob"
  }, "Date of Birth", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*"), ":"), /*#__PURE__*/React.createElement("input", {
    type: "date",
    id: "dob",
    name: "dob",
    value: formData.dob,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "phoneNumber"
  }, "Phone Number", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "tel",
    id: "phoneNumber",
    name: "phoneNumber",
    value: formData.phoneNumber,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "address"
  }, "Address", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement(Postcoder, {
    apiKey: config.REACT_APP_POSTCODER,
    addressSelectedCallback: useAddress,
    labelText: "",
    placeholder: "Search your postcode"
  }), visibleAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "address_line_1",
    className: "mb-2"
  }, "Address line 1 ", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "address_line_1",
    name: "address_line_1",
    type: "text",
    value: formData.address.address_line_1,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "address_line_2",
    className: "mb-2"
  }, "Address line 2"), /*#__PURE__*/React.createElement("input", {
    id: "address_line_2",
    name: "address_line_2",
    type: "text",
    value: formData.address.address_line_2,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "city",
    className: "mb-2"
  }, "City ", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "city",
    name: "city",
    type: "text",
    value: formData.address.city,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "country",
    className: "mb-2"
  }, "Country ", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "country",
    name: "country",
    type: "text",
    value: formData.address.country,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postcode",
    className: "mb-2"
  }, "Postcode ", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postcode",
    name: "postcode",
    type: "text",
    value: formData.address.postcode,
    onChange: handleInputChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "company"
  }, "Company"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "company",
    name: "company",
    value: formData.company,
    onChange: handleInputChange
  })), activeTab === 'business' && /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "companyNumber"
  }, "Company Number", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "companyNumber",
    name: "companyNumber",
    value: formData.companyNumber || '',
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "occupation"
  }, "Occupation"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "occupation",
    name: "occupation",
    value: formData.occupation,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "email"
  }, "Email", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "email",
    name: "email",
    value: formData.email,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "password"
  }, "Password", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "password",
    id: "password",
    name: "password",
    value: formData.password,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "confirmPassword"
  }, "Confirm your password", /*#__PURE__*/React.createElement("span", {
    className: modules_a372c501.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "password",
    id: "confirmPassword",
    name: "confirmPassword",
    value: formData.confirmPassword,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a372c501.formGroup
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Create account",
    onClick: handleSubmit,
    variant: "primary",
    fullWidth: true,
    large: true
  }))));
}
RegisterForm.defaultProps = {
  onRegister: () => {}
};
RegisterForm.propTypes = {
  onRegister: PropTypes.func
};

/* eslint-disable jsx-a11y/label-has-associated-control */
function LoginCard(_ref) {
  let {
    sendPasswordResetEmail,
    onLogin,
    onRegister
  } = _ref;
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !showLogin && !showRegister && /*#__PURE__*/React.createElement("div", {
    className: modules_09021504.loginCard
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_09021504.formGroup
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Login",
    onClick: () => {
      setShowLogin(true);
    },
    fullWidth: true,
    large: true
  }), /*#__PURE__*/React.createElement("span", {
    className: modules_09021504.divider
  }, "or"), /*#__PURE__*/React.createElement(Button, {
    label: "Register",
    variant: "secondary",
    onClick: () => {
      setShowRegister(true);
    },
    fullWidth: true,
    large: true
  }), /*#__PURE__*/React.createElement("h6", null, "Why do we need this?"), /*#__PURE__*/React.createElement("p", null, "As a UK health provider we are required by law to hold some basic details about the patients we see. Please either login with an existing account or register for a new one. The registration process takes around 4 minutes to complete."))), showLogin && /*#__PURE__*/React.createElement(LoginBox, {
    sendPasswordResetEmail: sendPasswordResetEmail,
    onSubmit: onLogin
  }), showRegister && /*#__PURE__*/React.createElement(RegisterForm, {
    onRegister: onRegister
  }));
}
LoginCard.propTypes = {
  sendPasswordResetEmail: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired
};

var css$c = ".registerSuccess_module_registerSuccess__ae1e9cd0 {\n  position: relative;\n  max-width: 500px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.0196078431);\n  padding: 25px;\n}\n.registerSuccess_module_registerSuccess__ae1e9cd0 h4 {\n  margin-bottom: 14px;\n}\n.registerSuccess_module_registerSuccess__ae1e9cd0 p {\n  color: #777;\n  margin-bottom: 24px;\n}\n.registerSuccess_module_registerSuccess__ae1e9cd0 .registerSuccess_module_divider__ae1e9cd0 {\n  position: relative;\n  padding: 20px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.registerSuccess_module_registerSuccess__ae1e9cd0 .registerSuccess_module_divider__ae1e9cd0:before {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 30%;\n  margin-right: 10px;\n}\n.registerSuccess_module_registerSuccess__ae1e9cd0 .registerSuccess_module_divider__ae1e9cd0:after {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 30%;\n  margin-left: 10px;\n}";
var modules_37c36dc9 = {"registerSuccess":"registerSuccess_module_registerSuccess__ae1e9cd0","divider":"registerSuccess_module_divider__ae1e9cd0"};
n(css$c,{});

/* eslint-disable jsx-a11y/label-has-associated-control */
function RegisterSuccess() {
  return /*#__PURE__*/React.createElement("div", {
    className: modules_37c36dc9.registerSuccess
  }, /*#__PURE__*/React.createElement("h4", null, "You now have two options"), /*#__PURE__*/React.createElement("p", null, "Sirkka Health members receive a discounted price. This is screen showcases the benefits of a Sirkka Health membership and why a user should choose this over booking as a free user."), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Become a Sirkka Member",
    fullWidth: true,
    large: true
  }), /*#__PURE__*/React.createElement("span", {
    className: modules_37c36dc9.divider
  }, "or"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    label: "Continue as free user",
    fullWidth: true,
    large: true
  }));
}

var css$b = ".serviceCard_module_serviceCard__b4551e2c {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  transition: 0.3s;\n  margin: 0px 0 20px 0;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n  width: calc(33.3333% - 14px);\n}\n@media (max-width: 991px) {\n  .serviceCard_module_serviceCard__b4551e2c {\n    width: calc(50% - 14px);\n  }\n}\n@media (max-width: 575px) {\n  .serviceCard_module_serviceCard__b4551e2c {\n    width: 100%;\n  }\n}\n.serviceCard_module_serviceCard__b4551e2c .serviceCard_module_cardTop__b4551e2c {\n  display: flex;\n}\n.serviceCard_module_serviceCard__b4551e2c .serviceCard_module_cardTop__b4551e2c .serviceCard_module_name__b4551e2c {\n  margin-left: 16px;\n}\n.serviceCard_module_serviceCard__b4551e2c .serviceCard_module_cardTop__b4551e2c .serviceCard_module_name__b4551e2c h6 {\n  font-size: 18px;\n}\n.serviceCard_module_serviceCard__b4551e2c .serviceCard_module_cardTop__b4551e2c .serviceCard_module_avatar__b4551e2c {\n  border-radius: 50%;\n  margin: auto;\n  overflow: hidden;\n  width: 60px;\n  display: block;\n}\n.serviceCard_module_serviceCard__b4551e2c button {\n  margin-top: 20px;\n}\n.serviceCard_module_serviceCard__b4551e2c .serviceCard_module_tag__b4551e2c {\n  border: 1px solid black;\n  padding: 1px 6px;\n  border-radius: 6px;\n  margin: 12px 5px 12px 0;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 12px;\n}";
var modules_a944dd76 = {"serviceCard":"serviceCard_module_serviceCard__b4551e2c","cardTop":"serviceCard_module_cardTop__b4551e2c","name":"serviceCard_module_name__b4551e2c","avatar":"serviceCard_module_avatar__b4551e2c","tag":"serviceCard_module_tag__b4551e2c"};
n(css$b,{});

/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */

// import NoReferral from '../NoReferral';

function ServiceCard(_ref) {
  let {
    type,
    service,
    content,
    onModalOpen
  } = _ref;
  const {
    service_id,
    service_name,
    service_price
  } = service;
  const {
    service_icon,
    modal_overview
  } = content;
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => () => {
    document.body.style.overflow = '';
  }, []);
  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  return Boolean(type === 'service') && /*#__PURE__*/React.createElement("div", {
    className: modules_a944dd76.serviceCard,
    key: service_id
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_a944dd76.cardTop
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/img/icon/".concat(service_icon, ".png"),
    alt: service_name,
    className: modules_a944dd76.avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_a944dd76.name
  }, /*#__PURE__*/React.createElement("h6", null, service_name), service_price && /*#__PURE__*/React.createElement("h6", null, (service_price / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: '1'
    }
  }, isExpanded ? /*#__PURE__*/React.createElement("p", null, modal_overview, /*#__PURE__*/React.createElement("span", {
    onClick: toggleText,
    style: {
      cursor: 'pointer',
      textDecoration: 'underline',
      paddingLeft: '10px'
    }
  }, "Read less")) : /*#__PURE__*/React.createElement("p", null, modal_overview === null || modal_overview === void 0 ? void 0 : modal_overview.slice(0, 250), (modal_overview === null || modal_overview === void 0 ? void 0 : modal_overview.length) > 250 && /*#__PURE__*/React.createElement(React.Fragment, null, "...", /*#__PURE__*/React.createElement("span", {
    onClick: toggleText,
    style: {
      cursor: 'pointer',
      textDecoration: 'underline',
      paddingLeft: '10px'
    }
  }, "Read more")))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '12px'
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: () => onModalOpen(),
    variant: "primary",
    label: "View details",
    fullWidth: true
  }));
}
ServiceCard.propTypes = {
  type: PropTypes.oneOf(['specialist', 'service', 'nhs']).isRequired,
  service: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.arrayOf(PropTypes.string),
    attribution: PropTypes.string,
    credentials: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.arrayOf(PropTypes.string),
    acceptedPatientAge: PropTypes.arrayOf(PropTypes.number),
    profile: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    virtual: PropTypes.bool,
    physical: PropTypes.bool,
    availability: PropTypes.arrayOf(PropTypes.string),
    modal_overview: PropTypes.string,
    icon: PropTypes.string,
    price: PropTypes.number
  }).isRequired,
  onModalOpen: PropTypes.func
};
ServiceCard.defaultProps = {
  onModalOpen: null
};

var css$a = "@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap\");\n.timePicker_module_label__402ac67e {\n  display: block;\n  color: #333;\n  max-width: 528px;\n  margin: 0 auto 10px auto;\n  text-align: center;\n}\n\n.timePicker_module_timePicker__402ac67e {\n  border-radius: 10px;\n  padding: 30px;\n  background: #f3f3f3;\n  display: inline-block;\n}\n.timePicker_module_timePicker__402ac67e ul {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 540px;\n}\n.timePicker_module_timePicker__402ac67e ul li {\n  display: flex;\n  flex: 1 0 17%;\n}\n.timePicker_module_timePicker__402ac67e input[type=radio] {\n  display: none;\n}\n.timePicker_module_timePicker__402ac67e input[type=radio] + label {\n  cursor: pointer;\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n  border: 2px solid transparent;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  width: 100%;\n  margin: 5px;\n}\n@media screen and (max-width: 768px) {\n  .timePicker_module_timePicker__402ac67e input[type=radio] + label {\n    padding: 7px 31px;\n  }\n}\n.timePicker_module_timePicker__402ac67e input[type=radio]:checked + label {\n  border: 2px solid #0279a3;\n  background: #fff;\n}\n.timePicker_module_timePicker__402ac67e input[type=radio]:disabled + label {\n  background: #e4e4e4;\n}";
var modules_5d7857a8 = {"label":"timePicker_module_label__402ac67e","timePicker":"timePicker_module_timePicker__402ac67e"};
n(css$a,{});

function TimePicker(_ref) {
  let {
    name,
    selectedDate,
    onTimeChange,
    label,
    required,
    availabilityData,
    clearSelectedTime,
    setClearSelectedTime
  } = _ref;
  const visibleTimes = {
    morning: ['07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45'],
    afternoon: ['12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00'],
    evening: ['17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00']
  };
  const [visibleSegment, setVisibleSegment] = useState('morning');
  const [selectedTime, setSelectedTime] = useState('');
  const {
    businessOpen,
    availableTimeSlots
  } = availabilityData[selectedDate] || {};
  useEffect(() => {
    if (clearSelectedTime) {
      setSelectedTime('');
      setClearSelectedTime(false);
    }
  }, [clearSelectedTime, setClearSelectedTime]);

  // Determine which segments have available times
  const availableSegments = Object.keys(visibleTimes).filter(segment => visibleTimes[segment].some(time => availableTimeSlots && availableTimeSlots.includes(time)));
  const isFullyBooked = !availabilityData || !availableTimeSlots || availableSegments.length === 0;
  const handleSelectionChange = input => {
    setVisibleSegment(input.value);
  };
  const handleTimeSelection = event => {
    setSelectedTime(event.target.value);
    onTimeChange({
      name,
      value: event.target.value
    });
  };

  // Use a ref to track the previous selectedDate so we only reset when the date actually changes
  const prevSelectedDateRef = useRef(selectedDate);
  useEffect(() => {
    if (selectedDate !== prevSelectedDateRef.current) {
      // Selected date changed, reset the visibleSegment to the first available one
      if (!isFullyBooked && availableSegments.length > 0) {
        setVisibleSegment(availableSegments[0]);
      } else {
        setVisibleSegment('morning');
      }
      prevSelectedDateRef.current = selectedDate;
    }
  }, [selectedDate, availableSegments, isFullyBooked]);
  if (!availabilityData || !selectedDate) {
    return /*#__PURE__*/React.createElement("p", {
      style: {
        textAlign: 'center'
      }
    }, "Please select a date to view available time slots.");
  }
  return selectedDate ? /*#__PURE__*/React.createElement("div", {
    className: modules_5d7857a8.formGroup
  }, isFullyBooked ? /*#__PURE__*/React.createElement("p", {
    className: modules_5d7857a8.message
  }, "The date has been fully booked.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThreeRadioSelection, {
    name: "visibleTimes",
    options: availableSegments.map(segment => ({
      id: segment,
      label: segment.charAt(0).toUpperCase() + segment.slice(1)
    })),
    onSelectionChange: handleSelectionChange,
    selectedValue: visibleSegment // Use the controlled prop
  }), businessOpen ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: modules_5d7857a8.label,
    htmlFor: "appointmentTime"
  }, /*#__PURE__*/React.createElement("b", null, label), required && /*#__PURE__*/React.createElement("span", {
    className: modules_5d7857a8.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: modules_5d7857a8.timePicker
  }, /*#__PURE__*/React.createElement("ul", null, visibleTimes[visibleSegment].map(time => /*#__PURE__*/React.createElement("li", {
    key: time
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: time,
    id: time,
    value: time,
    checked: selectedTime === time,
    onChange: handleTimeSelection,
    disabled: !availableTimeSlots.includes(time)
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: time
  }, time)))))) : /*#__PURE__*/React.createElement("p", null, "There is no availability for the selected date. Please try another working day."))) : null;
}
TimePicker.propTypes = {
  name: PropTypes.string,
  selectedDate: PropTypes.string,
  availabilityData: PropTypes.shape({}),
  onTimeChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  clearSelectedTime: PropTypes.bool,
  setClearSelectedTime: PropTypes.func
};
TimePicker.defaultProps = {
  name: 'TimePicker',
  selectedDate: '2023-03-23',
  availabilityData: null,
  onTimeChange: null,
  label: 'Available times',
  required: false,
  clearSelectedTime: false,
  setClearSelectedTime: () => {}
};

var css$9 = ".CardList_module_serviceCards__5a8079b3 {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: baseline;\n  gap: 0 20px;\n}\n@media screen and (max-width: 768px) {\n  .CardList_module_serviceCards__5a8079b3 {\n    margin: 10px 0;\n  }\n}\n.CardList_module_serviceCards__5a8079b3 .CardList_module_serviceCard__5a8079b3 {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  transition: 0.3s;\n  margin: 0px 0 20px 0;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n  width: calc(33.3333% - 14px);\n}\n.CardList_module_serviceCards__5a8079b3 .CardList_module_serviceCard__5a8079b3 .CardList_module_cardTop__5a8079b3 {\n  display: flex;\n}\n.CardList_module_serviceCards__5a8079b3 .CardList_module_serviceCard__5a8079b3 .CardList_module_cardTop__5a8079b3 .CardList_module_name__5a8079b3 {\n  margin-left: 16px;\n}\n.CardList_module_serviceCards__5a8079b3 .CardList_module_serviceCard__5a8079b3 .CardList_module_cardTop__5a8079b3 .CardList_module_avatar__5a8079b3 {\n  border-radius: 50%;\n  height: 60px;\n  margin: auto;\n  overflow: hidden;\n  width: 60px;\n}\n.CardList_module_serviceCards__5a8079b3 .CardList_module_serviceCard__5a8079b3 .CardList_module_tag__5a8079b3 {\n  border: 1px solid black;\n  padding: 1px 6px;\n  border-radius: 6px;\n  margin: 20px 5px 20px 0;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.CardList_module_singleColumn__5a8079b3 {\n  display: block;\n  column-count: 2;\n  flex-basis: calc(100% - 20px);\n}\n@media (max-width: 992px) {\n  .CardList_module_singleColumn__5a8079b3 {\n    column-count: 1;\n  }\n}\n\n.CardList_module_modal__5a8079b3 {\n  display: none;\n  height: 80vh;\n  width: 80vw;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  padding: 1em;\n  background: #ddd;\n  border: 2px solid black;\n  z-index: 999;\n}\n.CardList_module_modal__5a8079b3:target {\n  display: block;\n}\n.CardList_module_modal__5a8079b3:target + .CardList_module_backdrop__5a8079b3 {\n  display: block;\n}\n.CardList_module_modal__5a8079b3 .CardList_module_avatar__5a8079b3 {\n  border-radius: 50%;\n  height: 60px;\n  margin: auto;\n  overflow: hidden;\n  width: 60px;\n}\n\n.CardList_module_backdrop__5a8079b3 {\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: black;\n  opacity: 0.5;\n  z-index: 998;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.CardList_module_filters__5a8079b3 {\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid rgba(203, 205, 215, 0.231372549);\n}\n\n.CardList_module_accordionContainer__5a8079b3 {\n  border-radius: 12px;\n  overflow: hidden;\n  max-width: 500px;\n  flex: 0 1 calc(30% - 20px);\n  margin: 10px 20px 10px 0;\n}\n\n.CardList_module_accordionHeader__5a8079b3 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  width: 100%;\n  background: #eaeef3;\n  padding: 18px 28px 20px 26px;\n}\n\n.CardList_module_chevron__5a8079b3 {\n  border: solid #333;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 5px;\n  transform: rotate(227deg);\n  transition: transform 0.3s ease;\n}\n\n.CardList_module_chevron__5a8079b3.CardList_module_expanded__5a8079b3 {\n  transform: rotate(45deg);\n}\n\n.CardList_module_filterItem__5a8079b3 {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 16px 26px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  background: #fff;\n  margin-bottom: 16px;\n  border: 1px solid rgba(203, 205, 215, 0.231372549);\n  border-top: 0;\n  border-bottom-right-radius: 12px;\n  border-bottom-left-radius: 12px;\n}\n.CardList_module_filterItem__5a8079b3 button {\n  padding: 1px 14px;\n  border: 2px solid #0279a3;\n  border-radius: 20px;\n  background: transparent;\n  font-size: 14px;\n}\n.CardList_module_filterItem__5a8079b3 button:hover {\n  background: #0279a3;\n  color: #fff;\n  transition: 0s;\n}\n.CardList_module_filterItem__5a8079b3 ul {\n  width: 100%;\n}\n.CardList_module_filterItem__5a8079b3 h5 {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n}\n\n.CardList_module_filterCategory__5a8079b3:first-child label {\n  border-top: none;\n}\n.CardList_module_filterCategory__5a8079b3 label {\n  width: 100%;\n  box-sizing: border-box;\n  border-top: 1px solid lightgray;\n  padding: 16px 26px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #000;\n}\n.CardList_module_filterCategory__5a8079b3 label:hover input[type=checkbox] ~ .CardList_module_checkmark__5a8079b3 {\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.CardList_module_filterCategory__5a8079b3 label input[type=checkbox]:checked ~ .CardList_module_checkmark__5a8079b3 {\n  background-color: #0279a3;\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.CardList_module_filterCategory__5a8079b3 .CardList_module_filterSubcategory__5a8079b3 {\n  color: #737373;\n  border: none;\n  padding: 2px 26px 10px 29px;\n  justify-content: flex-start;\n}\n.CardList_module_filterCategory__5a8079b3 .CardList_module_filterSubcategory__5a8079b3 input {\n  margin-right: 8px;\n}\n.CardList_module_filterCategory__5a8079b3 .CardList_module_filterSubcategory__5a8079b3:nth-child(2) {\n  padding-top: 0px;\n}\n.CardList_module_filterCategory__5a8079b3 .CardList_module_filterSubcategory__5a8079b3:last-child {\n  padding-bottom: 20px;\n}\n.CardList_module_filterCategory__5a8079b3 input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.CardList_module_filterCategory__5a8079b3 input:checked ~ .CardList_module_checkmark__5a8079b3:after {\n  display: block;\n}\n.CardList_module_filterCategory__5a8079b3 .CardList_module_checkmark__5a8079b3:after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.CardList_module_filter__5a8079b3 h5 {\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0;\n  line-height: normal;\n}\n\n#CardList_module_filtersHeader__5a8079b3 {\n  background: #4d9ec2;\n  color: #fff;\n  padding: 16px 0 16px 20px;\n  border-radius: 6px;\n}\n\n.CardList_module_filterSubcategory__5a8079b3 {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.CardList_module_filterSubcategory__5a8079b3 .CardList_module_description__5a8079b3 {\n  margin-left: 10px;\n  margin-top: 3px;\n}\n.CardList_module_filterSubcategory__5a8079b3 input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.CardList_module_filterSubcategory__5a8079b3 input:checked ~ .CardList_module_checkmark__5a8079b3 {\n  background-color: #0279a3;\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.CardList_module_filterSubcategory__5a8079b3 input:checked ~ .CardList_module_checkmark__5a8079b3:after {\n  display: block;\n}\n.CardList_module_filterSubcategory__5a8079b3:hover input ~ .CardList_module_checkmark__5a8079b3 {\n  box-shadow: 0px 0px 0px 2px #0279a3;\n}\n.CardList_module_filterSubcategory__5a8079b3 .CardList_module_checkmark__5a8079b3:after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.CardList_module_checkmark__5a8079b3 {\n  position: relative;\n  height: 17px;\n  width: 17px;\n  background-color: transparent;\n  border-radius: 3px;\n  box-shadow: 0px 0px 0px 2px #b0b0b0;\n  margin-top: 3px;\n}\n.CardList_module_checkmark__5a8079b3:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #002845;\n  font-family: Rubik, sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 0;\n  text-transform: normal;\n}\n\nbody {\n  background-color: #f6f7fb;\n  color: #000;\n  font-family: Rubik, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.CardList_module_mt1__5a8079b3 {\n  margin-top: 0.25rem !important;\n}\n\n.CardList_module_p0__5a8079b3 {\n  padding: 0 !important;\n}\n\n.CardList_module_accordion__5a8079b3 {\n  background-color: #eaeef4;\n  color: #444;\n  cursor: pointer;\n  padding: 18px;\n  width: 100%;\n  text-align: left;\n  border: none;\n  outline: none;\n  transition: 0.4s;\n  max-width: 500px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n}\n.CardList_module_accordion__5a8079b3:after {\n  content: \" \";\n  float: right;\n  border: solid #000000;\n  border-width: 0 3px 3px 0;\n  height: 9px;\n  transform: rotate(45deg);\n  width: 9px;\n  margin-right: 10px;\n}\n.CardList_module_accordion__5a8079b3:hover {\n  background-color: #eaeef4;\n}\n\n.CardList_module_active__5a8079b3 {\n  background-color: #eaeef4;\n}\n.CardList_module_active__5a8079b3:after {\n  transform: rotate(225deg);\n  margin-top: 6px;\n}\n\n.CardList_module_panel__5a8079b3 {\n  padding: 0 18px;\n  background-color: white;\n  overflow: hidden;\n  max-height: 1000px;\n  transition: max-height 0.2s ease-out;\n}";
var modules_6d7b8177 = {"serviceCards":"CardList_module_serviceCards__5a8079b3","serviceCard":"CardList_module_serviceCard__5a8079b3","cardTop":"CardList_module_cardTop__5a8079b3","name":"CardList_module_name__5a8079b3","avatar":"CardList_module_avatar__5a8079b3","tag":"CardList_module_tag__5a8079b3","singleColumn":"CardList_module_singleColumn__5a8079b3","modal":"CardList_module_modal__5a8079b3","backdrop":"CardList_module_backdrop__5a8079b3","filters":"CardList_module_filters__5a8079b3","accordionContainer":"CardList_module_accordionContainer__5a8079b3","accordionHeader":"CardList_module_accordionHeader__5a8079b3","chevron":"CardList_module_chevron__5a8079b3","expanded":"CardList_module_expanded__5a8079b3","filterItem":"CardList_module_filterItem__5a8079b3","filterCategory":"CardList_module_filterCategory__5a8079b3","checkmark":"CardList_module_checkmark__5a8079b3","filterSubcategory":"CardList_module_filterSubcategory__5a8079b3","filter":"CardList_module_filter__5a8079b3","filtersHeader":"CardList_module_filtersHeader__5a8079b3","description":"CardList_module_description__5a8079b3","mt1":"CardList_module_mt1__5a8079b3","p0":"CardList_module_p0__5a8079b3","accordion":"CardList_module_accordion__5a8079b3","active":"CardList_module_active__5a8079b3","panel":"CardList_module_panel__5a8079b3"};
n(css$9,{});

var css$8 = ".specialistCard_module_serviceCard__d3942437 {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  transition: 0.3s;\n  margin: 0px 0 20px 0;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n  width: calc(33.3333% - 14px);\n  flex-grow: 1;\n}\n@media (max-width: 991px) {\n  .specialistCard_module_serviceCard__d3942437 {\n    width: calc(50% - 14px);\n  }\n}\n@media (max-width: 575px) {\n  .specialistCard_module_serviceCard__d3942437 {\n    width: 100%;\n  }\n}\n.specialistCard_module_serviceCard__d3942437 .specialistCard_module_cardTop__d3942437 {\n  display: flex;\n}\n.specialistCard_module_serviceCard__d3942437 .specialistCard_module_cardTop__d3942437 .specialistCard_module_name__d3942437 {\n  margin-left: 16px;\n}\n.specialistCard_module_serviceCard__d3942437 .specialistCard_module_cardTop__d3942437 .specialistCard_module_name__d3942437 h6 {\n  font-size: 18px;\n}\n.specialistCard_module_serviceCard__d3942437 .specialistCard_module_cardTop__d3942437 .specialistCard_module_avatar__d3942437 {\n  border-radius: 50%;\n  margin: auto;\n  overflow: hidden;\n  width: 60px;\n  height: 60px;\n  display: block;\n  object-fit: cover;\n}\n.specialistCard_module_serviceCard__d3942437 button {\n  margin-top: 20px;\n}\n.specialistCard_module_serviceCard__d3942437 .specialistCard_module_tag__d3942437 {\n  border: 1px solid black;\n  padding: 1px 6px;\n  border-radius: 6px;\n  margin: 18px 5px 12px 0;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 12px;\n}";
var modules_71cb7f2c = {"serviceCard":"specialistCard_module_serviceCard__d3942437","cardTop":"specialistCard_module_cardTop__d3942437","name":"specialistCard_module_name__d3942437","avatar":"specialistCard_module_avatar__d3942437","tag":"specialistCard_module_tag__d3942437"};
n(css$8,{});

var css$7 = ".Modal_module_modal__dc95385e {\n  background: #fff;\n  border-radius: 12px;\n  z-index: 999;\n  max-width: 900px;\n  margin: 1.75rem;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  position: relative;\n  cursor: auto;\n}\n@media screen and (max-width: 768px) {\n  .Modal_module_modal__dc95385e {\n    margin: 15px;\n  }\n}\n.Modal_module_modal__dc95385e .Modal_module_modalInner__dc95385e {\n  position: relative;\n  padding: 30px;\n  text-align: center;\n}\n.Modal_module_modal__dc95385e:target {\n  display: block;\n}\n.Modal_module_modal__dc95385e:target + .Modal_module_backdrop__dc95385e {\n  display: block;\n}\n.Modal_module_modal__dc95385e .Modal_module_close__dc95385e {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: 99;\n  cursor: pointer;\n}\n.Modal_module_modal__dc95385e .Modal_module_avatar__dc95385e {\n  border-radius: 50%;\n  height: 140px;\n  margin: auto;\n  overflow: hidden;\n  width: 140px;\n  border: 5px solid rgba(0, 0, 0, 0.1215686275);\n  object-fit: cover;\n}\n.Modal_module_modal__dc95385e .Modal_module_next__dc95385e {\n  display: flex;\n  position: relative;\n  align-items: flex-end;\n  flex-direction: column;\n  margin-top: auto;\n  z-index: 1;\n}\n.Modal_module_modal__dc95385e .Modal_module_next__dc95385e .Modal_module_buttonLocationDropdown__dc95385e {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  z-index: -1;\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  width: 157px;\n  padding: 5px 5px 11px 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  text-align: left;\n  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.2901960784);\n  margin-bottom: -6px;\n  transform: translateY(10%);\n  opacity: 0;\n  transition: transform 0.1s ease-out, opacity 0.1s ease-out;\n}\n.Modal_module_modal__dc95385e .Modal_module_next__dc95385e .Modal_module_buttonLocationDropdown__dc95385e.Modal_module_show__dc95385e {\n  transform: translateY(0);\n  opacity: 1;\n}\n.Modal_module_modal__dc95385e .Modal_module_next__dc95385e .Modal_module_buttonLocationDropdown__dc95385e div {\n  padding: 5px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.Modal_module_modal__dc95385e .Modal_module_next__dc95385e .Modal_module_buttonLocationDropdown__dc95385e div:hover {\n  background: #e8eaf1;\n}\n.Modal_module_modal__dc95385e .Modal_module_serviceSummary__dc95385e {\n  display: flex;\n  text-align: left;\n}\n@media screen and (max-width: 768px) {\n  .Modal_module_modal__dc95385e .Modal_module_serviceSummary__dc95385e {\n    flex-direction: column;\n  }\n}\n.Modal_module_modal__dc95385e ul {\n  margin-bottom: 18px;\n}\n.Modal_module_modal__dc95385e ul li {\n  list-style: disc;\n  margin-left: 14px;\n}\n.Modal_module_modal__dc95385e p,\n.Modal_module_modal__dc95385e li {\n  font-size: 14px;\n}\n.Modal_module_modal__dc95385e .Modal_module_serviceDetails__dc95385e {\n  min-width: 340px;\n  background: #f3f3f3;\n  border-radius: 12px;\n  align-self: flex-start;\n  padding: 20px;\n  margin-right: 24px;\n  margin-bottom: 20px;\n}\n.Modal_module_modal__dc95385e .Modal_module_serviceDetails__dc95385e li {\n  list-style-type: none;\n}\n.Modal_module_modal__dc95385e .Modal_module_serviceDetails__dc95385e li:not(:last-child) {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.062745098);\n  margin-bottom: 10px;\n  padding-bottom: 16px;\n}\n.Modal_module_modal__dc95385e .Modal_module_serviceDetails__dc95385e span {\n  color: #fff;\n  background: #0279a3;\n  padding: 3px 8px;\n  border-radius: 5px;\n  font-size: 12px;\n}\n\n.Modal_module_backdrop__dc95385e {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6901960784);\n  z-index: 998;\n  cursor: pointer;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n  width: 100%;\n  height: 100%;\n}";
var modules_ef226cb7 = {"modal":"Modal_module_modal__dc95385e","modalInner":"Modal_module_modalInner__dc95385e","backdrop":"Modal_module_backdrop__dc95385e","close":"Modal_module_close__dc95385e","avatar":"Modal_module_avatar__dc95385e","next":"Modal_module_next__dc95385e","buttonLocationDropdown":"Modal_module_buttonLocationDropdown__dc95385e","show":"Modal_module_show__dc95385e","serviceSummary":"Modal_module_serviceSummary__dc95385e","serviceDetails":"Modal_module_serviceDetails__dc95385e"};
n(css$7,{});

var css$6 = ".addressLookupSearchButton {\n\tcolor: #fff;\n\tbackground-color: #0279a3;\n\tborder-color: #0279a3;\n\twidth: 20%;\n\theight: 60px;\n\tborder: 0;\n\tborder-top-right-radius: 12px;\n\tborder-bottom-right-radius: 12px;\n\tmargin: 0px !important;\n}\n\n.addressLookupInput {\n\theight: 60px;\n\tpadding: 0.375rem 0.75rem;\n\tline-height: 1.5;\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tcolor: #495057;\n\tbackground-clip: padding-box;\n\tborder: 1px solid #ced4da;\n\tborder-radius: 0.25rem;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\twidth: 80% !important;\n\tborder-top-right-radius: 0 !important;\n\tborder-bottom-right-radius: 0 !important;\n\tborder-right: 0 !important;\n\tborder: 2px solid #eaedff;\n\tborder-radius: 12px;\n\tcolor: #6f7172;\n\tpadding: 0 20px;\n\tbackground: #fff;\n}\n\n.addressLookupSelect {\n\theight: 45px;\n\tmargin-top: 10px;\n\twidth: 100%;\n\tpadding: 0.375rem 0.75rem;\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tcolor: #495057;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid #ced4da;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media only screen and (max-width: 399px) {\n\t.addressLookupSearchButton {\n\t\tmargin-top: 10px;\n\t}\n}";
n(css$6,{});

// Hook for geocoding a single postcode
const useGeocodeUserPostcode = async postcode => new Promise((resolve, reject) => {
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({
    address: postcode
  }, (results, status) => {
    if (status === 'OK') {
      const {
        location
      } = results[0].geometry;
      // TODO: Return user address with geocode
      resolve({
        latitude: location.lat(),
        longitude: location.lng()
      });
    } else {
      reject(new Error("Geocode was not successful for the following reason: ".concat(status)));
    }
  });
});

// Hook for fetching clinician data
const useCliniciansData = () => {
  const config = window.envConfig;
  const [clinicians, setClinicians] = useState([]);
  useEffect(() => {
    const fetchClinicianData = async () => {
      try {
        const response = await fetch("".concat(config.REACT_APP_API_URL, "/booking-users"));
        const data = await response.json();
        setClinicians(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching clinician data:', error);
      }
    };
    fetchClinicianData();
  }, []);
  return clinicians;
};

// Function for calculating distances
const calculateDistances = async (userPostcode, allClinicians) => {
  if (!window.google || !window.google.maps || !window.google.maps.DistanceMatrixService) {
    // Return clinicians as if Google Maps API is not available
    return allClinicians;
  }
  const service = new window.google.maps.DistanceMatrixService();
  const CHUNK_SIZE = 25;
  const destinations = allClinicians.clinicians.map(clinician => ({
    lat: Number(clinician.latitude),
    lng: Number(clinician.longitude)
  })).filter(clinician => !Number.isNaN(clinician.lat) && !Number.isNaN(clinician.lng));

  // Split destinations into batches
  const batches = [];
  for (let i = 0; i < destinations.length; i += CHUNK_SIZE) {
    batches.push(destinations.slice(i, i + CHUNK_SIZE));
  }
  const batchPromises = batches.map(batchDestinations => new Promise((resolve, reject) => {
    service.getDistanceMatrix({
      origins: [userPostcode],
      destinations: batchDestinations,
      travelMode: 'DRIVING'
    }, (response, status) => {
      if (status === 'OK') {
        resolve(response.rows[0].elements);
      } else {
        reject(new Error("Error with Distance Matrix Service: ".concat(status)));
      }
    });
  }));
  try {
    const allResults = await Promise.all(batchPromises);
    const flattenedResults = allResults.flat();

    // Merge distances back into clinicians data
    const sortedClinicians = allClinicians.clinicians.map((clinician, index) => {
      var _flattenedResults$ind, _flattenedResults$ind2;
      return {
        ...clinician,
        distance: ((_flattenedResults$ind = flattenedResults[index]) === null || _flattenedResults$ind === void 0 || (_flattenedResults$ind = _flattenedResults$ind.distance) === null || _flattenedResults$ind === void 0 ? void 0 : _flattenedResults$ind.value) || Infinity,
        distanceText: ((_flattenedResults$ind2 = flattenedResults[index]) === null || _flattenedResults$ind2 === void 0 || (_flattenedResults$ind2 = _flattenedResults$ind2.distance) === null || _flattenedResults$ind2 === void 0 ? void 0 : _flattenedResults$ind2.text) || '-'
      };
    }).sort((a, b) => a.distance - b.distance);
    return sortedClinicians;
  } catch (error) {
    console.error('An error occurred:', error);
    // Consider how to handle partial results here
    return [];
  }
};

// Helper function to calculate the next business day
const getNextBusinessDay = (date, daysToAdd) => {
  let count = 0;
  while (count < daysToAdd) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) {
      // Skip weekends
      count += 1;
    }
  }
  return date;
};

// Utility function for generating availability
const generateDateAvailability = async function (id) {
  let businessDaysFromToday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  const config = window.envConfig;
  let availabilityObject;
  const response = await fetch("".concat(config.REACT_APP_API_URL, "/bookings/availability/").concat(id));
  if (!response.ok) {
    // Manually generate date slots
    const manualGeneratedAvailability = {};
    const today = new Date();
    for (let i = businessDaysFromToday; i <= 32; i += 1) {
      const futureDate = getNextBusinessDay(new Date(today), i);
      const dateString = futureDate.toISOString().split('T')[0];
      manualGeneratedAvailability[dateString] = {
        businessOpen: true
      };
    }
    availabilityObject = manualGeneratedAvailability;
  } else {
    // Get available date slots from response
    const data = await response.json();
    availabilityObject = {
      ...data
    };
    const today = getNextBusinessDay(new Date(), businessDaysFromToday);
    today.setHours(0, 0, 0, 0);
    Object.keys(availabilityObject).forEach(key => {
      const dateFromKey = new Date(key);
      dateFromKey.setHours(0, 0, 0, 0);
      if (dateFromKey < today) {
        delete availabilityObject[key];
      } else {
        delete availabilityObject[key].availableTimeSlots;
      }
    });
  }
  return availabilityObject;
};

var img$1 = "data:image/svg+xml,%3csvg enable-background='new 0 0 512 512' viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='256' cy='256.167' fill='%2300b1ff' r='223.167'/%3e%3c/svg%3e";

async function fetchAvailableTimeSlots(userId) {
  const config = window.envConfig;
  try {
    const response = await fetch("".concat(config.REACT_APP_API_URL, "/bookings/availability/5/clinician/").concat(userId));
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching time slots:', error);
    return {};
  }
}

// eslint-disable-next-line no-unused-vars
function PostcodeAvailabilityMap(_ref) {
  var _allClinicians$clinic2;
  let {
    handleDateTimeLocationSelection,
    isStyledForForms
  } = _ref;
  const config = window.envConfig;
  const [sortedClinicians, setSortedClinicians] = useState([]);
  const [userPostcode, setUserPostcode] = useState('');
  const [userLatLong, setUserLatLong] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [lastRequestTime, setLastRequestTime] = useState(0);
  const [timeSlots, setTimeSlots] = useState({});
  const [availableDatesObject, setAvailableDatesObject] = useState(null);
  const allClinicians = useCliniciansData();
  const mapRef = useRef(null);
  useEffect(() => {
    var _allClinicians$clinic;
    function isValidLocation(lat, lng) {
      return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
    }
    if (mapRef.current && userLatLong && ((_allClinicians$clinic = allClinicians.clinicians) === null || _allClinicians$clinic === void 0 ? void 0 : _allClinicians$clinic.length) > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(userLatLong.latitude, userLatLong.longitude));
      allClinicians.clinicians.forEach(clinician => {
        if (isValidLocation(Number(clinician.latitude), Number(clinician.longitude))) {
          bounds.extend(new window.google.maps.LatLng(Number(clinician.latitude), Number(clinician.longitude)));
        }
      });
      mapRef.current.fitBounds(bounds);
      console.log('fitting bounds', bounds);
    }
  }, [userLatLong, allClinicians]);
  useEffect(() => {
    // Generate available date slots from API, else manually done
    const fetchDateSlots = async () => {
      const data = await generateDateAvailability(5);
      setAvailableDatesObject(data);
    };
    fetchDateSlots();
  }, []);
  const handleSearch = async () => {
    console.log('userPostcode:', userPostcode, 'allClinicians:', allClinicians);
    if (!userPostcode || allClinicians.length === 0) {
      setErrorMessage('Please ensure you have entered your postcode.');
      return;
    }
    const currentTime = new Date().getTime();
    if (currentTime - lastRequestTime < 10000) {
      // eslint-disable-next-line no-console
      console.log('Please wait 10 seconds before making another request.');
      return;
    }
    setLastRequestTime(currentTime);
    setErrorMessage('');
    try {
      // Calculate distance of user and clinicians
      const geocodedUserLocation = await useGeocodeUserPostcode(userPostcode);
      setUserLatLong(geocodedUserLocation);
      let sortedData = await calculateDistances(userPostcode, allClinicians);

      // SEAN: This excludes clinician booking user with user id of 342 (Andy wellbeing physiotherapy) - This is temporary until wellbeing teams bookings has its own table set up in DB - Note see also 342 filter in map markers below
      sortedData = sortedData.filter(clinician => clinician.user_id !== 342);

      // Extract only the top 3 results
      setSortedClinicians(sortedData.slice(0, 3));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in handleSearch:', error);
      setErrorMessage('An error occurred while searching for locations.');
    }
  };
  const handleTimeChange = (e, clinician) => {
    const selectedTime = e.target.value;
    handleDateTimeLocationSelection(selectedDate, selectedTime, userPostcode, clinician);
    console.log('test', e.target.value, selectedDate, selectedTime, userPostcode, clinician);
  };
  useEffect(() => {
    if (selectedDate && sortedClinicians.length > 0) {
      sortedClinicians.forEach(async clinician => {
        var _slotsData$selectedDa;
        const slotsData = await fetchAvailableTimeSlots(clinician.user_id);
        // Filter for the selected date
        const slotsForSelectedDate = ((_slotsData$selectedDa = slotsData[selectedDate.value]) === null || _slotsData$selectedDa === void 0 ? void 0 : _slotsData$selectedDa.availableTimeSlots) || [];
        setTimeSlots(prevSlots => ({
          ...prevSlots,
          [clinician.user_id]: slotsForSelectedDate
        }));
      });
    }
  }, [selectedDate, sortedClinicians]);
  const {
    isLoaded,
    loadError
  } = useLoadScript({
    googleMapsApiKey: config.REACT_APP_GOOGLE_DISTANCE_MATRIX_API_KEY
  });
  function renderTimeSlots(clinician) {
    const slots = timeSlots[clinician.user_id];
    if (!Array.isArray(slots) || slots.length === 0) {
      return /*#__PURE__*/React.createElement("p", null, "No availability");
    }
    return /*#__PURE__*/React.createElement("select", {
      className: "form-select",
      onChange: e => handleTimeChange(e, clinician)
    }, /*#__PURE__*/React.createElement("option", {
      value: "",
      disabled: true,
      selected: true,
      defaultValue: true
    }, "Please select a time"), slots.map(timeSlot => /*#__PURE__*/React.createElement("option", {
      key: timeSlot,
      value: timeSlot
    }, timeSlot)));
  }
  if (loadError) return /*#__PURE__*/React.createElement("div", null, "Error loading maps");
  if (!isLoaded) return /*#__PURE__*/React.createElement("div", null, "Loading Maps");
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: isStyledForForms ? 'col-12 px-0' : 'col-md-6 col-12'
  }, /*#__PURE__*/React.createElement("div", {
    className: isStyledForForms ? 'input-group mt-2 mb-3' : 'input-group mt-3 mb-3'
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: userPostcode,
    onChange: e => setUserPostcode(e.target.value),
    placeholder: "Enter your postcode",
    className: "addressLookupInput"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "addressLookupSearchButton",
    onClick: handleSearch
  }, "Search")), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger"
  }, errorMessage), /*#__PURE__*/React.createElement(GoogleMap, {
    onLoad: map => {
      mapRef.current = map;
    },
    mapContainerStyle: {
      width: '100%',
      height: isStyledForForms ? '300px' : '500px'
    },
    center: {
      lat: 51.5301,
      lng: -0.1239
    },
    zoom: 8,
    options: {
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true
    }
  }, allClinicians && ((_allClinicians$clinic2 = allClinicians.clinicians) === null || _allClinicians$clinic2 === void 0 ? void 0 : _allClinicians$clinic2.length) > 0 && allClinicians.clinicians.filter(clinician => clinician.user_id !== 342) // SEAN: This excludes clinician booking user with user id of 342 (Andy wellbeing physiotherapy) - This is temporary until wellbeing teams bookings has its own table set up in DB - Note see filter for 342 in handleSearch
  .map(clinician => clinician.latitude && clinician.longitude && /*#__PURE__*/React.createElement(Marker, {
    key: clinician.id,
    position: {
      lat: Number(clinician.latitude),
      lng: Number(clinician.longitude)
    },
    zIndex: 1
  })), userLatLong && /*#__PURE__*/React.createElement(Marker, {
    position: {
      lat: userLatLong.latitude,
      lng: userLatLong.longitude
    },
    icon: {
      url: img$1,
      scaledSize: new window.google.maps.Size(26, 26)
    },
    zIndex: 2
  }))), /*#__PURE__*/React.createElement("div", {
    className: isStyledForForms ? 'col-12 px-0' : 'col-md-6 col-12'
  }, sortedClinicians.length > 0 && availableDatesObject !== null && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, {
    name: "date",
    label: "Please select a date",
    onDateChange: setSelectedDate,
    availabilityData: availableDatesObject
  }), /*#__PURE__*/React.createElement("b", null, "Select a time"), sortedClinicians.map((clinician, index) => /*#__PURE__*/React.createElement("div", {
    key: clinician.user_id,
    style: {
      backgroundColor: '#f3f3f3',
      borderRadius: '12px',
      marginBottom: '10px',
      padding: '12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, "Option ", index + 1, " (", clinician.distanceText, " away)"), selectedDate && selectedDate.value ? renderTimeSlots(clinician) : /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, "Please select a date to show availability")))))));
}
PostcodeAvailabilityMap.propTypes = {
  handleDateTimeLocationSelection: PropTypes.func.isRequired,
  isStyledForForms: PropTypes.bool
};
PostcodeAvailabilityMap.defaultProps = {
  isStyledForForms: false
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
function ServiceModal(_ref) {
  let {
    service,
    category,
    availableLocations,
    content,
    onClose,
    onOpen,
    onGoToCart,
    referrerParam
  } = _ref;
  const [modalStep, setModalStep] = useState(1);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const config = window.envConfig;
  const [formData, setFormData] = useState({
    serviceId: '',
    bookingId: '',
    clinicianId: '',
    completed: false,
    virtualOrPhysical: '',
    appointmentLocation: '',
    appointmentFor: 'Myself',
    statement: '',
    appointmentDate: '',
    appointmentTime: '',
    combineBooking: '',
    title: '',
    firstName: '',
    lastName: '',
    gender: '',
    dateOfBirth: '',
    phoneNumber: '',
    address: '',
    company: '',
    occupation: '',
    termsconditions: ''
  });
  useState('');
  useState(false);
  const [selectedLocationCategoryId, setSelectedLocationCategoryId] = useState(null);
  const [serviceLocationData, setServiceLocationData] = useState(null);
  const context = useContext(BookingContext) || {};
  const {
    setBookingStep,
    bookingData,
    setBookingData
  } = context;
  const handleFormSubmit = id => {
    if (category.service_category === 6) {
      // If service_category_id is 6 (All Imaging products), redirect to contact page
      window.location.href = '/contact';
    }

    // Generate unique ID
    const bookingId = Date.now().toString();
    if (service.service_type === 'Postal' || serviceLocationData === 'Postal') {
      setBookingData([...bookingData, {
        booking: {
          bookingId,
          bookingName: '',
          bookingProduct: '',
          appointmentLocation: '',
          appointmentRegion: '',
          appointmentDate: '',
          appointmentTime: '',
          appointmentNotes: '',
          appointmentFor: '',
          virtualOrPhysical: formData.virtualOrPhysical,
          sampleConsent: formData.sampleConsent,
          termsconditions: formData.termsconditions,
          completed: formData.completed,
          referrer: referrerParam || ''
        },
        customer: {
          nameTitle: formData.title,
          firstName: formData.firstName,
          lastName: formData.lastName,
          gender: formData.gender,
          dateOfBirth: formData.dateOfBirth,
          phoneNumber: formData.phoneNumber,
          company: formData.company,
          occupation: formData.occupation,
          address_line_1: formData.address_line_1,
          address_line_2: formData.address_line_1,
          city: formData.city,
          postcode: formData.postcode,
          country: formData.country,
          address_type: 'home'
        },
        postal: {
          postageAddressLine1: formData.postageAddressLine1,
          postageAddressLine2: formData.postageAddressLine2,
          postageCity: formData.postageCity,
          postagePostcode: formData.postagePostcode,
          postageCountry: formData.postageCountry,
          postageSelection: 'yes'
        },
        service: {
          serviceName: service.service_name,
          serviceId: service.service_code,
          serviceType: service.service_type,
          emailTemplate: service.email_template,
          price: service.service_price,
          icon: content.service_icon,
          apptStackable: service.appt_stackable,
          apptDuration: service.appt_duration
        },
        combineBooking: ''
      }]);
      onGoToCart();
    }
    const {
      building_name: buildingName,
      street,
      city,
      postcode
    } = serviceLocationData;
    const regionId = id || serviceLocationData.location_category_id;
    if (service.questionnaire_link) {
      window.open(service.questionnaire_link, '_blank');
    } else {
      let appointmentAddress = null;
      // City is the indication of region. Address such as buildingName or street or postcode can be blank
      if (city) {
        appointmentAddress = [buildingName, street, city, postcode].filter(value => value !== null).join(', ');
      }
      setBookingData([...bookingData, {
        booking: {
          bookingId,
          bookingName: "".concat(formData.firstName, " ").concat(formData.lastName),
          bookingProduct: service.service_code,
          appointmentLocation: appointmentAddress || 'Virtual',
          appointmentRegion: city || 'Virtual',
          appointmentDate: formData.appointmentDate,
          appointmentTime: formData.appointmentTime,
          appointmentNotes: formData.appointmentNotes,
          appointmentFor: formData.appointmentFor,
          virtualOrPhysical: formData.virtualOrPhysical,
          sampleConsent: formData.sampleConsent,
          termsconditions: formData.termsconditions,
          completed: formData.completed,
          referrer: referrerParam || ''
        },
        customer: {
          nameTitle: formData.title,
          firstName: formData.firstName,
          lastName: formData.lastName,
          gender: formData.gender,
          dateOfBirth: formData.dateOfBirth,
          phoneNumber: formData.phoneNumber,
          company: formData.company,
          occupation: formData.occupation,
          address_line_1: formData.address_line_1,
          address_line_2: formData.address_line_1,
          city: formData.city,
          postcode: formData.postcode,
          country: formData.country,
          address_type: 'home'
        },
        postal: {
          postageAddressLine1: '',
          postageAddressLine2: '',
          postageCity: '',
          postagePostcode: '',
          postageCountry: '',
          postageSelection: 'no'
        },
        service: {
          serviceName: service.service_name,
          serviceId: service.service_code,
          serviceType: service.service_type,
          emailTemplate: service.email_template,
          regionId,
          price: service.service_price,
          icon: content.service_icon,
          apptStackable: service.appt_stackable,
          apptDuration: service.appt_duration
        },
        combineBooking: ''
      }]);
      onGoToCart();
    }
  };
  const handleClose = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  useEffect(() => {
    if (onOpen) {
      onOpen();
    }
  }, [onOpen]);
  function stringToArray(str) {
    try {
      if (!str || typeof str !== 'string') {
        return str;
      }
      const validJsonString = str.replace(/'/g, '"');
      const arr = JSON.parse(validJsonString);
      if (Array.isArray(arr)) {
        return arr;
      }
      throw new Error('The input string is not formatted as an array.');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error:', err.message);
      return [];
    }
  }
  const topDescriptionSanitized = stringToArray(content.top_description);
  const bulletsSanitized = content.bullets ? stringToArray(content.bullets) : [];
  const bottomDescriptionSanitized = content.bottom_description ? stringToArray(content.bottom_description) : [];
  service.questionnaire_link ? 'Open questionnaire' : 'Book service';
  const handleDropdownSelect = async function (locationCategory) {
    let locationCategoryId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (locationCategoryId === 5) {
      setModalStep(2);
      return;
    }
    if (locationCategory === 'Postal' && locationCategoryId === null) {
      setIsDropdownOpen(false);
      setServiceLocationData('Postal');
    } else {
      setSelectedLocationCategoryId(locationCategoryId);
      try {
        const response = await fetch("".concat(config.REACT_APP_API_URL, "/bookings/service?location=").concat(locationCategory, "&serviceId=").concat(service.service_id));
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const serviceData = await response.json();
        setIsDropdownOpen(false);
        setServiceLocationData(serviceData[0].location);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('There was a problem with the fetch operation:', error.message);
      }
    }
  };
  useEffect(() => {
    if (serviceLocationData) {
      handleFormSubmit(selectedLocationCategoryId);
    }
  }, [serviceLocationData]);
  const locationCategoryIds = {
    London: 1,
    Edinburgh: 2,
    Manchester: 3,
    'Home Visit': 5,
    Virtual: 6,
    Glasgow: 7,
    Cardiff: 9,
    Belfast: 10,
    Cambridge: 11
  };
  const handleDateTimeLocationSelection = useCallback((date, time, userPostcode, clinician) => {
    // Generate unique ID
    const bookingId = Date.now().toString();
    setBookingData([...bookingData, {
      booking: {
        bookingId,
        clinicianId: clinician.user_id,
        bookingName: "".concat(formData.firstName, " ").concat(formData.lastName),
        bookingProduct: service.service_code,
        appointmentLocation: userPostcode,
        appointmentRegion: 'Home visit',
        appointmentDate: date.value,
        appointmentTime: time,
        appointmentNotes: '',
        appointmentFor: '',
        virtualOrPhysical: formData.virtualOrPhysical,
        sampleConsent: formData.sampleConsent,
        termsconditions: formData.termsconditions,
        completed: formData.completed
      },
      clinician: {
        id: clinician.user_id,
        name: clinician.full_name ? clinician.full_name : clinician.display_name,
        email: clinician.username ? clinician.username : clinician.email
      },
      customer: {
        nameTitle: formData.title,
        firstName: formData.firstName,
        lastName: formData.lastName,
        gender: formData.gender,
        dateOfBirth: formData.dateOfBirth,
        phoneNumber: formData.phoneNumber,
        company: formData.company,
        occupation: formData.occupation,
        address_line_1: formData.address_line_1,
        address_line_2: formData.address_line_1,
        city: formData.city,
        postcode: formData.postcode,
        country: formData.country,
        address_type: 'home'
      },
      postal: {
        postageAddressLine1: formData.postageAddressLine1,
        postageAddressLine2: formData.postageAddressLine2,
        postageCity: formData.postageCity,
        postagePostcode: formData.postagePostcode,
        postageCountry: formData.postageCountry,
        postageSelection: 'yes'
      },
      service: {
        serviceName: service.service_name,
        serviceId: service.service_code,
        serviceType: service.service_type,
        emailTemplate: service.email_template,
        price: service.service_price,
        icon: content.service_icon,
        apptStackable: service.appt_stackable,
        apptDuration: service.appt_duration
      },
      combineBooking: ''
    }]);
    onGoToCart();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClose,
    className: modules_ef226cb7.backdrop
  }, /*#__PURE__*/React.createElement("div", {
    id: service.service_code,
    className: modules_ef226cb7.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.close,
    onClick: handleClose
  }, "X"), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.modalInner
  }, modalStep === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/img/icon/".concat(content.service_icon, ".png"),
    alt: service.service_name,
    className: modules_ef226cb7.avatar
  })), /*#__PURE__*/React.createElement("h1", null, service.service_name), service.service_price > 0 && /*#__PURE__*/React.createElement("h6", null, (service.service_price / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.serviceSummary
  }, /*#__PURE__*/React.createElement("div", null, topDescriptionSanitized && topDescriptionSanitized.length > 0 ? topDescriptionSanitized.map(descriptionItem => /*#__PURE__*/React.createElement("p", {
    key: descriptionItem
  }, descriptionItem)) : /*#__PURE__*/React.createElement("p", null, topDescriptionSanitized), bulletsSanitized && /*#__PURE__*/React.createElement("ul", null, bulletsSanitized.map(bullet => /*#__PURE__*/React.createElement("li", {
    key: bullet
  }, bullet))), bottomDescriptionSanitized && bottomDescriptionSanitized.map(descriptionItem => /*#__PURE__*/React.createElement("p", {
    key: descriptionItem
  }, descriptionItem)))), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.next
  }, service.service_bookable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setIsDropdownOpen(!isDropdownOpen),
    label: "Choose location  \u25BE"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(modules_ef226cb7.buttonLocationDropdown, " ").concat(isDropdownOpen ? modules_ef226cb7.show : '')
  }, service.service_type === 'Clinic' && availableLocations.map(location => /*#__PURE__*/React.createElement("div", {
    key: location,
    onClick: () => handleDropdownSelect(location, locationCategoryIds[location])
  }, location)), service.service_type === 'Postal' && /*#__PURE__*/React.createElement("div", {
    key: "Postal",
    onClick: () => handleDropdownSelect('Postal', null)
  }, "Postal"))), !service.service_bookable && /*#__PURE__*/React.createElement("a", {
    href: "/contact"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Contact us"
  })))), modalStep === 2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h3", null, "Enter appointment date and postcode")), /*#__PURE__*/React.createElement(PostcodeAvailabilityMap, {
    handleDateTimeLocationSelection: handleDateTimeLocationSelection
  })))));
}
ServiceModal.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.arrayOf(PropTypes.string),
    attribution: PropTypes.string,
    credentials: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.arrayOf(PropTypes.string),
    accepted_patient_age: PropTypes.arrayOf(PropTypes.string),
    profile: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    icon: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    virtual: PropTypes.bool,
    physical: PropTypes.bool,
    availability: PropTypes.arrayOf(PropTypes.string),
    first_description: PropTypes.string,
    bullets: PropTypes.arrayOf(PropTypes.string),
    description_continued: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.number
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func
};
ServiceModal.defaultProps = {
  onOpen: () => {}
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
function SpecialistModal(_ref) {
  let {
    specialist,
    onClose,
    membershipType,
    onGoToCart
  } = _ref;
  // Move the below to transformer in client side
  const {
    metadata
  } = specialist;
  const {
    user_id: id
  } = specialist;
  const {
    credentials: creds,
    profile,
    avatar,
    first_name,
    last_name,
    title,
    profile_description
  } = metadata;
  const credsSanitized = creds.replace(/'/g, '"');
  const credentials = JSON.parse(credsSanitized);
  const physical = metadata['face-to-face_appointments'];
  const virtual = metadata.virtual_appointments;
  const fullname = "".concat(first_name, " ").concat(last_name);
  const [modalStep, setModalStep] = useState(1);
  const [formData, setFormData] = useState({
    booking: {
      bookingId: '',
      doctorId: '',
      bookingName: '',
      bookingProduct: '',
      appointmentLocation: '',
      appointmentRegion: '',
      appointmentDate: '',
      appointmentTime: '',
      appointmentNotes: '',
      appointmentFor: 'Myself',
      virtualOrPhysical: '',
      sampleConsent: '',
      termsconditions: '',
      completed: ''
    },
    customer: {
      nameTitle: '',
      firstName: '',
      lastName: '',
      gender: '',
      dateOfBirth: '',
      phoneNumber: '',
      company: '',
      occupation: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      postcode: '',
      country: '',
      address_type: 'home'
    },
    postal: {
      postageAddressLine1: '',
      postageAddressLine2: '',
      postageCity: '',
      postagePostcode: '',
      postageCountry: '',
      postageSelection: 'no'
    },
    service: {
      serviceName: '',
      serviceId: '',
      serviceType: '',
      emailTemplate: '',
      regionId: '',
      price: '',
      icon: ''
    }
  });
  const [selectedDate, setSelectedDate] = useState('');
  const [clearSelectedTime, setClearSelectedTime] = useState(false);
  const context = useContext(BookingContext) || {};
  const {
    bookingData,
    setBookingData
  } = context;
  const [locations, setLocations] = useState([]);
  const {
    services
  } = useContext(BookingContext);
  useEffect(() => {
    const config = window.envConfig;
    fetch("".concat(config.REACT_APP_API_URL, "/bookings/location")).then(response => response.json()).then(data => {
      setLocations(data.slice(0, 3));
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error fetching location data: ', error);
    });
  }, []);
  const handleFormSubmit = () => {
    // Generate unique ID
    const bookingId = Date.now().toString();

    // if gp add product else go to contact page
    if (title === 'GP') {
      const gpService = services.find(item => item.service.service_id === 49); // Service ID for GP consultation
      setBookingData([...bookingData, {
        ...formData,
        booking: {
          ...formData.booking,
          bookingId,
          doctorId: id,
          bookingProduct: gpService.service.service_code,
          appointmentLocation: 'Virtual',
          appointmentRegion: gpService.location.location_category
        },
        service: {
          ...formData.service,
          serviceName: gpService.service.service_name,
          serviceId: gpService.service.service_id,
          serviceType: gpService.service.service_type,
          emailTemplate: gpService.service.email_template,
          regionId: gpService.location.location_category_id,
          price: gpService.service.service_price,
          icon: gpService.content.service_icon
        }
      }]);
      onGoToCart();
    }
  };
  const handleNextModalStep = () => {
    const nextStep = modalStep + 1;
    setModalStep(nextStep);
  };
  const handleClose = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const handleInputChange = input => {
    if (!input) {
      return false;
    }
    const {
      name,
      value,
      target
    } = input;
    if (target) {
      if (target.name === 'virtualOrPhysical') {
        setFormData({
          ...formData,
          appointmentFor: target
        });
      } else if (target.name === 'location') {
        setFormData({
          ...formData,
          selectedLocation: target
        });
      } else if (target.name === 'appointmentDate') {
        setSelectedDate(target);
        setFormData({
          ...formData,
          appointmentDate: target,
          appointmentTime: ''
        });
        setClearSelectedTime(true);
      } else {
        setFormData({
          ...formData,
          [target.name]: target.value
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
      if (name === 'appointmentDate') {
        setSelectedDate(value);
        setFormData({
          ...formData,
          appointmentDate: value,
          appointmentTime: ''
        });
        setClearSelectedTime(true);
      }
    }
    return true;
  };
  const renderBookingButton = () => {
    if (title === 'GP') {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: handleFormSubmit,
        label: "Book appointment"
      });
    }
    if (membershipType !== null) {
      return /*#__PURE__*/React.createElement("a", {
        href: "/contact"
      }, /*#__PURE__*/React.createElement(Button, {
        label: "Book appointment"
      }));
    }
    return /*#__PURE__*/React.createElement("a", {
      href: "/membership"
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Become a member"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClose,
    className: modules_ef226cb7.backdrop
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: modules_ef226cb7.modal
  }, /*#__PURE__*/React.createElement("a", {
    className: modules_ef226cb7.close,
    href: "#".concat(id),
    onClick: handleClose
  }, "X"), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.modalInner
  }, modalStep === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/img/doctor/".concat(avatar),
    alt: fullname,
    className: modules_ef226cb7.avatar
  })), /*#__PURE__*/React.createElement("h1", null, fullname), /*#__PURE__*/React.createElement("p", null, title), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.serviceSummary
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.serviceDetails
  }, /*#__PURE__*/React.createElement("ul", null, credentials && credentials.some(credential => credential.trim() !== '') && /*#__PURE__*/React.createElement("li", null, credentials.map(credential => credential.trim() !== '' && /*#__PURE__*/React.createElement("span", {
    key: credential
  }, credential))), virtual && /*#__PURE__*/React.createElement("li", null, "Virtual appointments accepted"), physical && /*#__PURE__*/React.createElement("li", null, "Face to face appointments accepted"))), /*#__PURE__*/React.createElement("div", null, profile_description)), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.next
  }, renderBookingButton())), modalStep === 2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement("h2", null, "Choose your appointment type"), /*#__PURE__*/React.createElement(TwoRadioSelection, {
    name: "virtualOrPhysical",
    firstOption: "Virtual appointment",
    firstOptionId: "virtual",
    secondOption: "In person appointment",
    secondOptionId: "physical",
    large: true,
    onSelectionChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.next
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => formData.virtualOrPhysical === 'virtual' ? setModalStep(4) : setModalStep(3),
    label: "Choose location",
    disabled: !formData.virtualOrPhysical
  }))), modalStep === 3 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "Choose your location"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '0 0 auto',
      width: '41.66666667%'
    }
  }, /*#__PURE__*/React.createElement(LocationListingPanel, {
    locations: locations,
    onLocationChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '0 0 auto',
      width: '58.33333333%'
    }
  }, /*#__PURE__*/React.createElement(Map$2, {
    locations: locations
  })))), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.next
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleNextModalStep,
    label: "Choose availability",
    disabled: !formData.appointmentLocation
  }))), modalStep === 4 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "Choose your date and time"), /*#__PURE__*/React.createElement(DatePicker, {
    name: "appointmentDate",
    onDateChange: handleInputChange,
    label: "Choose a date and time"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimePicker, {
    name: "appointmentTime",
    onTimeChange: handleInputChange,
    label: "Available times",
    selectedDate: selectedDate,
    clearSelectedTime: clearSelectedTime,
    setClearSelectedTime: setClearSelectedTime
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_ef226cb7.next
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleFormSubmit,
    label: "Continue",
    disabled: !formData.appointmentTime
  }))))));
}
SpecialistModal.propTypes = {
  specialist: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.arrayOf(PropTypes.string),
    attribution: PropTypes.string,
    credentials: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.arrayOf(PropTypes.string),
    accepted_patient_age: PropTypes.arrayOf(PropTypes.string),
    profile: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    icon: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    virtual: PropTypes.bool,
    physical: PropTypes.bool,
    availability: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.string,
    description_continued: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.number
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
function SpecialistCard(_ref) {
  let {
    specialist,
    onModalOpen,
    onModalClose,
    membershipType,
    onGoToCart
  } = _ref;
  const {
    user_id,
    metadata
  } = specialist;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  metadata['face-to-face_appointments'];
  const {
    personal_title: personalTitle,
    first_name,
    last_name,
    title,
    profile_description,
    virtual_appointments,
    credentials,
    avatar
  } = metadata;
  const name = "".concat(first_name, " ").concat(last_name);
  const tagsSanitized = specialist.metadata.tags.replace(/'/g, '"');
  const tags = JSON.parse(tagsSanitized);
  useContext(BookingContext) || {};
  const handleModalOpen = () => {
    setIsModalOpen(true);
    if (onModalOpen) {
      onModalOpen();
    }
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    if (onModalClose) {
      onModalClose();
    }
  };
  const updateBodyOverflow = isOpen => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };
  useEffect(() => {
    updateBodyOverflow(isModalOpen);
  }, [isModalOpen]);
  useEffect(() => () => {
    document.body.style.overflow = '';
  }, []);
  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: modules_71cb7f2c.serviceCard,
    key: user_id
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_71cb7f2c.cardTop
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/img/doctor/".concat(avatar),
    alt: name,
    className: modules_71cb7f2c.avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_71cb7f2c.name
  }, /*#__PURE__*/React.createElement("h6", null, personalTitle, name), /*#__PURE__*/React.createElement("h6", null, title))), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: '1'
    }
  }, tags && /*#__PURE__*/React.createElement("li", null, tags.map(tag => /*#__PURE__*/React.createElement("span", {
    className: modules_71cb7f2c.tag,
    key: tag
  }, tag))), Boolean(specialist.tags) && specialist.tags.map(tag => /*#__PURE__*/React.createElement("span", {
    key: tag,
    className: modules_71cb7f2c.tag
  }, tag)), isExpanded ? /*#__PURE__*/React.createElement("p", null, profile_description, /*#__PURE__*/React.createElement("span", {
    onClick: toggleText,
    style: {
      cursor: 'pointer',
      textDecoration: 'underline',
      paddingLeft: '10px'
    }
  }, "Read less")) : /*#__PURE__*/React.createElement("p", null, profile_description === null || profile_description === void 0 ? void 0 : profile_description.slice(0, 150), (profile_description === null || profile_description === void 0 ? void 0 : profile_description.length) > 150 && /*#__PURE__*/React.createElement(React.Fragment, null, "...", /*#__PURE__*/React.createElement("span", {
    onClick: toggleText,
    style: {
      cursor: 'pointer',
      textDecoration: 'underline',
      paddingLeft: '10px'
    }
  }, "Read more")))), /*#__PURE__*/React.createElement(Button, {
    onClick: handleModalOpen,
    variant: "primary",
    label: "View details",
    fullWidth: true
  }), isModalOpen && /*#__PURE__*/React.createElement(SpecialistModal, {
    type: "specialist",
    specialist: specialist,
    onClose: handleModalClose,
    membershipType: membershipType,
    onGoToCart: onGoToCart
  }));
}
SpecialistCard.propTypes = {
  specialist: PropTypes.shape({
    type: PropTypes.oneOf(['specialist', 'service']),
    id: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.arrayOf(PropTypes.string),
    attribution: PropTypes.string,
    credentials: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.arrayOf(PropTypes.string),
    acceptedPatientAge: PropTypes.arrayOf(PropTypes.number),
    profile: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    virtual: PropTypes.bool,
    physical: PropTypes.bool,
    availability: PropTypes.arrayOf(PropTypes.string),
    overview_text: PropTypes.string,
    icon: PropTypes.string,
    price: PropTypes.number
  }).isRequired,
  membershipType: PropTypes.string
};
SpecialistCard.defaultProps = {
  membershipType: null
};

function CardList(_ref) {
  let {
    type,
    data,
    onModalOpen,
    onSpecialistModalOpen,
    onSpecialistModalClose,
    userHasChosenLocation,
    onGoToCart,
    membershipType,
    referrerParam
  } = _ref;
  const context = useContext(BookingContext) || {};
  const {
    selectedServiceCategories,
    selectedSpecialistCategories
  } = context;
  const [singleColumn, setSingleColumn] = useState(false);
  useEffect(() => {
    if (selectedServiceCategories.length > 0 && selectedSpecialistCategories.length === 0) {
      setSingleColumn(true);
    } else if (selectedServiceCategories.length === 0 && selectedSpecialistCategories.length > 0) {
      setSingleColumn(true);
    } else {
      setSingleColumn(false);
    }
  }, [selectedServiceCategories, selectedSpecialistCategories]);

  // Sort the incoming data array by display_order (ascending order)
  const sortedData = [...data].sort((a, b) => a.display_order - b.display_order);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, data.length > 0 && /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "".concat(modules_6d7b8177.serviceCards, " ").concat(singleColumn ? modules_6d7b8177.singleColumn : '')
    }, Boolean(type === 'serviceAndSpecialistItem') && sortedData.filter(item => !item.service ||
    // Item is a specialist
    item.service && item.service.service_code !== 'gpConsultation' // Item is a service but not 'gpConsultation'
    ).map(item => item.service ? /*#__PURE__*/React.createElement(ServiceCard, {
      key: item.service.service_id,
      type: "service",
      service: item.service,
      content: item.content,
      onModalOpen: () => onModalOpen(item.service)
    }) : /*#__PURE__*/React.createElement(SpecialistCard, {
      key: "".concat(item.user_id, "a"),
      specialist: item,
      userHasChosenLocation: userHasChosenLocation,
      onModalOpen: () => onSpecialistModalOpen(item.user_id),
      onModalClose: () => onSpecialistModalClose(item.user_id),
      onGoToCart: onGoToCart,
      membershipType: membershipType,
      referrerParam: referrerParam
    }))))
  );
}
CardList.propTypes = {
  type: PropTypes.oneOf(['service', 'specialist', 'serviceAndSpecialistItem']).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    service_id: PropTypes.number
  }).isRequired).isRequired,
  onModalOpen: PropTypes.func,
  onSpecialistModalOpen: PropTypes.func,
  onSpecialistModalClose: PropTypes.func,
  userHasChosenLocation: PropTypes.bool,
  onGoToCart: PropTypes.func.isRequired,
  membershipType: PropTypes.string,
  referrerParam: PropTypes.string
};
CardList.defaultProps = {
  onModalOpen: null,
  userHasChosenLocation: false,
  onSpecialistModalOpen: null,
  onSpecialistModalClose: null,
  membershipType: null,
  referrerParam: null
};

var css$5 = ".order-summary {\n  position: relative;\n  max-width: 1000px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.0196078431);\n  width: 100%;\n  margin: auto;\n}\n.order-summary h2 {\n  padding: 25px 25px 0 25px;\n}\n.order-summary li {\n  border-bottom: 1px solid #e4e4e4;\n  display: flex;\n  align-items: center;\n  padding: 16px 25px;\n  flex-wrap: wrap;\n  position: relative;\n}\n.order-summary li .price {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  padding: 0 12px;\n  margin-left: auto;\n  text-align: right;\n  flex-direction: column;\n}\n.order-summary li .remove {\n  margin-left: 12px;\n}\n.order-summary li .status {\n  margin-left: 0px;\n  margin-right: auto;\n}\n.order-summary li .success {\n  margin-left: 10px;\n  background: #ecf6e4;\n  padding: 2px 8px;\n  border-radius: 5px;\n  color: #4a8540;\n  font-weight: normal;\n  font-size: 12px;\n}\n.order-summary li .completed-info {\n  width: 100%;\n  background: #f6f6f6;\n  margin-top: 20px;\n  padding: 16px;\n  border-radius: 12px;\n  max-width: 530px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-left: 48px;\n}\n@media screen and (max-width: 768px) {\n  .order-summary li .completed-info {\n    margin-left: 0px;\n  }\n}\n.order-summary li .completed-info .col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n.order-summary li .completed-info .col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n.order-summary li .completed-info .info-item {\n  min-height: 68px;\n}\n.order-summary li .completed-info .info-item h6 {\n  font-weight: normal;\n  color: #000;\n  font-size: 14px;\n}\n.order-summary li .completed-info .info-item p {\n  padding: 0;\n  font-weight: 600;\n}\n.order-summary li img {\n  max-width: 42px;\n  border-radius: 42px;\n}\n@media only screen and (max-width: 768px) {\n  .order-summary li {\n    padding: 10px 22px 22px;\n  }\n  .order-summary li button {\n    width: 100%;\n    margin-top: 10px;\n  }\n  .order-summary li .remove {\n    margin-top: 0;\n    position: absolute;\n    top: 6px;\n    right: 5px;\n    width: 30px;\n  }\n}\n.order-summary button {\n  background: none;\n  border: none;\n}\n.order-summary .name {\n  flex-grow: 0;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n.order-summary .totalButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n@media (max-width: 768px) {\n  .order-summary .totalButtons {\n    width: 100%;\n  }\n}\n.order-summary .total {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  font-weight: 600;\n  justify-content: space-between;\n  height: 100%;\n  padding: 25px;\n  gap: 20px;\n}\n.order-summary .total .btn-primary {\n  margin-top: 24px;\n}\n.order-summary .total .amount {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  margin-right: 28px;\n  gap: 12px;\n}\n@media screen and (max-width: 768px) {\n  .order-summary .total .amount {\n    width: 100%;\n    margin-right: 0;\n  }\n}\n.order-summary .total .amount .priceContainer {\n  display: flex;\n  flex-direction: column;\n  max-width: 136px;\n  width: 100%;\n  gap: 5px;\n}\n.order-summary .total .amount .priceContainer .discount {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  padding: 0;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 14px;\n}\n.order-summary .total .amount .priceContainer .price {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  padding: 0;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 16px;\n}\n.order-summary .total .amount .priceContainer .price span {\n  color: #000;\n  margin: 0;\n}\n.order-summary .total .amount a {\n  text-decoration: underline;\n  font-weight: normal;\n  margin-right: 10px;\n  position: relative;\n  bottom: 2px;\n}\n.order-summary .remove-confirmation ~ .cart-summary-inner {\n  filter: blur(3px);\n  transition: 0.1s;\n}\n.order-summary .remove-confirmation {\n  box-shadow: 0px 6px 60px 20px rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  padding: 12px;\n  max-width: 600px !important;\n  position: fixed !important;\n  background: #fff;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 999 !important;\n}\n.order-summary .remove-confirmation h3 {\n  font-size: 20px;\n  padding: 10px;\n}\n.order-summary .remove-confirmation p {\n  font-weight: 600;\n  padding: 0 10px;\n}\n.order-summary .remove-confirmation .buttons {\n  display: flex !important;\n  float: right;\n  gap: 10px !important;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3607843137);\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: default;\n}\n.modalOverlay .modal {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  position: relative;\n  cursor: default;\n  display: block;\n  width: auto;\n  height: auto;\n}\n.modalOverlay .modal button {\n  cursor: pointer;\n  margin: 20px 0 0 0;\n}\n.modalOverlay .modal label {\n  display: block;\n}\n.modalOverlay .modal input[type=text] {\n  background: #ffffff;\n  border: 2px solid #eaedff;\n  border-radius: 8px;\n  height: 45px;\n  padding: 0 0 0 10px;\n  width: 100%;\n}\n.modalOverlay .modal .closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n.modalOverlay .modal .error {\n  color: red;\n  margin-top: 10px;\n}";
n(css$5,{});

var img = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect y='0.707107' width='1' height='18' transform='rotate(-45 0 0.707107)' fill='black'/%3e%3crect x='0.707031' y='13.4351' width='1' height='18' transform='rotate(-135 0.707031 13.4351)' fill='black'/%3e%3c/svg%3e";

var css$4 = ".discount-calculator {\n  padding: 20px;\n  border-radius: 12px;\n  width: 400px;\n  background: #fff;\n  position: absolute;\n  z-index: 999;\n  right: 0;\n  margin-top: 54px;\n}\n.discount-calculator:before {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 12px;\n  border-style: solid;\n  border-color: transparent transparent #fff transparent;\n}\n.discount-calculator input[type=text] {\n  border: 2px solid #eaedff;\n  border-radius: 6px;\n  color: #6f7172;\n  min-height: 40px;\n  padding: 0 20px;\n  width: 100%;\n  background: #fff;\n}\n.discount-calculator input[type=range] {\n  height: 27px;\n  -webkit-appearance: none;\n  margin: 10px 0;\n  width: 100%;\n}\n.discount-calculator input[type=range]:focus {\n  outline: none;\n}\n.discount-calculator input[type=range]:focus::-webkit-slider-runnable-track {\n  background: #0279a3;\n}\n.discount-calculator input[type=range]:focus::-ms-fill-lower {\n  background: #0279a3;\n}\n.discount-calculator input[type=range]:focus::-ms-fill-upper {\n  background: #0279a3;\n}\n.discount-calculator input[type=range]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0px 0px 0px #000000;\n  background: #0279a3;\n  border-radius: 1px;\n  border: 0px solid #000000;\n}\n.discount-calculator input[type=range]::-webkit-slider-thumb {\n  box-shadow: 1px 1px 3px #0c314a;\n  border: 2px solid #0279a3;\n  height: 18px;\n  width: 18px;\n  border-radius: 25px;\n  background: #ffffff;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -7.5px;\n}\n.discount-calculator label {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.discount-calculator h6 {\n  font-size: 14px;\n}\n.discount-calculator h6.money-off {\n  text-align: center;\n  font-weight: normal;\n}\n.discount-calculator p {\n  margin: 0;\n  font-weight: normal;\n}\n.discount-calculator .divider {\n  position: relative;\n  padding: 20px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.discount-calculator .divider:before {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 20%;\n  margin-right: 10px;\n}\n.discount-calculator .divider:after {\n  content: \" \";\n  background: #dedede;\n  height: 1px;\n  width: 20%;\n  margin-left: 10px;\n}\n\n.modal-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3607843137);\n  z-index: 100;\n}";
n(css$4,{});

/* eslint-disable no-alert */
function DiscountCalculator(_ref) {
  let {
    redeemablePoints,
    onModalVisibility,
    discountCode,
    setDiscountCode
  } = _ref;
  const {
    setBenefitPointsToUse
  } = useContext(BookingContext);
  const [sliderValue, setSliderValue] = useState(0);
  const handleModalVisibility = () => {
    onModalVisibility(true);
  };
  const handleModalKeyDown = event => {
    if (event.keyCode === 27) {
      onModalVisibility(false);
    }
  };
  const handleDiscountCodeChange = e => {
    setDiscountCode(e.target.value.toUpperCase());
    setSliderValue(0);
  };
  const handleSliderChange = e => {
    setSliderValue(parseInt(e.target.value, 10));
    setDiscountCode('');
  };

  // applyDiscount - either send discount code or points to the parent component if points are more than 0
  const applyDiscount = () => {
    if (discountCode) {
      setDiscountCode(discountCode);
      setBenefitPointsToUse(0);
      onModalVisibility(false);
    } else {
      setBenefitPointsToUse(sliderValue);
      onModalVisibility(false);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "discount-calculator"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "discount-code"
  }, "Enter discount code:", /*#__PURE__*/React.createElement("input", {
    id: "discount-code",
    type: "text",
    value: discountCode,
    onChange: handleDiscountCodeChange
  })), /*#__PURE__*/React.createElement("span", {
    className: "divider"
  }, "or"), /*#__PURE__*/React.createElement("h6", null, "Redeem points"), /*#__PURE__*/React.createElement("label", {
    htmlFor: "points-slider"
  }, /*#__PURE__*/React.createElement("p", null, "You have ", redeemablePoints, " points"), /*#__PURE__*/React.createElement("p", null, "Redeem ", sliderValue, " points"), /*#__PURE__*/React.createElement("input", {
    id: "points-slider",
    type: "range",
    min: "0",
    max: redeemablePoints,
    step: "150",
    value: sliderValue,
    onChange: handleSliderChange
  })), /*#__PURE__*/React.createElement("h6", {
    className: "money-off"
  }, "\xA3", sliderValue / 15, " off"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Redeem",
    fullWidth: true,
    large: true,
    onClick: applyDiscount
  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-background",
    onClick: () => handleModalVisibility(),
    onKeyDown: handleModalKeyDown,
    role: "presentation"
  }));
}
DiscountCalculator.propTypes = {
  redeemablePoints: PropTypes.number,
  onModalVisibility: PropTypes.func,
  discountCode: PropTypes.string,
  setDiscountCode: PropTypes.func
};
DiscountCalculator.defaultProps = {
  redeemablePoints: 0,
  onModalVisibility: false,
  discountCode: '',
  setDiscountCode: () => {}
};

const processDiscountCode = (data, bookingData, bookingDataTotal, noDiscountServices) => {
  let totalDiscountAmount = 0;
  let discountMessage = '';
  if (data.discount_status === false) {
    discountMessage = "Discount code '".concat(data.discount_code, "' is not active");
  } else if (data.expiration_date && new Date(data.expiration_date) < new Date()) {
    discountMessage = "Discount code '".concat(data.discount_code, "' has expired");
  } else if (data.service_code != null) {
    const specificServiceItem = bookingData.find(item => item.service.serviceId === data.service_code);
    if (specificServiceItem && !noDiscountServices.includes(specificServiceItem.service.serviceId)) {
      totalDiscountAmount = specificServiceItem.service.price * data.discount_rate / 100;
      discountMessage = "".concat(data.discount_rate, "% discount '").concat(data.discount_code, "' for ").concat(data.service_name, " applied successfully");
    } else {
      discountMessage = "Discount code '".concat(data.discount_code, "' found but ").concat(data.service_name, " isn't in your cart");
    }
  } else if (data.cart_value !== null && bookingDataTotal !== null && data.cart_value > bookingDataTotal) {
    discountMessage = "Discount code '".concat(data.discount_code, "' is not valid. You need to spend more than \xA3").concat(data.cart_value / 100, " to apply this discount code.");
  } else {
    totalDiscountAmount += bookingData.reduce((discountSoFar, item) => noDiscountServices.includes(item.service.serviceId) ? discountSoFar : discountSoFar + item.service.price * data.discount_rate / 100, 0);
    discountMessage = "".concat(data.discount_rate, "% discount '").concat(data.discount_code, "' applied successfully");
  }
  return {
    totalDiscountAmount,
    discountMessage
  };
};

/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
function GiftcardModal(_ref) {
  let {
    isOpen,
    onClose,
    children
  } = _ref;
  if (!isOpen) return null;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", {
      className: "modalOverlay",
      onClick: onClose,
      role: "button",
      tabIndex: 0,
      onKeyDown: event => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClose();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal",
      onClick: event => event.stopPropagation(),
      onKeyDown: event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopPropagation();
        }
      },
      role: "button",
      tabIndex: 0
    }, children))
  );
}

// eslint-disable-next-line no-unused-vars
function OrderSummary(_ref2) {
  let {
    membershipData,
    onNextStep,
    onPrevStep,
    onEditBooking
  } = _ref2;
  const {
    bookingData,
    setBookingData,
    setCurrentBookingId,
    discountCodeResponse,
    setDiscountCodeResponse,
    benefitPointsToUse,
    bookingDataTotal,
    setBookingDataTotal,
    bookingDataTotalDiscount,
    setBookingDataTotalDiscount
  } = useContext(BookingContext);
  const [bookingIdToRemove, setBookingIdToRemove] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingNameToRemove, setBookingNameToRemove] = useState(null);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [discountCode, setDiscountCode] = useState(discountCodeResponse ? discountCodeResponse.discount_code : '');
  const [discountMessage, setDiscountMessage] = useState(null);
  const [points, setPoints] = useState(0);
  const [subtotal, setSubtotal] = useState(bookingData.reduce((subtotalSoFar, item) => subtotalSoFar + item.service.price, 0));
  const [allBookingsCompleted, setAllBookingsCompleted] = useState(false);
  const [isGiftcardModalOpen, setIsGiftcardModalOpen] = useState(false);
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [giftCardError, setGiftCardError] = useState('');
  const [giftCardLoading, setGiftCardLoading] = useState(false);
  const config = window.envConfig;
  const handleGiftCardChange = event => {
    setGiftCardNumber(event.target.value);
  };
  const redeemGiftCard = async () => {
    // Disable button to prevent duplicate requests
    setGiftCardLoading(true);

    // Check if the gift card has already been added
    const isGiftCardAlreadyAdded = bookingData.some(item => item.service.giftcardId && item.service.giftcardId === giftCardNumber);
    if (isGiftCardAlreadyAdded) {
      setGiftCardError('This gift card has already been added.');
      setGiftCardLoading(false);
      return;
    }
    try {
      const response = await fetch("".concat(config.REACT_APP_API_URL, "/products/gift-card/").concat(giftCardNumber), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        setGiftCardLoading(false);
        throw new Error('Network response was not ok.');
      }
      const data = await response.json();
      if (data.status === 'success') {
        setIsGiftcardModalOpen(false);

        // Add gift card item to bookingData
        const giftCardItem = {
          booking: {
            bookingId: Date.now().toString(),
            bookingName: 'Giftcard discount',
            bookingProduct: 'giftcardDiscount',
            appointmentLocation: '',
            appointmentRegion: '',
            appointmentDate: '',
            appointmentTime: '',
            appointmentFor: '',
            sampleConsent: true,
            termsconditions: true,
            completed: true
          },
          customer: {
            nameTitle: '',
            firstName: '',
            lastName: '',
            gender: '',
            dateOfBirth: '',
            phoneNumber: '',
            company: '',
            occupation: '',
            address_line_1: '',
            address_line_2: '',
            city: '',
            postcode: '',
            country: '',
            address_type: '',
            emailAddress: ''
          },
          postal: {
            postageAddressLine1: '',
            postageAddressLine2: '',
            postageCity: '',
            postagePostcode: '',
            postageCountry: '',
            postageSelection: 'no'
          },
          service: {
            serviceName: 'Giftcard discount',
            serviceId: 'giftcardDiscount',
            giftcardId: giftCardNumber,
            serviceType: 'giftcardRedemption',
            emailTemplate: '',
            regionId: 0,
            price: -data.giftCard.amount,
            icon: 'health_screening'
          },
          combineBooking: ''
        };
        setBookingData(prevBookingData => [...prevBookingData, giftCardItem]);
        setBookingDataTotal(prevBookingDataTotal => {
          const newTotal = prevBookingDataTotal - data.giftCard.amount;
          return newTotal > 0 ? newTotal : 0;
        });
        setGiftCardLoading(false);
      } else {
        // Handle error
        setGiftCardError('This gift card was not found.');
        setGiftCardLoading(false);
      }
    } catch (error) {
      // Handle error
      setGiftCardError('This gift card was not found.');
      setGiftCardLoading(false);
    }
  };

  // User can redeem intervals of 150 points for £10 discount
  const pointsPerDiscount = 150;
  const benefitDiscountAmount = 1000;
  const noDiscountServices = ['ultrasoundScan', 'Mammogram', 'xRay', 'ctMRI'];

  // Calculate total and discount amount
  useEffect(() => {
    async function calculateTotal() {
      let totalDiscountAmount = 0;
      const newSubtotal = bookingData.reduce((subtotalSoFar, item) => {
        var _item$service$customi;
        const itemPrice = item.service.price;
        const markerPrices = ((_item$service$customi = item.service.customisedMarkers) === null || _item$service$customi === void 0 || (_item$service$customi = _item$service$customi.markers) === null || _item$service$customi === void 0 ? void 0 : _item$service$customi.map(marker => marker.price)) || [];
        const totalMarkerPrice = markerPrices.reduce((sum, price) => sum + price, 0);
        return subtotalSoFar + itemPrice + totalMarkerPrice;
      }, 0);
      setSubtotal(newSubtotal);
      if (benefitPointsToUse) {
        if (benefitPointsToUse >= pointsPerDiscount) {
          const timesToApplyDiscount = Math.floor(benefitPointsToUse / pointsPerDiscount);
          totalDiscountAmount += timesToApplyDiscount * benefitDiscountAmount;
          setDiscountMessage("\xA3".concat(totalDiscountAmount / 100, " discount (").concat(benefitPointsToUse, " points) applied successfully"));
        }
      } else if (discountCode) {
        try {
          const response = await fetch("".concat(config.REACT_APP_API_URL, "/products/discount?").concat(new URLSearchParams({
            discountCode: "".concat(discountCode)
          })));
          if (response.status === 200) {
            const data = await response.json();
            const discountInfo = processDiscountCode(data, bookingData, bookingDataTotal, noDiscountServices);
            totalDiscountAmount = discountInfo.totalDiscountAmount;
            setDiscountMessage(discountInfo.discountMessage);
            setDiscountCodeResponse(data);
          } else {
            setDiscountMessage("Discount code '".concat(discountCode, "' not found"));
            setDiscountCodeResponse(null);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching discount:', error);
          setDiscountMessage('Error applying discount code');
        }
      } else if (membershipData && membershipData.service_discount) {
        totalDiscountAmount = bookingData.reduce((discountSoFar, item) => noDiscountServices.includes(item.service.serviceId) ? discountSoFar : discountSoFar + item.service.price * membershipData.service_discount / 100, 0);
        setDiscountMessage("Your ".concat(membershipData.service_discount, "% membership discount has applied successfully"));
        setDiscountCodeResponse(null);
      } else {
        setDiscountMessage("");
        setDiscountCodeResponse(null);
      }
      setBookingDataTotalDiscount(totalDiscountAmount);
      setBookingDataTotal(Math.max(0, newSubtotal - totalDiscountAmount));
    }
    calculateTotal();
  }, [bookingData, benefitPointsToUse, discountCode, membershipData]);

  // Initialise points amount
  useEffect(() => {
    if (membershipData && typeof membershipData.reward_points === 'number') {
      setPoints(membershipData.reward_points);
    } else {
      setPoints(0);
    }
  }, [membershipData]);

  // Update total if discount changes
  useEffect(() => {
    setBookingDataTotal(Math.max(0, subtotal - bookingDataTotalDiscount));
  }, [subtotal, bookingDataTotalDiscount]);

  // Check if all bookings are completed
  useEffect(() => {
    const completed = bookingData.every(item => item.booking.completed);
    setAllBookingsCompleted(completed);
  }, [bookingData]);

  // Edit booking
  const handleEditBooking = item => {
    setCurrentBookingId(item.booking.bookingId);
    onEditBooking();
  };

  // Remove booking
  const handleRemoveClick = bookingId => {
    const itemToRemove = bookingData.find(item => item.booking.bookingId === bookingId);
    setBookingNameToRemove(itemToRemove.service.serviceName);
    setBookingIdToRemove(bookingId);
  };

  // Cancel dialog
  const handleCancelRemoveClick = () => {
    setBookingIdToRemove(null);
  };

  // Confirm dialog
  const handleConfirmRemoveClick = () => {
    const newItems = bookingData.filter(item => item.booking.bookingId !== bookingIdToRemove);
    const newSubtotal = newItems.reduce((subtotalSoFar, item) => {
      var _item$service$customi2;
      const itemPrice = item.service.price;
      const markerPrices = ((_item$service$customi2 = item.service.customisedMarkers) === null || _item$service$customi2 === void 0 || (_item$service$customi2 = _item$service$customi2.markers) === null || _item$service$customi2 === void 0 ? void 0 : _item$service$customi2.map(marker => marker.price)) || [];
      const totalMarkerPrice = markerPrices.reduce((sum, price) => sum + price, 0);
      return subtotalSoFar + itemPrice + totalMarkerPrice;
    }, 0);
    setBookingData(newItems);
    setBookingDataTotal(newSubtotal);
    setBookingIdToRemove(null);
  };
  const calculateTotalMarkerPrice = bookingId => {
    if (bookingData.length === 0) {
      return 0;
    }
    const totalMarkerPrice = bookingData.reduce((total, bookingItem) => {
      if (bookingItem.booking.bookingId === bookingId && bookingItem.service.customisedMarkers && bookingItem.service.customisedMarkers.markers) {
        const markerPrices = bookingItem.service.customisedMarkers.markers.map(marker => marker.price);
        return total + markerPrices.reduce((sum, price) => sum + price, 0);
      }
      return total;
    }, 0);
    return totalMarkerPrice;
  };
  const renderPatientAddress = item => {
    function combineAddress(_ref3) {
      let {
        addressLine1,
        addressLine2,
        city,
        country,
        postcode
      } = _ref3;
      const addressComponents = [addressLine1, addressLine2, city, postcode, country];
      const filteredComponents = addressComponents.filter(component => component);
      return filteredComponents.join(', ');
    }
    const isPostal = item.service.serviceType === 'postal';
    if (isPostal) {
      return /*#__PURE__*/React.createElement("p", null, combineAddress({
        addressLine1: item.postal.postageAddressLine1,
        addressLine2: item.postal.postageAddressLine2,
        city: item.postal.postageCity,
        postcode: item.postal.postagePostcode,
        country: item.postal.postageCountry
      }));
    }
    return /*#__PURE__*/React.createElement("p", null, combineAddress({
      addressLine1: item.customer.address_line_1,
      addressLine2: item.customer.address_line_2,
      city: item.customer.city,
      postcode: item.customer.postcode,
      country: item.customer.country
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "order-summary"
  }, bookingIdToRemove && /*#__PURE__*/React.createElement("div", {
    className: "remove-confirmation"
  }, /*#__PURE__*/React.createElement("h3", null, "Remove from order"), /*#__PURE__*/React.createElement("p", null, "Are you sure you want to remove ", bookingNameToRemove, "?"), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "border",
    label: "Cancel",
    onClick: handleCancelRemoveClick
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Remove",
    onClick: handleConfirmRemoveClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cart-summary-inner"
  }, /*#__PURE__*/React.createElement("ul", null, bookingData.map(item => {
    const itemPrice = item.service.price && !Number.isNaN(item.service.price) ? (item.service.price / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }) : null;
    return /*#__PURE__*/React.createElement("li", {
      key: item.booking.bookingId
    }, /*#__PURE__*/React.createElement("img", {
      src: item.service.icon ? "/img/icon/".concat(item.service.icon, ".png") : "/img/doctor/".concat(item.service.avatar),
      alt: item.service.serviceName
    }), /*#__PURE__*/React.createElement("div", {
      className: "name"
    }, item.service.serviceName, " "), item.booking.completed && item.service.serviceType !== 'giftcardRedemption' && item.service.serviceType !== 'giftcardPurchase' ? /*#__PURE__*/React.createElement("span", {
      className: "status success"
    }, "Information filled") : /*#__PURE__*/React.createElement("span", {
      className: "status"
    }), /*#__PURE__*/React.createElement("div", {
      className: "price"
    }, /*#__PURE__*/React.createElement("div", null, itemPrice), item.service.customisedMarkers && item.service.customisedMarkers.markers && item.service.customisedMarkers.markers.length > 0 && /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '13px',
        width: '100%',
        fontWeight: '500',
        color: '#868686'
      }
    }, "+", (calculateTotalMarkerPrice(item.booking.bookingId) / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }))), item.service.serviceType !== 'giftcardRedemption' && item.service.serviceType !== 'giftcardPurchase' && /*#__PURE__*/React.createElement(Button, {
      variant: item.booking.completed ? 'border' : 'primary',
      label: item.booking.completed ? 'Edit details' : 'Select appointment',
      onClick: () => {
        handleEditBooking(item);
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "remove",
      onClick: () => handleRemoveClick(item.booking.bookingId)
    }, /*#__PURE__*/React.createElement("img", {
      src: img,
      alt: "remove from cart"
    })), item.booking.completed && item.service.serviceType !== 'giftcardRedemption' && item.service.serviceType !== 'giftcardPurchase' && /*#__PURE__*/React.createElement("div", {
      className: "completed-info"
    }, item.service.customisedMarkers && /*#__PURE__*/React.createElement("div", {
      className: "mb-3",
      style: {
        width: '100%',
        borderBottom: '1px solid #cecece'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-direction-row flex-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-7 info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Additional markers"), item.service.customisedMarkers.markers.map(marker => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      key: marker.name,
      style: {
        border: '1px solid #b7b7b7',
        padding: '2px 4px',
        borderRadius: '4px',
        fontWeight: 500,
        display: 'inline'
      }
    }, marker.name), ' '))), /*#__PURE__*/React.createElement("div", {
      className: "col-5 info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Laboratory"), /*#__PURE__*/React.createElement("p", null, item.service.customisedMarkers.hospital)))), /*#__PURE__*/React.createElement("div", {
      className: "col-7"
    }, /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Patient name"), /*#__PURE__*/React.createElement("p", null, "".concat(item.customer.nameTitle, " ").concat(item.customer.firstName, " ").concat(item.customer.lastName))), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Appointment location"), /*#__PURE__*/React.createElement("p", null, item.service.serviceType.toLowerCase().includes('clinic') || item.service.serviceType.toLowerCase().includes('self-collection') ? item.booking.appointmentLocation : item.service.serviceType === 'Postal' ? 'Postal' : 'Virtual')), selectedBooking === item && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Patient address"), renderPatientAddress(item)), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Company"), /*#__PURE__*/React.createElement("p", null, item.customer.company)), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Occupation"), /*#__PURE__*/React.createElement("p", null, item.customer.occupation)))), /*#__PURE__*/React.createElement("div", {
      className: "col-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Time"), /*#__PURE__*/React.createElement("p", null, item.booking.appointmentTime ? item.booking.appointmentTime : 'N/a')), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Date"), /*#__PURE__*/React.createElement("p", null, item.booking.appointmentDate ? new Date(item.booking.appointmentDate).toLocaleDateString('en-GB') : 'N/a')), selectedBooking === item && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Gender"), /*#__PURE__*/React.createElement("p", null, item.customer.gender)), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Date of birth"), /*#__PURE__*/React.createElement("p", null, item.customer.dateOfBirth)), /*#__PURE__*/React.createElement("div", {
      className: "info-item"
    }, /*#__PURE__*/React.createElement("h6", null, "Phone number"), /*#__PURE__*/React.createElement("p", null, item.customer.phoneNumber)))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => setSelectedBooking(selectedBooking === item ? null : item)
    }, selectedBooking === item ? 'Hide details' : 'View details')));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "total"
  }, /*#__PURE__*/React.createElement("div", {
    className: "totalButtons"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "border",
    label: "Redeem Giftcard",
    onClick: () => setIsGiftcardModalOpen(true)
  })), /*#__PURE__*/React.createElement(GiftcardModal, {
    isOpen: isGiftcardModalOpen,
    onClose: () => setIsGiftcardModalOpen(false)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "giftcardCode"
  }, "Enter Gift Card number", /*#__PURE__*/React.createElement("input", {
    id: "giftcardCode",
    type: "text",
    value: giftCardNumber,
    onChange: handleGiftCardChange,
    placeholder: "Gift Card number"
  })), giftCardError && /*#__PURE__*/React.createElement("div", {
    className: "error"
  }, giftCardError), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Redeem Gift Card",
    onClick: redeemGiftCard,
    disabled: giftCardLoading,
    fullWidth: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "amount"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "border",
    label: "Redeem Discount Code / Membership Points",
    onClick: () => setShowDiscountModal(true),
    fullWidth: true
  }), showDiscountModal && /*#__PURE__*/React.createElement(DiscountCalculator, {
    redeemablePoints: points,
    tabIndex: -1,
    onModalVisibility: () => setShowDiscountModal(false),
    discountCode: discountCode,
    setDiscountCode: setDiscountCode,
    setDiscountMessage: setDiscountMessage
  }), discountMessage && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: '14px',
      color: 'rgb(2 121 163)',
      borderRadius: '4px',
      padding: '2px 10px',
      textAlign: 'center',
      background: '#0279a31a',
      margin: '10px 0 10px 0'
    }
  }, discountMessage), /*#__PURE__*/React.createElement("div", {
    className: "priceContainer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "discount"
  }, typeof bookingDataTotal === 'number' && !Number.isNaN(bookingDataTotal) && /*#__PURE__*/React.createElement("span", null, "Subtotal:"), typeof bookingDataTotal === 'number' && !Number.isNaN(bookingDataTotal) && /*#__PURE__*/React.createElement("span", null, ((bookingDataTotal + bookingDataTotalDiscount) / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))), /*#__PURE__*/React.createElement("span", {
    className: "discount"
  }, typeof bookingDataTotalDiscount === 'number' && !Number.isNaN(bookingDataTotalDiscount) && /*#__PURE__*/React.createElement("span", null, "Discount:"), typeof bookingDataTotalDiscount === 'number' && !Number.isNaN(bookingDataTotalDiscount) && /*#__PURE__*/React.createElement("span", null, "-", (bookingDataTotalDiscount / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))), /*#__PURE__*/React.createElement("span", {
    className: "price"
  }, typeof bookingDataTotal === 'number' && !Number.isNaN(bookingDataTotal) && 'Total:', typeof bookingDataTotal === 'number' && !Number.isNaN(bookingDataTotal) && /*#__PURE__*/React.createElement("span", null, (bookingDataTotal / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }))))), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    label: "Continue to booking",
    fullWidth: true,
    large: true,
    bold: true,
    onClick: onNextStep,
    disabled: !allBookingsCompleted || bookingData.length === 0
  })));
}

var css$3 = "@charset \"UTF-8\";\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition: background-color 600000s 0s, color 600000s 0s;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.bookingSubmissionForm_module_bookingSubmissionForm__7b2945e8 {\n  position: relative;\n  width: 100%;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.02);\n  padding: 25px;\n}\n\nform .bookingSubmissionForm_module_errorBox__7b2945e8 {\n  border: 2px solid red;\n  border-radius: 6px;\n  padding: 20px;\n  background: #fff6f8;\n  margin-bottom: 24px;\n}\nform .bookingSubmissionForm_module_errorBox__7b2945e8 p:last-child {\n  margin-bottom: 0;\n}\nform .bookingSubmissionForm_module_errorBox__7b2945e8 h3 {\n  color: #b00;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\nform .bookingSubmissionForm_module_errorBox__7b2945e8 a {\n  color: #b00;\n  text-decoration: underline;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 {\n  max-width: 470px;\n  margin: auto;\n  margin-bottom: 30px;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 input:not([type=radio]):not([type=checkbox]),\nform .bookingSubmissionForm_module_formGroup__7b2945e8 select {\n  border: 2px solid #eaedff;\n  border-radius: 12px;\n  color: #6f7172;\n  height: 60px;\n  padding: 0 20px;\n  width: 100%;\n  background: #fff;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 textarea {\n  border: 2px solid #eaedff;\n  border-radius: 12px;\n  color: #6f7172;\n  height: 60px;\n  width: 100%;\n  background: #fff;\n  padding: 20px;\n  min-height: 110px;\n  margin-bottom: 24px;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 textarea::placeholder {\n  color: #9f9f9f;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 label {\n  display: block;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_required__7b2945e8 {\n  color: red;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_addressInput__7b2945e8 {\n  flex: 1;\n  display: flex;\n  align-items: start;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_addressInput__7b2945e8 input[type=text] {\n  flex: 1;\n  width: 100%;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_addressInput__7b2945e8 button {\n  flex-shrink: 0;\n  background: #0279a3;\n  color: #fff;\n  border: none;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  transition: 0.3s;\n  padding: 0 26px;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_addressInput__7b2945e8 button:hover {\n  background: #0c8dbb;\n}\nform .bookingSubmissionForm_module_formGroup__7b2945e8 .bookingSubmissionForm_module_radioGroup__7b2945e8 label {\n  display: block;\n  margin-left: 35px;\n  margin-top: 14px;\n}\nform input[type=radio] {\n  opacity: 0;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n}\nform .bookingSubmissionForm_module_radioGroup__7b2945e8 div {\n  position: relative;\n  display: inline-block;\n  margin-right: 20px;\n}\nform .bookingSubmissionForm_module_radioGroup__7b2945e8 div label:before,\nform .bookingSubmissionForm_module_radioGroup__7b2945e8 div label.bookingSubmissionForm_module_checkbox__7b2945e8:before {\n  content: \"\";\n  position: absolute;\n  margin-left: -35px;\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  border: 2px solid #eaeefe;\n  background-color: #ffffff;\n}\nform label.bookingSubmissionForm_module_checkbox__7b2945e8:before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: 8px;\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  border: 2px solid #eaeefe;\n  background-color: #ffffff;\n}\nform .bookingSubmissionForm_module_radioGroup__7b2945e8 div input[type=radio]:checked + label:before,\nform input[type=checkbox]:checked + label.bookingSubmissionForm_module_checkbox__7b2945e8:before {\n  content: \"✓\";\n  color: #ffffff;\n  background-color: #0279a3;\n  text-align: center;\n  line-height: 20px;\n  display: inline-block;\n  position: relative;\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  border: 2px solid #0279a3;\n  top: 0px;\n  margin-top: 8px;\n  margin-bottom: -3px;\n}\nform .bookingSubmissionForm_module_radioGroup__7b2945e8 div label {\n  font-size: 14px;\n  font-weight: normal;\n  color: #737373;\n}\nform .bookingSubmissionForm_module_required__7b2945e8 {\n  color: red;\n}\nform .bookingSubmissionForm_module_hidden__7b2945e8 {\n  display: none;\n}";
var modules_dcc64c53 = {"bookingSubmissionForm":"bookingSubmissionForm_module_bookingSubmissionForm__7b2945e8","errorBox":"bookingSubmissionForm_module_errorBox__7b2945e8","formGroup":"bookingSubmissionForm_module_formGroup__7b2945e8","required":"bookingSubmissionForm_module_required__7b2945e8","addressInput":"bookingSubmissionForm_module_addressInput__7b2945e8","radioGroup":"bookingSubmissionForm_module_radioGroup__7b2945e8","checkbox":"bookingSubmissionForm_module_checkbox__7b2945e8","hidden":"bookingSubmissionForm_module_hidden__7b2945e8"};
n(css$3,{});

var css$2 = ".modal ::-webkit-scrollbar {\n  background-color: #d6d6d6;\n  border-radius: 10px;\n  width: 7px;\n  height: 2px;\n}\n.modal ::-webkit-scrollbar-thumb {\n  background-color: #7c7a7a;\n  border-radius: 10px;\n}\n.modal form {\n  max-width: 400px;\n  margin: auto;\n  width: 100%;\n}\n.modal form .checkbox-item {\n  display: inline-block;\n  width: auto;\n  cursor: pointer;\n  margin: 0;\n  padding: 6px 8px;\n  border: none;\n  margin: 2px;\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.0588235294);\n}\n.modal form .checkbox-item span {\n  font-size: 14px;\n  color: #4a4a4a;\n}\n.modal form .checkbox-item:first-of-type {\n  border-top: 1px solid transparent !important;\n}\n.modal form .checkbox-item-selected {\n  background-color: #0279a3;\n  color: white;\n  border-top: 1px solid transparent;\n  border-radius: 6px;\n}\n.modal form .checkbox-item-selected span {\n  color: white;\n}\n.modal form .checkbox-item-selected img {\n  visibility: hidden !important;\n  transition: none;\n}\n.modal form .checkbox-item-selected + .checkbox-item {\n  border-top: 1px solid transparent;\n}\n.modal form .checkbox-item input[type=checkbox] {\n  display: block;\n  width: 14px;\n  height: 14px;\n  margin: 0 0 0 10px;\n}\n.modal form .checkbox-item img {\n  visibility: visible;\n  transition: none;\n}\n.modal form .checkbox-label {\n  margin-left: auto;\n}\n.modal form .hospital {\n  max-width: 300px;\n  margin: auto;\n}\n.modal form .hospital label {\n  margin: 0;\n}\n.modal form .remove-marker-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n}\n.modal form .remove-marker-btn img {\n  width: 15px;\n  height: auto;\n}";
n(css$2,{});

/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
function CustomiseMarkersModal(_ref) {
  var _currentBookingData$s;
  let {
    showCustomiseMarkersModal,
    onClose,
    onSubmitCustomisedMarkers,
    currentBookingData
  } = _ref;
  const config = window.envConfig;
  const [loading, setLoading] = useState(false);
  const [markersData, setMarkersData] = useState([]);
  const [customisedMarkersForm, setCustomisedMarkersForm] = useState({
    hospital: '',
    vials_qty: '',
    vials_type: '',
    test_instructions: '',
    markers: []
  });

  // Effect for setting initial form state from currentBookingData
  useEffect(() => {
    if (currentBookingData && currentBookingData.service && currentBookingData.service.customisedMarkers) {
      setCustomisedMarkersForm(currentBookingData.service.customisedMarkers);
    }
  }, [currentBookingData]);
  useEffect(() => {
    const fetchMarkers = async () => {
      try {
        setLoading(true);
        const response = await fetch("".concat(config.REACT_APP_API_URL, "/bookings/testMarkers"));
        const fetchedMarkers = await response.json();

        // Organize markers by category and set selected based on currentBookingData
        const groupedMarkers = fetchedMarkers.reduce((acc, marker) => {
          const {
            category
          } = marker;
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push({
            name: marker.marker_name,
            price: marker.marker_price,
            // Check if the marker is selected
            selected: currentBookingData.service.customisedMarkers.markers.some(m => m.name === marker.marker_name)
          });
          return acc;
        }, {});
        setMarkersData(groupedMarkers);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchMarkers();
  }, [config.REACT_APP_API_URL, currentBookingData === null || currentBookingData === void 0 || (_currentBookingData$s = currentBookingData.service) === null || _currentBookingData$s === void 0 || (_currentBookingData$s = _currentBookingData$s.customisedMarkers) === null || _currentBookingData$s === void 0 ? void 0 : _currentBookingData$s.markers]);
  const handleFormChange = eventOrData => {
    let name;
    let value;
    if (eventOrData.target) {
      const {
        target
      } = eventOrData;
      name = target.name;
      value = target.value;
    } else {
      const {
        name: dataName,
        value: dataValue
      } = eventOrData;
      name = dataName;
      value = dataValue;
    }
    if (name === 'markers') {
      const [category, markerName] = value.split(':');
      const marker = markersData[category].find(m => m.name === markerName);
      setCustomisedMarkersForm(prevForm => {
        if (marker) {
          if (prevForm.markers.some(m => m.name === marker.name)) {
            return {
              ...prevForm,
              markers: prevForm.markers.filter(m => m.name !== marker.name)
            };
          }
          return {
            ...prevForm,
            markers: [...prevForm.markers, marker]
          };
        }
        return prevForm;
      });
    } else {
      setCustomisedMarkersForm(prevForm => ({
        ...prevForm,
        [name]: value
      }));
    }
  };
  const handleRemoveMarker = markerName => {
    setCustomisedMarkersForm(prevForm => ({
      ...prevForm,
      markers: prevForm.markers.filter(marker => marker.name !== markerName)
    }));
  };
  const handleFormSubmit = event => {
    event.preventDefault();
    onSubmitCustomisedMarkers(customisedMarkersForm);
  };
  const totalMarkerCost = customisedMarkersForm.markers.reduce((total, marker) => total + marker.price, 0);
  if (!showCustomiseMarkersModal) return null;
  if (showCustomiseMarkersModal) return /*#__PURE__*/React.createElement("div", {
    className: "modal",
    style: {
      display: 'block',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      cursor: 'pointer'
    },
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content",
    style: {
      backgroundColor: 'white',
      padding: '30px',
      margin: '20px auto',
      width: '100%',
      maxWidth: '600px'
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("span", {
    className: "close",
    onClick: onClose,
    style: {
      float: 'right',
      cursor: 'pointer'
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("h3", null, "Additional markers"), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "hospital mt-3"
  }, /*#__PURE__*/React.createElement(TwoRadioSelection, {
    label: "Please choose a laboratory",
    name: "hospital",
    firstOption: "TDL",
    firstOptionId: "TDL",
    secondOption: "Hospital Lab",
    secondOptionId: "Hospital Lab",
    required: true,
    onSelectionChange: handleFormChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "cart-section pt-3 px-4 pb-2 mb-3",
    style: {
      maxHeight: '300px',
      overflowX: 'hidden',
      overflowY: 'scroll'
    }
  }, Object.entries(markersData).map(_ref2 => {
    let [category, markers] = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-1 mb-3",
      key: category
    }, /*#__PURE__*/React.createElement("h6", null, category), markers.map(marker => /*#__PURE__*/React.createElement("label", {
      key: marker.name,
      className: "checkbox-item ".concat(customisedMarkersForm.markers.some(m => m.name === marker.name) ? 'checkbox-item-selected' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center w-100"
    }, marker.name, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      name: "markers",
      value: "".concat(category, ":").concat(marker.name),
      checked: customisedMarkersForm.markers.some(m => m.name === marker.name),
      onChange: handleFormChange
    })))));
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Number of vials:", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#fe4536'
    }
  }, " *")), /*#__PURE__*/React.createElement("input", {
    type: "number",
    name: "vials_qty",
    value: customisedMarkersForm.vials_qty || '',
    onChange: handleFormChange
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Vial type:", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#fe4536'
    }
  }, " *")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "vials_type",
    value: customisedMarkersForm.vials_type || '',
    onChange: handleFormChange
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Test instructions:", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#fe4536'
    }
  }, " *")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "test_instructions",
    value: customisedMarkersForm.test_instructions || '',
    onChange: handleFormChange
  })), customisedMarkersForm.markers.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
    className: "mt-4"
  }, "Review of your additional markers"), /*#__PURE__*/React.createElement("div", {
    className: "cart-section pt-3 px-4 pb-2 mb-3"
  }, customisedMarkersForm.markers.map(marker => /*#__PURE__*/React.createElement("div", {
    key: marker.id,
    className: "checkbox-item",
    style: {
      cursor: 'default'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "marker-name"
  }, marker.name), /*#__PURE__*/React.createElement("button", {
    className: "remove-marker-btn",
    type: "button",
    onClick: () => handleRemoveMarker(marker.name)
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/icon/close-icon.svg",
    style: {
      filter: 'invert(1)',
      maxWidth: '15px',
      marginLeft: '10px'
    },
    alt: "Remove marker"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Complete customisation ".concat(totalMarkerCost > 0 ? "+".concat((totalMarkerCost / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    })) : ''),
    type: "submit",
    fullWidth: true,
    large: true
  })))));
}
CustomiseMarkersModal.propTypes = {
  showCustomiseMarkersModal: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitCustomisedMarkers: PropTypes.func,
  currentBookingData: PropTypes.shape({
    service: PropTypes.shape({
      customisedMarkers: PropTypes.shape({
        hospital: PropTypes.string,
        vials_qty: PropTypes.string,
        vials_type: PropTypes.string,
        test_instructions: PropTypes.string,
        markers: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string,
          price: PropTypes.number
        }))
      })
    })
  })
};
CustomiseMarkersModal.defaultProps = {
  showCustomiseMarkersModal: false,
  onClose: () => {},
  onSubmitCustomisedMarkers: () => {},
  currentBookingData: null
};

var css$1 = ".loader_module_loaderContainer__70e8dcb6 {\n  position: fixed;\n  z-index: 999;\n  width: 130px;\n  height: 44px;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\n.loader_module_loader__70e8dcb6 {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: flex;\n  margin: 15px auto;\n  color: #fff;\n  animation: loader_module_loader__70e8dcb6 2s linear infinite;\n  position: absolute;\n}\n\n.loader_module_background__70e8dcb6 {\n  background: rgba(1, 37, 49, 0.168627451);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30px;\n}\n\n@keyframes loader_module_loader__70e8dcb6 {\n  0% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n  25% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 2px;\n  }\n  50% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 2px, -38px 0 0 -2px;\n  }\n  75% {\n    box-shadow: 14px 0 0 2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n  100% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n}";
var modules_86750745 = {"loaderContainer":"loader_module_loaderContainer__70e8dcb6","loader":"loader_module_loader__70e8dcb6","background":"loader_module_background__70e8dcb6"};
n(css$1,{});

function Loader() {
  return /*#__PURE__*/React.createElement("span", {
    className: modules_86750745.loaderContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: modules_86750745.loader
  }), /*#__PURE__*/React.createElement("span", {
    className: modules_86750745.background
  }));
}

/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */

// import VerticalRadioSelection from '../../atoms/VerticalRadioSelection';

function BookingSubmissionForm(_ref) {
  var _bookingItem$booking, _bookingItem$booking2, _bookingItem$booking3;
  let {
    registeredUser,
    onComplete
  } = _ref;
  const config = window.envConfig;
  const {
    currentBookingId,
    bookingData,
    setBookingData
  } = useContext(BookingContext);
  const bookingItem = bookingData.find(obj => obj.booking.bookingId === currentBookingId);
  if (!bookingItem) {
    window.location.href = '/cart';
  }
  const requireAvailability = (bookingItem === null || bookingItem === void 0 || (_bookingItem$booking = bookingItem.booking) === null || _bookingItem$booking === void 0 ? void 0 : _bookingItem$booking.requireAvailability) !== false;
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState('');
  const [availabilityData, setAvailabilityData] = useState({});
  const [postageAddressVisible, setPostageAddressVisible] = useState(false);
  const [isSomeoneElse, setIsSomeoneElse] = useState(false);
  const [clearSelectedTime, setClearSelectedTime] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [currentBookingData, setCurrentBookingData] = useState(null);
  const [visibleAddress, setIsVisibleAddress] = useState(false);
  const [showCustomiseMarkersModal, setShowCustomiseMarkersModal] = useState(false);
  const [formData, setFormData] = useState({
    completed: true,
    appointmentFor: 'myself',
    statement: '',
    appointmentDate: bookingItem.booking.appointmentDate || '',
    appointmentTime: bookingItem.booking.appointmentTime || '',
    appointmentLocation: bookingItem.booking.appointmentLocation || '',
    // combineBooking: '',
    nameTitle: '',
    firstName: '',
    lastName: '',
    emailAddress: registeredUser.email_address,
    patientEmailAddress: '',
    gender: '',
    dob: '',
    phoneNumber: '',
    nhsNumber: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    postcode: '',
    country: '',
    address_type: 'home',
    postageAddressLine1: '',
    postageAddressLine2: '',
    postageCity: '',
    postagePostcode: '',
    postageCountry: '',
    company: '',
    occupation: '',
    postageSelection: 'no',
    appointmentNotes: '',
    termsconditions: '',
    sampleConsent: '',
    emailConsent: '',
    locationCategoryId: ''
  });
  const closeModal = () => {
    setShowCustomiseMarkersModal(false);
  };
  useEffect(() => {
    setCurrentBookingData(bookingItem);
    if (bookingItem) {
      setSelectedDate(formData.appointmentDate);
      setIsSomeoneElse(formData.appointmentFor === 'someoneelse');
    }
  }, [bookingData, currentBookingId, formData]);
  useEffect(() => {
    const serviceSelected = bookingData.find(obj => obj.booking.bookingId === currentBookingId);
    if (serviceSelected.service.serviceType === 'Postal' || serviceSelected.booking.appointmentRegion === 'Home visit') {
      // Break if condition is fulfilled
      setLoading(false);
      return;
    }

    // Fetch availability with customised request queries
    const {
      entityId
    } = bookingItem.entity;
    const baseUrl = bookingItem.booking.eventId ? "".concat(config.REACT_APP_API_URL, "/bookings/availability/event/").concat(bookingItem.booking.eventId) : "".concat(config.REACT_APP_API_URL, "/bookings/availability/entity/").concat(entityId);
    let url = baseUrl;
    if (!bookingItem.booking.eventId) {
      const queryParams = [];
      switch (serviceSelected.service.serviceType) {
        case 'Consultation':
          queryParams.push("doctor=".concat(serviceSelected.booking.doctorId));
          queryParams.push('locationCategory=6'); // ID for Virtual = 6
          break;
        case 'virtualWellbeing':
          queryParams.push("clinician=".concat(serviceSelected.clinician.id));
          queryParams.push("timeInterval=".concat(bookingItem.service.apptDuration));
          break;
        default:
          queryParams.push("location=".concat(serviceSelected.booking.locationId));
          queryParams.push("timeInterval=".concat(bookingItem.service.apptDuration));
          break;
      }
      if (queryParams.length > 0) {
        url = "".concat(baseUrl, "?").concat(queryParams.join('&'));
      }
    }
    const getFormattedDate = daysToAdd => {
      const today = new Date();
      today.setDate(today.getDate() + daysToAdd);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    const today = getFormattedDate(0); // Get today's date
    const thirdDay = getFormattedDate(2);
    fetch(url).then(response => response.json()).then(data => {
      let filteredData;
      if (serviceSelected.service.serviceId === 'restingECG') {
        // Filter out dates after the third day
        filteredData = Object.fromEntries(Object.entries(data).filter(_ref2 => {
          let [date] = _ref2;
          return new Date(date) > new Date(thirdDay);
        }));
      } else {
        // Filter out dates before the third day
        filteredData = Object.fromEntries(Object.entries(data).filter(_ref3 => {
          let [date] = _ref3;
          return new Date(date) >= new Date(today);
        }));
      }
      setAvailabilityData(filteredData);
      // Set selected date to the first date from the third day onwards
      setSelectedDate(Object.keys(filteredData)[0]);
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error fetching location data: ', error);
    }).finally(() => {
      setLoading(false);
    });
  }, [bookingData, currentBookingId]);
  function createAddressString() {
    for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
      parts[_key] = arguments[_key];
    }
    console.log(parts.filter(part => part && part.trim().length > 0).join(', '));
    return parts.filter(part => part && part.trim().length > 0).join(', ');
  }
  const useAddress = _ref4 => {
    let {
      addressline1,
      addressline2,
      posttown,
      postcode,
      country
    } = _ref4;
    if (bookingItem.booking.clinicianId) {
      setFormData({
        // If clinicianId exists (home visit), set appointmentLocation
        ...formData,
        appointmentLocation: createAddressString(addressline1, addressline2, posttown, postcode, country || 'United Kingdom'),
        address_line_1: addressline1,
        address_line_2: addressline2,
        city: posttown,
        postcode,
        country: country || 'United Kingdom',
        address_type: 'home'
      });
      setIsVisibleAddress(true);
    } else {
      setFormData({
        ...formData,
        address_line_1: addressline1,
        address_line_2: addressline2,
        city: posttown,
        postcode,
        country: country || 'United Kingdom',
        address_type: 'home'
      });
      setIsVisibleAddress(true);
    }
  };
  const usePostageAddress = _ref5 => {
    let {
      addressline1,
      addressline2,
      posttown,
      postcode,
      country
    } = _ref5;
    setFormData({
      ...formData,
      postageAddressLine1: addressline1,
      postageAddressLine2: addressline2,
      postageCity: posttown,
      postagePostcode: postcode,
      postageCountry: country || 'United Kingdom'
    });
    setIsVisibleAddress(true);
  };
  useEffect(() => {
    if (formData.postageSelection === 'yes') {
      setPostageAddressVisible(true);
    } else {
      setPostageAddressVisible(false);
    }
  }, [formData.postageSelection]);
  const handleInputChange = event => {
    const {
      name,
      value,
      type,
      checked
    } = event.target;
    const inputValue = type === 'checkbox' ? checked : value;
    const nameParts = name.split('.');
    if (nameParts.length === 1) {
      setFormData({
        ...formData,
        [name]: inputValue
      });
    } else {
      const [firstPart, secondPart] = nameParts;
      setFormData({
        ...formData,
        [firstPart]: {
          ...formData[firstPart],
          [secondPart]: inputValue
        }
      });
    }
  };
  const handleCustomComponentChange = _ref6 => {
    let {
      name,
      value
    } = _ref6;
    setFormData({
      ...formData,
      [name]: value
    });
    if (name === 'appointmentDate') {
      setSelectedDate(value);
      setFormData({
        ...formData,
        appointmentDate: value,
        appointmentTime: ''
      });
      setClearSelectedTime(true);
    }
  };
  const handleCheckboxChange = event => {
    const {
      name,
      checked
    } = event.target;
    setFormData({
      ...formData,
      [name]: checked
    });
  };
  const handleSubmit = event => {
    event.preventDefault();
    window.scrollTo(0, 0);

    // validate form values
    const errors = {};
    if (!formData.appointmentFor) {
      errors.appointmentFor = 'Please enter who your appointment is for';
    }

    // if (!formData.combineBooking) {
    // 	errors.combineBooking = 'Please select whether to combine with your other bookings';
    // }
    if (!formData.appointmentDate && !bookingItem.booking.appointmentDate && bookingItem.service.serviceType && (bookingItem.service.serviceType.toLowerCase().includes('clinic') || bookingItem.service.serviceType.toLowerCase().includes('consultation'))) {
      errors.appointmentDate = 'Please choose an available date';
    }
    if (!formData.appointmentTime && !bookingItem.booking.appointmentTime && bookingItem.service.serviceType && (bookingItem.service.serviceType.toLowerCase().includes('clinic') || bookingItem.service.serviceType.toLowerCase().includes('consultation'))) {
      errors.appointmentTime = 'Please choose an available time slot';
    }
    if (bookingItem.service.serviceType && bookingItem.service.serviceType.toLowerCase().includes('postal') && !formData.postageAddressLine1) {
      errors.postageAddressLine1 = 'Please fill in the address for the delivery';
    }
    if (!formData.statement && isSomeoneElse) {
      errors.statement = 'Please choose which statement applies to this booking';
    }
    if (!formData.nameTitle && isSomeoneElse) {
      errors.nameTitle = 'Please enter your title';
    }
    if (!formData.firstName && isSomeoneElse) {
      errors.firstName = 'Please enter your first name';
    } else if (!/^[a-zA-Z\s-]+$/.test(formData.firstName)) {
      errors.firstName = 'First name can only contain letters, hyphens, and spaces';
    }
    if (!formData.lastName && isSomeoneElse) {
      errors.lastName = 'Please enter your last name';
    } else if (!/^[a-zA-Z\s-]+$/.test(formData.lastName)) {
      errors.lastName = 'Last name can only contain letters, hyphens, and spaces';
    }
    if (!formData.gender && isSomeoneElse) {
      errors.gender = 'Please enter your gender';
    }
    if (!formData.dateOfBirth && isSomeoneElse) {
      errors.dateOfBirth = 'Please enter your date of birth';
    }
    if (!formData.phoneNumber) {
      errors.phoneNumber = 'Please enter your phone number';
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      errors.phoneNumber = 'Phone number must contain only numbers';
    }
    if (!formData.address_line_1) {
      errors.address_line_1 = 'Please enter your address';
    }
    if (!formData.city) {
      errors.city = 'Please enter your city';
    }
    if (!formData.postcode) {
      errors.postcode = 'Please enter your postcode';
    }
    if (!formData.country) {
      errors.country = 'Please enter your country';
    }
    if (!formData.termsconditions) {
      errors.termsconditions = 'Please accept the terms and conditions';
    }
    if (!formData.sampleConsent) {
      errors.sampleConsent = 'Please consent to samples being taken and tested if needed';
    }
    if (bookingItem.booking.eventId && !formData.gpConsent) {
      errors.gpConsent = 'Please consent for details to be passed on to our private GP to contact you regarding results';
    }
    if (bookingItem.booking.eventId && !formData.eventConsentForm) {
      errors.eventConsentForm = 'Please complete the Consent Form and tick on the checkbox';
    }
    if (bookingItem.booking.eventId === 7 && !formData.nhsNumber) {
      errors.nhsNumber = 'Please enter your NHS number. It is required.';
    }
    setFormErrors(errors);

    // submit form if no errors
    if (Object.keys(errors).length === 0) {
      const updatedBookingIndex = bookingData.findIndex(booking => booking.booking.bookingId === currentBookingId);
      if (updatedBookingIndex !== -1) {
        let updatedService = {
          ...bookingItem.service
        };
        if (bookingItem.booking.appointmentRegion === 'Home visit') {
          updatedService = {
            ...updatedService,
            regionId: 5
          };
        }
        const updatedBookingItem = {
          ...bookingItem,
          service: updatedService,
          booking: {
            ...bookingItem.booking,
            bookingName: "".concat(formData.firstName, " ").concat(formData.lastName),
            appointmentDate: formData.appointmentDate || bookingItem.booking.appointmentDate,
            appointmentTime: formData.appointmentTime || bookingItem.booking.appointmentTime,
            appointmentNotes: formData.appointmentNotes,
            appointmentFor: formData.appointmentFor,
            appointmentLocation: formData.appointmentLocation,
            nhsNumber: formData.nhsNumber,
            virtualOrPhysical: formData.virtualOrPhysical,
            sampleConsent: formData.sampleConsent,
            termsconditions: formData.termsconditions,
            completed: formData.completed
          },
          customer: {
            ...bookingItem.customer,
            nameTitle: formData.nameTitle,
            firstName: formData.firstName,
            lastName: formData.lastName,
            emailAddress: registeredUser.email_address,
            patientEmailAddress: formData.patientEmailAddress || 'Not provided',
            gender: formData.gender,
            dateOfBirth: formData.dateOfBirth,
            phoneNumber: formData.phoneNumber,
            company: formData.company,
            occupation: formData.occupation,
            address_line_1: formData.address_line_1,
            address_line_2: formData.address_line_2,
            city: formData.city,
            postcode: formData.postcode,
            country: formData.country
          },
          postal: {
            ...bookingItem.postal,
            postageAddressLine1: formData.postageAddressLine1,
            postageAddressLine2: formData.postageAddressLine2,
            postageCity: formData.postageCity,
            postagePostcode: formData.postagePostcode,
            postageCountry: formData.postageCountry,
            postageSelection: formData.postageSelection
          }
        };
        const updatedBookingData = bookingData.map(item => item.booking.bookingId === currentBookingId ? updatedBookingItem : item);
        setBookingData(updatedBookingData);
      } else {
        // eslint-disable-next-line no-console
        console.error('Booking not found');
      }
      onComplete();
    }
  };
  useEffect(() => {
    if (formData.appointmentFor === 'myself' && registeredUser) {
      const updatedFormData = {
        ...formData,
        firstName: registeredUser.first_name || 'Unset',
        lastName: registeredUser.last_name || 'Unset',
        gender: registeredUser.gender || 'Unset',
        dateOfBirth: formData.dateOfBirth || new Date(registeredUser.date_of_birth).toLocaleDateString('en-GB') || 'Unset',
        phoneNumber: registeredUser.contact_number || 'Unset',
        address_line_1: registeredUser.address_line_1 || 'Unset',
        city: registeredUser.city || 'Unset',
        postcode: registeredUser.postcode || 'Unset',
        country: registeredUser.country || 'Unset',
        company: registeredUser.company || 'Unset',
        occupation: registeredUser.occupation || 'Unset'
      };
      setFormData(updatedFormData);
    } else if (formData.appointmentFor !== 'myself') {
      setFormData({
        ...formData,
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        phoneNumber: '',
        address_line_1: '',
        city: '',
        postcode: '',
        country: '',
        company: '',
        occupation: ''
      });
    }
  }, [formData.appointmentFor, registeredUser]);
  const updateCustomisedMarkersInBookingData = customisedMarkers => {
    setBookingData(prevBookingData => prevBookingData.map(booking => {
      if (booking.booking.bookingId === currentBookingId) {
        return {
          ...booking,
          service: {
            ...booking.service,
            customisedMarkers: {
              ...customisedMarkers
            }
          }
        };
      }
      return booking;
    }));
  };
  const onSubmitCustomisedMarkers = updatedMarkers => {
    updateCustomisedMarkersInBookingData(updatedMarkers);
    setShowCustomiseMarkersModal(false);
  };
  const openCustomiseMarkersModal = bookingItemId => {
    // setCustomiseMarkersBookingItemId(bookingItemId);
    setShowCustomiseMarkersModal(true);
  };
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.bookingSubmissionForm
  }, registeredUser && registeredUser.account_type_id === 2 && /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement(CustomiseMarkersModal, {
    showCustomiseMarkersModal: showCustomiseMarkersModal,
    onSubmitCustomisedMarkers: onSubmitCustomisedMarkers,
    currentBookingData: currentBookingData,
    onClose: closeModal
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, Object.keys(formErrors).length !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.errorBox
  }, /*#__PURE__*/React.createElement("h3", null, "Please complete the missing fields below:"), Object.keys(formErrors).map(fieldName => {
    const errorMessage = formErrors[fieldName];
    if (errorMessage) {
      return /*#__PURE__*/React.createElement("p", {
        key: fieldName
      }, /*#__PURE__*/React.createElement("a", {
        href: "#".concat(fieldName)
      }, errorMessage));
    }
    return null;
  }))) : '', bookingItem.service.customisedMarkers && /*#__PURE__*/React.createElement("div", {
    className: "p-3 mt-2 mb-3",
    style: {
      background: 'rgb(243 243 243)',
      borderRadius: '6px',
      maxWidth: '470px',
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '14px',
      fontWeight: 500
    }
  }, "Customisations"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      border: 'none',
      background: 'none'
    },
    onClick: () => openCustomiseMarkersModal(bookingItem.booking.bookingId)
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/icon/pencil.png",
    style: {
      maxWidth: '13px',
      marginRight: '10px'
    },
    alt: "remove from cart"
  }))), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    style: {
      fontSize: '14px'
    }
  }, "Laboratory: ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, bookingItem.service.customisedMarkers.hospital)), /*#__PURE__*/React.createElement("li", {
    style: {
      fontSize: '14px'
    }
  }, "Additional markers:", ' ', bookingItem.service.customisedMarkers.markers.map(marker => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    key: "index",
    style: {
      border: '1px solid #b7b7b7',
      padding: '2px 4px',
      borderRadius: '4px',
      fontWeight: 500
    }
  }, marker.name), ' '))))), currentBookingData && (currentBookingData.service.serviceType.toLowerCase().includes('clinic') || currentBookingData.service.serviceType.toLowerCase().includes('virtualwellbeing') || currentBookingData.service.serviceType.toLowerCase().includes('consultation')) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement(TwoRadioSelection, {
    name: "appointmentFor",
    label: "Who is this appointment for?",
    firstOption: "Myself",
    firstOptionId: "myself",
    secondOption: "Someone else",
    secondOptionId: "someoneelse",
    onSelectionChange: handleCustomComponentChange
  }), ((bookingItem === null || bookingItem === void 0 || (_bookingItem$booking2 = bookingItem.booking) === null || _bookingItem$booking2 === void 0 ? void 0 : _bookingItem$booking2.locationId) !== 4 || (bookingItem === null || bookingItem === void 0 || (_bookingItem$booking3 = bookingItem.booking) === null || _bookingItem$booking3 === void 0 ? void 0 : _bookingItem$booking3.appointmentRegion) && bookingItem.booking.appointmentRegion.toLowerCase() !== 'home visit' && requireAvailability) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DatePicker, {
    name: "appointmentDate",
    onDateChange: handleCustomComponentChange,
    availabilityData: availabilityData,
    label: "Please select your appointment date and time *"
  }), /*#__PURE__*/React.createElement(TimePicker, {
    name: "appointmentTime",
    onTimeChange: handleCustomComponentChange,
    label: "Available times",
    selectedDate: selectedDate,
    availabilityData: availabilityData,
    clearSelectedTime: clearSelectedTime,
    setClearSelectedTime: setClearSelectedTime
  }))), isSomeoneElse && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("b", null, "Please choose the statement that applies to this booking"), /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.radioGroup
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "under18",
    name: "statement",
    value: "Under 18",
    checked: formData.statement === 'Under 18',
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "under18"
  }, "This is an under 18 booking and I am their legal parent/guardian")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "caringFor",
    name: "statement",
    value: "Caring for someone",
    checked: formData.statement === 'Caring for someone',
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "caringFor"
  }, "This is for a person I am caring for and I have their consent")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "familyFriend",
    name: "statement",
    value: "Family/Friend",
    checked: formData.statement === 'Family/Friend',
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "familyFriend"
  }, "This is for a friend/family member and I have their consent")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "organisation",
    name: "statement",
    value: "Organisation",
    checked: formData.statement === 'Organisation',
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "organisation"
  }, "This is an organisation and I have the consent for this person")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "noConsent",
    name: "statement",
    value: "No consent",
    checked: formData.statement === 'No consent',
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "noConsent"
  }, "I do not yet have the consent for this person")))), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "nameTitle"
  }, "Title", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("select", {
    id: "nameTitle",
    name: "nameTitle",
    value: formData.nameTitle,
    onChange: handleInputChange
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, " "), /*#__PURE__*/React.createElement("option", {
    value: "Mr"
  }, "Mr"), /*#__PURE__*/React.createElement("option", {
    value: "Mrs"
  }, "Mrs"), /*#__PURE__*/React.createElement("option", {
    value: "Miss"
  }, "Miss"), /*#__PURE__*/React.createElement("option", {
    value: "Ms"
  }, "Ms"), /*#__PURE__*/React.createElement("option", {
    value: "Dr"
  }, "Dr"))), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "firstName"
  }, "First Name", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "firstName",
    name: "firstName",
    value: formData.firstName,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "lastName"
  }, "Last Name", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "lastName",
    name: "lastName",
    value: formData.lastName,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "gender"
  }, "Gender", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("select", {
    id: "gender",
    name: "gender",
    value: formData.gender,
    onChange: handleInputChange
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, " "), /*#__PURE__*/React.createElement("option", {
    value: "Male"
  }, "Male"), /*#__PURE__*/React.createElement("option", {
    value: "Female"
  }, "Female"), /*#__PURE__*/React.createElement("option", {
    value: "Other"
  }, "Other"))), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "dateOfBirth"
  }, "Date of Birth", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*"), ":"), /*#__PURE__*/React.createElement("input", {
    type: "date",
    id: "dateOfBirth",
    name: "dateOfBirth",
    value: formData.dateOfBirth,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "phoneNumber"
  }, "Phone Number", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "tel",
    id: "phoneNumber",
    name: "phoneNumber",
    value: formData.phoneNumber,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "patientEmailAddress"
  }, "Patient email address (If over 18)", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    type: "email",
    id: "patientEmailAddress",
    name: "patientEmailAddress",
    value: formData.patientEmailAddress,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement(Postcoder, {
    apiKey: config.REACT_APP_POSTCODER,
    addressSelectedCallback: useAddress,
    labelText: "Address lookup",
    placeholder: "Search your postcode"
  }), visibleAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "address_line_1",
    className: "mb-2"
  }, "Address line 1 ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "address_line_1",
    name: "address_line_1",
    type: "text",
    value: formData.address_line_1,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "address_line_2",
    className: "mb-2"
  }, "Address line 2"), /*#__PURE__*/React.createElement("input", {
    id: "address_line_2",
    name: "address_line_2",
    type: "text",
    value: formData.address_line_2,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "city",
    className: "mb-2"
  }, "City ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "city",
    name: "city",
    type: "text",
    value: formData.city,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "country",
    className: "mb-2"
  }, "Country ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "country",
    name: "country",
    type: "text",
    value: formData.country,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postcode",
    className: "mb-2"
  }, "Postcode ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postcode",
    name: "postcode",
    type: "text",
    value: formData.postcode,
    onChange: handleInputChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "company"
  }, "Company"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "company",
    name: "company",
    value: formData.company,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "occupation"
  }, "Occupation"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "occupation",
    name: "occupation",
    value: formData.occupation,
    onChange: handleInputChange
  })))), currentBookingData && currentBookingData.service.serviceType === 'Postal' && /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement(TwoRadioSelection, {
    name: "postageSelection",
    label: "Do you require this order to be posted to you?",
    firstOption: "No",
    firstOptionId: "no",
    secondOption: "Yes",
    secondOptionId: "yes",
    onSelectionChange: handleCustomComponentChange
  }), postageAddressVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Postcoder, {
    apiKey: config.REACT_APP_POSTCODER,
    addressSelectedCallback: usePostageAddress,
    labelText: "Choose address for delivery",
    placeholder: "Search your postcode"
  }), visibleAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "postageAddressLine1",
    className: "mb-2"
  }, "Address line 1 ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postageAddressLine1",
    name: "postageAddressLine1",
    type: "text",
    value: formData.postageAddressLine1,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postageAddressLine2",
    className: "mb-2"
  }, "Address line 2"), /*#__PURE__*/React.createElement("input", {
    id: "postageAddressLine2",
    name: "postageAddressLine2",
    type: "text",
    value: formData.postageAddressLine2,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postageCity",
    className: "mb-2"
  }, "City ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postageCity",
    name: "postageCity",
    type: "text",
    value: formData.postageCity,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postageCountry",
    className: "mb-2"
  }, "Country ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postageCountry",
    name: "postageCountry",
    type: "text",
    value: formData.postageCountry,
    onChange: handleInputChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "postagePostcode",
    className: "mb-2"
  }, "Postcode ", /*#__PURE__*/React.createElement("span", {
    className: modules_dcc64c53.required
  }, "*")), /*#__PURE__*/React.createElement("input", {
    required: true,
    id: "postagePostcode",
    name: "postagePostcode",
    type: "text",
    value: formData.postagePostcode,
    onChange: handleInputChange
  })))), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, currentBookingData && currentBookingData.booking.eventId && currentBookingData.booking.eventId === 7 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "nhsNumber"
  }, "NHS Number *"), /*#__PURE__*/React.createElement("input", {
    id: "nhsNumber",
    name: "nhsNumber",
    type: "text",
    value: formData.nhsNumber,
    onChange: handleInputChange,
    placeholder: "Enter your NHS number"
  }), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("label", {
    htmlFor: "appointmentNotes"
  }, "Notes"), /*#__PURE__*/React.createElement("textarea", {
    id: "appointmentNotes",
    name: "appointmentNotes",
    value: formData.appointmentNotes,
    onChange: handleInputChange,
    placeholder: "Important: please leave a note here or email customers@sirkkaltd.com for any relevant medical conditions, including needle phobia or previous difficulties with blood draw"
  }), /*#__PURE__*/React.createElement("h6", null, "Cancellation Policy"), /*#__PURE__*/React.createElement("p", null, "Provided you change or cancel your appointment more than 48 hours in advance there will be no cancellation fee. If you change or cancel your appointment on the day, you will be charged the full amount."), /*#__PURE__*/React.createElement("h6", null, "Booking"), /*#__PURE__*/React.createElement("p", null, "Bookings are subject to terms and conditions which can be found", ' ', /*#__PURE__*/React.createElement("a", {
    href: "/legalStatement",
    target: "_blank"
  }, "here"), ". Please tick the checkbox to confirm you have read and agree to", ' ', /*#__PURE__*/React.createElement("a", {
    href: "/legalStatement",
    target: "_blank"
  }, "these terms and conditions"), "."), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "termsconditions",
    name: "termsconditions",
    className: modules_dcc64c53.hidden,
    value: formData.termsconditions,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "termsconditions",
    className: modules_dcc64c53.checkbox
  }, "I agree to the", ' ', /*#__PURE__*/React.createElement("a", {
    href: "/legalStatement",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'underline'
    }
  }, "terms and conditions.")), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "sampleConsent",
    name: "sampleConsent",
    className: modules_dcc64c53.hidden,
    value: formData.sampleConsent,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "sampleConsent",
    className: modules_dcc64c53.checkbox
  }, "I consent that my samples will be taken and tested."), bookingItem.booking.eventId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "gpConsent",
    name: "gpConsent",
    className: modules_dcc64c53.hidden,
    value: formData.gpConsent,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "gpConsent",
    className: modules_dcc64c53.checkbox
  }, "I consent for details to be passed on to our private GP to contact you regarding results."), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "eventConsentForm",
    name: "eventConsentForm",
    className: modules_dcc64c53.hidden,
    value: formData.eventConsentForm,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "eventConsentForm",
    className: modules_dcc64c53.checkbox
  }, "I have completed the Consent Form before booking.", /*#__PURE__*/React.createElement("a", {
    href: "https://forms.office.com/e/CwUmxys5U5",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'underline'
    }
  }, /*#__PURE__*/React.createElement("b", null, " Click Here.")))), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "researchConsent",
    name: "researchConsent",
    className: modules_dcc64c53.hidden,
    value: formData.researchConsent,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "researchConsent",
    className: modules_dcc64c53.checkbox
  }, "I hereby consent for completely anonymised medical data related to these tests to be used for medical research purposes.")), /*#__PURE__*/React.createElement("div", {
    className: modules_dcc64c53.formGroup
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Confirm Details",
    onClick: handleSubmit,
    variant: "primary",
    fullWidth: true,
    large: true
  }))));
}
BookingSubmissionForm.propTypes = {
  registeredUser: PropTypes.shape({
    account_type_id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email_address: PropTypes.string,
    gender: PropTypes.string,
    date_of_birth: PropTypes.string,
    contact_number: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    postcode: PropTypes.string,
    company: PropTypes.string,
    occupation: PropTypes.string
  }).isRequired,
  onComplete: PropTypes.func.isRequired
};

var css = "@charset \"UTF-8\";\n.no-referral {\n  text-decoration: underline;\n  color: #015c7d;\n  cursor: pointer;\n  position: relative;\n  margin: 5px 0 !important;\n  width: 100%;\n  max-width: 400px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  text-align: left;\n}\n.no-referral .circle-check {\n  content: \"✔\";\n  left: 0;\n  top: 0px;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  background: #0279a3;\n  border-radius: 50%;\n  color: white;\n  z-index: 1;\n  position: relative;\n  font-size: 10px;\n  font-family: initial;\n  line-height: 2.2em;\n  display: inline-block;\n  margin-left: 5px;\n  padding-right: 2px;\n}\n\n.no-referral-tooltip {\n  position: absolute;\n  background-color: #ffffff;\n  border: 1px solid rgba(211, 211, 211, 0.3803921569);\n  padding: 5px;\n  border-radius: 4px;\n  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.14);\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  z-index: 2;\n  padding: 12px 16px;\n  margin-top: 11px;\n}\n.no-referral-tooltip::before {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  margin-left: -5px;\n  border-width: 12px;\n  border-style: solid;\n  border-color: transparent transparent #fff transparent;\n}";
n(css,{});

function NoReferral() {
  const [showTooltip, setShowTooltip] = useState(false);
  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "no-referral",
    onClick: toggleTooltip
  }, "No referral fees", /*#__PURE__*/React.createElement("i", {
    className: "circle-check"
  }, "\u2714"), showTooltip && /*#__PURE__*/React.createElement("div", {
    className: "no-referral-tooltip"
  }, /*#__PURE__*/React.createElement("p", null, "We do not take any referral fees from third parties listed on our website, nor have any financial interests in referring customers to doctors or clinics. Our medical assistance services are for Sirkka members only."), /*#__PURE__*/React.createElement("p", null, ' ', "The information and details of third parties are provided directly by third party providers. These details are based upon the best judgement of Sirkka and does not constitute an endorsement or recommendation regarding the quality of their services nor shall Sirkka be liable for any consequences arising out of the services provided by these third parties. Sirkka shall not be held responsible for service continuity and other issues caused by changes of policies implemented by a country, relevant organizations and/or key service providers."))));
}

export { BookingContext, BookingProvider, BookingSubmissionForm, Button, CardList, CartSummary, DatePicker, Filter, Hero, LocationCard, LoginCard, NoReferral, OrderSummary, PostcodeAvailabilityMap, RegisterForm, RegisterSuccess, ServiceCard, ServiceModal, SpecialistModal, ThreeRadioSelection, TimePicker, Tooltip, TwoRadioSelection, VerticalRadioSelection };
